function ItemAegisToId() {
    return(ItemList)
}

function ItemAegisToIdConsult(ItemAegisName) {
    return(ItemList[ItemAegisName])
}

export {ItemAegisToId, ItemAegisToIdConsult};

const ItemList = {

"Warnut_Chocoball":500,
"Red_Potion":501,
"Orange_Potion":502,
"Yellow_Potion":503,
"White_Potion":504,
"Blue_Potion":505,
"Green_Potion":506,
"Red_Herb":507,
"Yellow_Herb":508,
"White_Herb":509,
"Blue_Herb":510,
"Green_Herb":511,
"Apple":512,
"Banana":513,
"Grape":514,
"Carrot":515,
"Sweet_Potato":516,
"Meat":517,
"Honey":518,
"Milk":519,
"Leaflet_Of_Hinal":520,
"Leaflet_Of_Aloe":521,
"Fruit_Of_Mastela":522,
"Holy_Water":523,
"Panacea":525,
"Royal_Jelly":526,
"Monster's_Feed":528,
"Candy":529,
"Candy_Striper":530,
"Apple_Juice":531,
"Banana_Juice":532,
"Grape_Juice":533,
"Carrot_Juice":534,
"Pumpkin":535,
"Ice_Cream":536,
"Pet_Food":537,
"Well_Baked_Cookie":538,
"Piece_Of_Cake":539,
"Falcon's_Feed":540,
"Pecopeco's_Feed":541,
"Festive_Cookie":542,
"Festive_Rainbow_Cake":543,
"Fish_Slice":544,
"Red_Slim_Potion":545,
"Yellow_Slim_Potion":546,
"White_Slim_Potion":547,
"Cheese":548,
"Nice_Sweet_Potato":549,
"Popped_Rice":550,
"Shusi":551,
"KETUPAT":552,
"Bun":553,
"Mojji":554,
"Rice_Cake":555,
"Long_Rice_Cake":556,
"Hash_Rice_Cake":557,
"Chocolate":558,
"HandMade_Chocolate":559,
"HandMade_Chocolate_":560,
"White_Chocolate":561,
"Pizza":562,
"Pizza_01":563,
"Rice_Ball":564,
"Vita500_Bottle":565,
"Tomyumkung":566,
"Prawn":567,
"Lemon":568,
"Novice_Potion":569,
"Lucky_Candy":570,
"Lucky_Candy_Cane":571,
"Lucky_Cookie":572,
"Chocolate_Drink":573,
"Egg":574,
"Piece_Of_Cake_":575,
"Prickly_Fruit":576,
"Grain":577,
"Strawberry":578,
"Delicious_Fish":579,
"Bread":580,
"Mushroom":581,
"Orange":582,
"KETUPAT_":583,
"Fish_Ball_Soup":584,
"Wurst":585,
"Mother's_Cake":586,
"Prickly_Fruit_":587,
"Spaghetti":588,
"Pizza_02":589,
"Brezel_":590,
"Caviar_Pancake":591,
"Jam_Pancake":592,
"Honey_Pancake":593,
"Sour_Cream_Pancake":594,
"Mushroom_Pancake":595,
"Cute_Strawberry_Choco":596,
"Lovely_Choco_Tart":597,
"Light_Red_Pot":598,
"Light_Orange_Pot":599,
"Wing_Of_Fly":601,
"Wing_Of_Butterfly":602,
"Old_Blue_Box":603,
"Branch_Of_Dead_Tree":604,
"Anodyne":605,
"Aloebera":606,
"Yggdrasilberry":607,
"Seed_Of_Yggdrasil":608,
"Amulet":609,
"Leaf_Of_Yggdrasil":610,
"Spectacles":611,
"Portable_Furnace":612,
"Iron_Hammer":613,
"Golden_Hammer":614,
"Oridecon_Hammer":615,
"Old_Card_Album":616,
"Old_Violet_Box":617,
"Worn_Out_Scroll":618,
"Unripe_Apple":619,
"Orange_Juice":620,
"Bitter_Herb":621,
"Rainbow_Carrot":622,
"Earthworm_The_Dude":623,
"Rotten_Fish":624,
"Lusty_Iron":625,
"Monster_Juice":626,
"Sweet_Milk":627,
"Well_Dried_Bone":628,
"Singing_Flower":629,
"Dew_Laden_Moss":630,
"Deadly_Noxious_Herb":631,
"Fatty_Chubby_Earthworm":632,
"Baked_Yam":633,
"Tropical_Banana":634,
"Horror_Of_Tribe":635,
"No_Recipient":636,
"Old_Broom":637,
"Silver_Knife_Of_Chaste":638,
"Armlet_Of_Obedience":639,
"Shining_Stone":640,
"Contracts_In_Shadow":641,
"Book_Of_Devil":642,
"Pet_Incubator":643,
"Gift_Box":644,
"Center_Potion":645,
"Awakening_Potion":656,
"Berserk_Potion":657,
"Union_Of_Tribe":658,
"Heart_Of_Her":659,
"Prohibition_Red_Candle":660,
"Sway_Apron":661,
"Inspector_Certificate":662,
"Korea_Rice_Cake":663,
"Gift_Box_1":664,
"Gift_Box_2":665,
"Gift_Box_3":666,
"Gift_Box_4":667,
"Handsei":668,
"Rice_Cake_Soup":669,
"Gold_Coin_Moneybag":670,
"Gold_Coin":671,
"Copper_Coin_Moneybag":672,
"Copper_Coin":673,
"Mithril_Coin":674,
"Silver_Coin":675,
"Silver_Coin_Moneybag":676,
"White_Gold_Coin":677,
"Poison_Bottle":678,
"Gold_Pill":679,
"Magical_Carnation":680,
"Memory_Of_Wedding":681,
"Realgar_Wine":682,
"Exorcize_Herb":683,
"Durian":684,
"RAMADAN":685,
"Earth_Scroll_1_3":686,
"Earth_Scroll_1_5":687,
"Cold_Scroll_1_3":688,
"Cold_Scroll_1_5":689,
"Fire_Scroll_1_3":690,
"Fire_Scroll_1_5":691,
"Wind_Scroll_1_3":692,
"Wind_Scroll_1_5":693,
"Ghost_Scroll_1_3":694,
"Ghost_Scroll_1_5":695,
"Fire_Scroll_2_1":696,
"Fire_Scroll_2_5":697,
"Fire_Scroll_3_1":698,
"Fire_Scroll_3_5":699,
"Cold_Scroll_2_1":700,
"Ora_Ora":701,
"Animal_Blood":702,
"Hinalle":703,
"Aloe":704,
"Clover":705,
"Four_Leaf_Clover":706,
"Singing_Plant":707,
"Ment":708,
"Izidor":709,
"Illusion_Flower":710,
"Shoot":711,
"Flower":712,
"Empty_Bottle":713,
"Emperium":714,
"Yellow_Gemstone":715,
"Red_Gemstone":716,
"Blue_Gemstone":717,
"Dark_Red_Jewel":718,
"Violet_Jewel":719,
"Skyblue_Jewel":720,
"Azure_Jewel":721,
"Scarlet_Jewel":722,
"Cardinal_Jewel":723,
"Cardinal_Jewel_":724,
"Red_Jewel":725,
"Blue_Jewel":726,
"White_Jewel":727,
"Golden_Jewel":728,
"Bluish_Green_Jewel":729,
"Crystal_Jewel":730,
"Crystal_Jewel_":731,
"Crystal_Jewel__":732,
"Crystal_Jewel___":733,
"Red_Frame":734,
"Blue_Porcelain":735,
"White_Platter":736,
"Black_Ladle":737,
"Pencil_Case":738,
"Rouge":739,
"Stuffed_Doll":740,
"Poring_Doll":741,
"Chonchon_Doll":742,
"Spore_Doll":743,
"Bunch_Of_Flowers":744,
"Wedding_Bouquet":745,
"Glass_Bead":746,
"Crystal_Mirror":747,
"Witherless_Rose":748,
"Frozen_Rose":749,
"Baphomet_Doll":750,
"Osiris_Doll":751,
"Grasshopper_Doll":752,
"Monkey_Doll":753,
"Raccoondog_Doll":754,
"Oridecon_Stone":756,
"Elunium_Stone":757,
"Silky_Fur_Bundle":766,
"2ndTH_S_Booster_Ticket":793,
"3rdTH_Ragwart_Ticket":824,
"Danggie":901,
"Tree_Root":902,
"Reptile_Tongue":903,
"Scorpion's_Tail":904,
"Stem":905,
"Pointed_Scale":906,
"Resin":907,
"Spawn":908,
"Jellopy":909,
"Garlet":910,
"Scell":911,
"Zargon":912,
"Tooth_Of_Bat":913,
"Fluff":914,
"Chrysalis":915,
"Feather_Of_Birds":916,
"Talon":917,
"Sticky_Webfoot":918,
"Animal's_Skin":919,
"Claw_Of_Wolves":920,
"Mushroom_Spore":921,
"Orcish_Cuspid":922,
"Evil_Horn":923,
"Powder_Of_Butterfly":924,
"Bill_Of_Birds":925,
"Scale_Of_Snakes":926,
"Insect_Feeler":928,
"Immortal_Heart":929,
"Rotten_Bandage":930,
"Orcish_Voucher":931,
"Skel_Bone":932,
"Mementos":934,
"Shell":935,
"Scales_Shell":936,
"Posionous_Canine":937,
"Sticky_Mucus":938,
"Bee_Sting":939,
"Grasshopper's_Leg":940,
"Nose_Ring":941,
"Yoyo_Tail":942,
"Solid_Shell":943,
"Horseshoe":944,
"Raccoon_Leaf":945,
"Snail's_Shell":946,
"Horn":947,
"Bear's_Foot":948,
"Feather":949,
"Heart_Of_Mermaid":950,
"Fin":951,
"Cactus_Needle":952,
"Stone_Heart":953,
"Shining_Scales":954,
"Worm_Peelings":955,
"Gill":956,
"Decayed_Nail":957,
"Horrendous_Mouth":958,
"Rotten_Scale":959,
"Nipper":960,
"Conch":961,
"Tentacle":962,
"Sharp_Scale":963,
"Crap_Shell":964,
"Clam_Shell":965,
"Flesh_Of_Clam":966,
"Turtle_Shell":967,
"Voucher_Of_Orcish_Hero":968,
"Gold":969,
"Alchol":970,
"Detrimindexta":971,
"Karvodailnirol":972,
"Counteragent":973,
"Mixture":974,
"Scarlet_Dyestuffs":975,
"Lemon_Dyestuffs":976,
"Cobaltblue_Dyestuffs":978,
"Darkgreen_Dyestuffs":979,
"Orange_Dyestuffs":980,
"Violet_Dyestuffs":981,
"White_Dyestuffs":982,
"Black_Dyestuffs":983,
"Oridecon":984,
"Elunium":985,
"Anvil":986,
"Oridecon_Anvil":987,
"Golden_Anvil":988,
"Emperium_Anvil":989,
"Boody_Red":990,
"Crystal_Blue":991,
"Wind_Of_Verdure":992,
"Yellow_Live":993,
"Flame_Heart":994,
"Mistic_Frozen":995,
"Rough_Wind":996,
"Great_Nature":997,
"Iron":998,
"Steel":999,
"Star_Crumb":1000,
"Sparkling_Dust":1001,
"Iron_Ore":1002,
"Coal":1003,
"Patriotism_Marks":1004,
"Hammer_Of_Blacksmith":1005,
"Old_Magic_Book":1006,
"Penetration":1007,
"Frozen_Heart":1008,
"Sacred_Marks":1009,
"Phracon":1010,
"Emveretarcon":1011,
"Lizard_Scruff":1012,
"Colorful_Shell":1013,
"Jaws_Of_Ant":1014,
"Thin_N'_Long_Tongue":1015,
"Rat_Tail":1016,
"Moustache_Of_Mole":1017,
"Nail_Of_Mole":1018,
"Wooden_Block":1019,
"Long_Hair":1020,
"Dokkaebi_Horn":1021,
"Fox_Tail":1022,
"Fish_Tail":1023,
"Chinese_Ink":1024,
"Spiderweb":1025,
"Acorn":1026,
"Porcupine_Spike":1027,
"Wild_Boar's_Mane":1028,
"Tiger's_Skin":1029,
"Tiger_Footskin":1030,
"Limb_Of_Mantis":1031,
"Blossom_Of_Maneater":1032,
"Root_Of_Maneater":1033,
"Cobold_Hair":1034,
"Dragon_Canine":1035,
"Dragon_Scale":1036,
"Dragon_Train":1037,
"Petite_DiablOfs_Horn":1038,
"Petite_DiablOfs_Wing":1039,
"Elder_Pixie's_Beard":1040,
"Lantern":1041,
"Short_Leg":1042,
"Nail_Of_Orc":1043,
"Tooth_Of_":1044,
"Sacred_Masque":1045,
"Tweezer":1046,
"Head_Of_Medusa":1047,
"Slender_Snake":1048,
"Skirt_Of_Virgin":1049,
"Tendon":1050,
"Detonator":1051,
"Single_Cell":1052,
"Tooth_Of_Ancient_Fish":1053,
"Lip_Of_Ancient_Fish":1054,
"Earthworm_Peeling":1055,
"Grit":1056,
"Moth_Dust":1057,
"Wing_Of_Moth":1058,
"Transparent_Cloth":1059,
"Golden_Hair":1060,
"Starsand_Of_Witch":1061,
"Pumpkin_Head":1062,
"Sharpened_Cuspid":1063,
"Reins":1064,
"Booby_Trap":1065,
"Tree_Of_Archer_1":1066,
"Tree_Of_Archer_2":1067,
"Tree_Of_Archer_3":1068,
"Mushroom_Of_Thief_1":1069,
"Mushroom_Of_Thief_2":1070,
"Mage_Test_1":1071,
"Delivery_Message":1072,
"Merchant_Voucher_1":1073,
"Merchant_Voucher_2":1074,
"Merchant_Voucher_3":1075,
"Merchant_Voucher_4":1076,
"Merchant_Voucher_5":1077,
"Merchant_Voucher_6":1078,
"Merchant_Voucher_7":1079,
"Merchant_Voucher_8":1080,
"Merchant_Box_1":1081,
"Merchant_Box_2":1082,
"Merchant_Box_3":1083,
"Kapra's_Pass":1084,
"Mage_Test_2":1085,
"Mage_Test_3":1086,
"Mage_Test_4":1087,
"Morocc_Potion":1088,
"Payon_Potion":1089,
"Mage_Test_Etc":1090,
"Merchant_Box_Etc":1091,
"Empty_Cylinder":1092,
"Empty_Potion":1093,
"Short_Daenggie":1094,
"Needle_Of_Alarm":1095,
"Round_Shell":1096,
"Worn_Out_Page":1097,
"Manacles":1098,
"Worn_Out_Prison_Uniform":1099,
"Taurus_Sword_J":1100,
"Sword":1101,
"Sword_":1102,
"Sword__":1103,
"Falchion":1104,
"Falchion_":1105,
"Falchion__":1106,
"Blade":1107,
"Blade_":1108,
"Blade__":1109,
"Lapier":1110,
"Lapier_":1111,
"Lapier__":1112,
"Scimiter":1113,
"Scimiter_":1114,
"Scimiter__":1115,
"Katana":1116,
"Katana_":1117,
"Katana__":1118,
"Tsurugi":1119,
"Tsurugi_":1120,
"Tsurugi__":1121,
"Ring_Pommel_Saber":1122,
"Haedonggum":1123,
"Orcish_Sword":1124,
"Ring_Pommel_Saber_":1125,
"Saber":1126,
"Saber_":1127,
"Hae_Dong_Gum_":1128,
"Flamberge":1129,
"Nagan":1130,
"Ice_Falchon":1131,
"Edge":1132,
"Fire_Brand":1133,
"Scissores_Sword":1134,
"Cutlas":1135,
"Solar_Sword":1136,
"Excalibur":1137,
"Mysteltainn_":1138,
"Tale_Fing_":1139,
"Byeorrun_Gum":1140,
"Immaterial_Sword":1141,
"Jewel_Sword":1142,
"Gaia_Sword":1143,
"Sasimi":1144,
"Holy_Avenger":1145,
"Town_Sword":1146,
"Town_Sword_":1147,
"Star_Dust_Blade":1148,
"Flamberge_":1149,
"Libra_Krasnaya_J":1150,
"Slayer":1151,
"Slayer_":1152,
"Slayer__":1153,
"Bastard_Sword":1154,
"Bastard_Sword_":1155,
"Bastard_Sword__":1156,
"Two_Hand_Sword":1157,
"Two_Hand_Sword_":1158,
"Two_Hand_Sword__":1159,
"Broad_Sword":1160,
"Balmung":1161,
"Broad_Sword_":1162,
"Claymore":1163,
"Muramasa":1164,
"Masamune":1165,
"Dragon_Slayer":1166,
"Schweizersabel":1167,
"Zweihander":1168,
"Executioner_":1169,
"Katzbalger":1170,
"Zweihander_":1171,
"Claymore_":1172,
"Muramasa_C":1173,
"Executioner_C":1174,
"Altas_Weapon":1175,
"Muscle_Cutter":1176,
"Muramash":1177,
"Schweizersabel_":1178,
"Executioner__":1179,
"Dragon_Slayer_":1180,
"Tae_Goo_Lyeon":1181,
"Bloody_Eater":1182,
"BF_Two_Handed_Sword1":1183,
"BF_Two_Handed_Sword2":1184,
"Violet_Fear":1185,
"Death_Guidance":1186,
"Krieger_Twohand_Sword1":1187,
"Veteran_Sword":1188,
"Krasnaya":1189,
"Claymore_C":1190,
"Alca_Bringer":1191,
"P_Slayer1":1192,
"P_Slayer2":1193,
"F_Executioner_C":1194,
"E_Executioner_C":1195,
"Chrome_Twohand_Sword":1196,
"P_Slayer3":1197,
"Hairtail":1198,
"Ebony_Toe_Nail":1199,
"Knife":1201,
"Knife_":1202,
"Knife__":1203,
"Cutter":1204,
"Cutter_":1205,
"Cutter__":1206,
"Main_Gauche":1207,
"Main_Gauche_":1208,
"Main_Gauche__":1209,
"Dirk":1210,
"Dirk_":1211,
"Dirk__":1212,
"Dagger":1213,
"Dagger_":1214,
"Dagger__":1215,
"Stiletto":1216,
"Stiletto_":1217,
"Stiletto__":1218,
"Gladius":1219,
"Gladius_":1220,
"Gladius__":1221,
"Damascus":1222,
"Forturn_Sword":1223,
"Sword_Breaker":1224,
"Mail_Breaker":1225,
"Damascus_":1226,
"Weeder_Knife":1227,
"Combat_Knife":1228,
"Mama's_Knife":1229,
"House_Auger":1230,
"Bazerald":1231,
"Assasin_Dagger":1232,
"Exercise":1233,
"Moonlight_Sword":1234,
"Azoth":1235,
"Sucsamad":1236,
"Grimtooth_":1237,
"Zeny_Knife":1238,
"Poison_Knife":1239,
"Princess_Knife":1240,
"Cursed_Dagger":1241,
"Counter_Dagger":1242,
"Novice_Knife":1243,
"Holy_Dagger":1244,
"Cinquedea":1245,
"Cinquedea_":1246,
"Kindling_Dagger":1247,
"Obsidian_Dagger":1248,
"Fisherman's_Dagger":1249,
"Jur":1250,
"Jur_":1251,
"Katar":1252,
"Katar_":1253,
"Jamadhar":1254,
"Jamadhar_":1255,
"Katar_Of_Cold_Icicle":1256,
"Katar_Of_Thornbush":1257,
"Katar_Of_Raging_Blaze":1258,
"Katar_Of_Piercing_Wind":1259,
"Ghoul_Leg":1260,
"Infiltrator":1261,
"Nail_Of_Loki":1262,
"Unholy_Touch":1263,
"Various_Jur":1264,
"Bloody_Roar":1265,
"Infiltrator_":1266,
"Infiltrator_C":1267,
"Wild_Beast_Claw":1268,
"Inverse_Scale":1269,
"Drill_Katar":1270,
"Blood_Tears":1271,
"Scratcher":1272,
"Bloody_Roar_C":1273,
"Unholy_Touch_C":1274,
"Katar_Of_Cold_Icicle_":1275,
"Katar_Of_Thornbush_":1276,
"Katar_Of_Raging_Blaze_":1277,
"Katar_Of_Piercing_Wind_":1278,
"BF_Katar1":1279,
"BF_Katar2":1280,
"Krieger_Katar1":1281,
"Krieger_Katar2":1282,
"Katar_Of_Speed":1283,
"Krishna":1284,
"Cakram":1285,
"Jamadhar_C":1286,
"Durga":1287,
"Bloody_Fear_C":1288,
"P_Katar1":1289,
"Agent_Katar":1290,
"Guillotine_Katar":1291,
"Upg_Katar":1292,
"Velum_Jamadhar":1293,
"Velum_Scare":1294,
"Blood_Tears_":1295,
"Metal_Katar":1296,
"Inverse_Scale_":1297,
"Shiver_Katar":1298,
"TE_Woe_Katar":1299,
"Cleaver_":1300,
"Axe":1301,
"Axe_":1302,
"Axe__":1303,
"Orcish_Axe":1304,
"Cleaver":1305,
"War_Axe":1306,
"Windhawk":1307,
"Golden_Axe":1308,
"Orcish_Axe_":1309,
"Krieger_Onehand_Axe1":1310,
"Vecer_Axe":1311,
"Orcish_Axe_C":1312,
"Tourist_Axe":1313,
"F_Tomahawk_C":1314,
"F_Right_Epsilon_C":1315,
"Adventure_Axe":1316,
"Academy_Axe":1317,
"Dofle_Axe":1318,
"TE_Woe_Axe":1319,
"Diva_Axe":1320,
"Dofle_Axe_":1321,
"Ru_Blue_Axe":1322,
"Ru_Gold_Axe":1323,
"War_Axe_S":1324,
"Mirage_Axe":1325,
"War_Axe_IL":1326,
"Axe_Z":1327,
"Blut_Axe":1328,
"Woe_One_Hand_Axe1_Z":1329,
"Sunset_Buster":1330,
"Variant_Axe":1331,
"Octopus_Axe":1332,
"Golden_Wrench":1333,
"Ein_1HAXE":1334,
"Cancer_Axe_J":1335,
"G_Knight_Axe":1336,
"Golden_Wrench_J":1337,
"Hauyne_Huuma_EXE":1339,
"Arcanite_Hammer_EXE":1340,
"Destruction_Axe":1341,
"Comp_Avenger":1350,
"Battle_Axe":1351,
"Battle_Axe_":1352,
"Battle_Axe__":1353,
"Hammer":1354,
"Hammer_":1355,
"Hammer__":1356,
"Buster":1357,
"Buster_":1358,
"Buster__":1359,
"Two_Handed_Axe":1360,
"Two_Handed_Axe_":1361,
"Two_Handed_Axe__":1362,
"Brood_Axe":1363,
"Great_Axe":1364,
"Sabbath":1365,
"Right_Epsilon":1366,
"Slaughter":1367,
"Tomahawk":1368,
"Guillotine":1369,
"Doom_Slayer":1370,
"Doom_Slayer_":1371,
"Right_Epsilon_C":1372,
"Brood_Axe_C":1373,
"Tomahawk_C":1374,
"Berdysz":1375,
"Heart_Breaker":1376,
"Hurricane_Fury":1377,
"Great_Axe_C":1378,
"BF_Two_Handed_Axe1":1379,
"BF_Two_Handed_Axe2":1380,
"N_Battle_Axe":1381,
"Krieger_Twohand_Axe1":1382,
"Holy_Celestial_Axe":1383,
"Veteran_Axe":1384,
"Bradium_Stonehammer":1385,
"Doom_Slayer_I":1386,
"Giant_Axe":1387,
"Two_Handed_Axe_C":1388,
"E_Tomahawk_C":1389,
"E_Right_Epsilon_C":1390,
"P_Two_Handed_Axe1":1391,
"Ygnus_Stale":1392,
"End_Sektura":1393,
"Upg_Two_Handed_Axe":1394,
"Velum_Buster":1395,
"Velum_Guillotine":1396,
"Bradium_Stonehammer_":1397,
"Metal_Two_Handed_Axe":1398,
"TE_Woe_Two_Handed_Axe":1399,
"Sinister_Spear":1400,
"Javelin":1401,
"Javelin_":1402,
"Javelin__":1403,
"Spear":1404,
"Spear_":1405,
"Spear__":1406,
"Pike":1407,
"Pike_":1408,
"Pike__":1409,
"Lance":1410,
"Lance_":1411,
"Lance__":1412,
"Gungnir":1413,
"Gelerdria":1414,
"Skewer":1415,
"Tjungkuletti":1416,
"Pole_Axe":1417,
"Gungnir_":1418,
"Pole_Axe_C":1419,
"Long_Horn":1420,
"Battle_Hook":1421,
"Hunting_Spear":1422,
"Pole_XO":1423,
"Skewer_C":1424,
"BF_Spear1":1425,
"Krieger_Onehand_Spear1":1426,
"Spear_Of_Excellent":1427,
"Long_Horn_M":1428,
"Hunting_Spear_M":1429,
"Pike_C":1430,
"F_Pole_Axe_C":1431,
"E_Pole_Axe_C":1432,
"Imperial_Spear":1433,
"P_Sphere1":1434,
"Cannon_Spear":1435,
"Velum_Spear":1436,
"TE_Woe_Pike":1437,
"Thanos_Spear":1438,
"Half_BF_Spear1":1439,
"Battle_Hook_":1440,
"Ru_Blue_Spear":1441,
"Ru_Gold_Spear":1442,
"Scarlet_Spear":1443,
"Spear_of_Trust":1444,
"Spear_of_Trust2":1445,
"Thanos_Spear_J":1446,
"Poison_Forged_Spear":1447,
"UnrivaledSpear":1448,
"Gelerdria_":1449,
"Sinister_Lance":1450,
"Guisarme":1451,
"Guisarme_":1452,
"Guisarme__":1453,
"Glaive":1454,
"Glaive_":1455,
"Glaive__":1456,
"Partizan":1457,
"Partizan_":1458,
"Partizan__":1459,
"Trident":1460,
"Trident_":1461,
"Trident__":1462,
"Halberd":1463,
"Halberd_":1464,
"Halberd__":1465,
"Crescent_Scythe":1466,
"Bill_Guisarme":1467,
"Zephyrus":1468,
"Longinus's_Spear":1469,
"Brionac":1470,
"Hell_Fire":1471,
"Staff_Of_Soul":1472,
"Wizardy_Staff":1473,
"Gae_Bolg":1474,
"Horseback_Lance":1475,
"Crescent_Scythe_":1476,
"Spectral_Spear":1477,
"Ahlspiess":1478,
"Spectral_Spear_":1479,
"Gae_Bolg_":1480,
"Zephyrus_":1481,
"BF_Lance1":1482,
"Ivory_Lance":1483,
"Cardo":1484,
"Battle_Fork":1485,
"Krieger_Twohand_Spear1":1486,
"Lance_C":1487,
"Ahlspiess_C":1488,
"Spearfish_":1489,
"Giant_Lance":1490,
"Upg_Lance":1491,
"Velum_Glaive":1492,
"Metal_Lance":1493,
"Undine_Spear":1494,
"TE_Woe_Lance":1495,
"Thanos_Long_Spear":1496,
"Hell_Fire_S":1497,
"Scarlet_Lance":1498,
"Thanos_Long_Spear_J":1499,
"Club":1501,
"Club_":1502,
"Club__":1503,
"Mace":1504,
"Mace_":1505,
"Mace__":1506,
"Smasher":1507,
"Smasher_":1508,
"Smasher__":1509,
"Flail":1510,
"Flail_":1511,
"Flail__":1512,
"Morning_Star":1513,
"Morning_Star_":1514,
"Morning_Star__":1515,
"Sword_Mace":1516,
"Sword_Mace_":1517,
"Sword_Mace__":1518,
"Chain":1519,
"Chain_":1520,
"Chain__":1521,
"Stunner":1522,
"Spike":1523,
"Golden_Mace":1524,
"Long_Mace":1525,
"Slash":1526,
"Quadrille":1527,
"Grand_Cross":1528,
"Iron_Driver":1529,
"Mjolnir":1530,
"Spanner":1531,
"Stunner_":1532,
"Warrior_Balmung":1533,
"Spanner_C":1534,
"Hollgrehenn_Hammer":1535,
"Good_Morning_Star":1536,
"Quadrille_C":1537,
"Spike_":1538,
"Golden_Mace_":1539,
"Grand_Cross_":1540,
"Nemesis":1541,
"BF_Morning_Star1":1542,
"BF_Morning_Star2":1543,
"Lunakaligo":1544,
"N_Mace":1545,
"Krieger_Onehand_Mace1":1546,
"Mace_Of_Madness":1547,
"Veteran_Hammer":1548,
"Pilebuncker":1549,
"Book":1550,
"Bible":1551,
"Tablet":1552,
"Book_Of_Billows":1553,
"Book_Of_Mother_Earth":1554,
"Book_Of_Blazing_Sun":1555,
"Book_Of_Gust_Of_Wind":1556,
"Book_Of_The_Apocalypse":1557,
"Girl's_Diary":1558,
"Legacy_Of_Dragon":1559,
"Diary_Of_Great_Sage":1560,
"Hardback":1561,
"Bible_Of_Battlefield":1562,
"Diary_Of_Great_Sage_C":1563,
"Encyclopedia":1564,
"Death_Note":1565,
"Diary_Of_Great_Basil":1566,
"Hardback_C":1567,
"Book_Of_Billows_":1568,
"Book_Of_Mother_Earth_":1569,
"Book_Of_Blazing_Sun_":1570,
"Book_Of_Gust_Of_Wind_":1571,
"Principles_Of_Magic":1572,
"Ancient_Magic":1573,
"BF_Book1":1574,
"BF_Book2":1575,
"Krieger_Book1":1576,
"Krieger_Book2":1577,
"Book_Of_Prayer":1578,
"Death_Note_M":1579,
"Encyclopedia_C":1580,
"F_Diary_Of_Great_Sage_C":1581,
"E_Diary_Of_Great_Sage_C":1582,
"P_Dic1":1583,
"Chilly_Spell_Book":1584,
"Upg_Book":1585,
"Velum_Bible":1586,
"Velum_Encyclopedia":1587,
"Metal_Book":1588,
"Legacy_Of_Dragon_":1589,
"Snake_Encyclopedia":1590,
"TE_Woe_Book":1591,
"Thor_Pedigree_Book":1592,
"Book_Of_Destiny":1593,
"Fire_Pedigree_Book":1594,
"Ice_Pedigree_Book":1595,
"Earth_Pedigree_Book":1596,
"Half_BF_Book2":1597,
"Snake_Encyclopedia_":1598,
"Angra_Manyu":1599,
"Sinister_Rod":1600,
"Rod":1601,
"Rod_":1602,
"Rod__":1603,
"Wand":1604,
"Wand_":1605,
"Wand__":1606,
"Staff":1607,
"Staff_":1608,
"Staff__":1609,
"Arc_Wand":1610,
"Arc_Wand_":1611,
"Arc_Wand__":1612,
"Mighty_Staff":1613,
"Blessed_Wand":1614,
"Bone_Wand":1615,
"Staff_Of_Wing":1616,
"Survival_Rod":1617,
"Survival_Rod_":1618,
"Survival_Rod2":1619,
"Survival_Rod2_":1620,
"Hypnotist's_Staff":1621,
"Hypnotist's_Staff_":1622,
"Mighty_Staff_C":1623,
"Lich_Bone_Wand":1624,
"Healing_Staff":1625,
"Piercing_Staff":1626,
"Staffy":1627,
"Survival_Rod_C":1628,
"Walking_Stick":1629,
"Release_Of_Wish":1630,
"Holy_Stick":1631,
"BF_Staff1":1632,
"BF_Staff2":1633,
"BF_Staff3":1634,
"BF_Staff4":1635,
"Thorn_Staff":1636,
"Eraser":1637,
"Healing_Staff_C":1638,
"N_Rod":1639,
"Krieger_Onehand_Staff1":1640,
"Krieger_Onehand_Staff2":1641,
"Staff_Of_Darkness":1642,
"Dead_Tree_Cane":1643,
"Piercing_Staff_M":1644,
"Lich_Bone_Wand_M":1645,
"La'cryma_Stick":1646,
"Croce_Staff":1647,
"Staff_Of_Bordeaux":1648,
"Rafini_Staff":1649,
"P_Staff1":1650,
"P_Staff2":1651,
"Tourist_Staff":1652,
"Staff_Of_Healing_C":1653,
"Mental_Stick":1654,
"Adventure_Staff":1655,
"Academy_Wand":1656,
"Wand_Of_Affection":1657,
"P_Staff3":1658,
"Recovery_Light":1659,
"Wand_Of_Affection2":1660,
"Mental_Destroyer":1661,
"Bone_Wand_":1662,
"Staff_Of_Bordeaux_":1663,
"Thorn_Staff_":1664,
"Piercing_Staff_":1665,
"Healing_Staff_":1666,
"TE_Woe_Staff":1667,
"Sword_Stick":1668,
"Thanos_Staff":1669,
"RWC_Memory_Staff":1670,
"Staff_Of_Evil_Slayer":1671,
"Safety_Rod":1672,
"Half_BF_Staff4":1673,
"Half_BF_Staff2":1674,
"Walking_Stick_":1675,
"Baculum_Daemonicum":1676,
"Ru_Blue_Wand":1677,
"Ru_Gold_Wand":1678,
"Rafini_Staff_S":1679,
"Scarlet_Rod":1680,
"Newbie_Foxtail":1681,
"Shadow_Staff":1682,
"Abundantly_Foxtail":1683,
"Long_Foxtail":1684,
"DragonFry_Foxtail":1685,
"BigSize_Foxtail":1686,
"Beginner_FoxTail":1687,
"Staff_of_Trust":1688,
"Staff_of_Trust2":1689,
"Amazing_Foxtail":1690,
"Strange_Foxtail":1691,
"Magical_Foxtail":1692,
"Magical_Y_Foxtail":1693,
"Model_Foxtail":1694,
"Detail_Model_Foxtail":1695,
"Ex_Model_Foxtail":1696,
"Ex_Y_Model_Foxtail":1697,
"Thanos_Staff_J":1698,
"P_Foxtail1":1699,
"Bow":1701,
"Bow_":1702,
"Bow__":1703,
"Composite_Bow":1704,
"Composite_Bow_":1705,
"Composite_Bow__":1706,
"Great_Bow":1707,
"Great_Bow_":1708,
"Great_Bow__":1709,
"CrossBow":1710,
"CrossBow_":1711,
"CrossBow__":1712,
"Arbalest":1713,
"Kakkung":1714,
"Arbalest_":1715,
"Kakkung_":1716,
"Hunter_Bow":1718,
"Bow_Of_Roguemaster":1719,
"Bow_Of_Rudra":1720,
"Repeting_CrossBow":1721,
"Balistar":1722,
"Luna_Bow":1723,
"Dragon_Wing":1724,
"Bow_Of_Minstrel":1725,
"Hunter_Bow_":1726,
"Balistar_":1727,
"Balistar_C":1728,
"Bow_Of_Rudra_C":1729,
"Burning_Bow":1730,
"Frozen_Bow":1731,
"Earth_Bow":1732,
"Gust_Bow":1733,
"Orc_Archer_Bow":1734,
"Kkakkung":1735,
"Double_Bound":1736,
"Ixion_Wing":1737,
"BF_Bow1":1738,
"BF_Bow2":1739,
"Nepenthes_Bow":1740,
"Cursed_Lyre":1741,
"N_Composite_Bow":1742,
"Krieger_Bow1":1743,
"Bow_Of_Evil":1744,
"Falken_Blitz":1745,
"Elven_Bow":1746,
"P_Bow1":1747,
"P_Bow2":1748,
"Tourist_Bow":1749,
"Arrow":1750,
"Silver_Arrow":1751,
"Fire_Arrow":1752,
"Steel_Arrow":1753,
"Crystal_Arrow":1754,
"Arrow_Of_Wind":1755,
"Stone_Arrow":1756,
"Immatrial_Arrow":1757,
"Stun_Arrow":1758,
"Freezing_Arrow":1759,
"Flash_Arrow":1760,
"Curse_Arrow":1761,
"Rusty_Arrow":1762,
"Poison_Arrow":1763,
"Incisive_Arrow":1764,
"Oridecon_Arrow":1765,
"Arrow_Of_Counter_Evil":1766,
"Arrow_Of_Shadow":1767,
"Sleep_Arrow":1768,
"Silence_Arrow":1769,
"Iron_Arrow":1770,
"Venom_Knife":1771,
"Holy_Arrow":1772,
"Arrow_Of_Elf":1773,
"Hunting_Arrow":1774,
"Siege_Arrow_S":1775,
"Siege_Arrow_A":1776,
"Sinister_Fist":1800,
"Waghnakh":1801,
"Waghnakh_":1802,
"Knuckle_Duster":1803,
"Knuckle_Duster_":1804,
"Hora":1805,
"Hora_":1806,
"Fist":1807,
"Fist_":1808,
"Claw":1809,
"Claw_":1810,
"Finger":1811,
"Finger_":1812,
"Kaiser_Knuckle":1813,
"Berserk":1814,
"Claw_Of_Garm":1815,
"Berserk_":1816,
"Kaiser_Knuckle_C":1817,
"Magma_Fist":1818,
"Icicle_Fist":1819,
"Electric_Fist":1820,
"Seismic_Fist":1821,
"Combo_Battle_Glove":1822,
"BF_Knuckle1":1823,
"BF_Knuckle2":1824,
"Horn_Of_Hilthrion":1825,
"Krieger_Knuckle1":1826,
"Krieger_Knuckle2":1827,
"Monk_Knuckle":1828,
"Fist_C":1829,
"Sura_Rampage":1830,
"P_Knuckle1":1831,
"Velum_Claw":1832,
"Claw_Of_Flash":1833,
"TE_Woe_Fist":1834,
"Spartacus":1835,
"Thanos_Knuckle":1836,
"Iron_nail":1837,
"Half_BF_Knuckle1":1838,
"Scarlet_Knuckle":1839,
"Thanos_Knuckle_J":1840,
"Claw_Of_Flash_":1841,
"Diva_Claw":1842,
"Mirage_Claw":1843,
"Sinister_Fist_J":1844,
"Probation_Knuckle":1845,
"Combo_Battle_Glove_IL":1846,
"Iron_Nail_K":1847,
"Rebeginer_SR_Nuckle":1848,
"Local01_Claw":1857,
"Local02_Claw":1858,
"Woe_Pist1_Z":1859,
"Variant_Claw":1861,
"Burning_Knuckle_OS":1862,
"Evt_Iron_Nail_K":1864,
"Combo_Fist":1865,
"Asura_Bandage":1866,
"Ein_1HKNUCK":1867,
"Combo_Fist_J":1868,
"Asura_Bandage_J":1869,
"R_Knuckle":1870,
"Bauxite_Knuckle_EXE":1871,
"Knuckle_Of_Infinite":1872,
"Comp_Iron_Nail_K":1873,
"Sinister_Viollin":1900,
"Violin":1901,
"Violin_":1902,
"Mandolin":1903,
"Mandolin_":1904,
"Lute":1905,
"Lute_":1906,
"Guitar":1907,
"Guitar_":1908,
"Harp":1909,
"Harp_":1910,
"Guh_Moon_Goh":1911,
"Guh_Moon_Goh_":1912,
"Electronic_Guitar":1913,
"Guitar_Of_Passion":1914,
"Guitar_Of_Blue_Solo":1915,
"Guitar_Of_Vast_Land":1916,
"Guitar_Of_Gentle_Breeze":1917,
"Oriental_Lute":1918,
"Base_Guitar":1919,
"Berserk_Guitar":1920,
"Guh_Moon_Gom":1921,
"Oriental_Lute_":1922,
"BF_Instrument1":1923,
"BF_Instrument2":1924,
"Cello":1925,
"Harp_Of_Nepenthes":1926,
"Krieger_Instrument1":1927,
"Berserk_Guitar_I":1928,
"Guitar_C":1929,
"Green_Whistle":1930,
"P_String_Inst1":1931,
"TE_Woe_Guitar":1932,
"Thanos_Violin":1933,
"Contabass":1934,
"Ukulele_Of_Newoz":1935,
"Ru_Blue_Violin":1936,
"Ru_Gold_Violin":1937,
"Viollin_Of_Infinite":1938,
"Scarlet_Viollin":1939,
"Trumpet_Shell":1940,
"Union_Viollin":1941,
"Thanos_Violin_J":1942,
"Erhu":1943,
"Hippie_Guitar":1944,
"Diva_Viollin":1945,
"Mirage_Viollin":1946,
"Sinister_Viollin_J":1947,
"Hippie_Guitar_J":1948,
"2nd_Job_Weapon12":1949,
"Rope":1950,
"Rope_":1951,
"Line":1952,
"Line_":1953,
"Wire":1954,
"Wire_":1955,
"Rante":1956,
"Rante_":1957,
"Tail":1958,
"Tail_":1959,
"Whip":1960,
"Whip_":1961,
"Lariat":1962,
"Rapture_Rose":1963,
"Chemeti":1964,
"Whip_Of_Red_Flame":1965,
"Whip_Of_Ice_Piece":1966,
"Whip_Of_Earth":1967,
"Jump_Rope":1968,
"Bladed_Whip":1969,
"Queen's_Whip":1970,
"Electric_Wire":1971,
"Electric_Eel":1972,
"Sea_Witch_Foot":1973,
"Carrot_Whip":1974,
"Queen_Is_Whip":1975,
"Queen's_Whip_":1976,
"BF_Whip1":1977,
"BF_Whip2":1978,
"Stem_Of_Nepenthes":1979,
"Whip_Of_Balance":1980,
"Krieger_Whip1":1981,
"Phenomena_Whip":1982,
"Rante_C":1983,
"Stem_Whip":1984,
"Rosebine":1985,
"P_Tail1":1986,
"TE_Woe_Rope":1987,
"Thanos_Whip":1988,
"Gymnastics_Ribbon":1989,
"Floral_Mic_Of_Igu":1990,
"Ru_Blue_Whip":1991,
"Ru_Gold_Whip":1992,
"Concertina_Wire":1993,
"Whip_Of_Infinite":1994,
"Scarlet_Wire":1995,
"Sinister_Wire":1996,
"Union_Wire":1997,
"Thanos_Whip_J":1998,
"Moonlight_Bell":1999,
"Destruction_Rod":2000,
"Divine_Cross":2001,
"Krieger_Twohand_Staff1":2002,
"Destruction_Rod_M":2003,
"Kronos":2004,
"Dea_Staff":2005,
"G_Staff_Of_Light":2006,
"Golden_Rod_Staff":2007,
"Aqua_Staff":2008,
"Crimson_Staff":2009,
"Forest_Staff":2010,
"Golden_Rod_Staff2":2011,
"Aqua_Staff2":2012,
"Crimson_Staff2":2013,
"Forest_Staff2":2014,
"Upg_Staff":2015,
"Velum_Arc_Wand":2016,
"Divine_Cross_":2017,
"Metal_Staff":2018,
"TE_Woe_Two_Hand_Staff":2019,
"Jormungand":2020,
"Ganbantein":2021,
"Staff_Of_Geffen":2022,
"Thanos_Rod":2023,
"D_Staff_Of_Infinite":2024,
"Scarlet_Staff":2025,
"Sinister_Staff":2026,
"Staff_170":2027,
"Aion_Staff":2028,
"TStaff_Of_E_Slayer_J":2029,
"Union_Twohand_Staff":2030,
"Tw_Staff_Of_Malang_J":2031,
"Thanos_Rod_J":2032,
"Toughen_Metal_Staff":2033,
"Avenger_Wizardy_Staff":2034,
"Diva_Staff":2035,
"Mirage_Staff":2036,
"Sinister_Staff_J":2037,
"Staff_170_J":2038,
"Wizardy_Staff_IL":2039,
"Probation_Staff":2040,
"Jirant_Staff":2041,
"Neev_Wizardy_Staff":2042,
"Neev_Arc_Wand":2043,
"Neev_Holy_Stick":2044,
"Neev_Divine_Cross":2045,
"Rebeginer_WL_Staff":2046,
"Jirant_Staff_BR":2047,
"Iron_Staff":2048,
"Staff_Of_Blue_Flame":2049,
"2nd_Job_Weapon8":2050,
"Survival_Staff_IL":2051,
"Woe_T_Staff1_Z":2052,
"Variant_Staff":2053,
"Evt_Iron_Staff":2054,
"Staff_Of_Miracle":2055,
"Gravitation_Staff":2056,
"Adorare_Staff":2057,
"Ein_BHSTAFF":2058,
"Survival_Staff_IL_J":2059,
"R_Magician_Staff":2060,
"Staff_Of_Miracle_J":2061,
"Gravitation_Staff_J":2062,
"Adorare_Staff_J":2063,
"Comp_Iron_Staff":2064,
"Guard":2101,
"Guard_":2102,
"Buckler":2103,
"Buckler_":2104,
"Shield":2105,
"Shield_":2106,
"Mirror_Shield":2107,
"Mirror_Shield_":2108,
"Memorize_Book":2109,
"Holy_Guard":2110,
"Herald_Of_GOD":2111,
"Novice_Guard":2112,
"Novice_Shield":2113,
"Stone_Buckler":2114,
"Valkyrja's_Shield":2115,
"Angel's_Safeguard":2116,
"Arm_Guard":2117,
"Arm_Guard_":2118,
"Improved_Arm_Guard":2119,
"Improved_Arm_Guard_":2120,
"Memorize_Book_":2121,
"Platinum_Shield":2122,
"Orleans_Server":2123,
"Thorny_Buckler":2124,
"Strong_Shield":2125,
"Guyak_Shield":2126,
"Secular_Mission":2127,
"Herald_Of_GOD_":2128,
"Exorcism_Bible":2129,
"Cross_Shield":2130,
"Magic_Study_Vol1":2131,
"Shelter_Resistance":2132,
"Tournament_Shield":2133,
"Shield_Of_Naga":2134,
"Shadow_Guard":2135,
"Cracked_Buckler":2136,
"Valkyrja's_Shield_C":2137,
"Bradium_Shield":2138,
"Flame_Thrower":2139,
"Energy_Rune_Guard":2140,
"Freyja_SShield7":2141,
"Freyja_SShield30":2142,
"Freyja_SShield60":2143,
"Freyja_SShield90":2144,
"Time_Keepr_Shield":2145,
"Siver_Guard":2146,
"Round_Buckler":2147,
"Rotha_Shield":2148,
"Upg_Guard":2149,
"Upg_Buckler":2150,
"Upg_Shield":2151,
"Anti_Demon_Shield_C":2152,
"Imperial_Guard":2153,
"Toy_Shield":2154,
"Academy_Shield":2155,
"Bible_Of_Promise1":2156,
"Insecticide":2157,
"Ramor_Shield_Undead":2158,
"Sharel_Shield":2159,
"Giant_Shield":2160,
"Geffenia_Book_Water":2161,
"Bible_Of_Promise2":2162,
"Flow_Shield":2163,
"Sombre_Shield":2164,
"Sol_Shield":2165,
"Exorcism_Bible_":2166,
"Poison_Shield":2167,
"Immuned_Shield":2168,
"Kalasak":2169,
"Bayani_Kalasak":2170,
"Fox_Armguard":2171,
"Wolf_Armguard":2172,
"Crescent_Armguard":2173,
"Lumiere_Shield":2174,
"Esprit_Shield":2175,
"Dark_Book":2176,
"Shield_Of_Death":2177,
"TE_Woe_Buckler":2178,
"TE_Woe_Shield":2179,
"TE_Woe_Magic_Guard":2180,
"Hervor":2181,
"Hervor_Alvitr":2182,
"Impr_Angel's_Safeguard":2183,
"Bunker_Shield":2184,
"Magic_Reflector":2185,
"Encyclopedia_Revision":2186,
"Shield_Of_Gray":2187,
"Svalinn_J":2188,
"Mad_Bunny":2189,
"Ancient_Shield_Of_Aeon":2190,
"Solomon_Key":2191,
"Rose_Of_Eden":2192,
"Fallen_Angel_Shield":2193,
"Rouban_Shield":2194,
"Lian_Shield":2195,
"White_Gold_Shield":2196,
"Iron_Shield":2197,
"Lapine_Shield":2198,
"Ahura_Mazda":2199,
"Sunglasses":2201,
"Sunglasses_":2202,
"Glasses":2203,
"Glasses_":2204,
"Diver's_Goggles":2205,
"Wedding_Veil":2206,
"Fancy_Flower":2207,
"Ribbon":2208,
"Ribbon_":2209,
"Hair_Band":2210,
"Bandana":2211,
"Eye_Bandage":2212,
"Cat_Hairband":2213,
"Bunny_Band":2214,
"Flower_Hairband":2215,
"Biretta":2216,
"Biretta_":2217,
"Flu_Mask":2218,
"Flu_Mask_":2219,
"Hat":2220,
"Hat_":2221,
"Turban":2222,
"Turban_":2223,
"Goggle":2224,
"Goggle_":2225,
"Cap":2226,
"Cap_":2227,
"Helm":2228,
"Helm_":2229,
"Gemmed_Sallet":2230,
"Gemmed_Sallet_":2231,
"Circlet":2232,
"Circlet_":2233,
"Tiara":2234,
"Crown":2235,
"Santa's_Hat":2236,
"Weird_Goatee":2237,
"Weird_Moustache":2238,
"One_Eyed_Glass":2239,
"Beard":2240,
"Granpa_Beard":2241,
"Luxury_Sunglasses":2242,
"Spinning_Eyes":2243,
"Big_Sis'_Ribbon":2244,
"Sweet_Gents":2245,
"Golden_Gear":2246,
"Oldman's_Romance":2247,
"Western_Grace":2248,
"Coronet":2249,
"Fillet":2250,
"Holy_Bonnet":2251,
"Star_Sparkling":2252,
"Sunflower":2253,
"Angelic_Chain":2254,
"Satanic_Chain":2255,
"Magestic_Goat":2256,
"Snowy_Horn":2257,
"Sharp_Gear":2258,
"Mini_Propeller":2259,
"Mini_Glasses":2260,
"Prontera_Army_Cap":2261,
"Pierrot_Nose":2262,
"Gangster_Patch":2263,
"Munak_Turban":2264,
"Ganster_Mask":2265,
"Iron_Cane":2266,
"Cigar":2267,
"Smoking_Pipe":2268,
"Centimental_Flower":2269,
"Centimental_Leaf":2270,
"Jack_A_Dandy":2271,
"Stop_Post":2272,
"Doctor_Cap":2273,
"Ghost_Bandana":2274,
"Red_Bandana":2275,
"Eagle_Eyes":2276,
"Nurse_Cap":2277,
"Mr_Smile":2278,
"Bomb_Wick":2279,
"Sahkkat":2280,
"Phantom_Of_Opera":2281,
"Spirit_Chain":2282,
"Ear_Mufs":2283,
"Antler":2284,
"Apple_Of_Archer":2285,
"Elven_Ears":2286,
"Pirate_Bandana":2287,
"Mr_Scream":2288,
"Poo_Poo_Hat":2289,
"Funeral_Costume":2290,
"Masquerade":2291,
"Welding_Mask":2292,
"Pretend_Murdered":2293,
"Star_Dust":2294,
"Blinker":2295,
"Binoculars":2296,
"Goblini_Mask":2297,
"Green_Feeler":2298,
"Viking_Helm":2299,
"Cotton_Shirt":2301,
"Cotton_Shirt_":2302,
"Leather_Jacket":2303,
"Leather_Jacket_":2304,
"Adventure_Suit":2305,
"Adventurere's_Suit_":2306,
"Mantle":2307,
"Mantle_":2308,
"Coat":2309,
"Coat_":2310,
"Mink_Coat":2311,
"Padded_Armor":2312,
"Padded_Armor_":2313,
"Chain_Mail":2314,
"Chain_Mail_":2315,
"Plate_Armor":2316,
"Plate_Armor_":2317,
"Clothes_Of_The_Lord":2318,
"Glittering_Clothes":2319,
"Formal_Suit":2320,
"Silk_Robe":2321,
"Silk_Robe_":2322,
"Scapulare":2323,
"Scapulare_":2324,
"Saint_Robe":2325,
"Saint_Robe_":2326,
"Holy_Robe":2327,
"Wooden_Mail":2328,
"Wooden_Mail_":2329,
"Tights":2330,
"Tights_":2331,
"Silver_Robe":2332,
"Silver_Robe_":2333,
"Mage_Coat":2334,
"Thief_Clothes":2335,
"Thief_Clothes_":2336,
"Ninja_Suit":2337,
"Wedding_Dress":2338,
"G_Strings":2339,
"Novice_Breast":2340,
"Full_Plate_Armor":2341,
"Full_Plate_Armor_":2342,
"Robe_Of_Casting":2343,
"Flame_Sprits_Armor":2344,
"Flame_Sprits_Armor_":2345,
"Water_Sprits_Armor":2346,
"Water_Sprits_Armor_":2347,
"Wind_Sprits_Armor":2348,
"Wind_Sprits_Armor_":2349,
"Earth_Sprits_Armor":2350,
"Earth_Sprits_Armor_":2351,
"Novice_Plate":2352,
"Odin's_Blessing":2353,
"Goibne's_Armor":2354,
"Angel's_Protection":2355,
"Vestment_Of_Grace":2356,
"Valkyrie_Armor":2357,
"Dress_Of_Angel":2358,
"Ninja_Suit_":2359,
"Robe_Of_Casting_":2360,
"Blue_Aodai":2361,
"Red_Aodai":2362,
"White_Aodai":2363,
"Meteo_Plate_Armor":2364,
"Orleans_Gown":2365,
"Divine_Cloth":2366,
"Sniping_Suit":2367,
"Golden_Armor":2368,
"Freyja_Overcoat":2369,
"Used_Mage_Coat":2370,
"G_Strings_":2371,
"Mage_Coat_":2372,
"Holy_Robe_":2373,
"Diabolus_Robe":2374,
"Diabolus_Armor":2375,
"Assaulter_Plate":2376,
"Elite_Engineer_Armor":2377,
"Assassin_Robe":2378,
"Warlock_Battle_Robe":2379,
"Medic_Robe":2380,
"Elite_Archer_Suit":2381,
"Elite_Shooter_Suit":2382,
"Brynhild":2383,
"Spritual_Tunic":2384,
"Recuperative_Armor":2385,
"Chameleon_Armor":2386,
"Sprint_Mail":2387,
"Kandura":2388,
"Armor_Of_Naga":2389,
"Improved_Tights":2390,
"Life_Link":2391,
"Old_Pant":2392,
"N_Adventurer's_Suit":2393,
"Krieger_Suit1":2394,
"Krieger_Suit2":2395,
"Krieger_Suit3":2396,
"Incredible_Coat":2397,
"Sniping_Suit_M":2398,
"Dragon_Vest":2399,
"Pollux_Shoes_J":2400,
"Sandals":2401,
"Sandals_":2402,
"Shoes":2403,
"Shoes_":2404,
"Boots":2405,
"Boots_":2406,
"Chrystal_Pumps":2407,
"Cuffs":2408,
"Spiky_Heel":2409,
"Sleipnir":2410,
"Grave":2411,
"Grave_":2412,
"Safty_Boots":2413,
"Novice_Boots":2414,
"Slipper":2415,
"Novice_Shoes":2416,
"Fricco_Shoes":2417,
"Vidar's_Boots":2418,
"Goibne's_Combat_Boots":2419,
"Angel's_Arrival":2420,
"Valkyrie_Shoes":2421,
"High_Fashion_Sandals":2422,
"Variant_Shoes":2423,
"Tidal_Shoes":2424,
"Black_Leather_Boots":2425,
"Shadow_Walk":2426,
"Golden_Shoes":2427,
"Freyja_Boots":2428,
"Iron_Boots01":2429,
"Iron_Boots02":2430,
"Valley_Shoes":2431,
"Spiky_Heel_":2432,
"Diabolus_Boots":2433,
"Black_Leather_Boots_":2434,
"Battle_Greave":2435,
"Combat_Boots":2436,
"Battle_Boots":2437,
"Paw_Of_Cat":2438,
"Refresh_Shoes":2439,
"Sprint_Shoes":2440,
"Beach_Sandal":2441,
"Boots_Perforated":2442,
"Fish_Shoes":2443,
"Krieger_Shoes1":2444,
"Krieger_Shoes2":2445,
"Krieger_Shoes3":2446,
"Military_Boots":2447,
"Air_Boss":2448,
"Variant_Shoes_M":2449,
"Vital_Tree_Shoes":2450,
"Freyja_SSandal7":2451,
"Freyja_SSandal30":2452,
"Freyja_SSandal60":2453,
"Freyja_SSandal90":2454,
"Time_Keepr_Boots":2455,
"Para_Team_Boots1":2456,
"Para_Team_Boots2":2457,
"Para_Team_Boots3":2458,
"Upg_Shoes":2459,
"Upg_Boots":2460,
"Upg_Greave":2461,
"Sleipnir_C":2462,
"Feral_Boots":2463,
"No_Fear_Shoes":2464,
"Dance_Shoes":2465,
"Training_Shoes":2466,
"Golden_Rod_Shoes":2467,
"Aqua_Shoes":2468,
"Crimson_Shoes":2469,
"Forest_Shoes":2470,
"Shoes_Of_Affection":2471,
"Shoes_Of_Judgement":2472,
"Para_Team_Boots4":2473,
"Lehmannza_Shoes":2474,
"Ur_Greave":2475,
"Peuz_Greave":2476,
"Sabah_Shoes":2477,
"Nab_Shoes":2478,
"White_Wing_Boots":2479,
"Black_Wing_Boots":2480,
"Rune_Boots":2481,
"Shoes_Of_Valor":2482,
"Siege_Greave":2483,
"Siege_Boots":2484,
"Siege_Shoes":2485,
"Shadow_Walk_":2486,
"Vital_Tree_Shoes_":2487,
"Fricco_Shoes_":2488,
"Vidar's_Boots_":2489,
"Rune_Boots_":2490,
"Bangungot_Boots":2491,
"Bayani_Bangungot_Boots":2492,
"Goibne_Combat_Boots_":2493,
"Chrystal_Pumps_":2494,
"Egir_Shoes":2495,
"TE_Woe_Shoes":2496,
"TE_Woe_Boots":2497,
"TE_Woe_Magic_Sandal":2498,
"Temporal_Boots":2499,
"Hood":2501,
"Hood_":2502,
"Muffler":2503,
"Muffler_":2504,
"Manteau":2505,
"Manteau_":2506,
"Cape_Of_Ancient_Lord":2507,
"Ragamuffin_Cape":2508,
"Clack_Of_Servival":2509,
"Novice_Hood":2510,
"Skeleton's_Cape":2511,
"Novice_Manteau":2512,
"Celestial_Robe":2513,
"Pauldron":2514,
"Wing_Of_Eagle":2515,
"Falcon_Robe":2516,
"Vali's_Manteau":2517,
"Morpheus's_Shawl":2518,
"Morrigane's_Manteau":2519,
"Goibne's_Shoulder_Arms":2520,
"Angel's_Warmth":2521,
"Undershirt":2522,
"Undershirt_":2523,
"Valkyrie_Manteau":2524,
"Cape_Of_Ancient_Lord_":2525,
"Dragon_Scale_Coat":2526,
"Dragon_Breath":2527,
"Wool_Scarf":2528,
"Rider_Insignia":2529,
"Rider_Insignia_":2530,
"Ulfhedinn":2531,
"Mithril_Magic_Cape":2532,
"Freyja_Cape":2533,
"Ruffler":2534,
"Cloak_Of_Survival_C":2535,
"Skin_Of_Ventus":2536,
"Diabolus_Manteau":2537,
"Commander_Manteau":2538,
"Commander_Manteau_":2539,
"Sheriff_Manteau":2540,
"Asprika":2541,
"Flame_Manteau":2542,
"Sylphid_Manteau":2543,
"Leather_Of_Tendrilion":2544,
"Musika":2545,
"Beach_Manteau":2546,
"Cheap_Running_Shirts":2547,
"Muffler_C":2548,
"Krieger_Muffler1":2549,
"Fisher's_Muffler":2550,
"Rider_Insignia_M":2551,
"Mithril_Magic_Cape_M":2552,
"Dragon_Manteau":2553,
"Piece_Of_Angent_Skin":2554,
"Freyja_SScarf7":2555,
"Freyja_SScarf30":2556,
"Freyja_SScarf60":2557,
"Freyja_SScarf90":2558,
"Time_Keepr_Manteau":2559,
"Para_Team_Manteau":2560,
"Upg_Hood":2561,
"Upg_Muffler":2562,
"Upg_Manteau":2563,
"Feral_Tail":2564,
"Beach_Towel":2565,
"Half_Asprika":2566,
"Academy_Manteau":2567,
"Muffler_Of_Roki":2568,
"Shawl_Of_Affection":2569,
"Shawl_Of_Judgement":2570,
"Para_Team_Manteau2":2571,
"Katabart_Sholder":2572,
"Archangel_Wing":2573,
"Ur_Manteau":2574,
"Peuz_Manteau":2575,
"Bravery_Bag":2576,
"Sabah_Hood":2577,
"Nab_Hood":2578,
"Magic_Stole":2579,
"White_Wing_Manteau":2580,
"Black_Wing_Manteau":2581,
"Salvage_Cape":2582,
"Holy_Cape":2583,
"Wanderer_Outer":2584,
"Muffler_Of_Valor":2585,
"Siege_Manteau":2586,
"Siege_Muffler":2587,
"Ragamuffin_Cape_":2588,
"Fallen_Angel_Wing":2589,
"Buwaya_Cloth":2590,
"Bayani_Buwaya_Cloth":2591,
"Boss_Domovoi_Cape":2592,
"Flow_Manteau":2593,
"Wrapping_Manteau":2594,
"Sombre_Manteau":2595,
"Sharel_Manteau":2596,
"Scarlet_Poncho":2597,
"Ramor_Manteau":2598,
"Goibne_Shoulder_Arms_":2599,
"Ring":2601,
"Earring":2602,
"Necklace":2603,
"Glove":2604,
"Brooch":2605,
"Whike_Black_Tail_L":2606,
"Clip":2607,
"Rosary":2608,
"Skul_Ring":2609,
"Gold_Ring":2610,
"Silver_Ring":2611,
"Flower_Ring":2612,
"Diamond_Ring":2613,
"An_Eye_Of_Dullahan":2614,
"Safety_Ring":2615,
"Critical_Ring":2616,
"Mitten_Of_Presbyter":2617,
"Matyr's_Flea_Guard":2618,
"Thimble_Of_Archer":2619,
"Ring_Of_Rogue":2620,
"Ring_":2621,
"Earring_":2622,
"Necklace_":2623,
"Glove_":2624,
"Brooch_":2625,
"Rosary_":2626,
"Belt":2627,
"Novice_Armlet":2628,
"Magingiorde":2629,
"Brysinggamen":2630,
"First_Age_Ring":2631,
"Korean_Trinket":2632,
"Jade_Ring":2633,
"Bridegroom_Ring":2634,
"Bride_Ring":2635,
"Gold_Ring_":2636,
"Silver_Ring_":2637,
"Exorcize_Sachet":2638,
"Purification_Sachet":2639,
"Kafra_Ring":2640,
"Fashionable_Sack":2641,
"Serin's_Gold_Ring":2642,
"Serin's_Gold_Ring_":2643,
"The_Sign_":2644,
"Moonlight_Ring":2645,
"Bunch_Of_Carnation":2646,
"Nile_Rose":2647,
"Morpheus's_Ring":2648,
"Morpheus's_Armlet":2649,
"Morrigane's_Belt":2650,
"Morrigane's_Pendant":2651,
"Cursed_Lucky_Brooch":2652,
"Sacrifice_Ring":2653,
"Shinobi's_Sash":2654,
"Bloody_Iron_Ball":2655,
"Hyper_Changer":2656,
"Lab_Passport":2657,
"Nile_Rose_":2658,
"Vesper_Core01":2659,
"Vesper_Core02":2660,
"Vesper_Core03":2661,
"Vesper_Core04":2662,
"Gauntlet_Of_Accuracy":2663,
"Scarf_Belt":2664,
"Ring_Of_Exorcism":2665,
"Lamp_Of_Hope":2666,
"Glove_Of_Archer":2667,
"Women's_Glory":2668,
"Golden_Necklace_":2669,
"Ring_Of_Longing":2670,
"Thimble_Of_Archer_":2671,
"Anniversary_Ring":2672,
"Shining_Ring":2673,
"Honor_Ring":2674,
"Lord_Ring":2675,
"Hunter_Earring":2676,
"Spiritual_Ring":2677,
"Ring_Of_Flame_Lord":2678,
"Ring_Of_Resonance":2679,
"Lesser_Elemental_Ring":2680,
"Republic_Ring":2681,
"Ring_Of_Water":2682,
"Ring_Of_Fire":2683,
"Ring_Of_Wind":2684,
"Ring_Of_Earth":2685,
"Elven_Ears_C":2686,
"Steel_Flower_C":2687,
"Critical_Ring_C":2688,
"Earring_C":2689,
"Ring_C":2690,
"Necklace_C":2691,
"Glove_C":2692,
"Brooch_C":2693,
"Rosary_C":2694,
"Safety_Ring_C":2695,
"Vesper_Core01_C":2696,
"Vesper_Core02_C":2697,
"Vesper_Core03_C":2698,
"Vesper_Core04_C":2699,
"Red_Silk_Seal":2700,
"Orleans_Glove":2701,
"Bison_Horn":2702,
"Expert_Ring":2703,
"Golden_Accessory":2704,
"Golden_Accessory2":2705,
"Handcuff":2706,
"GUSLI":2707,
"Chinese_Handicraft":2708,
"5_Anniversary_Coin":2709,
"Bloody_Iron_Ball_C":2710,
"Spiritual_Ring_C":2711,
"Ragnarok_Limited_Ed":2712,
"Certificate_TW":2713,
"Marvelous_Pandent":2714,
"Skul_Ring_":2715,
"Librarian_Glove":2716,
"Pocket_Watch_":2717,
"Lunatic_Brooch":2718,
"Iron_Wrist":2719,
"Medal_Swordman":2720,
"Medal_Thief":2721,
"Medal_Acolyte":2722,
"Medal_Mage":2723,
"Medal_Archer":2724,
"Medal_Merchant":2725,
"Icarus_Wing":2726,
"Bowman_Scarf":2727,
"Cursed_Hand":2728,
"Diabolus_Ring":2729,
"Morroc_Seal":2730,
"Morroc_Charm_Stone":2731,
"Morroc_Ring":2732,
"Medal_Gunner":2733,
"Directive_A":2734,
"Directive_B":2735,
"Navel_Ring":2736,
"Foot_Ring":2737,
"Shiny_Coin":2738,
"Ordinary_Coin":2739,
"Rusty_Coin":2740,
"All_In_One_Ring":2741,
"Lucky_Clip":2742,
"Angelic_Ring":2743,
"Sprint_Ring":2744,
"Pinguicula_Corsage":2745,
"Cold_Heart":2746,
"Black_Cat":2747,
"Cursed_Star":2748,
"Linen_Glove":2749,
"Summer_Night_Dream":2750,
"Academy_Badge":2751,
"Praxinus_C":2752,
"Beholder_Ring":2753,
"Hallow_Ring":2754,
"Clamorous_Ring":2755,
"Chemical_Ring":2756,
"Insecticide_Ring":2757,
"Fisher_Ring":2758,
"Decussate_Ring":2759,
"Bloody_Ring":2760,
"Satanic_Ring":2761,
"Dragoon_Ring":2762,
"Skul_Ring_C":2763,
"Small_Fishing_Rod":2764,
"Novice_Figure":2765,
"Swordman_Figure":2766,
"Acolyte_Figure":2767,
"Mage_Figure":2768,
"Archer_Figure":2769,
"Thief_Figure":2770,
"Merchant_Figure":2771,
"Krieger_Ring1":2772,
"Krieger_Ring2":2773,
"Krieger_Ring3":2774,
"Lure":2775,
"Cool_Towel":2776,
"Shaman_Ring":2777,
"Shaman_Earing":2778,
"Dark_Knight_Belt":2779,
"Dark_Knight_Glove":2780,
"Aumdura's_Grace":2781,
"Ring_Of_Wise_King":2782,
"Eyes_Stone_Ring":2783,
"Oh_Holy_Night":2784,
"Orleans_Glove_M":2785,
"Spiritual_Ring_M":2786,
"Waterdrop_Brooch":2787,
"Bradium_Earing":2788,
"Bradium_Ring":2789,
"Bradium_Brooch":2790,
"Just_Got_Fish":2791,
"Ring_Of_Flame_Lord_I":2792,
"Ring_Of_Resonance_I":2793,
"Magic_Stone_Ring":2794,
"Green_Apple_Ring":2795,
"Magical_Stone":2796,
"Magical_Stone_":2797,
"Will_Of_Exhausted_Angel":2798,
"Kuirpenring":2799,
"Accelerator":2800,
"Hovering_Booster":2801,
"Suicidal_Device":2802,
"Shape_Shifter":2803,
"Cooling_Device":2804,
"Mag_Field_Generator":2805,
"Barrier_Builder":2806,
"Repair_Kit":2807,
"Camouflage_Generator":2808,
"High_Quality_Cooler":2809,
"Special_Cooler":2810,
"Freyja_SBracelet7":2811,
"Freyja_SBracelet30":2812,
"Freyja_SBracelet60":2813,
"Freyja_SBracelet90":2814,
"Th_Ring_Of_Water":2815,
"Radar_Ring1":2816,
"Radar_Ring2":2817,
"Radar_Ring3":2818,
"Swordman_Manual":2819,
"Thief_Manual":2820,
"Acolyte_Manual":2821,
"Archer_Manual":2822,
"Merchant_Manual":2823,
"Mage_Manual":2824,
"Shaman_EaringB":2825,
"Dark_Knight_BeltB":2826,
"Dark_Knight_GloveB":2827,
"Upg_Clip":2828,
"Greed_Clip":2829,
"Magingiorde_C":2830,
"Brysinggamen_C":2831,
"Freyja_Ring":2832,
"Odin's_Recall":2833,
"F_All_In_One_Ring":2834,
"F_Critical_Ring_C":2835,
"F_Glove_C":2836,
"F_Safety_Ring_C":2837,
"F_Necklace_C":2838,
"F_Ring_C":2839,
"F_Rosary_C":2840,
"Caracas_Ring":2841,
"F_Earing_C":2842,
"Gold_Trickle":2843,
"El_Dicastes_Light":2844,
"No_Fear_Belt":2845,
"E_All_In_One_Ring":2846,
"E_Critical_Ring_C":2847,
"E_Glove_C":2848,
"E_Safety_Ring_C":2849,
"E_Ring_C":2850,
"E_Necklace_C":2851,
"E_Rosary_C":2852,
"Telekinetic_Orb":2853,
"Alchemy_Glove":2854,
"Whike_Black_Tail":2855,
"Half_Megin":2856,
"Half_Brysing":2857,
"Pendant_Of_Guardian":2858,
"Golden_Rod_Orb":2859,
"Aqua_Orb":2860,
"Crimson_Orb":2861,
"Forest_Orb":2862,
"Ring_Of_Valkyrie":2863,
"Light_Of_Cure":2864,
"Seal_Of_Cathedral":2865,
"Ring_Of_Archbishop":2866,
"Broken_Bamboo_Piece":2867,
"Green_Batik":2868,
"Colorful_Ketupat":2869,
"Tw_8th_Anni_Ring":2870,
"Brazilian_Emblem":2871,
"G_Honor_Certificate":2872,
"Cat_Hand_Glove":2873,
"Buffalo_Horn":2874,
"RO_Appreciation_Ring":2875,
"Necklace_Spica":2876,
"Glove_Sabik":2877,
"Bracelet_Arunairi":2878,
"Badge_Giorredart":2879,
"Ring_Lupak":2880,
"Orleans_Necklace":2881,
"Ecoro_Cardslip":2882,
"Ur_Seal":2883,
"Peuz_Seal":2884,
"Mother_Heart":2885,
"Sabah_Ring":2886,
"Nab_Ring":2887,
"School_Bag":2888,
"Endure_Ring":2889,
"White_Wing_Brooch":2890,
"Black_wing_Brooch":2891,
"Assassin_Handcuffs":2892,
"Cursed_Heart":2893,
"Glove_Of_Shura":2894,
"Medal_Of_Valor1":2895,
"Medal_Of_Valor2":2896,
"2011RWC_Necklace_J":2897,
"Black_Rosary":2898,
"Sound_Amplifier":2899,
"Morrigane's_Belt_":2900,
"Morrigane's_Pendant_":2901,
"Morpheus's_Ring_":2902,
"Morpheus's_Armlet_":2903,
"Naqsh":2904,
"Super_Ora_Ora":2905,
"Happy_Gauntlet":2906,
"Buwaya_Tattoo":2907,
"Light_Ring":2908,
"Darkness_Ring":2909,
"Bakonawa_Tattoo":2910,
"Bangungot_Tattoo":2911,
"Xylitol_2011":2912,
"Thief_Handcuff":2913,
"Wizard_Left_Eye":2914,
"Ettlang_Keepsake":2915,
"Fairy_Wing":2916,
"Str_Glove":2917,
"Int_Glove":2918,
"Agi_Glove":2919,
"Vit_Glove":2920,
"Dex_Glove":2921,
"Luk_Glove":2922,
"Str_Glove_":2923,
"Int_Glove_":2924,
"Agi_Glove_":2925,
"Vit_Glove_":2926,
"Dex_Glove_":2927,
"Luk_Glove_":2928,
"Charm_Str":2929,
"Charm_Agi":2930,
"Charm_Vit":2931,
"Charm_Dex":2932,
"Charm_Int":2933,
"Charm_Luk":2934,
"Sprint_Glove":2935,
"Recovery_Ring":2936,
"RJC_Exp":2937,
"RJC_Status":2938,
"RJC_Spell":2939,
"Ninja_Manual":2940,
"Gunslinger_Manual":2941,
"Taekwon_Manual":2942,
"Critical_Ring_":2943,
"TE_Ring_Of_Protection":2944,
"TE_Ring_Of_Rage":2945,
"TE_Ring_Of_Defiance":2946,
"Memories_of_Spring":2947,
"Demon_Wing":2948,
"Silversmith_Bracelet":2949,
"Rune_Ring":2950,
"Kvasir_Ring_Blue":2951,
"Kvasir_Ring_Red":2952,
"Kvasir_Ring_Green":2953,
"Kvasir_Ring_Brown":2954,
"Neutral_Ring_J":2955,
"Safety_Ring_":2956,
"Good_Ring_Of_Flame_Lord":2957,
"Good_Ring_Of_Resonance":2958,
"Fidelity_Necklace":2959,
"Badge_Of_Manny":2960,
"Magic_Carpet":2961,
"Willpower_Ring":2962,
"Body_Power_Up_Ring":2963,
"Ring_Of_Spell_Explosion":2964,
"Angel_Egg":2965,
"RWC_2012_Ring":2966,
"RWC_2012_Ring_":2967,
"RWC_2012_Pendant":2968,
"RWC_2012_Pendant_":2969,
"Pie_Fruit_Box":2970,
"Pocket_Watch__":2971,
"Eternal_Protected_Love":2974,
"10th_Anni_Badge_J":2975,
"Red_Lantern":2976,
"Hurt_Mind":2977,
"KindHeart":2978,
"Strawberry_Decoration":2979,
"Evilspirit_Gloves":2980,
"RingOfHero":2981,
"Earth_Ring_J":2982,
"Brooch_Greed":2983,
"Limnil_Glove":2984,
"Gyges_Ring":2985,
"Snake_Ring":2986,
"Snake_Pendant":2987,
"Winged_Ring_Of_Newoz":2988,
"Floral_Bracelet_Of_Igu":2989,
"Pendant_Of_Harmony":2990,
"Pendant_Of_Chaos":2991,
"Pendant_Of_Maelstorm":2992,
"Yggdrasil_Ring":2993,
"Water_Crystal_Stone":2994,
"Supplement_Part_Dex":2995,
"Upgrade_Part_Gun_Barrel":2996,
"RWC_Gold_Brooch":2997,
"Shining_Trapezohedron":2998,
"RWC_Silver_Brooch":2999,
"Poring_Card":4001,
"Fabre_Card":4002,
"Pupa_Card":4003,
"Drops_Card":4004,
"Poring__Card":4005,
"Lunatic_Card":4006,
"Pecopeco_Egg_Card":4007,
"Picky_Card":4008,
"Chonchon_Card":4009,
"Wilow_Card":4010,
"Picky__Card":4011,
"Thief_Bug_Egg_Card":4012,
"Andre_Egg_Card":4013,
"Roda_Frog_Card":4014,
"Condor_Card":4015,
"Thief_Bug_Card":4016,
"Savage_Babe_Card":4017,
"Andre_Larva_Card":4018,
"Hornet_Card":4019,
"Farmiliar_Card":4020,
"Rocker_Card":4021,
"Spore_Card":4022,
"Desert_Wolf_Babe_Card":4023,
"Plankton_Card":4024,
"Skeleton_Card":4025,
"Thief_Bug_Female_Card":4026,
"Kukre_Card":4027,
"Tarou_Card":4028,
"Wolf_Card":4029,
"Mandragora_Card":4030,
"Pecopeco_Card":4031,
"Ambernite_Card":4032,
"Poporing_Card":4033,
"Worm_Tail_Card":4034,
"Hydra_Card":4035,
"Muka_Card":4036,
"Snake_Card":4037,
"Zombie_Card":4038,
"Stainer_Card":4039,
"Creamy_Card":4040,
"Coco_Card":4041,
"Steel_Chonchon_Card":4042,
"Andre_Card":4043,
"Smokie_Card":4044,
"Horn_Card":4045,
"Martin_Card":4046,
"Ghostring_Card":4047,
"Poison_Spore_Card":4048,
"Vadon_Card":4049,
"Thief_Bug_Male_Card":4050,
"Yoyo_Card":4051,
"Elder_Wilow_Card":4052,
"Vitata_Card":4053,
"Angeling_Card":4054,
"Marina_Card":4055,
"Dustiness_Card":4056,
"Metaller_Card":4057,
"Thara_Frog_Card":4058,
"Soldier_Andre_Card":4059,
"Goblin_Card":4060,
"Cornutus_Card":4061,
"Anacondaq_Card":4062,
"Caramel_Card":4063,
"Zerom_Card":4064,
"Kaho_Card":4065,
"Orc_Warrior_Card":4066,
"Megalodon_Card":4067,
"Scorpion_Card":4068,
"Drainliar_Card":4069,
"Eggyra_Card":4070,
"Orc_Zombie_Card":4071,
"Golem_Card":4072,
"Pirate_Skel_Card":4073,
"BigFoot_Card":4074,
"Argos_Card":4075,
"Magnolia_Card":4076,
"Phen_Card":4077,
"Savage_Card":4078,
"Mantis_Card":4079,
"Flora_Card":4080,
"Hode_Card":4081,
"Desert_Wolf_Card":4082,
"Rafflesia_Card":4083,
"Marine_Sphere_Card":4084,
"Orc_Skeleton_Card":4085,
"Soldier_Skeleton_Card":4086,
"Giearth_Card":4087,
"Frilldora_Card":4088,
"Sword_Fish_Card":4089,
"Munak_Card":4090,
"Kobold_Card":4091,
"Skel_Worker_Card":4092,
"Obeaune_Card":4093,
"Archer_Skeleton_Card":4094,
"Marse_Card":4095,
"Zenorc_Card":4096,
"Matyr_Card":4097,
"Dokebi_Card":4098,
"Pasana_Card":4099,
"Sohee_Card":4100,
"Sand_Man_Card":4101,
"Whisper_Card":4102,
"Horong_Card":4103,
"Requiem_Card":4104,
"Marc_Card":4105,
"Mummy_Card":4106,
"Verit_Card":4107,
"Myst_Card":4108,
"Jakk_Card":4109,
"Ghoul_Card":4110,
"Strouf_Card":4111,
"Marduk_Card":4112,
"Marionette_Card":4113,
"Argiope_Card":4114,
"Hunter_Fly_Card":4115,
"Isis_Card":4116,
"Side_Winder_Card":4117,
"Petit_Card":4118,
"Bathory_Card":4119,
"Petit__Card":4120,
"Phreeoni_Card":4121,
"Deviruchi_Card":4122,
"Eddga_Card":4123,
"Medusa_Card":4124,
"Deviace_Card":4125,
"Minorous_Card":4126,
"Nightmare_Card":4127,
"Golden_Bug_Card":4128,
"Baphomet__Card":4129,
"Scorpion_King_Card":4130,
"Moonlight_Flower_Card":4131,
"Mistress_Card":4132,
"Daydric_Card":4133,
"Dracula_Card":4134,
"Orc_Load_Card":4135,
"Khalitzburg_Card":4136,
"Drake_Card":4137,
"Anubis_Card":4138,
"Joker_Card":4139,
"Knight_Of_Abyss_Card":4140,
"Evil_Druid_Card":4141,
"Doppelganger_Card":4142,
"Orc_Hero_Card":4143,
"Osiris_Card":4144,
"Berzebub_Card":4145,
"Maya_Card":4146,
"Baphomet_Card":4147,
"Pharaoh_Card":4148,
"Gargoyle_Card":4149,
"Goat_Card":4150,
"Gajomart_Card":4151,
"Galapago_Card":4152,
"Crab_Card":4153,
"Rice_Cake_Boy_Card":4154,
"Goblin_Leader_Card":4155,
"Steam_Goblin_Card":4156,
"Goblin_Archer_Card":4157,
"Flying_Deleter_Card":4158,
"Nine_Tail_Card":4159,
"Antique_Firelock_Card":4160,
"Grand_Peco_Card":4161,
"Grizzly_Card":4162,
"Gryphon_Card":4163,
"Gullinbursti_Card":4164,
"Gig_Card":4165,
"Nightmare_Terror_Card":4166,
"Neraid_Card":4167,
"Dark_Lord_Card":4168,
"Dark_Illusion_Card":4169,
"Dark_Frame_Card":4170,
"Dark_Priest_Card":4171,
"The_Paper_Card":4172,
"Demon_Pungus_Card":4173,
"Deviling_Card":4174,
"Poison_Toad_Card":4175,
"Dullahan_Card":4176,
"Dryad_Card":4177,
"Dragon_Tail_Card":4178,
"Dragon_Fly_Card":4179,
"Driller_Card":4180,
"Disguise_Card":4181,
"Diabolic_Card":4182,
"Vagabond_Wolf_Card":4183,
"Lava_Golem_Card":4184,
"Rideword_Card":4185,
"Raggler_Card":4186,
"Raydric_Archer_Card":4187,
"Leib_Olmai_Card":4188,
"Wraith_Dead_Card":4189,
"Wraith_Card":4190,
"Loli_Ruri_Card":4191,
"Rotar_Zairo_Card":4192,
"Lude_Card":4193,
"Rybio_Card":4194,
"Leaf_Cat_Card":4195,
"Marin_Card":4196,
"Mastering_Card":4197,
"Maya_Puple_Card":4198,
"Merman_Card":4199,
"Megalith_Card":4200,
"Majoruros_Card":4201,
"Civil_Servant_Card":4202,
"Mutant_Dragon_Card":4203,
"Mini_Demon_Card":4204,
"Mimic_Card":4205,
"Mystcase_Card":4206,
"Mysteltainn_Card":4207,
"Miyabi_Ningyo_Card":4208,
"Violy_Card":4209,
"Wander_Man_Card":4210,
"Vocal_Card":4211,
"Bon_Gun_Card":4212,
"Brilight_Card":4213,
"Bloody_Murderer_Card":4214,
"Blazzer_Card":4215,
"Sasquatch_Card":4216,
"Live_Peach_Tree_Card":4217,
"Succubus_Card":4218,
"Sageworm_Card":4219,
"Solider_Card":4220,
"Skeleton_General_Card":4221,
"Skel_Prisoner_Card":4222,
"Stalactic_Golem_Card":4223,
"Stem_Worm_Card":4224,
"Stone_Shooter_Card":4225,
"Sting_Card":4226,
"Spring_Rabbit_Card":4227,
"Sleeper_Card":4228,
"C_Tower_Manager_Card":4229,
"Shinobi_Card":4230,
"Increase_Soil_Card":4231,
"Wild_Ginseng_Card":4232,
"Baby_Leopard_Card":4233,
"Anolian_Card":4234,
"Cookie_XMAS_Card":4235,
"Amon_Ra_Card":4236,
"Owl_Duke_Card":4237,
"Owl_Baron_Card":4238,
"Iron_Fist_Card":4239,
"Arclouse_Card":4240,
"Archangeling_Card":4241,
"Apocalips_Card":4242,
"Antonio_Card":4243,
"Alarm_Card":4244,
"Am_Mut_Card":4245,
"Assulter_Card":4246,
"Aster_Card":4247,
"Ancient_Mummy_Card":4248,
"Ancient_Worm_Card":4249,
"Executioner_Card":4250,
"Elder_Card":4251,
"Alligator_Card":4252,
"Alice_Card":4253,
"Tirfing_Card":4254,
"Orc_Lady_Card":4255,
"Orc_Archer_Card":4256,
"Wild_Rose_Card":4257,
"Wicked_Nymph_Card":4258,
"Wooden_Golem_Card":4259,
"Wootan_Shooter_Card":4260,
"Wootan_Fighter_Card":4261,
"Evil_Cloud_Hermit_Card":4262,
"Incant_Samurai_Card":4263,
"Wind_Ghost_Card":4264,
"Li_Me_Mang_Ryang_Card":4265,
"Eclipse_Card":4266,
"Explosion_Card":4267,
"Injustice_Card":4268,
"Incubus_Card":4269,
"Giant_Spider_Card":4270,
"Giant_Honet_Card":4271,
"Dancing_Dragon_Card":4272,
"Shellfish_Card":4273,
"Zombie_Master_Card":4274,
"Zombie_Prisoner_Card":4275,
"Lord_Of_Death_Card":4276,
"Zherlthsh_Card":4277,
"Gibbet_Card":4278,
"Deleter_Card":4279,
"Geographer_Card":4280,
"Zipper_Bear_Card":4281,
"Tengu_Card":4282,
"Greatest_General_Card":4283,
"Chepet_Card":4284,
"Choco_Card":4285,
"Karakasa_Card":4286,
"Kapha_Card":4287,
"Carat_Card":4288,
"Caterpillar_Card":4289,
"Cat_O_Nine_Tail_Card":4290,
"Kobold_Leader_Card":4291,
"Kobold_Archer_Card":4292,
"Cookie_Card":4293,
"Quve_Card":4294,
"Kraben_Card":4295,
"Cramp_Card":4296,
"Cruiser_Card":4297,
"Cremy_Fear_Card":4298,
"Clock_Card":4299,
"Chimera_Card":4300,
"Killer_Mantis_Card":4301,
"Tao_Gunka_Card":4302,
"Whisper_Boss_Card":4303,
"Tamruan_Card":4304,
"Turtle_General_Card":4305,
"Toad_Card":4306,
"Kind_Of_Beetle_Card":4307,
"Tri_Joint_Card":4308,
"Parasite_Card":4309,
"Panzer_Goblin_Card":4310,
"Permeter_Card":4311,
"Fur_Seal_Card":4312,
"Punk_Card":4313,
"Penomena_Card":4314,
"Pest_Card":4315,
"Fake_Angel_Card":4316,
"Mobster_Card":4317,
"Knight_Windstorm_Card":4318,
"Freezer_Card":4319,
"Bloody_Knight_Card":4320,
"Hylozoist_Card":4321,
"High_Orc_Card":4322,
"Garm_Baby_Card":4323,
"Garm_Card":4324,
"Harpy_Card":4325,
"See_Otter_Card":4326,
"Blood_Butterfly_Card":4327,
"Hyegun_Card":4328,
"Phendark_Card":4329,
"Dark_Snake_Lord_Card":4330,
"Heater_Card":4331,
"Waste_Stove_Card":4332,
"Venomous_Card":4333,
"Noxious_Card":4334,
"Pitman_Card":4335,
"Ungoliant_Card":4336,
"Porcellio_Card":4337,
"Obsidian_Card":4338,
"Mineral_Card":4339,
"Teddy_Bear_Card":4340,
"Metaling_Card":4341,
"Rsx_0806_Card":4342,
"Mole_Card":4343,
"Anopheles_Card":4344,
"Hill_Wind_Card":4345,
"Ygnizem_Card":4346,
"Armaia_Card":4347,
"Whikebain_Card":4348,
"Erend_Card":4349,
"Rawrel_Card":4350,
"Kavac_Card":4351,
"B_Ygnizem_Card":4352,
"Removal_Card":4353,
"Gemini_Card":4354,
"Gremlin_Card":4355,
"Beholder_Card":4356,
"B_Seyren_Card":4357,
"Seyren_Card":4358,
"B_Eremes_Card":4359,
"Eremes_Card":4360,
"B_Harword_Card":4361,
"Harword_Card":4362,
"B_Magaleta_Card":4363,
"Magaleta_Card":4364,
"B_Katrinn_Card":4365,
"Katrinn_Card":4366,
"B_Shecil_Card":4367,
"Shecil_Card":4368,
"Venatu_Card":4369,
"Dimik_Card":4370,
"Archdam_Card":4371,
"Bacsojin_Card":4372,
"Chung_E_Card":4373,
"Apocalips_H_Card":4374,
"Orc_Baby_Card_Card":4375,
"Lady_Tanee_Card":4376,
"Green_Iguana_Card":4377,
"Acidus_Card":4378,
"Acidus__Card":4379,
"Ferus_Card":4380,
"Ferus__Card":4381,
"Novus__Card":4382,
"Novus_Card":4383,
"Hydro_Card":4384,
"Dragon_Egg_Card":4385,
"Detale_Card":4386,
"Ancient_Mimic_Card":4387,
"Deathword_Card":4388,
"Plasma_Card":4389,
"Breeze_Card":4390,
"Retribution_Card":4391,
"Observation_Card":4392,
"Shelter_Card":4393,
"Solace_Card":4394,
"Tha_Maero_Card":4395,
"Tha_Odium_Card":4396,
"Tha_Despero_Card":4397,
"Tha_Dolor_Card":4398,
"Thanatos_Card":4399,
"Aliza_Card":4400,
"Alicel_Card":4401,
"Aliot_Card":4402,
"Kiel_Card":4403,
"Skogul_Card":4404,
"Frus_Card":4405,
"Skeggiold_Card":4406,
"Randgris_Card":4407,
"Gloom_Under_Night_Card":4408,
"Agav_Card":4409,
"Echio_Card":4410,
"Vanberk_Card":4411,
"Isilla_Card":4412,
"Hodremlin_Card":4413,
"Seeker_Card":4414,
"Snowier_Card":4415,
"Siroma_Card":4416,
"Ice_Titan_Card":4417,
"Gazeti_Card":4418,
"Ktullanux_Card":4419,
"Muscipular_Card":4420,
"Drosera_Card":4421,
"Roween_Card":4422,
"Galion_Card":4423,
"Stapo_Card":4424,
"Atroce_Card":4425,
"Byorgue_Card":4426,
"Sword_Guardian_Card":4427,
"Bow_Guardian_Card":4428,
"Salamander_Card":4429,
"Ifrit_Card":4430,
"Kasa_Card":4431,
"Magmaring_Card":4432,
"Imp_Card":4433,
"Knocker_Card":4434,
"Zombie_Slaughter_Card":4435,
"Ragged_Zombie_Card":4436,
"Hell_Poodle_Card":4437,
"Banshee_Card":4438,
"Flame_Skull_Card":4439,
"Necromancer_Card":4440,
"Fallen_Bishop_Card":4441,
"Tatacho_Card":4442,
"Aqua_Elemental_Card":4443,
"Draco_Card":4444,
"Luciola_Vespa_Card":4445,
"P_Skeleton_Card":4446,
"Centipede_Card":4447,
"Cornus_Card":4448,
"Dark_Shadow_Card":4449,
"Banshee_Master_Card":4450,
"Ant_Buyanne_Card":4451,
"Centipede_Larva_Card":4452,
"Hilsrion_Card":4453,
"Light_Up_Card1":4454,
"Light_Up_Card2":4455,
"Nidhogg_Shadow_Card":4456,
"Nahtzigger_Card":4457,
"Duneirre_Card":4458,
"Lata_Card":4459,
"Ringco_Card":4460,
"Pillar_Card":4461,
"Hardrock_Mommos_Card":4462,
"Tendrilion_Card":4463,
"Aunoe_Card":4464,
"Panat_Card":4465,
"Beholder_Master_Card":4466,
"Heavy_Metaling_Card":4467,
"Pinguicula_Dark_Card":4468,
"Naga_Card":4469,
"Nepenthes_Card":4470,
"Egg_Of_Draco_Card":4471,
"Bradium_Goram_Card":4472,
"Ancient_Tree_Card":4473,
"Jakudam_Card":4474,
"Cobalt_Mineral_Card":4475,
"Pinguicula_Card":4476,
"Hell_Apocalips_Card":4477,
"Light_Up_Card3":4478,
"Light_Up_Card4":4479,
"Sealed_Kiel_Card":4480,
"Sealed_Ktullanux_Card":4481,
"Sealed_B_Ygnizem_Card":4482,
"Sealed_Dracula_Card":4483,
"Sealed_Mistress_Card":4484,
"Sealed_Gloom_Card":4485,
"Sealed_Berz_Card":4486,
"Sealed_Ifrit_Card":4487,
"Sealed_D_Lord_Card":4488,
"Sealed_Pharaoh_Card":4489,
"Sealed_M_Flower_Card":4490,
"Sealed_B_Shecil_Card":4491,
"Sealed_Orc_Hero_Card":4492,
"Sealed_Tao_Card":4493,
"Sealed_TurtleG_Card":4494,
"Sealed_Amon_Ra_Card":4495,
"Sealed_Drake_Card":4496,
"Sealed_Knight_WS_Card":4497,
"Sealed_Lady_Tanee_Card":4498,
"Sealed_Samurai_Card":4499,
"Sealed_Orc_Load_Card":4500,
"Sealed_B_Magaleta_Card":4501,
"Sealed_B_Harword_Card":4502,
"Sealed_Apocalips_H_Card":4503,
"Sealed_Eddga_Card":4504,
"Scaraba_Card":4505,
"Dolomedes_Card":4506,
"Q_Scaraba_Card":4507,
"Gold_Scaraba_Card":4508,
"Gold_Q_Scaraba_Card":4509,
"Miming_Card":4510,
"Little_Fatum_Card":4511,
"Parus_Card":4512,
"Angra_Mantis_Card":4513,
"Pom_Spider_Card":4514,
"Alnoldi_Card":4515,
"Comodo_Card":4516,
"Cendrawasih_Card":4517,
"Banaspaty_Card":4518,
"Butoijo_Card":4519,
"Leak_Card":4520,
"Sedora_Card":4521,
"Sropho_Card":4522,
"Pot_Dofle_Card":4523,
"King_Dramoh_Card":4524,
"Kraken_Card":4525,
"Odd_Coelacanth_Card":4526,
"Black_Coelacanth_Card":4527,
"Mutant_Coelacanth_Card":4528,
"Cruel_Coelacanth_Card":4529,
"Siorava_Card":4530,
"Red_Eruma_Card":4531,
"Wild_Rider_Card":4532,
"Mini_Octopus_Card":4533,
"Giant_Octopus_Card":4534,
"Sealed_Rand_Card":4535,
"Sealed_Atroce_Card":4536,
"Sealed_Phreeoni_Card":4537,
"Sealed_Bacsojin_Card":4538,
"Sealed_F_Bishop_Card":4539,
"SLD_Lord_Of_Death_Card":4540,
"SLD_B_Katrinn_Card":4541,
"SLD_Detale_Card":4542,
"SLD_Garm_Card":4543,
"SLD_Dark_Snake_Card":4544,
"Novice_Poring_Card":4545,
"Light_Up_Card5":4546,
"Upd_Byorgue_Card":4547,
"Upd_Salamander_Card":4548,
"Upd_Maya_Puple_Card":4549,
"Upd_Bow_Guardian_Card":4550,
"Upd_Necromancer_Card":4551,
"Manny_Card":4552,
"Sid_Card":4553,
"Diego_Card":4554,
"Scrat_Card":4555,
"Fenrir_Card":4556,
"Fenrir_Card_":4557,
"Woodie_Card":4558,
"M_Morocc_Card":4559,
"Clown_Card":4560,
"Professor_Card":4561,
"Champion_Card":4562,
"Creator_Card":4563,
"Stalker_Card":4564,
"Paladin_Card":4565,
"Gypsy_Card":4566,
"Alphoccio_Card":4567,
"Ceila_Card":4568,
"Chen_Card":4569,
"Flamel_Card":4570,
"Gertie_Card":4571,
"Randel_Card":4572,
"Trentini_Card":4573,
"Daehyon_Card":4574,
"Soheon_Card":4575,
"Gioia_Card":4576,
"Elvira_Card":4577,
"Pyuriel_Card":4578,
"Lora_Card":4579,
"Kades_Card":4580,
"Rudo_Card":4581,
"Bungisngis_Card":4582,
"Engkanto_Card":4583,
"Manananggal_Card":4584,
"Mangkukulam_Card":4585,
"Tikbalang_Card":4586,
"Tiyanak_Card":4587,
"Wakwak_Card":4588,
"Jejeling_Card":4589,
"Bangungot_Card":4590,
"Bakonawa_Card":4591,
"Buwaya_Card":4592,
"Menblatt_Card":4593,
"Petal_Card":4594,
"Cenere_Card":4595,
"AntiqueBook_Card":4596,
"LichternB_Card":4597,
"LichternY_Card":4598,
"LichternR_Card":4599,
"LichternG_Card":4600,
"Amdarais_Card":4601,
"AmdaraisH_Card":4602,
"CorruptionRoot_Card":4603,
"CorruptionRootH_Card":4604,
"UndeadKnightM_Card":4605,
"UndeadKnightF_Card":4606,
"FaithfulManager_Card":4607,
"White_Knightage_Card":4608,
"Khaliz_Knightage_Card":4609,
"Sarah_Card":4610,
"Adventures_Card":4623,
"Timeholder_Card":4625,
"Big_Ben_Card":4626,
"Big_Bell_Card":4627,
"Neo_Punk_Card":4628,
"Arc_Elder_Card":4629,
"Time_Keeper_Card":4630,
"Owl_Viscount_Card":4631,
"Owl_Marquees_Card":4632,
"P_Archer_Skeleton_Card":4633,
"P_Soldier_Skeleton_Card":4634,
"P_Amdarais_Card":4635,
"Bijou_Card":4636,
"Immotal_Corps_Card":4637,
"Watcher_Card":4638,
"Tappy_Card":4639,
"Frozenwolf_Card":4640,
"Zombie_Guard_Card":4641,
"IFN_Toad_Card":4642,
"IFN_V_Wolf_Card":4643,
"IFN_Vocal_Card":4644,
"IFN_Eclipse_Card":4645,
"IFN_Chimera_Card":4646,
"IFN_Osiris_Card":4647,
"IFN_Eddga_Card":4648,
"IFN_Phreeoni_Card":4649,
"IFN_OrcHero_Card":4650,
"IFN_Tao_Gunka_Card":4651,
"Grave_Amon_Ra_Card":4652,
"Grave_Arclouse_Card":4653,
"Grave_Mimic_Card":4654,
"Grave_Minorous_Card":4655,
"Grave_Mummy_Card":4656,
"Grave_A_Mummy_Card":4657,
"Grave_Verit_Card":4658,
"Eggring_Card":4659,
"Basilisk1_Card":4660,
"Basilisk2_Card":4661,
"Big_Eggring_Card":4662,
"Leaf_Lunatic_Card":4663,
"Grass_Fabre_Card":4664,
"Wild_Honet_Card":4665,
"Sw_Roda_Frog_Card":4666,
"Hunter_Wolf_Card":4667,
"Trance_Spore_Card":4668,
"Ju_Mandragora_Card":4669,
"Fru_Pom_Spider_Card":4670,
"Sorcerer_Card":4671,
"Sura_Card":4672,
"Minstrel_Card":4673,
"GuillotineCross_Card":4674,
"Archbishop_Card":4675,
"Ranger_Card":4676,
"Mechanic_Card":4677,
"Warlock_Card":4678,
"RuneKnight_Card":4679,
"RoyalGuard_Card":4680,
"Genetic_Card":4681,
"ShadowChaser_Card":4682,
"Wanderer_Card":4683,
"Real_Eremes_Card":4684,
"Real_Magaleta_Card":4685,
"Real_Katrinn_Card":4686,
"Real_Shecil_Card":4687,
"Real_Harword_Card":4688,
"Real_Seyren_Card":4689,
"Real_Randel_Card":4690,
"Real_Flamel_Card":4691,
"Real_Ceila_Card":4692,
"Real_Chen_Card":4693,
"Real_Gertie_Card":4694,
"Real_Trentini_Card":4695,
"Real_Alphoccio_Card":4696,
"Charleston_Card":4697,
"Step_Card":4698,
"Rock_Step_Card":4699,
"Strength1":4700,
"Strength2":4701,
"Strength3":4702,
"Strength4":4703,
"Strength5":4704,
"Strength6":4705,
"Strength7":4706,
"Strength8":4707,
"Strength9":4708,
"Strength10":4709,
"Inteligence1":4710,
"Inteligence2":4711,
"Inteligence3":4712,
"Inteligence4":4713,
"Inteligence5":4714,
"Inteligence6":4715,
"Inteligence7":4716,
"Inteligence8":4717,
"Inteligence9":4718,
"Inteligence10":4719,
"Dexterity1":4720,
"Dexterity2":4721,
"Dexterity3":4722,
"Dexterity4":4723,
"Dexterity5":4724,
"Dexterity6":4725,
"Dexterity7":4726,
"Dexterity8":4727,
"Dexterity9":4728,
"Dexterity10":4729,
"Agility1":4730,
"Agility2":4731,
"Agility3":4732,
"Agility4":4733,
"Agility5":4734,
"Agility6":4735,
"Agility7":4736,
"Agility8":4737,
"Agility9":4738,
"Agility10":4739,
"Vitality1":4740,
"Vitality2":4741,
"Vitality3":4742,
"Vitality4":4743,
"Vitality5":4744,
"Vitality6":4745,
"Vitality7":4746,
"Vitality8":4747,
"Vitality9":4748,
"Vitality10":4749,
"Luck1":4750,
"Luck2":4751,
"Luck3":4752,
"Luck4":4753,
"Luck5":4754,
"Luck6":4755,
"Luck7":4756,
"Luck8":4757,
"Luck9":4758,
"Luck10":4759,
"Matk1":4760,
"Matk2":4761,
"Evasion6":4762,
"Evasion12":4763,
"Critical5":4764,
"Critical7":4765,
"Atk2":4766,
"Atk3":4767,
"Str1_J":4768,
"Str2_J":4769,
"Str3_J":4770,
"Int1_J":4771,
"Int2_J":4772,
"Int3_J":4773,
"Vit1_J":4774,
"Vit2_J":4775,
"Vit3_J":4776,
"Agi1_J":4777,
"Agi2_J":4778,
"Agi3_J":4779,
"Dex1_J":4780,
"Dex2_J":4781,
"Dex3_J":4782,
"Luk1_J":4783,
"Luk2_J":4784,
"Luk3_J":4785,
"Mdef2":4786,
"Mdef4":4787,
"Mdef6":4788,
"Mdef8":4789,
"Mdef10":4790,
"Def3":4791,
"Def6":4792,
"Def9":4793,
"Def12":4794,
"HP100":4795,
"HP200":4796,
"HP300":4797,
"HP400":4798,
"HP500":4799,
"SP50":4800,
"SP100":4801,
"SP150":4802,
"Highness_Heal_3sec":4803,
"Coluceo_Heal30":4804,
"Heal_Amount2":4805,
"Matk3":4806,
"Atk_Speed1":4807,
"Fighting_Spirit4":4808,
"Fighting_Spirit3":4809,
"Fighting_Spirit2":4810,
"Fighting_Spirit1":4811,
"Spell4":4812,
"Spell3":4813,
"Spell2":4814,
"Spell1":4815,
"Sharp3":4816,
"Sharp2":4817,
"Sharp1":4818,
"Atk1":4819,
"Fighting_Spirit5":4820,
"Fighting_Spirit6":4821,
"Fighting_Spirit7":4822,
"Fighting_Spirit8":4823,
"Fighting_Spirit9":4824,
"Fighting_Spirit10":4825,
"Spell5":4826,
"Spell6":4827,
"Spell7":4828,
"Spell8":4829,
"Spell9":4830,
"Spell10":4831,
"Expert_Archer1":4832,
"Expert_Archer2":4833,
"Expert_Archer3":4834,
"Expert_Archer4":4835,
"Expert_Archer5":4836,
"Expert_Archer6":4837,
"Expert_Archer7":4838,
"Expert_Archer8":4839,
"Expert_Archer9":4840,
"Expert_Archer10":4841,
"Atk_Speed2":4842,
"Sharp4":4843,
"Sharp5":4844,
"Sea_Energy":4845,
"2011Valentin_Angel":4846,
"2011Valentin_Devil":4847,
"Immuned1":4848,
"Cranial1":4849,
"Heal_Amount3":4850,
"Heal_Amount4":4851,
"Heal_Amount5":4852,
"S_Str":4853,
"S_Agi":4854,
"S_Vital":4855,
"S_Int":4856,
"S_Dex":4857,
"S_Luck":4858,
"Evasion1":4859,
"Evasion3":4860,
"MHP1":4861,
"MHP2":4862,
"Fatal1":4863,
"Fatal2":4864,
"Fatal3":4865,
"Fatal4":4866,
"MHP3":4867,
"MHP4":4868,
"Attack_Delay_1":4869,
"SP25":4870,
"SP75":4871,
"Attack_Delay_2":4872,
"Attack_Delay_3":4873,
"Beryl_of_Spring":4874,
"Bear's_Power":4875,
"Runaway_Magic":4876,
"Speed_Of_Light":4877,
"Muscle_Fool":4878,
"Hawkeye":4879,
"Lucky_Day":4880,
"Attack_Delay_4":4881,
"Atk1p":4882,
"Matk1p":4883,
"HIT1":4884,
"Conjure1":4885,
"Conjure2":4886,
"Conjure3":4887,
"Conjure4":4888,
"Conjure5":4889,
"Mdef1":4890,
"Mdef3":4891,
"Mdef5":4892,
"Def15":4893,
"Atk4p":4894,
"Atk5p":4895,
"Matk2p":4896,
"Matk3p":4897,
"Matk4p":4898,
"Matk5p":4899,
"MHP5":4900,
"Def18":4902,
"Def21":4903,
"Atk6p":4904,
"Atk7p":4905,
"Matk6p":4906,
"Matk7p":4907,
"Force1":4908,
"Force2":4909,
"Force3":4910,
"Intellect1":4911,
"Intellect2":4912,
"Intellect3":4913,
"Swiftness1":4914,
"Swiftness2":4915,
"Swiftness3":4916,
"Tough1":4917,
"Tough2":4918,
"Tough3":4919,
"Artful1":4920,
"Artful2":4921,
"Artful3":4922,
"Fortune1":4923,
"Fortune2":4924,
"Fortune3":4925,
"Critical1":4926,
"HP50":4927,
"SP10":4928,
"MSP1":4929,
"HEAL2":4930,
"HEALHP1":4931,
"HEALSP1":4932,
"Tolerance_Not1":4933,
"Tolerance_Not2":4934,
"Tolerance_Not3":4935,
"ATK_BIG1":4936,
"ATK_MEDIUM1":4937,
"ATK_SMALL1":4938,
"Critical2":4939,
"Critical3":4940,
"Critical4":4941,
"Dodge1":4942,
"Dodge2":4943,
"Dodge3":4944,
"Thrift1":4945,
"Thrift2":4946,
"Thrift3":4947,
"Skill_Delay1":4948,
"Skill_Delay2":4949,
"Skill_Delay3":4950,
"A_Drop_Of_Dark_":4951,
"A_Drop_Of_Fire_":4952,
"A_Drop_Of_Water_":4953,
"A_Drop_Of_Tree_":4954,
"A_Drop_Of_Light_":4955,
"A_Drop_Of_Heal_":4956,
"CollaboPower":4957,
"Z_Stone_1":4958,
"Z_Stone_2":4959,
"Z_Stone_3":4960,
"Z_Stone_4":4961,
"Z_Stone_5":4962,
"Z_Stone_6":4963,
"Z_Stone_7":4964,
"Z_Stone_8":4965,
"Z_Stone_9":4966,
"Z_Stone_10":4967,
"Z_Stone_11":4968,
"Z_Stone_12":4969,
"Reactor_P_FIRE":4970,
"Reactor_P_WATER":4971,
"Reactor_P_GROUND":4972,
"Reactor_P_WIND":4973,
"Reactor_T_FIRE":4974,
"Reactor_T_WATER":4975,
"Reactor_T_GROUND":4976,
"Reactor_T_WIND":4977,
"Reactor_Cure_101":4978,
"Reactor_Cure_102":4979,
"Reactor_Cure_201":4980,
"Reactor_Cure_202":4981,
"Reactor_A_STR":4982,
"Reactor_A_INT":4983,
"Reactor_A_DEF":4984,
"Reactor_A_AVOI":4985,
"Reactor_A_ATK":4986,
"Reactor_A_MATK":4987,
"Reactor_A_MHP":4988,
"Reactor_A_MSP":4989,
"Reactor_A_FROZ":4990,
"Reactor_A_ASPD":4991,
"HPdrain1":4992,
"SPdrain1":4993,
"Neev_STR_1":4994,
"Neev_STR_2":4995,
"Neev_STR_3":4996,
"Neev_AGI_1":4997,
"Neev_AGI_2":4998,
"Neev_AGI_3":4999,
"Headset":5001,
"Gemmed_Crown":5002,
"Joker_Jester":5003,
"Oxygen_Mask":5004,
"Gas_Mask":5005,
"Machoman_Glasses":5006,
"Loard_Circlet":5007,
"Puppy_Love":5008,
"Safety_Helmet":5009,
"Indian_Hair_Piece":5010,
"Antenna":5011,
"Ph.D_Hat":5012,
"Horn_Of_Lord_Kaho":5013,
"Fin_Helm":5014,
"Egg_Shell":5015,
"Boy's_Cap":5016,
"Bone_Helm":5017,
"Feather_Bonnet":5018,
"Corsair":5019,
"Kafra_Band":5020,
"Bankruptcy_Of_Heart":5021,
"Helm_Of_Sun":5022,
"Hat_Of_Bundle":5023,
"Hat_Of_Cake":5024,
"Helm_Of_Angel":5025,
"Hat_Of_Cook":5026,
"Wizardry_Hat":5027,
"Candle":5028,
"Spore_Hat":5029,
"Panda_Cap":5030,
"Mine_Helm":5031,
"Picnic_Hat":5032,
"Smokie_Hat":5033,
"Light_Bulb_Band":5034,
"Poring_Hat":5035,
"Cross_Band":5036,
"Fruit_Shell":5037,
"Deviruchi_Cap":5038,
"Mottled_Egg_Shell":5039,
"Blush":5040,
"Heart_Hair_Pin":5041,
"Hair_Protector":5042,
"Opera_Ghost_Mask":5043,
"Devil's_Wing":5044,
"Magician_Hat":5045,
"Bongun_Hat":5046,
"Fashion_Sunglass":5047,
"First_Moon_Hair_Pin":5048,
"Stripe_Band":5049,
"Mystery_Fruit_Shell":5050,
"Kitty_Bell":5051,
"Blue_Hair_Band":5052,
"Spinx_Helm":5053,
"Popcorn_Hair":5054,
"Novice_Egg_Cap":5055,
"Love_Berry":5056,
"Ear_Of_Black_Cat":5057,
"Drooping_Kitty":5058,
"Brown_Bear_Cap":5059,
"Party_Hat":5060,
"Flower_Hairpin":5061,
"Straw_Hat":5062,
"Plaster":5063,
"Leaf_Headgear":5064,
"Fish_On_Head":5065,
"Horn_Of_Succubus":5066,
"Sombrero":5067,
"Ear_Of_Devil's_Wing":5068,
"Mask_Of_Fox":5069,
"Headband_Of_Power":5070,
"Indian_Headband":5071,
"Inccubus_Horn":5072,
"Cap_Of_Concentration":5073,
"Ear_Of_Angel's_Wing":5074,
"Cowboy_Hat":5075,
"Fur_Hat":5076,
"Tulip_Hairpin":5077,
"Sea_Otter_Cap":5078,
"Crossed_Hair_Band":5079,
"Headgear_Of_Queen":5080,
"Mistress_Crown":5081,
"Mushroom_Band":5082,
"Red_Tailed_Ribbon":5083,
"Lazy_Raccoon":5084,
"Pair_Of_Red_Ribbon":5085,
"Alarm_Mask":5086,
"Goblin_Mask_01":5087,
"Goblin_Mask_02":5088,
"Goblin_Mask_03":5089,
"Goblin_Mask_04":5090,
"Big_Golden_Bell":5091,
"Blue_Coif":5092,
"Blue_Coif_":5093,
"Orc_Hero_Helm":5094,
"Orc_Hero_Helm_":5095,
"Assassin_Mask_":5096,
"Cone_Hat_":5097,
"Tiger_Mask":5098,
"Cat_Hat":5099,
"Sales_Signboard":5100,
"Takius_Blindfold":5101,
"Round_Eyes":5102,
"Sunflower_Hairpin":5103,
"Dark_Blindfold":5104,
"Hat_Of_Cake_":5105,
"Cone_Hat_INA":5106,
"Well_Baked_Toast":5107,
"Detective_Hat":5108,
"Red_Bonnet":5109,
"Baby_Pacifier":5110,
"Galapago_Cap":5111,
"Super_Novice_Hat":5112,
"Angry_Mouth":5113,
"Fedora":5114,
"Winter_Hat":5115,
"Banana_Hat":5116,
"Mistic_Rose":5117,
"Ear_Of_Puppy":5118,
"Super_Novice_Hat_":5119,
"Fedora_":5120,
"Zherlthsh_Mask":5121,
"Magni_Cap":5122,
"Ulle_Cap":5123,
"Fricca_Circlet":5124,
"Kiss_Of_Angel":5125,
"Morpheus's_Hood":5126,
"Morrigane's_Helm":5127,
"Goibne's_Helmet":5128,
"Bird_Nest":5129,
"Lion_Mask":5130,
"Close_Helmet":5131,
"Angeling_Hat":5132,
"Sheep_Hat":5133,
"Pumpkin_Hat":5134,
"Cyclops_Visor":5135,
"Santa's_Hat_":5136,
"Alice_Doll":5137,
"Magic_Eyes":5138,
"Hibiscus":5139,
"Charming_Ribbon":5140,
"Marionette_Doll":5141,
"Crescent_Helm":5142,
"Kabuki_Mask":5143,
"Gambler_Hat":5144,
"Carnival_Joker_Jester":5145,
"Elephant_Hat":5146,
"Baseball_Cap":5147,
"Phrygian_Cap":5148,
"Silver_Tiara":5149,
"Joker_Jester_":5150,
"Headset_OST":5151,
"Chinese_Crown":5152,
"Angeling_Hairpin":5153,
"Sunglasses_F":5154,
"Granpa_Beard_F":5155,
"Flu_Mask_F":5156,
"Viking_Helm_":5157,
"Holy_Bonnet_":5158,
"Golden_Gear_":5159,
"Magestic_Goat_":5160,
"Sharp_Gear_":5161,
"Bone_Helm_":5162,
"Corsair_":5163,
"Tiara_":5164,
"Crown_":5165,
"Spinx_Helm_":5166,
"Munak_Turban_":5167,
"Bongun_Hat_":5168,
"Bride_Mask":5169,
"Feather_Beret":5170,
"Valkyrie_Helm":5171,
"Beret":5172,
"Satto_Hat":5173,
"Ayam":5174,
"Censor_Bar":5175,
"Hahoe_Mask":5176,
"Guardian_Lion_Mask":5177,
"Candle_":5178,
"Gold_Tiara":5179,
"Phrygian_Cap_":5180,
"Helm_Of_Darkness":5181,
"Puppy_Hat":5182,
"Bird_Nest_Hat":5183,
"Captain_Hat":5184,
"Laurel_Wreath":5185,
"Geographer_Band":5186,
"Twin_Ribbon":5187,
"Minstrel_Hat":5188,
"Fallen_Leaves":5189,
"Baseball_Cap_":5190,
"Ribbon_Black":5191,
"Ribbon_Yellow":5192,
"Ribbon_Green":5193,
"Ribbon_Pink":5194,
"Ribbon_Red":5195,
"Ribbon_Orange":5196,
"Ribbon_White":5197,
"Drooping_Bunny":5198,
"Baseball_Cap_I":5199,
"Coppola":5200,
"Party_Hat_B":5201,
"Pumpkin_Hat_":5202,
"Tongue_Mask":5203,
"Event_Pierrot_Nose":5204,
"Wreath":5205,
"Romantic_White_Flower":5206,
"Gold_Spirit_Chain":5207,
"Rideword_Hat":5208,
"Yellow_Baseball_Cap":5209,
"Flying_Angel":5210,
"Dress_Hat":5211,
"Satellite_Hairband":5212,
"Black_Bunny_Band":5213,
"Moonlight_Flower_Hat":5214,
"Angelic_Chain_":5215,
"Satanic_Chain_":5216,
"Magestic_Goat_TW":5217,
"Bunny_Band_":5218,
"Drooping_Kitty_":5219,
"Smoking_Pipe_":5220,
"Pair_Of_Red_Ribbon_":5221,
"Fish_On_Head_":5222,
"Big_Golden_Bell_":5223,
"Orc_Hero_Helm_TW":5224,
"Marcher_Hat":5225,
"Mini_Propeller_":5226,
"Red_Deviruchi_Cap":5227,
"White_Deviruchi_Cap":5228,
"Gray_Deviruchi_Cap":5229,
"White_Drooping_Kitty":5230,
"Gray_Drooping_Kitty":5231,
"Pink_Drooping_Kitty":5232,
"Blue_Drooping_Kitty":5233,
"Yellow_Drooping_Kitty":5234,
"Gray_Fur_Hat":5235,
"Blue_Fur_Hat":5236,
"Pink_Fur_Hat":5237,
"Red_Wizardry_Hat":5238,
"White_Wizardry_Hat":5239,
"Gray_Wizardry_Hat":5240,
"Blue_Wizardry_Hat":5241,
"Yellow_Wizardry_Hat":5242,
"Chullos":5243,
"Elven_Blindfold":5244,
"Elven_Sunglasses":5245,
"Angelic_Helm":5246,
"Satanic_Helm":5247,
"Robotic_Blindfold":5248,
"Human_Blindfold":5249,
"Robotic_Ears":5250,
"Round_Ears":5251,
"Drooping_Nine_Tail":5252,
"Lif_Doll_Hat":5253,
"Deviling_Hat":5254,
"Triple_Poring_Hat":5255,
"Valkyrie_Feather_Band":5256,
"Soulless_Wing":5257,
"Afro_Wig":5258,
"Elephant_Hat_":5259,
"Cookie_Hat":5260,
"Silver_Tiara_":5261,
"Gold_Tiara_":5262,
"Ati_Atihan_Hat":5263,
"Aussie_Flag_Hat":5264,
"Apple_Of_Archer_C":5265,
"Bunny_Band_C":5266,
"Sahkkat_C":5267,
"Lord_Circlet_C":5268,
"Flying_Angel_":5269,
"Fallen_Leaves_":5270,
"Chinese_Crown_":5271,
"Tongue_Mask_":5272,
"Happy_Wig":5273,
"Shiny_Wig":5274,
"Marvelous_Wig":5275,
"Fantastic_Wig":5276,
"Yellow_Bandana":5277,
"Yellow_Ribbon":5278,
"Drooping_Kitty_C":5279,
"Magestic_Goat_C":5280,
"Deviruchi_Cap_C":5281,
"euRO_Baseball_Cap":5282,
"Chick_Hat":5283,
"Water_Lily_Crown":5284,
"Vane_Hairpin":5285,
"Pecopeco_Hairband":5286,
"Vacation_Hat":5287,
"Red_Glasses":5288,
"Vanilmirth_Hat":5289,
"Drooping_Bunny_":5290,
"Kettle_Hat":5291,
"Dragon_Skull":5292,
"Ramen_Hat":5293,
"Whisper_Mask":5294,
"Golden_Bandana":5295,
"Drooping_Nine_Tail_":5296,
"Soulless_Wing_":5297,
"Marvelous_Wig_":5298,
"Ati_Atihan_Hat_":5299,
"Bullock_Helm":5300,
"Russian_Ribbon":5301,
"Lotus_Flower_Hat":5302,
"Flower_Coronet":5303,
"Cap_Of_Blindness":5304,
"Pirate_Dagger":5305,
"Freyja_Crown":5306,
"Carmen_Miranda's_Hat":5307,
"Brazilian_Flag_Hat":5308,
"Mahican":5309,
"Bulb_Hairband":5310,
"Large_Hibiscus":5311,
"Ayothaya_Hat":5312,
"Diadem":5313,
"Hockey_Mask":5314,
"Observer":5315,
"Umbrella_Hat":5316,
"Fisherman_Hat":5317,
"Poring_Party_Hat":5318,
"Hellomother_Hat":5319,
"Champion_Wreath":5320,
"Indonesian_Bandana":5321,
"Scarf":5322,
"Misstrance_Crown":5323,
"Little_Angel_Doll":5324,
"Robo_Eye":5325,
"Masquerade_C":5326,
"Orc_Hero_Helm_C":5327,
"Evil_Wing_Ears_C":5328,
"Dark_Blindfold_C":5329,
"kRO_Drooping_Kitty_C":5330,
"Corsair_C":5331,
"Loki_Mask":5332,
"Radio_Antenna":5333,
"Angeling_Wanna_Fly":5334,
"Jumping_Poring":5335,
"Guildsman_Recruiter":5336,
"Party_Recruiter_Hat":5337,
"Bf_Recruiter_Hat":5338,
"Friend_Recruiter_Hat":5339,
"Deprotai_Doll_Hat":5340,
"Claris_Doll_Hat":5341,
"Sorin_Doll_Hat":5342,
"Tayelin_Doll_Hat":5343,
"Binit_Doll_Hat":5344,
"Debril_Doll_Hat":5345,
"Gf_Recruiter_Hat":5346,
"Ph.D_Hat_":5347,
"Big_Sis'_Ribbon_":5348,
"Boy's_Cap_":5349,
"Pirate_Bandana_":5350,
"Sunflower_":5351,
"Poporing_Cap":5352,
"Helm_Of_Sun_":5353,
"Muslim_Hat_M":5354,
"Muslim_Hat_F":5355,
"Pumpkin_Hat_H":5356,
"Wings_Of_Victory":5357,
"Pecopeco_Wing_Ears":5358,
"J_Captain_Hat":5359,
"Whikebain_Ears":5360,
"Gang_Scarf":5361,
"Ninja_Scroll":5362,
"Helm_Of_Abyss":5363,
"Dark_Snake_Lord_Hat":5364,
"Fried_Egg":5365,
"Hat_0f_King":5366,
"Hyegun_Hat":5367,
"White_Wing":5368,
"Dark_Wing":5369,
"Orchid_Hairband":5370,
"Hat_Of_Judge":5371,
"Drooping_White_Kitty":5372,
"Darkness_Helm":5373,
"L_Magestic_Goat":5374,
"L_Orc_Hero_Helm":5375,
"Satanic_Chain_P":5376,
"Antique_Pipe":5377,
"Rabbit_Ear_Hat":5378,
"Balloon_Hat":5379,
"Fish_Head_Hat":5380,
"Santa_Poring_Hat":5381,
"Bell_Ribbon":5382,
"Hunting_Cap":5383,
"Santa_Hat_1":5384,
"Yoyo_Hat":5385,
"Ayam_":5386,
"Neko_Mimi_Kafra":5387,
"Snake_Head":5388,
"Angel_Spirit":5389,
"Santa_Hat_2":5390,
"Toast_C":5391,
"Louyang_Cap":5392,
"Valentine_Hat":5393,
"Bubblegum_Lower":5394,
"Tiraya_Bonnet":5395,
"Jasper_Crest":5396,
"Scuba_Mask":5397,
"Bone_Head":5398,
"Mandragora_Cap":5399,
"Fox_Hat":5400,
"Black_Glasses":5401,
"Mischievous_Fairy":5402,
"Fish_In_Mouth":5403,
"Blue_Ribbon":5404,
"Filir_Hat":5405,
"Academy_Freshman_Hat":5406,
"Academy_Graduating_Cap":5407,
"Old_Bandanna":5408,
"New_Cowboy_Hat":5409,
"Bread_Bag2":5410,
"White_Snake_Hat":5411,
"Sweet_Candy":5412,
"Popcorn_Hat":5413,
"Campfire_Hat":5414,
"Poring_Cake_Cap":5415,
"Beer_Cap":5416,
"Crown_Parrot":5417,
"Soldier_Hat":5418,
"Evolved_Leaf":5419,
"Mask_Of_Ifrit":5420,
"Ifrit's_Ear":5421,
"Linguistic_Book_Cap":5422,
"Lovecap_China":5423,
"Fanta_Orange_Can":5424,
"Fanta_Grape_Can":5425,
"Karada_Meguri_Tea_Hat":5426,
"Royal_Milk_Tea_Hat":5427,
"Bread_Bag1":5428,
"Bogy_Cap":5429,
"Sacred_Torch_Coronet":5430,
"Chicken_Hat":5431,
"Brazil_Baseball_Cap":5432,
"Golden_Wreath":5433,
"Cola_Can":5434,
"Coke_Hat":5435,
"Bride's_Corolla":5436,
"Flower_Of_Fairy":5437,
"Fillet_Green":5438,
"Fillet_Red":5439,
"Fillet_Blue":5440,
"Fillet_White":5441,
"Necktie":5442,
"Status_Of_Baby_Angel":5443,
"Hair_Brush":5444,
"Candy_Cane_In_The_Mouth":5445,
"Cat_Foot_Hairpin":5446,
"Frog_Cap":5447,
"Solo_Play_Box1":5448,
"Solo_Play_Box2":5449,
"Sun_Cap":5450,
"Dragonhelm_Gold":5451,
"Dragonhelm_Silver":5452,
"Dragonhelm_Copper":5453,
"Dog_Cap_":5454,
"Geographer_Band_":5455,
"Vacation_Hat_":5456,
"Spring_Rabbit_Hat":5457,
"Pinwheel_Cap":5458,
"Drooping_Bunny_Chusuk":5459,
"Adv_Dragon_Skull":5460,
"Adv_Whisper_Mask":5461,
"Spiked_Scarf":5462,
"Rainbow_Scarf":5463,
"Zaha_Doll_Hat":5464,
"Celestial_Hat":5465,
"Wind_Milestone":5466,
"Helm_Of_Dragoon":5467,
"Parade_Cap":5468,
"Noble_Hat":5469,
"Eyes_Of_Darkness":5470,
"Hairband_Of_Reginleif":5471,
"Red_White_Hat":5472,
"Forceps_Hairpin":5473,
"Notice_Board":5474,
"Cube_Mask":5475,
"Hairband_Of_Grandpeco":5476,
"Bro_Flag":5477,
"Classic_Hat":5478,
"Shaman's_Hair_Ornament":5479,
"Bizofnil_Wing_Deco":5480,
"Hermose_Cap":5481,
"Dark_Knight_Mask":5482,
"Odin_Mask":5483,
"Taiwan_Flag_Hat":5484,
"Tiger_Face":5485,
"J_Anniversary_Hat":5486,
"J_Poringcake_Hat":5487,
"J_Twin_Santahat":5488,
"Love_Daddy":5489,
"Anubis_Helm":5490,
"Hat_Of_Outlaw":5491,
"Boy's_Cap_I":5492,
"Ulle_Cap_I":5493,
"Spinx_Helm_I":5494,
"Power_Of_Thor":5495,
"Dice_Hat":5496,
"King_Tiger_Doll_Hat":5497,
"Wondering_Wolf_Helm":5498,
"Pizza_Hat":5499,
"Icecream_Hat":5500,
"Pirate's_Pride":5501,
"Necromencer's_Hood":5502,
"Rabbit_Magic_Hat":5503,
"China_Wedding_Veil":5504,
"Asara_Fairy_Hat":5505,
"Blue_Pajamas_Hat":5506,
"Pink_Pajamas_Hat":5507,
"Shark_Hat":5508,
"Sting_Hat":5509,
"Shower_Cap":5510,
"Samambaia":5511,
"Aquarius_Diadem":5512,
"Aquarius_Crown":5513,
"Pisces_Diadem":5514,
"Pisces_Crown":5515,
"Hawk_Eyes01":5516,
"Hawk_Eyes02":5517,
"L_Magestic_Goat2":5518,
"Peacock_Feather":5519,
"Rabbit_Earplug":5520,
"Angry_Mouth_C":5521,
"Fanta_Zero_Lemon_Hat":5522,
"Sakura_Mist_Hat":5523,
"Sakura_Milk_Tea_Hat":5524,
"First_Leaf_Tea_Hat":5525,
"Lady_Tanee_Doll":5526,
"Lunatic_Hat":5527,
"King_Frog_Hat":5528,
"Evil's_Bone_Hat":5529,
"Raven_Cap":5530,
"B_Dragon_Hat":5531,
"Pirate_Dagger_J":5532,
"Emperor_Wreath_J":5533,
"Fox_Hat_J":5534,
"Side_Cap":5535,
"Spare_Card":5536,
"Quati_Hat":5537,
"Tucan_Hat":5538,
"Jaguar_Hat":5539,
"Freyja_SCirclet7":5540,
"Freyja_SCirclet30":5541,
"Freyja_SCirclet60":5542,
"Freyja_SCirclet90":5543,
"Time_Keeper_Hat":5544,
"Aries_Diadem":5545,
"Aries_Crown":5546,
"RJC_Katusa":5547,
"Scarlet_Rose":5548,
"Taurus_Diadem":5549,
"Taurus_Crown":5550,
"Holy_Egg_Hat":5551,
"Fest_Lord_Circlet":5552,
"Fest_Bunny_Band":5553,
"Octopus_Hat":5554,
"Leaf_Cat_Hat":5555,
"Fur_Seal_Hat":5556,
"Wild_Rose_Hat":5557,
"Saci_Hat":5558,
"Piece_Of_White_Cloth_E":5559,
"Bullock_Helm_J":5560,
"Rabbit_Magic_Hat_J":5561,
"Good_Wedding_Veil_J":5562,
"Dolor_Hat":5563,
"Crown_Of_Deceit":5564,
"Dragon_Arhat_Mask":5565,
"Tiger_Arhat_Mask":5566,
"Bright_Fury":5567,
"Rabbit_Bonnet":5568,
"Gemini_Diadem":5569,
"Gemini_Crown":5570,
"Rasta_Wig":5571,
"Savage_Baby_Hat":5572,
"Bogy_Horn":5573,
"Pencil_In_Mouth":5574,
"Onigiri_Hat":5575,
"Japan_Winecup":5576,
"Dark_Knight_MaskB":5577,
"Voyage_Hat":5578,
"Wanderer's_Sakkat":5579,
"Red_Beret":5580,
"Cancer_Diadem":5581,
"Cancer_Crown":5582,
"Para_Team_Hat":5583,
"Majestic_Evil_Horn":5584,
"Rune_Hairband":5585,
"Mosquito_Coil":5586,
"Mosquito_Coil_1Use":5587,
"Leo_Crown":5588,
"Leo_Diadem":5589,
"K_Poring_Cake_Cap":5590,
"Desert_Prince":5591,
"Sigrun's_Wing":5592,
"K_Rabbit_Bonnet":5593,
"Donut_In_Mouth":5594,
"Eye_Of_Juno":5595,
"4Leaf_Clover_In_Mouth":5596,
"Bubble_Gum_In_Mouth":5597,
"Virgo_Crown":5598,
"Virgo_Diadem":5599,
"Br_Twin_Ribbon":5600,
"Br_Beret":5601,
"Jaguar_Hat_J":5602,
"RTC_Winner_Only":5603,
"RTC_Second_Best":5604,
"RTC_Third_Best":5605,
"Campume_Hat":5606,
"Lyria_Doll_Hat":5607,
"Dorothy_Doll_Hat":5608,
"Chung_Hairband":5609,
"Ice_Wing_Ear":5610,
"Turtle_Hat":5611,
"F_Blue_Drooping_Kitty":5612,
"F_Flying_Angel":5613,
"F_Smoking_Pipe_":5614,
"F_Pair_Of_Red_Ribbon_":5615,
"F_Fish_On_Head_":5616,
"F_Hibiscus":5617,
"F_Cat_Hat":5618,
"F_Bunny_Band_":5619,
"F_Magestic_Goat_TW":5620,
"F_Sheep_Hat":5621,
"F_Mini_Propeller_":5622,
"F_Alice_Doll":5623,
"F_Red_Glasses":5624,
"F_Chick_Hat":5625,
"F_White_Deviruchi_Cap":5626,
"F_Vane_Hairpin":5627,
"F_Pecopeco_Hairband":5628,
"F_Vacation_Hat":5629,
"F_Charming_Ribbon":5630,
"F_Water_Lily_Crown":5631,
"F_Vanilmirth_Hat":5632,
"F_Drooping_Bunny_":5633,
"F_Kettle_Hat":5634,
"F_Dragon_Skull":5635,
"F_Ramen_Hat":5636,
"F_Pink_Fur_Hat":5637,
"F_Puppy_Hat":5638,
"F_Magic_Eyes":5639,
"F_Jumping_Poring":5640,
"F_Robo_Eye":5641,
"F_Yellow_Wizardry_Hat":5642,
"F_Crescent_Helm":5643,
"F_Tiger_Mask":5644,
"F_Fantastic_Wig":5645,
"F_Whisper_Mask":5646,
"F_Bunny_Band_C":5647,
"F_Centimental_Flower_C":5648,
"F_Apple_Of_Archer_C":5649,
"F_Elven_Ears_C":5650,
"F_Brooch_C":5651,
"F_Magestic_Goat_C":5652,
"Darkness_Helm_J":5653,
"Holy_Marching_Hat_J":5654,
"Dark_Snake_Lord_Hat_J":5655,
"Scooter_Hat_J":5656,
"Antique_Pipe_J":5657,
"Imp_Hat":5658,
"Sleepr_Hat":5659,
"Gryphon_Hat":5660,
"Red_Pirate_Bandana":5661,
"Libra_Crown":5662,
"Libra_Diadem":5663,
"Filir_Wing":5664,
"Shaman_Hat":5665,
"Golden_Crown":5666,
"Skull_Hood":5667,
"Weird_Pumpkin_Hat":5668,
"Poring_Party_Hat_J":5669,
"Aniv_Star_Hat":5670,
"Drooping_Morocc_Minion":5671,
"Southern_Cross":5672,
"Home_Cherry_Blossom":5673,
"Pig_Moneybox":5674,
"Poring_Letter":5675,
"Scorpio_Crown":5676,
"Scorpio_Diadem":5677,
"Notation_Hairband":5678,
"Engineer_Cap":5679,
"Hawkeyes":5680,
"F_Ribbon_Green":5681,
"Triangle_Rune_Cap":5682,
"Majestic_Goat_Repl":5683,
"Jewel_Crown_Repl":5684,
"Prontera_Army_Cap_Repl":5685,
"Feather_Bonnet_Repl":5686,
"Viking_Helm_Repl":5687,
"2009Love_Daddy":5688,
"Queen_Ant_Diadem":5689,
"Red_Wing_Hat":5690,
"Catain_Bandanna":5691,
"Sea_Cat_Hat":5692,
"No_Fear_Underware":5693,
"No_Fear_P_Headgear":5694,
"E_Blue_Drooping_Kitty":5695,
"E_Flying_Angel":5696,
"E_Smoking_Pipe_":5697,
"E_Pair_OE_Red_Ribbon_":5698,
"E_Fish_On_Head_":5699,
"E_Hibiscus":5700,
"E_Cat_Hat":5701,
"E_Bunny_Band_":5702,
"E_Magestic_Goat_TW":5703,
"E_Sheep_Hat":5704,
"E_Mini_Propeller_":5705,
"E_Alice_Doll":5706,
"E_Red_Glasses":5707,
"E_Chick_Hat":5708,
"E_White_Deviruchi_Cap":5709,
"E_Vane_Hairpin":5710,
"E_Pecopeco_Hairband":5711,
"E_Vacation_Hat":5712,
"E_Charming_Ribbon":5713,
"E_Water_Lily_Crown":5714,
"E_Vanilmirth_Hat":5715,
"E_Drooping_Bunny_":5716,
"E_Kettle_Hat":5717,
"E_Dragon_Skull":5718,
"E_Ramen_Hat":5719,
"E_Pink_Fur_Hat":5720,
"E_Puppy_Hat":5721,
"E_Magic_Eyes":5722,
"E_Jumping_Poring":5723,
"E_Robo_Eye":5724,
"E_Yellow_Wizardry_Hat":5725,
"E_Crescent_Helm":5726,
"E_Tiger_Mask":5727,
"E_Fantastic_Wig":5728,
"E_Bunny_Band_C":5729,
"E_Centimental_Flower_C":5730,
"E_Apple_OE_Archer_C":5731,
"E_Elven_Ears_C":5732,
"E_Brooch_C":5733,
"E_Magestic_Goat_C":5734,
"E_Ribbon_Green":5735,
"EF_Whisper_Mask":5736,
"Cactus_Hat":5737,
"Snowman_Hat":5738,
"Sagittarius_Crown":5739,
"Sagittarius_Diadem":5740,
"Im_Egg_Shell_Hat":5741,
"Rudolf_Santa_Hat":5742,
"Orange_Stem_Hat":5743,
"Capricon_Crown":5744,
"Capricon_Diadem":5745,
"Rune_Circlet":5746,
"Mitra":5747,
"Sniper_Goggle":5748,
"Driver_Band":5749,
"Shadow_Handicraft":5750,
"Minstrel_Song_Hat":5751,
"Midas_Whisper":5752,
"Magic_Stone_Hat":5753,
"Blazing_Soul":5754,
"Silent_Executer":5755,
"Wind_Whisper":5756,
"Schmidt_Helm":5757,
"Dying_Swan":5758,
"Noah_Hat":5759,
"Driver_Band_":5760,
"Sloth_Hat":5761,
"Duneyrr_Helm":5762,
"Red_Bunny_Band":5763,
"Love_Rabbit_Hood":5764,
"Black_Tail_Ribbon":5765,
"Amistr_Cap":5766,
"Samurai_Mask":5767,
"Sakura_Coronet":5768,
"Gold_Angel_Sculpture":5769,
"Splash_Hat":5770,
"Family_Hat":5771,
"Red_Navy_Hat":5772,
"Navy_Beret":5773,
"Red_Pirate_Hat":5774,
"Choco_Donut_In_Mouth":5775,
"Blazing_Sun":5776,
"Remover_Hat":5777,
"Blue_Arara_Hat":5778,
"Drooping_Boto":5779,
"Tendrilion_Hat":5780,
"Persika":5781,
"Hoplite_Helmet":5782,
"YellowBunny_Hairband":5783,
"PinkBunny_Hairband":5784,
"Green_Bunny_Hairband":5785,
"Ancient_Elven_Ear":5786,
"Tha_Maero_Mask":5787,
"3D_Glasses":5788,
"Thanatos_Mal_Mask":5789,
"Holy_Mom_Love":5790,
"Tenkaippin_Ramen":5791,
"Fish_Pin":5792,
"Ribbon_Of_Life":5793,
"3D_Glasses_":5794,
"Red_Dress_Hat":5795,
"Cheer_Scarf":5796,
"Cheer_Scarf2":5797,
"Cheer_Scarf3":5798,
"Cheer_Scarf4":5799,
"Blush_Of_Groom":5800,
"Ribbon_Of_Bride":5801,
"Upgrade_Elephant_Hat":5802,
"Flower_Love_Hat":5803,
"Pirate_Eyepatch":5804,
"Victorious_Coronet":5805,
"Poem_Natalia_Hat":5806,
"October_Fest_Cap":5807,
"Diabolus_Helmet":5808,
"Boom_Boom_Hat":5809,
"Ph.D_Hat_V":5810,
"Santa_Beard":5811,
"Hat_Of_Expert":5812,
"Red_Ph.D_Hat":5813,
"Ati_Atihan_Hat3":5814,
"Classic_Hat_J":5815,
"Cowboy_Hat_J":5816,
"Valentine_Pledge":5817,
"Carnival_Hat":5818,
"Carnival_Circlet":5819,
"Black_Elven_Ears":5820,
"Gold_Tulip_Hairpin":5821,
"Love_Chick_Hat":5822,
"Love_Arrow":5823,
"Fools_Day_Hat":5824,
"Badge_Of_Order_Grace":5825,
"Valkyrie_Helmet":5826,
"Book_File_Hat":5827,
"Honor_Gold_Ring":5828,
"Ordinary_Armor":5829,
"Woe_Sahkkat":5830,
"Woe_Big_Sis_Ribbon":5831,
"Woe_Vane_Hairpin":5832,
"Woe_Picnic_Hat":5833,
"Woe_Crown":5834,
"Woe_Tiara":5835,
"Woe_Boys_Cap":5836,
"Woe_Sunglass":5837,
"Woe_Fin_Helm":5838,
"Woe_Blush":5839,
"Woe_Elven_Ears":5840,
"Shaman_Hat_":5841,
"Loyal_Ring1":5842,
"Loyal_Ring2":5843,
"Loyal_Ring3":5844,
"Buzzy_Ball_Board":5845,
"Buzzy_Ball_Gum":5846,
"Fools_Day_Helmet":5847,
"Robin_Eyepatch":5848,
"Doctor_Hairband":5849,
"Golden_Savage_Hat":5850,
"Summer_Knight":5851,
"Easter_Egg_Shell":5852,
"1Aniversary_Crown":5853,
"Fish_Rod":5855,
"Passion_FB_Hat":5856,
"Cool_FB_Hat":5857,
"Victory_FB_Hat":5858,
"Glory_FB_Hat":5859,
"Shadow_Booster":5864,
"Filir_Wing_Ears":5865,
"Red_Cherry_Blossom":5866,
"Hat_Of_Drowsy_Cat":5867,
"Bushy_Moustache":5868,
"Mimic_Egg_Shell":5869,
"Bunny_Egg_Shell":5870,
"Picky_Egg_Shell":5871,
"Helmet_Of_Siegfried":5873,
"Circlet_Of_Kriemhild":5874,
"Diadem_Of_Bruenhild":5875,
"Miracle_Blue_Rose":5878,
"Poring_Sunglasses_J":5879,
"Cheering_Whistle_J":5880,
"Weissbier_Hat":5881,
"White_Wizardry_Hat_C":5882,
"Gray_Wizardry_Hat_C":5883,
"Blue_Wizardry_Hat_C":5884,
"Red_Wizardry_Hat_C":5885,
"Yellow_Wizardry_Hat_C":5886,
"Half_L_Magestic_Goat":5887,
"Wedding_Veil_":5888,
"L_Orc_Hero_Helm_":5889,
"Angel_Earing":5890,
"Black_Cat_Hat":5891,
"RCC2013_1ST_CROWN":5892,
"RCC2013_2ND_CROWN":5893,
"RCC2013_3RD_CROWN":5894,
"RCC2013_ANV_Hat":5895,
"EGGTART_HAT":5896,
"Ascendant_Crown_":5897,
"Autumn_Headband":5898,
"Black_Ribbon_":5899,
"Divine_Guard_Hat_":5900,
"Focus_Beret_":5901,
"Harvester_Hat_":5902,
"Hitaikakushi_":5903,
"Inconspicuous_Hat_":5904,
"Lyrica_Hat_":5905,
"Oni_Horns_":5906,
"Sea_Captain_Hat_":5907,
"Accessory_of_Ascetic":5908,
"C_Valkyrie_Circlet":5909,
"C_Imperial_Feather":5911,
"C_Minions_Of_Devil":5912,
"C_Anemos_Mask":5913,
"C_Flutter_Butterfly":5914,
"C_Angel_Veil":5915,
"Exosrcist_Glass":5916,
"Yellow_Scarf":5917,
"Gambler_Seal":5918,
"Camellia_Hair_Pin":5919,
"Medical_Boots":5920,
"Monster_Fish_Gill":5921,
"DragonKnight_Eyepatch":5924,
"Magical_Feather":5930,
"Niflheim_Bunny_Hat":5931,
"Heaven_Cage":5932,
"Crow_Tengu_Mask":5933,
"Happy_Balloon_J":5934,
"8_Type_PurgatorialWing":5936,
"Flying_Helmet":5937,
"Octopus_Hat_J":5938,
"Boitata_Hat_J":5940,
"Owlviscount_Silk_Hat":5943,
"Thief_Hood":5944,
"Red_Pencil_Mouth":5945,
"Drama_Clockwork":5946,
"Love_Guard_L":5953,
"Wing_Headphone":5963,
"Riot_Chip_J":5965,
"KarduiEar":5966,
"FlyingGalapago":5967,
"DVAngelNurseCap":5968,
"QueenAnzRevenge":5969,
"RuneHelm":5970,
"Moon_Eyepatch":5971,
"Chatty_Parrot":5972,
"Ancient_Elven_Ear_J":5973,
"Zherlthsh_Doll":5975,
"C_Poker_Card_In_Mouth":5977,
"Toy_Syringe":5978,
"C_Angel_Fluttering":5979,
"C_Classical_Fhat":5980,
"C_Satanic_Chain_P":5981,
"Noble_Mask":5985,
"Whikebain_Ears_":5986,
"Dark_Ashes":6000,
"Essence_Of_Fire":6001,
"Token_Of_Apostle":6002,
"Soul_Pendant":6003,
"Bapho_Doll":6004,
"New_Year_Rice_Cake":6005,
"Rice_Cake_Delivery_Box":6006,
"New_Year_Rice_Cake_Soup":6007,
"Wood":6008,
"Large_Magical_Fan":6009,
"Pickaxe":6010,
"Blue_Card_B":6011,
"Blue_Card_C":6012,
"Blue_Card_J":6013,
"Blue_Card_M":6015,
"Blue_Card_Q":6016,
"Blue_Card_T":6017,
"Blue_Card_V":6018,
"Blue_Card_Z":6019,
"Fur":6020,
"Peaked_Hat":6021,
"Hard_Skin":6022,
"Mystic_Horn":6023,
"17Carat_Dia":6024,
"Towel_Of_Memory":6025,
"Marriage_Covenant":6026,
"Crystal_Of_Feardoom":6027,
"Seal_Scroll":6028,
"Morocc_Tracing_Log":6029,
"Glitering_PaperA":6030,
"Glitering_PaperB":6031,
"Horn_Of_Hilsrion":6032,
"Horn_Of_Tendrilion":6033,
"Weird_Part":6034,
"Decaying_Stem":6035,
"Invite_To_Meeting":6036,
"Rough_File":6037,
"Neat_Report":6038,
"Piece_Of_Fish":6039,
"Some_Of_Report":6040,
"Strong_Bine":6041,
"Ordinary_Branch":6042,
"Letter_From_Lugen":6043,
"Letter_From_Otto":6044,
"Supply_Box":6045,
"Clothing_Dye_Coupon":6046,
"Clothing_Dye_Coupon2":6047,
"Unidentified_Mineral":6048,
"Marlin":6049,
"Mercenary_Contract":6050,
"Gray_Hollow":6051,
"Ornamental_Hairpin":6052,
"Yuanbao":6053,
"Blue_Card_6":6054,
"Blue_Card_Annyver":6055,
"Blue_Card_Sary":6056,
"Blue_Card_E":6057,
"Blue_Card_Ven":6058,
"Blue_Card_Nt":6059,
"Moon_Admin_Ticket":6060,
"Plantain":6061,
"Moon_Cake15":6062,
"Moon_Cake16":6063,
"Moon_Cake17":6064,
"Moon_Cake18":6065,
"Moon_Cake19":6066,
"Moon_Cake20":6067,
"Rabbit_Skin":6068,
"ABUNDANCE":6069,
"Shaman's_Old_Paper":6070,
"Broken_Sword":6071,
"Wing_Of_Bizofnil":6072,
"Dragon's_Mane":6073,
"Bazett's_Order":6074,
"Crystalized_Teardrop":6075,
"Portable_Toolbox":6076,
"Rough_Mineral":6077,
"Stone_Fragments":6078,
"Flower_Of_Alfheim":6079,
"Manuk_Coin":6080,
"Splendide_Coin":6081,
"Spirit_Of_Alfheim":6082,
"Dolly_Capsule":6083,
"Bradium_Fragments":6084,
"Shaggy_Muffler":6085,
"Withered_Flower":6086,
"Crystal_Of_Soul_01":6087,
"Crystal_Of_Soul_02":6088,
"Piece_Of_Darkness":6089,
"Purified_Bradium":6090,
"Dark_Red_Scale":6091,
"Singing_Crystal_Piece":6092,
"Egg_Of_Draco":6093,
"Traditional_Cookie":6094,
"Flavored_Alcohol":6095,
"Fish_With_Blue_Back":6096,
"Pumpkin_Pie_":6097,
"Small_Snow_Flower":6098,
"Grilled_Rice_Cake":6099,
"Damp_Darkness":6100,
"Attendance_Card":6101,
"Report_On_Splendide":6102,
"Report_On_Manuk":6103,
"Big_Cell":6104,
"Morning_Dew":6105,
"Well_Ripened_Berry":6106,
"Sunset_On_The_Rock":6107,
"Apple_Pudding":6108,
"Plant_Neutrient":6109,
"Vital_Flower":6110,
"Mystic_Stone":6111,
"Fresh_Plant":6112,
"Vital_Flower_":6113,
"Flame_Gemstone":6114,
"Bun_":6115,
"Succu_Pet_Coupon":6116,
"Imp_Pet_Coupon":6117,
"Chung_E_Pet_Coupon":6118,
"Natural_Leather":6119,
"Face_Paint":6120,
"Makeover_Brush":6121,
"Paint_Brush":6122,
"Surface_Paint":6123,
"Wolf's_Flute":6124,
"Lucky_Box":6125,
"Happy_Box":6126,
"Purification_Stone":6127,
"Guillotine_Antidote":6128,
"Ticket_Nightmare":6129,
"Ticket_Loli_Ruri":6130,
"Ticket_Goblin_Leader":6131,
"Ticket_Incubus":6132,
"Ticket_Miyabi_Ningyo":6133,
"Ticket_Whisper":6134,
"Ticket_Wicked_Nymph":6135,
"Ticket_Medusa":6136,
"Ticket_Stoneshooter":6137,
"Ticket_Marionette":6138,
"Ticket_Leafcat":6139,
"Ticket_Dullahan":6140,
"Ticket_Shinobi":6141,
"Ticket_Golem":6142,
"Ticket_Civil_Servant":6143,
"Heartbroken_Tears":6144,
"Vulcan_Bullet":6145,
"Magic_Gear_Fuel":6146,
"Liquid_Condensed_Bullet":6147,
"Chocolate_Of_Eternity":6148,
"Plain_Chocolate":6149,
"Key_Of_The_Mansion":6150,
"Peice_Of_Great_Bradium":6151,
"Glittering_Crystal":6152,
"Special_Exchange_Coupon":6153,
"Broken_Horn_Pipe":6154,
"Coke_Membership_Card":6155,
"Approval_Report":6156,
"Poring_Ticket":6157,
"Drops_Ticket":6158,
"Poporing_Ticket":6159,
"Lunatic_Ticket":6160,
"Picky_Ticket":6161,
"Pecopeco_Ticket":6162,
"Savage_Baby_Ticket":6163,
"Spore_Ticket":6164,
"Poison_Spore_Ticket":6165,
"Chonchon_Ticket":6166,
"Steel_Chonchon_Ticket":6167,
"Petit_Ticket":6168,
"Deviruchi_Ticket":6169,
"Isis_Ticket":6170,
"Smokie_Ticket":6171,
"Dokebi_Ticket":6172,
"Desert_Wolf_B_Ticket":6173,
"Yoyo_Ticket":6174,
"Sohee_Ticket":6175,
"Rocker_Ticket":6176,
"Hunter_Fly_Ticket":6177,
"Orc_Warrior_Ticket":6178,
"Bapho_Jr_Ticket":6179,
"Munak_Ticket":6180,
"Bongun_Ticket":6181,
"Goblin_Ticket":6182,
"Hardtack_Ticket":6183,
"Zherlthsh_Ticket":6184,
"Alice_Ticket":6185,
"Monkey_Wrench":6186,
"Blank_Card":6187,
"Slot_Coupon":6188,
"Magic_Book_FB":6189,
"Magic_Book_CB":6190,
"Magic_Book_LB":6191,
"Magic_Book_SG":6192,
"Magic_Book_LOV":6193,
"Magic_Book_MS":6194,
"Magic_Book_CM":6195,
"Magic_Book_TV":6196,
"Magic_Book_TS":6197,
"Magic_Book_JT":6198,
"Magic_Book_WB":6199,
"Magic_Book_HD":6200,
"Magic_Book_ES":6201,
"Magic_Book_ES_":6202,
"Magic_Book_CL":6203,
"Magic_Book_CR":6204,
"Magic_Book_DL":6205,
"I_Love_You":6206,
"Thank_You":6207,
"I_Respect_You":6208,
"Glory_Of_Knights":6209,
"Seed_Of_Horny_Plant":6210,
"Bloodsuck_Plant_Seed":6211,
"Bomb_Mushroom_Spore":6212,
"Explosive_Powder":6213,
"Smoke_Powder":6214,
"Tear_Gas":6215,
"Oil_Bottle":6216,
"Mandragora_Flowerpot":6217,
"Disin_Delivery_Box":6218,
"Para_Team_Mark":6219,
"Mysterious_Dyestuff":6220,
"Mystic_Leaf_Cat_Ball":6221,
"Shining_Beads":6222,
"Carnium":6223,
"Bradium":6224,
"HD_Carnium":6225,
"HD_Bradium":6226,
"Guarantee_Weapon_9Up":6228,
"Guarantee_Weapon_8Up":6229,
"Guarantee_Weapon_7Up":6230,
"Guarantee_Weapon_6Up":6231,
"Guarantee_Armor_9Up":6232,
"Guarantee_Armor_8Up":6233,
"Guarantee_Armor_7Up":6234,
"Guarantee_Armor_6Up":6235,
"Blue_Card_7":6236,
"Guarana_Fruit":6237,
"Guarantee_Weapon_11Up":6238,
"Guarantee_Armor_11Up":6239,
"HD_Oridecon":6240,
"HD_Elunium":6241,
"Midgard_Coin":6242,
"Exchange_Coupon":6243,
"Gun_Powder":6244,
"Black_Powder":6245,
"Yellow_Powder":6246,
"White_Powder":6247,
"Melange_Pot":6248,
"Savage_Meat":6249,
"Cooking_Skewer":6250,
"Black_Charcoal":6251,
"Wolf_Blood":6252,
"Cold_Ice":6253,
"Beef_Head_Meat":6254,
"Large_Cookpot":6255,
"Ice_Fragment":6256,
"Ice_Crystal":6257,
"Comodo_Tropic_Fruit":6258,
"Drocera_Tentacle":6259,
"Petti_Tail":6260,
"Fine_Noodle":6261,
"Cool_Gravy":6262,
"Coconut_Fruit":6263,
"Melon":6264,
"Pineapple":6265,
"Cheat_Key":6266,
"Virtual_Key":6267,
"Mirth_Key":6268,
"Master_Brush":6269,
"Mins_Picture":6270,
"Mins_Receipt":6271,
"Experiment_Seed":6272,
"Altered_Seed":6273,
"Saint_Cloth_Piece":6274,
"King_Shield":6275,
"Clear_Reagent":6276,
"Red_Reagent":6277,
"Black_Reagent":6278,
"Apple_Bomb_CB":6279,
"Pinepple_Bomb_CB":6280,
"Coconut_Bomb_CB":6281,
"Melon_Bomb_CB":6282,
"Banana_Bomb_CB":6283,
"Plant_Genetic_Grow":6284,
"Quality_Potion_Book":6285,
"F_Max_Weight_Up_Scroll":6286,
"F_Clothing_Dye_Coupon":6287,
"F_Happy_Box":6288,
"F_Mysterious_Dyestuff":6289,
"F_New_Style_Coupon":6290,
"F_Enriched_Elunium":6291,
"F_Enriched_Oridecon":6292,
"F_Token_Of_Siegfried":6293,
"F_Marriage_Covenant":6294,
"F_Clothing_Dye_Coupon2":6295,
"RF_Taining_Notice":6296,
"Bottle_To_Throw":6297,
"Pumpkin_Head_Crushed":6298,
"Worn_Cloth_Piece":6299,
"J_7Draw":6300,
"J_Semi_Draw":6301,
"GM_Handwriting":6302,
"Changed_Hydra_Ball":6303,
"Sapa_Feat_Cert":6304,
"Frozen_Skin_Piece":6305,
"Solid_Bloodstain":6306,
"Suspicious_Magic_Stone":6307,
"Unidentified_Relic":6308,
"E_Max_Weight_Up_Scroll":6309,
"E_Cloth_Dye_Coupon":6310,
"E_Happy_Box":6311,
"E_Mysterious_Dyestuff":6312,
"E_New_Style_Coupon":6313,
"E_Enriched_Elunium":6314,
"E_Enriched_Oridecon":6315,
"E_Token_Of_Siegfried":6316,
"E_Marriage_Covenant":6317,
"E_Cloth_Dye_Coupon2":6318,
"Small_Bradium":6319,
"Premium_Reset_Stone":6320,
"Rakehorn_Helm":6321,
"Antler_Helm":6322,
"Twinhorn_Helm":6323,
"Singlehorn_Helm":6324,
"White_Spider_Limb":6325,
"Queen_Wing_Piece":6326,
"LI_HD_Bradium":6327,
"Calender_January":6328,
"Calender_February":6329,
"Calender_March":6330,
"Calender_April":6331,
"Calender_May":6332,
"Calender_June":6333,
"Calender_July":6334,
"Calender_August":6335,
"Calender_September":6336,
"Calender_October":6337,
"Calender_November":6338,
"Calender_December":6339,
"Fade_Notation_Green":6340,
"Fade_Notation_Red":6341,
"Fade_Notation_Purple":6342,
"Fade_Notation_Blue":6343,
"Muscle_Story":6344,
"Love_Ball":6345,
"Seagate_Mark":6346,
"Bless_Word_Paper1":6347,
"Bless_Word_Paper2":6348,
"Bless_Word_Paper3":6349,
"Bless_Word_Paper4":6350,
"Bless_Word_Paper5":6351,
"Bless_Word_Paper6":6352,
"Bless_Word_Paper7":6353,
"Bless_Word_Paper8":6354,
"Bless_Word_Paper9":6355,
"Bless_Word_Paper10":6356,
"Fortune_Cookie_Fail":6357,
"Free_Cash_Coupon":6358,
"Guidebook_Exchange":6359,
"Scarlet_Pts":6360,
"Indigo_Pts":6361,
"Yellow_Wish_Pts":6362,
"Lime_Green_Pts":6363,
"Woe_Coin":6364,
"Arena_Coin":6365,
"Turbo_Track_Coin":6366,
"Kafra_Coin":6367,
"Endless_Coin":6368,
"Amatsu_Bead_A":6369,
"Amatsu_Bead_Ma":6370,
"Amatsu_Bead_Tsu":6371,
"Amatsu_Bead_Jam":6372,
"Amatsu_Bead_Bo":6373,
"Amatsu_Bead_Ree":6374,
"Amatsu_Bead_!":6375,
"KVM_Badge":6376,
"Buy_Market_Permit":6377,
"Winning_Mark":6378,
"Card_Coin":6379,
"Mora_Coin":6380,
"Field_Shovel":6381,
"Urn":6382,
"Clue_Of_Lope":6383,
"Ring_Of_Lope":6384,
"Research_Tool_Bag":6385,
"Bathtub_R_Sample":6386,
"Teeth_Sample":6387,
"Scale_Sample":6388,
"Puddle_R_Sample":6389,
"Small_Pocket":6390,
"Splendid_Supply_Kit":6391,
"Bradium_Box":6392,
"Round_Feather":6393,
"Golden_Feather":6394,
"Angel_Magic_Power":6395,
"Auger_Of_Spirit":6396,
"PR_Team_Ticket":6397,
"Develop_Team_Ticket":6398,
"Marketing_Team_Ticket":6399,
"Operating_Team_Ticket":6400,
"Palm_O":6401,
"Oil_Palm_F":6402,
"Comodo_L":6403,
"Caress_H":6404,
"Cendrawasih_F":6405,
"Cendrawasih_SF":6406,
"Life_Stone1":6407,
"Life_Stone2":6408,
"Life_Stone3":6409,
"Idul_Fitri_Card":6410,
"Ripe_Watermelon":6411,
"Special_Medal":6412,
"New_Insurance":6413,
"Raganta_Card":6414,
"Strange_Embryo":6415,
"Pet_Exchange":6416,
"Silvervine":6417,
"Agrade_Coin":6418,
"Bgrade_Coin":6419,
"Cgrade_Coin":6420,
"Dgrade_Coin":6421,
"Egrade_Coin":6422,
"Anger_Seagod":6423,
"Halloween_Fragment":6424,
"Halloween_Certificate":6425,
"Bad_Can":6426,
"Bad_Can_Sack":6427,
"Bravery_Card_A":6428,
"Bravery_Card_B":6429,
"Picture_Piece":6430,
"Bucket":6431,
"Full_Bucket":6432,
"Clean_Brush":6433,
"Fix_Kit":6434,
"Fresh_Fruit":6435,
"Ptotection_Seagod":6436,
"Scaraba_Perfume":6437,
"Unbreakable_Weap":6438,
"Unbreakable_Def":6439,
"General_Lubricant":6440,
"High_RankLubricant":6441,
"Octopus_Hunt_Stick":6442,
"Sillit_Pong_Bottle":6443,
"Emperium_G":6444,
"Blue_Card_X":6445,
"Green_Paper":6446,
"Red_Paper":6447,
"White_Paper":6448,
"Casual_Diary":6449,
"Honest_Diary":6450,
"Unknown_Fish":6451,
"Etoile_Ring":6452,
"Undelivered_Gift":6453,
"Santa_Bag":6454,
"Tiny_Ticket":6455,
"Guarantee_Weapon_5Up":6456,
"Guarantee_Armor_5Up":6457,
"Jae_Sinho_Unpo":6459,
"Jae_Sinho_Undo":6460,
"Mimong_Sungjin":6461,
"Gilsang_Yeoui":6462,
"Sin_Sun_Jeonsul":6463,
"Hate_Bundle":6464,
"Guard_Coin":6465,
"Clean_Water":6466,
"Perfume":6467,
"Thai_Perfume":6468,
"Will_Of_Warrior":6469,
"Blood_Thirst":6470,
"Goast_Chill":6471,
"Holy_Mom_Blaze":6472,
"Amatsu_Orb01":6473,
"Amatsu_Orb02":6474,
"Amatsu_Orb03":6475,
"Amatsu_Orb04":6476,
"Amatsu_Orb05":6477,
"Amatsu_Orb06":6478,
"Amatsu_Orb07":6479,
"Event_Coin":6480,
"Holy_Rock_Piece":6481,
"Ancient_City_Key":6482,
"Dream_Scroll":6483,
"Enchant_Book":6484,
"BlueCard_2":6485,
"BlueCard_0":6486,
"BlueCard_1":6487,
"Thanks_Invest_Ticket":6488,
"Cats_Invest_Certif":6489,
"Magic_Clay_Fragment":6490,
"Magic_Clay":6491,
"Magic_Clay_Lump":6492,
"Makibishi":6493,
"Kafra_Coin2":6494,
"Eden_Merit_Badge":6495,
"Tikbalang_Thick_Spine":6496,
"Lesser_Agimat":6497,
"Jejellopy":6498,
"Ancient_Grudge":6499,
"Sharp_Bamboo":6500,
"Salt_Bag":6501,
"Silver_Cross":6502,
"Soul_Protection":6503,
"Cast_Iron_Caldron":6504,
"Purified_Bone":6505,
"Offering_Bouquet":6506,
"Evil_Bone":6507,
"Silver_Bracelet":6508,
"Mysterious_Flower":6509,
"Elegant_Flower":6510,
"Beautiful_Flower":6511,
"Charm_Fire":6512,
"Charm_Ice":6513,
"Charm_Wind":6514,
"Charm_Earth":6515,
"Bakonawa_Doll":6516,
"Bangungot_Doll":6517,
"Buwaya_Doll":6518,
"Collected_Sample":6519,
"Lost_Belongings":6520,
"Royal_Certificate":6521,
"Royal_Certificate_":6522,
"Bakonawa_Spirit_Piece":6523,
"Bangungot_Spirit_Piece":6524,
"Buwaya_Spirit_Piece":6525,
"BlueCard_Happy":6526,
"BlueCard_Enjoy":6527,
"BlueCard_Light":6528,
"BlueCard_Mid":6529,
"BlueCard_Fall":6530,
"Royal_Certificate__":6531,
"Honey_Songpyun":6532,
"Torn_Document":6533,
"Fruit_Sundae":6534,
"Red_Cloth":6535,
"Star_Decor":6536,
"Sky_Medal":6537,
"Real_Blank_Card":6538,
"Old_Left_Lapine":6539,
"Golden_Leaf":6540,
"Avant_Research_Data":6541,
"Star_Shape_Mushroom":6542,
"Lv110_Achieved_Coin":6543,
"Lv120_Achieved_Coin":6544,
"Firm_Hair":6545,
"Younger_Bro_Letter":6546,
"Stained_Research_Book":6547,
"Piece_Of_Lapine_Wing":6548,
"Courtesy_Ticket":6549,
"Brownie_Ticket":6550,
"RWC_Spirit_Auger":6551,
"Mail_Package":6552,
"Leaf_Made_Wood":6553,
"Seed_Box":6554,
"Birthday_Candle":6555,
"Nespresso_Ticket":6556,
"Fancy_Fairy_Wing":6557,
"Pile_Of_Acorn":6558,
"Eye_Drops":6559,
"Leaf_Bookmark":6560,
"Dustball":6561,
"Tiny_Mouse_Tail":6562,
"Weeds":6563,
"Captive_Hatchling":6564,
"Racy_Spice":6565,
"Cacao99_Recipe":6566,
"Choco_Drink_Recipe":6567,
"Holy_Amulet":6581,
"3rd_Test_Pass":6583,
"Guarantee_Weapon_12Up":6584,
"Guarantee_Armor_12Up":6585,
"CapturedBook":6586,
"Small_Wooden_Chest":6592,
"Cryptura_Hair_Coupon":6593,
"Magic_Bronze_Bullion":6594,
"Hammer_Of_Velund":6595,
"Anvil_Of_Velund":6596,
"Bracelet_Of_Velund":6597,
"Rib_Of_Jormungand":6598,
"Spirit_Of_Hugin":6599,
"Spirit_Of_Munin":6600,
"Chisel_Of_Giant":6601,
"Secret_Of_Rune":6602,
"Skin_Of_Hraesvelg":6603,
"Essence_Of_Rune":6604,
"Muspellium":6605,
"P_Cart_C":6606,
"Temporal_Crystal":6607,
"Coagulated_Spell":6608,
"Glast_Decayed_Nail":6609,
"Glast_Horrendous_Mouth":6610,
"Colorful_Key":6611,
"Gold_Coin_Basket":6612,
"Colorful_Brooch":6613,
"Siege_Guild_Coin":6615,
"Lmtd_Manny_Card":6616,
"Lmtd_Sid_Card":6617,
"Lmtd_Diego_Card":6618,
"Lmtd_Scrat_Card":6619,
"Rough_Energy_Crystal":6623,
"Purified_Energy_Crystal":6624,
"High_Purity_Energy_Xtal":6625,
"Blacksmith_Blessing":6635,
"STRStone_Top":6636,
"INTStone_Top":6637,
"AGIStone_Top":6638,
"DEXStone_Top":6639,
"VITStone_Top":6640,
"LUKStone_Top":6641,
"ATKStone_Middle":6642,
"MATKStone_Middle":6643,
"HITStone_Bottom":6644,
"FLEEStone_Bottom":6645,
"Poring_Badge":6646,
"Shabby_Crown":6648,
"Broken_Horn":6649,
"Shabby_Ring":6650,
"Rusty_Bracelet":6651,
"Old_Photo_Album":6652,
"Shabby_Pill":6653,
"Needle_And_Thread":6654,
"Firm_Pumpkin":6655,
"Goast_Free_Charm":6656,
"Memory_Of_Jack":6657,
"Halloween_Coin":6658,
"RWC_Inicializer":6665,
"Jade_Leaf":6669,
"Geffen_Magic_Coin":6671,
"Gray_Shard":6672,
"Bossnia_Ticket":6673,
"Daily_Coin":6674,
"XMAS_Cookie":6681,
"Bag_Of_Selling_Goods":6682,
"Thirsty_Flower":6683,
"TokenOfHero":6684,
"MoroccMerit":6685,
"Brick":6686,
"LongRopes":6687,
"Wood_":6688,
"BurningSkin":6689,
"YummyStem":6690,
"BurningFeather":6691,
"PatrolLog":6692,
"Stone_Of_Blessing":6693,
"Monster_Blood":6694,
"ToothOfFlameGolem":6695,
"ToothOfFlameFrilldora":6696,
"Costume_Exchange":6697,
"Hatchet":6698,
"Silence_Of_God":6699,
"White_Scale":6700,
"Treasure_Of_Dvergr":6701,
"Sweat_Of_Dvergr":6702,
"Tear_Of_Warrior":6703,
"Anger_Of_Warrior":6704,
"Medal_Of_Honor":6705,
"Flower_Of_Guardian":6706,
"J_Shop_Coupon":6707,
"Mana_crystal":6708,
"Crispy_silk":6709,
"Twisted_Snake":6710,
"Lovely_Stick":6712,
"Soul_Of_Ahat":6713,
"Soul_Of_Shnaim":6714,
"P_Of_Evil_Soul":6715,
"Cri_Stone":6716,
"MaxHP_Stone":6717,
"MaxSP_Stone":6718,
"Tooth_Of_Jitterbug":6719,
"Status_Reset_Coupon":6720,
"Status_Reset_Coupon2":6721,
"Delicious_Clam":6722,
"Delicious_Can":6723,
"Savage_Box":6724,
"Grand_Peco_Box":6725,
"Desert_Wolf_Box":6726,
"Meeting_Album":6727,
"Monster_Coin":6732,
"Itchy_Feather":6733,
"Unknown_Meal":6734,
"Special_Condiment":6735,
"Minced_Meat":6736,
"Fermented_Wheat_Flour":6737,
"Rissole":6738,
"Recipe":6739,
"HealStone_Top":6740,
"HealStone2_Top":6741,
"HealStone_Middle":6742,
"HPStone_Middle":6743,
"SPStone_Middle":6744,
"HealStone_Bottom":6745,
"Steel_Article":6746,
"Steel_Article_":6747,
"Excavator_Repoet":6748,
"Power_Control_Device":6749,
"Wrong_Engine":6750,
"Distorted_Iron_Plate":6751,
"Charleston_Parts":6752,
"Sign_Of_Destruction":6753,
"Collected_Herb":6754,
"Polluted_Spell":6755,
"Condensed_Energy":6756,
"Memory_Record":6757,
"Banana_Can":6762,
"Spicy_Rice_Cake":6763,
"Hotdog":6764,
"Big_Wheel_Cracker":6765,
"Ice_World_Ticket":6766,
"Summer_Fes_Coin":6767,
"Red_Beans_Of_Ice":6768,
"Sweet_Rice_Cake":6769,
"Shark":6770,
"Bluefin_Tuna":6771,
"Octopus":6772,
"Snapper":6773,
"Piranha":6774,
"Salmon":6775,
"Eels":6776,
"Carp":6777,
"Squid_2":6778,
"Mackerel":6779,
"Crucian_Carp":6780,
"Living_Earthworm":6781,
"Fresh_Lobster":6782,
"Squid_Skewer":6784,
"Fantastic_Sauce":6785,
"Squid_Of_Bbq":6786,
"Good_Firewood":6787,
"Rose_Knife":6788,
"Custom_Pan":6789,
"BigStone_Top":6790,
"MediumStone_Top":6791,
"SmallStone_Top":6792,
"Ticket_Card_RO2":6795,
"Name_Card_RO2":6796,
"11th_Coin":6797,
"Piece_Of_Gigantes":6803,
"ORGANIC_PUMPKIN":6804,
"INORGANIC_PUMPKIN":6805,
"LI_Kapra's_Pass":6813,
"Soul_Of_Swordman":6814,
"Soul_Of_Merchant":6815,
"Soul_Of_Thief":6816,
"Soul_Of_Magicion":6817,
"Soul_Of_Archer":6818,
"Soul_Of_Acolyte":6819,
"Particles_Of_Energy":6820,
"Solo_Troops_Badge":6821,
"Lab_Memory_Record":6824,
"Box_Of_Aircleaner":6825,
"Fresh_Grape":6826,
"Normal_Parts":6827,
"Gravity_Parts":6828,
"Problematical_Part":6832,
"LI_Token_Of_Siegfried":6833,
"Legendary_Fur":6834,
"Legendary_Mane":6835,
"Charm_Of_Soul":6836,
"Mouse_Soul_Piece":6837,
"Secret_Letter_K":6838,
"Gold_Chocoin":6839,
"Silver_Chocoin":6840,
"Bronze_Chocoin":6841,
"Big_Jewel":6842,
"Grass_Ring":6843,
"Soft_Stone":6844,
"Aged_Poo":6845,
"LC_Max_WeightUp_Srl":6846,
"Very_Tiny_Box":6847,
"Light_Box":6848,
"Request_Complete":6849,
"Suspicious_Box":6850,
"Suspicious_Paper":6851,
"Super_Neutralizer":6852,
"Thankful_Flowers":6853,
"Captured_Novus":6854,
"Captured_Tatacho":6855,
"Blood_Pus_Script":6856,
"Very_Hard_Stone":6857,
"Captured_Rude":6858,
"Captured_Wanderer":6859,
"Cow_Soul_Piece":6860,
"Tiger_Soul_Piece":6862,
"Tiger_Soul_Piece2":6863,
"Guarantee_Weapon_19Up":6864,
"Guarantee_Armor_19Up":6865,
"Rabbit_Soul_Piece":6866,
"InsectCollected_BigBox":6867,
"InsectCollected_MidBox":6868,
"Dust_14ySummerEvent":6869,
"Guarantee_Weapon_13Up":6870,
"Guarantee_Weapon_14Up":6871,
"Guarantee_Weapon_15Up":6872,
"Guarantee_Weapon_16Up":6873,
"Guarantee_Weapon_17Up":6874,
"Guarantee_Weapon_18Up":6875,
"Guarantee_Armor_13Up":6876,
"Guarantee_Armor_14Up":6877,
"Guarantee_Armor_15Up":6878,
"Guarantee_Armor_16Up":6879,
"Guarantee_Armor_17Up":6880,
"Guarantee_Armor_18Up":6881,
"Bait_14ySummerEvent":6882,
"Snow_Rabbit_Ticket":6883,
"Tikbalang_Ticket":6884,
"Dragon_Soul_Piece":6885,
"Dragon_Soul_Piece2":6886,
"Invasion_Plan":6892,
"Human_Cookbook":6893,
"Champion_Badge":6894,
"TE_RuneOfAncient":6895,
"TE_RuneOfMystery":6896,
"Blue_Whale":6897,
"Whale":6898,
"Giant_Octopus":6899,
"Giant_Squid":6900,
"Sturgeon":6901,
"Jumbo_Shrimp":6902,
"Giant_Earthworm":6903,
"Snake_Soul_Piece":6904,
"Shattered_Rune":6905,
"LI_HD_Carnium":6906,
"Horse_Soul_Piece":6907,
"ASPDStone_Robe":6908,
"Nyangvine_Fruit":6909,
"LI_HD_Oridecon":6910,
"LI_HD_Elunium":6911,
"Lamb_Soul_Piece":6912,
"Sacred_Rosary":6913,
"Black_Soul":6914,
"Captured_Soul":6915,
"Monkey_Soul_Piece":6916,
"Chicken_Soul_Piece":6917,
"TokenOfHonor":6919,
"RuneMagicPowder":6920,
"Desiccant":6921,
"Sandpaper":6922,
"Bright_Lights":6923,
"Red_Eyes":6924,
"Prisoner_Letter":6925,
"Midgards_Histories":6926,
"Filled_With_SeaStones":6927,
"Poring_Loofah":6928,
"Letters_Stamped_Seal":6929,
"Biz_Items_Sample":6930,
"Secret_Documents":6931,
"Rare_Old_Books":6932,
"Banquet_Invitation":6933,
"Wonderful_Cuisine":6934,
"Luxurious_Dish":6935,
"Stone_Of_Chill":6936,
"Soften_Skin":6937,
"Porcupine_Big_Spike":6938,
"Shabby_Old_Belt":6939,
"Moving_Black_Things":6940,
"Valkyrie_Fragment":6941,
"Will_Of_Owner":6942,
"ATKStone_Top":6943,
"MATKStone_Top":6944,
"STRStone_Middle":6945,
"INTStone_Middle":6946,
"AGIStone_Middle":6947,
"DEXStone_Middle":6948,
"VITStone_Middle":6949,
"LUKStone_Middle":6950,
"HPStone_Bottom":6951,
"RamorRob_G_Ticket":6953,
"Dog_Soul_Piece":6954,
"Pig_Soul_Piece":6955,
"Captured_Sheep":6956,
"Soft_Wool":6957,
"Lamb_Horn":6958,
"Costume_Ticket":6959,
"Air_Stronghold_Key":6960,
"LargeScrap":6961,
"OldTank":6962,
"HPdrainStone_Robe":6963,
"SPdrainStone_Robe":6964,
"Reactor_P_FIRE_":6965,
"Reactor_P_WATER_":6966,
"Reactor_P_GROUND_":6967,
"Reactor_P_WIND_":6968,
"Reactor_T_FIRE_":6969,
"Reactor_T_WATER_":6970,
"Reactor_T_GROUND_":6971,
"Reactor_T_WIND_":6972,
"Reactor_Cure_101_":6973,
"Reactor_Cure_102_":6974,
"Reactor_Cure_201_":6975,
"Reactor_Cure_202_":6976,
"Reactor_A_STR_":6977,
"Reactor_A_INT_":6978,
"Reactor_A_DEF_":6979,
"Reactor_A_AVOI_":6980,
"Reactor_A_ATK_":6981,
"Reactor_A_MATK_":6982,
"Reactor_A_MHP_":6983,
"Reactor_A_MSP_":6984,
"Reactor_A_FROZ_":6985,
"Reactor_A_ASPD_":6986,
"Guarantee_Weapon_10Up":6993,
"Guarantee_Armor_10Up":6994,
"WarmStone":6995,
"Rabbit_Doll":6996,
"Antique_Arrow":6997,
"HPdrainStone_Top":6999,
"Evt_Cos_Coin":7000,
"Mould_Powder":7001,
"Ogre_Tooth":7002,
"Anolian_Skin":7003,
"Mud_Lump":7004,
"Skull":7005,
"Wing_Of_Red_Bat":7006,
"Claw_Of_Rat":7007,
"Stiff_Horn":7008,
"Glitter_Shell":7009,
"Tail_Of_Steel_Scorpion":7010,
"Claw_Of_Monkey":7011,
"Tough_Scalelike_Stem":7012,
"Coral_Reef":7013,
"Old_Portrait":7014,
"Bookclip_In_Memory":7015,
"Spoon_Stub":7016,
"Executioner's_Mitten":7017,
"Young_Twig":7018,
"Loki's_Whispers":7019,
"Mother's_Nightmare":7020,
"Foolishness_Of_Blind":7021,
"Old_Hilt":7022,
"Blade_Lost_In_Darkness":7023,
"Bloody_Edge":7024,
"Lucifer's_Lament":7025,
"Key_Of_Clock_Tower":7026,
"Underground_Key":7027,
"Invite_For_Duel":7028,
"Admission_For_Duel":7029,
"Claw_Of_Desert_Wolf":7030,
"Old_Frying_Pan":7031,
"Piece_Of_Egg_Shell":7032,
"Poison_Spore":7033,
"Red_Socks_With_Holes":7034,
"Matchstick":7035,
"Fang_Of_Garm":7036,
"Trade_Coupon":7037,
"Yarn":7038,
"Novice_Nametag":7039,
"Megaphone":7040,
"Fine_Grit":7041,
"Leather_Bag_Of_Infinity":7042,
"Fine_Sand":7043,
"Vigorgra":7044,
"Magic_Paint":7045,
"Cart_Parts":7046,
"Alice's_Apron":7047,
"Talon_Of_Griffin":7048,
"Stone":7049,
"Cotton_Mat":7050,
"Silk_Mat":7051,
"Old_Magazine":7052,
"Cyfar":7053,
"Brigan":7054,
"Animal_Pooopoo":7055,
"Payroll_Of_Kafra":7056,
"Gallar_Horn":7057,
"Gullraifnir":7058,
"Cargo_Free_Ticket":7059,
"Warp_Free_Ticket":7060,
"Cart_Free_Ticket":7061,
"Turtle_Shell_":7062,
"Soft_Feather":7063,
"Dragon_Fly_Wing":7064,
"Sea_Otter_Leather":7065,
"Ice_Piece":7066,
"Stone_Piece":7067,
"Burn_Tree":7068,
"Broken_Armor_Piece":7069,
"Broken_Shell":7070,
"Tatters_Clothes":7071,
"Rust_Suriken":7072,
"Jewel_Of_Prayer":7073,
"Iron_Glove":7074,
"Iron_Maiden":7075,
"Mystery_Wheel":7076,
"Silver_Fancy":7077,
"Anger_Of_Valkurye":7078,
"Feather_Of_Angel":7079,
"Foot_Step_Of_Cat":7080,
"Beard_Of_Women":7081,
"Root_Of_Stone":7082,
"Soul_Of_Fish":7083,
"Saliva_Of_Bird":7084,
"Tendon_Of_Bear":7085,
"Symbol_Of_Sun":7086,
"Breath_Of_Soul":7087,
"Crystal_Of_Snow":7088,
"Indication_Of_Tempest":7089,
"Slilince_Wave":7090,
"Rough_Billows":7091,
"Air_Stream":7092,
"Wheel":7093,
"Mystery_Piece":7094,
"Broken_Steel_Piece":7095,
"Cold_Magma":7096,
"Burning_Heart":7097,
"Live_Coal":7098,
"Old_Magic_Circle":7099,
"Sharp_Leaf":7100,
"Peco_Wing_Feather":7101,
"Hideous_Dream":7102,
"Unknown_Liquid_Bottle":7103,
"Fake_Angel_Wing":7104,
"Fake_Angel_Loop":7105,
"Goat's_Horn":7106,
"Gaoat's_Skin":7107,
"Boroken_Shiled_Piece":7108,
"Shine_Spear_Blade":7109,
"Vroken_Sword":7110,
"Smooth_Paper":7111,
"Fright_Paper_Blade":7112,
"Broken_Pharaoh_Symbol":7113,
"Tutankhamen's_Mask":7114,
"Harpy's_Feather":7115,
"Harpy's_Claw":7116,
"Rent_Spell_Book":7117,
"Rent_Scroll":7118,
"Spawns":7119,
"Burning_Horse_Shoe":7120,
"Honey_Jar":7121,
"Hot_Hair":7122,
"Dragon's_Skin":7123,
"Sand_Lump":7124,
"Scropion's_Nipper":7125,
"Large_Jellopy":7126,
"Alcol_Create_Book":7127,
"FireBottle_Create_Book":7128,
"Acid_Create_Book":7129,
"Plant_Create_Book":7130,
"Mine_Create_Book":7131,
"Coating_Create_Book":7132,
"Slim_Potion_Create_Book":7133,
"Medicine_Bowl":7134,
"Fire_Bottle":7135,
"Acid_Bottle":7136,
"MenEater_Plant_Bottle":7137,
"Mini_Bottle":7138,
"Coating_Bottle":7139,
"Seed_Of_Life":7140,
"Yggdrasilberry_Dew":7141,
"Germination_Breed":7142,
"Life_Force_Pot":7143,
"Normal_Potion_Book":7144,
"Rag_T_Shirts":7145,
"Vacance_Ticket":7146,
"Jasmin":7147,
"Mother_Letter":7148,
"Yellow_Plate":7149,
"Bamboo_Cut":7150,
"Oil_Paper":7151,
"Glossy_Hair":7152,
"Old_Japaness_Clothes":7153,
"Poison_Powder":7154,
"Poison_Toad's_Skin":7155,
"Broken_Shuriken":7156,
"Black_Mask":7157,
"Broken_Wine_Vessel":7158,
"Tengu's_Nose":7159,
"Lord's_Passable_Ticket":7160,
"Black_Bear's_Skin":7161,
"Cloud_Piece":7162,
"Sharp_Feeler":7163,
"Hard_Peach":7164,
"Limpid_Celestial_Robe":7165,
"Soft_Silk_Cloth":7166,
"Mystery_Iron_Bit":7167,
"Great_Wing":7168,
"Taegeuk_Plate":7169,
"Tuxedo":7170,
"Leopard_Skin":7171,
"Leopard_Talon":7172,
"BurnBuster_Bag":7173,
"Packing_Ribbon":7174,
"Packing_Paper":7175,
"XMAS_Coupon":7176,
"Part_Of_Star's_Sob":7177,
"Star's_Sob":7178,
"Donation_Card":7179,
"Introduction_Of_Mr.Han":7180,
"Receipt_01":7181,
"Cacao":7182,
"Sister_Letter":7183,
"Piano_Keyboard":7184,
"Quiz_Ticket":7185,
"Thin_Stem":7186,
"Festival_Mask":7187,
"Browny_Root":7188,
"Heart_Of_Tree":7189,
"Solid_Peeling":7190,
"Lamplight":7191,
"Blade_Of_Pinwheel":7192,
"Germinating_Sprout":7193,
"Soft_Leaf":7194,
"Air_Rifle":7195,
"Shoulder_Protection":7196,
"Tough_Vines":7197,
"Great_Leaf":7198,
"Coupon":7199,
"Flexible_String":7200,
"Log":7201,
"Beetle_Nipper":7202,
"Solid_Twig":7203,
"Gunpowder":7204,
"Piece_Of_Black_Cloth":7205,
"Black_Kitty_Doll":7206,
"Old_Manteau":7207,
"Rusty_Cleaver":7208,
"Dullahan's_Helm":7209,
"Dullahan_Armor":7210,
"Rojerta_Piece":7211,
"Hanging_Doll":7212,
"Needle_Pouch":7213,
"Bat_Cage":7214,
"Broken_Needle":7215,
"Red_Scarf":7216,
"Spool":7217,
"Rotten_Rope":7218,
"Striped_Socks":7219,
"Ectoplasm":7220,
"Tangled_Chain":7221,
"Tree_Knot":7222,
"Distorted_Portrait":7223,
"Stone_Of_Intelligence":7224,
"Pumpkin_Bucket":7225,
"Pill":7226,
"TCG_Card":7227,
"Gold_Bullion":7228,
"Silver_Bullion":7229,
"White_Gold_Bullion":7230,
"Gold_Ore":7231,
"Silver_Ore":7232,
"Mithril_Ore":7233,
"Soul_Of_Guild":7234,
"Soul_Of_Courage":7235,
"Soul_Of_Guard":7236,
"Soul_Of_Partnership":7237,
"Soul_Of_Correspondence":7238,
"Soul_Of_Proceeding":7239,
"Soul_Of_Confidence":7240,
"Soul_Of_Agreement":7241,
"Soul_Of_Harmony":7242,
"Soul_Of_Cooperate":7243,
"Soul_Of_Unity":7244,
"Soul_Of_Friendship":7245,
"Soul_Of_Peace":7246,
"Soul_Of_Spirit":7247,
"Soul_Of_Honor":7248,
"Soul_Of_Service":7249,
"Soul_Of_Glory":7250,
"Soul_Of_Victory":7251,
"Herb_Medicine":7252,
"Taeguk_Flag":7253,
"Digital_Print_Ticket":7254,
"China_Marble01":7255,
"China_Marble02":7256,
"China_Marble03":7257,
"China_Marble04":7258,
"China_Marble05":7259,
"China_Marble06":7260,
"China_Marble07":7261,
"Fan":7262,
"Cat_Eyed_Stone":7263,
"Dried_Sand":7264,
"Dragon_Horn":7265,
"Dragon_Fang":7266,
"Tiger_Skin_Panties":7267,
"Little_Blacky_Ghost":7268,
"Bib":7269,
"Milk_Bottle":7270,
"Figure":7271,
"Meat_Dumpling_Doll":7272,
"Golden_Necklace":7273,
"Ancient_Translator":7274,
"Ancient_Document":7275,
"Picture_Letter":7276,
"Munak_Doll":7277,
"Wellbeing_Letter":7278,
"Vita500_Lid":7279,
"Quiz_Ticket01":7280,
"Quiz_Ticket02":7281,
"Quiz_Ticket03":7282,
"Quiz_Ticket04":7283,
"Quiz_Ticket05":7284,
"Thread_Skein":7285,
"Chilli":7286,
"Thread_Skein_":7287,
"Thai_Ring":7288,
"Olivine":7289,
"Phlogopite":7290,
"Agate":7291,
"Muscovite":7292,
"Rose_Quartz":7293,
"Turquoise":7294,
"Citrine":7295,
"Pyroxene":7296,
"Biotite":7297,
"Leaf_Clothes":7298,
"Bamboo_Basket":7299,
"Gemstone":7300,
"Sword_Accessory":7301,
"KRATHONG":7302,
"Bag_Of_Rice":7303,
"Witch's_Spell_Book":7304,
"Authority_Of_Nine_World":7305,
"Fragment_Of_Soul":7306,
"Whisper_Of_Soul":7307,
"Witch's_Potion":7308,
"Wing_Of_Crow":7309,
"Free_Peco_Ticket":7310,
"Free_Flying_Ship_Ticket":7311,
"Jubilee":7312,
"Seal_Of_Witch":7313,
"The_Sign":7314,
"Dark_Crystal_Fragment":7315,
"Long_Limb":7316,
"Screw":7317,
"Old_Pick":7318,
"Old_Steel_Plate":7319,
"Air_Pollutant":7320,
"Fragment_Of_Crystal":7321,
"Poisonous_Gas":7322,
"Battered_Kettle":7323,
"IL_Kraken_Leg":7324,
"Tube":7325,
"Fluorescent_Liquid":7326,
"Headlamp":7327,
"Legendary_Scroll":7328,
"Old_Copper_Key":7329,
"2anny":7330,
"Flower_Of_Heaven":7331,
"Slate":7332,
"Piece_Of_Slate_1":7333,
"Piece_Of_Slate_2":7334,
"Piece_Of_Slate_3":7335,
"Piece_Of_Slate_4":7336,
"Eye_Of_Hellion":7337,
"RO_Transportation_Card":7338,
"RO_Transportation_Card_":7339,
"Will_Of_Darkness":7340,
"Worn_Out_Pendant":7341,
"File01":7342,
"File02":7343,
"File03":7344,
"Armlet_Of_Prisoner":7345,
"Pile_Of_Ymir_Heart":7346,
"Lab_Staff_Record":7347,
"Indication_Of_Member01":7348,
"Indication_Of_Member02":7349,
"Pass":7350,
"Friend's_Diary":7351,
"Transparent_Plate01":7352,
"Transparent_Plate02":7353,
"Transparent_Plate03":7354,
"Transparent_Plate04":7355,
"Piece_Of_Crest1":7356,
"Piece_Of_Crest2":7357,
"Piece_Of_Crest3":7358,
"Piece_Of_Crest4":7359,
"RO_Festival_Ticket":7360,
"Lotto01":7361,
"Lotto02":7362,
"Lotto03":7363,
"Lotto04":7364,
"Lotto05":7365,
"Lotto06":7366,
"Lotto07":7367,
"Lotto08":7368,
"Lotto09":7369,
"Lotto10":7370,
"Lotto11":7371,
"Lotto12":7372,
"Lotto13":7373,
"Lotto14":7374,
"Lotto15":7375,
"Lotto16":7376,
"Lotto17":7377,
"Lotto18":7378,
"Lotto19":7379,
"Lotto20":7380,
"Lotto21":7381,
"Lotto22":7382,
"Lotto23":7383,
"Lotto24":7384,
"Lotto25":7385,
"Lotto26":7386,
"Lotto27":7387,
"Lotto28":7388,
"Lotto29":7389,
"Lotto30":7390,
"Lotto31":7391,
"Lotto32":7392,
"Lotto33":7393,
"Lotto34":7394,
"Lotto35":7395,
"Lotto36":7396,
"Lotto37":7397,
"Lotto38":7398,
"Word_Card01":7399,
"Word_Card02":7400,
"Word_Card03":7401,
"Word_Card04":7402,
"Word_Card05":7403,
"Word_Card06":7404,
"Crushed_Can":7405,
"Moon_Cake1":7406,
"Moon_Cake2":7407,
"Moon_Cake3":7408,
"Moon_Cake4":7409,
"Moon_Cake5":7410,
"Moon_Cake6":7411,
"Moon_Cake7":7412,
"Moon_Cake8":7413,
"Moon_Cake9":7414,
"Stone_Of_Summons":7415,
"Letter_Of_Recommend":7416,
"Mission_ScrollA":7417,
"Mission_ScrollB":7418,
"Embryo_HandBook":7419,
"Skull_":7420,
"Key_Red":7421,
"Key_Yellow":7422,
"Key_Blue":7423,
"Key_Green":7424,
"Key_Black":7425,
"Magic_Gem_Red":7426,
"Magic_Gem_Yellow":7427,
"Magic_Gem_Blue":7428,
"Magic_Gem_Green":7429,
"Magic_Gem_Black":7430,
"Several_Books":7431,
"Leather_Pouch":7432,
"Scroll":7433,
"Elemental_Potion_Book":7434,
"Golden_Bracelet":7435,
"Piece_Of_Memory_Green":7436,
"Piece_Of_Memory_Purple":7437,
"Piece_Of_Memory_Blue":7438,
"Piece_Of_Memory_Red":7439,
"Red_Feather":7440,
"Blue_Feather":7441,
"Cursed_Seal":7442,
"Tri_Headed_Dragon_Head":7443,
"Treasure_Box":7444,
"Dragonball_Green":7445,
"Dragonball_Blue":7446,
"Dragonball_Red":7447,
"Dragonball_Yellow":7448,
"Bloody_Page":7449,
"Piece_Of_Bone_Armor":7450,
"Scale_Of_Red_Dragon":7451,
"Yellow_Spice":7452,
"Sweet_Sauce":7453,
"Plain_Sauce":7454,
"Hot_Sauce":7455,
"Red_Spice":7456,
"Cooking_Oil":7457,
"Baphomet's_Horn":7458,
"RAMADAN_":7459,
"Niflheim_Ticket":7460,
"BlueCard_A":7461,
"BlueCard_E":7462,
"BlueCard_F":7463,
"BlueCard_H":7464,
"BlueCard_L":7465,
"BlueCard_N":7466,
"BlueCard_O":7467,
"BlueCard_P":7468,
"BlueCard_U":7469,
"BlueCard_W":7470,
"BlueCard_Y":7471,
"Cookbook01":7472,
"Cookbook02":7473,
"Cookbook03":7474,
"Cookbook04":7475,
"Cookbook05":7476,
"Cookbook06":7477,
"Cookbook07":7478,
"Cookbook08":7479,
"Cookbook09":7480,
"Cookbook10":7481,
"Pot":7482,
"Key_Of_Seal":7483,
"Warrior_Symbol":7484,
"2nd_Floor_Pass":7485,
"3rd_Floor_Pass":7486,
"Tavern_Wine":7487,
"Delivery_Box":7488,
"Villa_Spare_Key":7489,
"Kyll_Hire_Letter":7490,
"Iron_Box":7491,
"Yellow_Key_Card":7492,
"Golden_Key":7493,
"Kiel_Button":7494,
"Blue_Key_Card":7495,
"Red_Key_Card":7496,
"Steel_Piece":7497,
"Rosimier_Key":7498,
"Family_Portrait":7499,
"Elysia_Portrait":7500,
"Kyll_Hire_Letter2":7501,
"Piece_Memo_Of_James":7502,
"Man_Portrait":7503,
"Toy_Motor":7504,
"Toy_Key":7505,
"Black_Key_Card":7506,
"Sturdy_Iron_Piece":7507,
"Elysia_Ring":7508,
"Fancy_Key_Card":7509,
"Valhalla_Flower":7510,
"Rune_Of_Darkness":7511,
"Burnt_Parts":7512,
"Pocket_Watch":7513,
"Monster_Ticket":7514,
"Marvelous_Medal":7515,
"Green_Key_Card":7516,
"Gold_Coin_":7517,
"Women's_Medal":7518,
"Money_Envelope":7519,
"Chinese_Scroll":7520,
"Flame_Stone":7521,
"Ice_Stone":7522,
"Wind_Stone":7523,
"Shadow_Orb":7524,
"Summer_Feast_Ticket":7525,
"Manuscript_Paper":7526,
"Life_Book":7527,
"Id_Lottery_Ticket":7528,
"Stolen_Sandals":7529,
"Travel_Brochure_01":7530,
"Travel_Brochure_02":7531,
"Travel_Brochure_03":7532,
"Travel_Brochure_04":7533,
"Photo_Album_01":7534,
"Photo_Album_02":7535,
"Photo_Album_03":7536,
"Photo_Album_04":7537,
"Sifted_Sand":7538,
"Poring_Coin":7539,
"Lotto39":7540,
"Lotto40":7541,
"Lotto41":7542,
"Lotto42":7543,
"Lotto43":7544,
"Lotto44":7545,
"Lotto45":7546,
"Soccer_Ball":7547,
"Soccer_Shoes":7548,
"Brazilian_Flag":7549,
"Ticket01":7550,
"Ticket02":7551,
"Ticket03":7552,
"Lotus_Flower":7553,
"Striped_Candle":7554,
"Green_Incense":7555,
"Longing_Heart":7556,
"Invitation_Letter":7557,
"Invitation_Ticket":7558,
"Key_Of_Flower_Garden":7559,
"Longing_Heart2":7560,
"Ice_Heart":7561,
"Ice_Scale":7562,
"Bloody_Rune":7563,
"Rotten_Meat":7564,
"Sticky_Poison":7565,
"Will_Of_Darkness_":7566,
"Suspicious_Hat":7567,
"White_Mask":7568,
"Hammer_Of_Wind":7569,
"Temple_Lottery_Ticket":7570,
"Diary_Of_Blue":7571,
"Magic_Necklace":7572,
"Magic_Necklace_":7573,
"Ice_Particle":7574,
"Red_Jewel_":7575,
"Blue_Jewel_":7576,
"Golden_Jewel_":7577,
"Anti_Spell_Bead":7578,
"Silk_Handkerchief":7579,
"Black_Bead":7580,
"Anniversary_Ticket":7581,
"Gem_Of_Ruin":7582,
"Evil_Mind":7583,
"Proof_Of_Guard1":7584,
"Proof_Of_Guard2":7585,
"Proof_Of_Guard3":7586,
"Proof_Of_Guard4":7587,
"IPOD_Ticker":7588,
"Moon_Cake10":7589,
"Moon_Cake11":7590,
"Moon_Cake12":7591,
"Moon_Cake13":7592,
"Moon_Cake14":7593,
"Sonia's_Letter":7594,
"Unique_Sword":7595,
"Unique_Shield":7596,
"Magic_Stone":7597,
"BlueCard_I":7598,
"BlueCard_D":7599,
"BlueCard_K":7600,
"BlueCard_S":7601,
"BlueCard_R":7602,
"RO_Party_Ticket":7603,
"Flour":7604,
"Chicken_Egg":7605,
"Coin":7606,
"Evil_Dragon_Head":7607,
"Premium_Ticket":7608,
"Pumpkin_Mojo":7609,
"Food_Ticket":7610,
"Fox_Symbol":7611,
"Heart_Of_Fox_Queen":7612,
"Small_Rice_Dough":7613,
"Special_Packing_Paper":7614,
"MVP_Ticket":7615,
"Mini_Boss_Ticket":7616,
"Monster_Ticket_":7617,
"Monster_Crystal":7618,
"Enriched_Elunium":7619,
"Enriched_Oridecon":7620,
"Token_Of_Siegfried":7621,
"New_Style_Coupon":7622,
"Name_Change_Coupon":7623,
"Spring_Stanza23":7624,
"Registration_Ticket":7625,
"Bubble_Gum_Token":7626,
"Sage_Key":7627,
"Idiot_Key":7628,
"Pink_Gift_Box":7629,
"Clean_Beach_Brush":7630,
"Trash_Debris":7631,
"To_Afterworld_Record":7632,
"To_Heaven_Record":7633,
"Rose_Of_Father":7634,
"Perfume_Pouch":7635,
"Magic_Potion_Bottle":7636,
"Father_Giftbox":7637,
"Tw_Green_Box":7638,
"Tw_Red_Box":7639,
"Butterfly_Hair_Clip":7640,
"Cure_Box":7641,
"Bloody_Coin":7642,
"Bloody_Letter":7643,
"Unsent_Mail":7644,
"RO_Luk_Bookmark":7646,
"Taiwan_Luk_Coin":7647,
"Snake_Bookmark":7648,
"Big_Luk_Bookmark":7649,
"Mystery_Egg":7651,
"Full_Metal_Jacket":7663,
"Shooting_Mine":7664,
"Dragon_Tail_Missile":7665,
"TimeTravel_Scroll":7666,
"Abandoned_Machine":7667,
"Clean_Bandage":7668,
"Rubbing_Alchohol":7669,
"Sour_Grass":7670,
"187_Firstaid_Kit":7671,
"Relief_Food":7672,
"Mysterious_Ingredient":7674,
"Mysterious_Doll":7675,
"Transmission_Coupon":7676,
"Oneclick_Weapon_7UP":7679,
"Oneclick_Weapon9UP":7680,
"Oneclick_Armor_7UP":7681,
"Oneclick_Armor_9UP":7682,
"Sour_Melon":7685,
"Special_Tiket":7690,
"Dragon_Spirit":7701,
"Special_Cogwheel":7702,
"Piece_Of_Cogwheel":7703,
"Broken_Thermometer":7704,
"Note_Of_Geologist":7705,
"Spoiled_Carrot_Juice":7706,
"Spoiled_Banana_Juice":7707,
"Spoiled_Apple_Juice":7708,
"Spoiled_Grape_Juice":7709,
"Black_Gemstone":7710,
"Update_Ticket":7711,
"Nokia5500":7712,
"BlueCard_A_":7713,
"BlueCard_R_":7714,
"Handmade_Choco_Recipe":7715,
"Strawberry_Choco_Recipe":7716,
"Choco_Tart_Recipe":7717,
"Cacao_Bean":7718,
"BlueCard_G":7719,
"Gold_Coin_US":7720,
"Treasure_Box_":7721,
"Debt_Note":7722,
"Diamond_Of_Ruin":7723,
"Forbidden_Secret_Art":7724,
"Unlucky_Emerald":7725,
"Token_Of_King":7726,
"HP_Doctor_Ticket":7727,
"SP_Doctor_Ticket":7728,
"Rok_Star_Badge":7729,
"Mission_Certificate1":7730,
"Mission_Certificate2":7731,
"Mission_Certificate3":7732,
"Mission_Certificate4":7733,
"Mission_Certificate5":7734,
"Mission_Certificate6":7735,
"Mission_Certificate7":7736,
"Mission_Certificate8":7737,
"Mission_Certificate9":7738,
"Mission_Certificate10":7739,
"Mission_Certificate11":7740,
"Mission_Certificate12":7741,
"Kaong":7742,
"Gulaman":7743,
"Leche_Flan":7744,
"Ube_Jam":7745,
"Sago":7746,
"Langka":7747,
"Sweet_Bean":7748,
"Sweet_Banana":7749,
"Macapuno":7750,
"Old_White_Cloth":7751,
"Clattering_Skull":7752,
"Broken_Farming_Utensil":7753,
"Broken_Crown":7754,
"Research_Note":7755,
"Sealed_Book":7756,
"Mithril":7757,
"Star_Crystal":7758,
"Geology_Report":7759,
"Yaga_Magic_Book":7760,
"Magic_Gourd_Bottle":7761,
"Yaga_Pestle":7762,
"Sticky_Herb":7763,
"High_Strength_Adhesive":7764,
"Yaga_Secret_Medicine":7765,
"Bok_Choy":7766,
"Chung_E_Cake":7767,
"Squid":7768,
"Egg_Yolk":7769,
"Sweet_Rice":7770,
"Lotus_Leaf":7771,
"String":7772,
"War_Badge":7773,
"Chung_E_Ticket":7774,
"Spring_Rabbit_Ticket":7775,
"Max_Weight_Up_Scroll":7776,
"Gold_Box":7777,
"Silver_Box":7778,
"Gold_Key_TW":7779,
"Silver_Key":7780,
"Heart_Box":7781,
"Gold_Key77":7782,
"Silver_Key77":7783,
"Fawner_Coupon1":7784,
"Fawner_Coupon2":7785,
"Fawner_Coupon3":7786,
"Fawner_Coupon4":7787,
"Fawner_Coupon5":7788,
"Fawner_Coupon6":7789,
"Fawner_Coupon7":7790,
"Fawner_Coupon8":7791,
"Guyak":7792,
"Golden_Apple":7793,
"Fate_Of_Crow":7794,
"Mami_Photo_Album":7795,
"Author_Autograph":7796,
"Author_Memo":7797,
"Dark_Debris":7798,
"Dark_Crystal":7799,
"Golden_Apple_":7800,
"Girl_Fan_Letter":7801,
"Autograph_Book":7802,
"Battle_Manual_TW":7803,
"Octopig_Tentacle":7804,
"Brown_Ring":7805,
"Black_Anvil":7806,
"Ore":7807,
"Gold_Hammer":7808,
"Gold_Furnace":7809,
"Yellow_Cat_Eyed_Stone":7810,
"Gold_Anvil":7811,
"Red_Cat_Eyed_Stone":7812,
"Th_Red_Ring":7813,
"Green_Ring":7814,
"Blue_Ring":7815,
"Blue_Cat_Eyed_Stone":7816,
"White_Cat_Eyed_Stone":7817,
"RJC_Golden_Necklace":7818,
"Nokia5300":7819,
"Morroc_Skin":7820,
"Green_Apple":7821,
"Whole_Barbecue":7822,
"Meat_Veg_Skewer":7823,
"Spirit_Liquor":7824,
"Heroic_Stone":7825,
"Continental_Guard_Paper":7826,
"Mineral_Report":7827,
"BF_Badge1":7828,
"BF_Badge2":7829,
"Goddess_Tear":7830,
"Valkyrie_Token":7831,
"Brynhild_Armor_Piece":7832,
"Hero_Remains":7833,
"Andvari_Ring":7834,
"Dusk_Glow":7835,
"Dawn_Essence":7836,
"Cold_Moonlight":7837,
"Hazy_Starlight":7838,
"Crystal_Key":7839,
"Valkyrie_Gift":7840,
"Spotted_Paper":7841,
"Torn_Paper":7842,
"Old_Paper":7843,
"Burnt_Paper":7844,
"Copy_Of_Spotted_Paper":7845,
"Copy_Of_Torn_Paper":7846,
"Copy_Of_Old_Paper":7847,
"Copy_Of_Burnt_Paper":7848,
"Soul_Crystal":7849,
"Wooden_Block_":7850,
"Pass_F1":7851,
"Pass_F2":7852,
"Pass_F3":7853,
"Pass_CF":7854,
"Heart":7855,
"GuillotineC_Pack_Item_2":7856,
"Handmade_Kitty_Doll":7857,
"Dragonball_Yellow_":7858,
"Game_Ticket":7859,
"Peeps":7860,
"Jelly_Bean":7861,
"Marshmallow":7862,
"GOLD_ID4":7863,
"Love_Flower":7864,
"Gold_Pouch":7865,
"Certificate":7866,
"SesamePouch":7867,
"Water":7868,
"RicePouch":7869,
"Corn":7870,
"BeanPouch":7871,
"Grass":7872,
"MVP_Monster_Scroll":7873,
"Monster_Scroll":7874,
"Pirate_Box":7875,
"Gold_Key":7876,
"Red_Ring":7877,
"Lusalka_Hair":7878,
"Golden_Thread":7879,
"Babayaga_Silver_Spoon":7880,
"Book_Of_Magic":7881,
"Pointed_Branch":7882,
"Pointed_Wooden_Flute":7883,
"Jade_Plate":7884,
"Sacred_Arrow":7885,
"Bean_Paste":7886,
"Dried_Fruit_Box":7887,
"Bag_Of_Nuts":7888,
"Chicken_Feed":7889,
"Mug":7891,
"Charcoal":7892,
"Sulfur":7893,
"Nitrate":7894,
"TRO_Memory_Book01":7895,
"TRO_Memory_Book02":7896,
"TRO_Memory_Book03":7897,
"VVS_Balmung":7898,
"Spiritualist_Dagger":7899,
"Jenoss_Ring1":7900,
"Jenoss_Ring2":7901,
"Jenoss_Ring3":7902,
"Jenoss_Ring4":7903,
"Piano_Key":7904,
"Rok_Star_Badge_":7905,
"Poppy_Wreath":7906,
"Bobbin_Of_Goddess":7907,
"Louis_Hair_Coupon":7908,
"Stolen_Cookie":7909,
"Stolen_Candy":7910,
"Yulia_Hat":7911,
"Portable_Snowman":7912,
"Test_Certificate":7913,
"Ancient_Document_TW":7914,
"Copper_Coin_":7915,
"Silver_Coin_":7916,
"Magic_Potion":7917,
"Particle_Of_Memory":7918,
"Festival_Ticket":7919,
"Hero's_Arsenal":7920,
"Essence_Of_Dragon":7921,
"RWC_Ticket":7922,
"KRATHONG_":7923,
"Special_Ticket_Lv170":7924,
"M_Dimension_Essence":7925,
"Break_Box_CN":7926,
"Old_Box_CN":7927,
"Brazilian_Flag_":7928,
"Golden_Coin_":7929,
"Cowking's_Nose_Ring":7930,
"Poison_Kit":7931,
"Poison_Herb_Nerium":7932,
"Poison_Herb_Rantana":7933,
"Poison_Herb_Makulata":7934,
"Poison_Herb_Seratum":7935,
"Poison_Herb_Scopolia":7936,
"Poison_Herb_Amoena":7937,
"Light_Granule":7938,
"Elder_Branch":7939,
"Special_Alloy_Trap":7940,
"Halloween_Ticket":7941,
"Letter_From_Chico":7942,
"Caskinya":7943,
"Box_Of_Seal":7944,
"Almighty_Charm":7945,
"Valentine_Gold_Ring":7946,
"Valentine_Silver_Ring":7947,
"Box":7948,
"Woven_Wool":7949,
"Ayothaya_Ticket":7950,
"Gold_Tulip":7951,
"Gift_From_Romiros":7952,
"Gift_From_Juliedge":7953,
"Festival_Ticket_":7954,
"Lost_Card1":7955,
"Lost_Card2":7956,
"Lost_Card3":7957,
"Lost_Card4":7958,
"Ancient_Gold_Coin":7959,
"Ancient_Silver_Coin":7960,
"Weapon_Exchange":7961,
"Treasure_Map1":7962,
"Treasure_Map2":7963,
"Treasure_Map3":7964,
"Treasure_Map4":7965,
"Weird_Parchment1":7966,
"Weird_Parchment2":7967,
"Weird_Parchment3":7968,
"Weird_Parchment4":7969,
"Unwritten_Letter1":7970,
"Unwritten_Letter2":7971,
"Oath_Day_Letter":7972,
"Immortality_Egg":7973,
"Illusion_Piece":7974,
"Cupid_Choco":7975,
"Gf_Magic_Coin":7976,
"Hunting_Medal_Badge":7977,
"Spring_Stanza1":7978,
"Spring_Stanza2":7979,
"Spring_Stanza3":7980,
"Spring_Stanza4":7981,
"Spring_Stanza5":7982,
"Spring_Stanza6":7983,
"Spring_Stanza7":7984,
"Spring_Stanza8":7985,
"Spring_Stanza9":7986,
"Spring_Stanza10":7987,
"Spring_Stanza11":7988,
"Spring_Stanza12":7989,
"Spring_Stanza13":7990,
"Spring_Stanza14":7991,
"Spring_Stanza15":7992,
"Spring_Stanza16":7993,
"Spring_Stanza17":7994,
"Spring_Stanza18":7995,
"Spring_Stanza19":7996,
"Spring_Stanza20":7997,
"Spring_Stanza21":7998,
"Spring_Stanza22":7999,
"Poring_Egg":9001,
"Drops_Egg":9002,
"Poporing_Egg":9003,
"Lunatic_Egg":9004,
"Picky_Egg":9005,
"Chonchon_Egg":9006,
"Steel_Chonchon_Egg":9007,
"Hunter_Fly_Egg":9008,
"Savage_Bebe_Egg":9009,
"Baby_Desert_Wolf_Egg":9010,
"Rocker_Egg":9011,
"Spore_Egg":9012,
"Poison_Spore_Egg":9013,
"PecoPeco_Egg":9014,
"Smokie_Egg":9015,
"Yoyo_Egg":9016,
"Orc_Warrior_Egg":9017,
"Munak_Egg":9018,
"Dokkaebi_Egg":9019,
"Sohee_Egg":9020,
"Isis_Egg":9021,
"Green_Petite_Egg":9022,
"Deviruchi_Egg":9023,
"Bapho_Jr._Egg":9024,
"Bongun_Egg":9025,
"Zherlthsh_Egg":9026,
"Alice_Egg":9027,
"Rice_Cake_Egg":9028,
"Santa_Goblin_Egg":9029,
"Chung_E_Egg":9030,
"Spring_Rabbit_Egg":9031,
"Knife_Goblin_Egg":9032,
"Flail_Goblin_Egg":9033,
"Hammer_Goblin_Egg":9034,
"Red_Deleter_Egg":9035,
"Diabolic_Egg":9036,
"Wanderer_Egg":9037,
"New_Year_Doll_Egg":9038,
"Bacsojin_Egg":9039,
"Civil_Servant_Egg":9040,
"Leaf_Cat_Egg":9041,
"Loli_Ruri_Egg":9042,
"Marionette_Egg":9043,
"Shinobi_Egg":9044,
"Whisper_Egg":9045,
"Goblin_Leader_Egg":9046,
"Wicked_Nymph_Egg":9047,
"Miyabi_Ningyo_Egg":9048,
"Dullahan_Egg":9049,
"Medusa_Egg":9050,
"Stone_Shooter_Egg":9051,
"Incubus_Egg":9052,
"Golem_Egg":9053,
"Nightmare_Terror_Egg":9054,
"Succubus_Egg":9055,
"Imp_Egg":9056,
"Egg_Of_Tiny":9057,
"Snow_Rabbit_Egg":9058,
"Tikbalang_Pet":9059,
"Brownie_Egg":9060,
"Marin_Egg":9061,
"Novice_Poring_Egg":9062,
"Woodie_Egg":9063,
"Elephant_Egg":9064,
"Gorilla_Egg":9065,
"Lion_Egg":9066,
"Rhino_Egg":9067,
"Blue_Unicorn_Egg":9068,
"Mastering_Egg":9069,
"Savage_Egg":9070,
"Grand_Peco_Egg":9071,
"Orc_Hero_Egg":9072,
"Orc_Lord_Egg":9073,
"Rubylit_Egg":9074,
"Sapphilit_Egg":9075,
"Emelit_Egg":9076,
"Topalit_Egg":9077,
"Amelit_Egg":9078,
"Mythlit_Egg":9079,
"Tamadora_Egg":9080,
"High_Orc_Egg":9087,
"Angeling_Egg":9088,
"Ammut_Egg":9089,
"Littleisis_Egg":9090,
"Choco_Egg":9091,
"Eggring_Egg":9092,
"Hyegun_Egg":9093,
"Leaf_Lunatic_Egg":9094,
"Nine_Tail_Egg":9095,
"Cat_O_Nine_Tail_Egg":9096,
"Diabolic_Egg2":9097,
"Red_Deleter_Egg2":9098,
"Teddy_Bear_Egg":9099,
"Gremlin_Egg":9100,
"Scatletoncarrier":9101,
"Mummy_Egg":9102,
"Wilow_Egg":9103,
"Roween_Egg":9104,
"Hodremlin_Egg":9105,
"Metaller_Egg":9106,
"Ancient_Mummy_Egg":9107,
"Xm_Teddybear_Egg":9108,
"Sweets_Drops_Egg":9109,
"Phreeoni_Egg":9111,
"Moonlight_Egg":9112,
"Roost_Of_Skelion":9113,
"Pouring_Egg":9114,
"Bacsojin_Egg2":9115,
"Nightmare_TerrorH_EGG":9116,
"Wanderer_H_EGG":9117,
"Aliot_EGG":9118,
"Alicel_EGG":9119,
"Aliza_EGG":9120,
"Ork_Hero_EGG":9121,
"Gloom_Under_Egg":9122,
"Ep17_2_C_Admin1_Egg":9123,
"Ep17_2_C_Admin2_Egg":9124,
"E_Duckling_Egg":9125,
"Kiel_Egg":9126,
"Dark_Priest_Egg":9128,
"Desert_Wolf_Egg":9129,
"Chaos_Bapho_Jr_Egg":9130,
"Fire_Golem_Egg":9131,
"Abyss_Knight_Egg":9132,
"Change_W_Knight_Egg":9133,
"White_Knight_Egg":9134,
"Baphomet_Egg":9137,
"Farmiliar_Egg":9138,
"Dark_Illusion_Egg":9139,
"Blue_Moon_Loli_Ruri_Egg":9140,
"Wild_Rose_Egg2":9141,
"Eddga_Egg2":9142,
"Larva_Violet_Egg":9144,
"Copo_Egg":9145,
"Grey_Icewind_Egg":9146,
"Icewind_Egg":9147,
"Dark_Lord_Egg":9148,
"aegis_9155":9155,
"Sonic_Chao_Egg":9156,
"aegis_9157":9157,
"CLB_SS_Egg01":9183,
"CLB_SS_Egg02":9184,
"aegis_9192":9192,
"aegis_9193":9193,
"Enchant_Stone_Box17":9510,
"Ein_Ddbox":9514,
"Ein_1HITEMbox":9515,
"Ein_UNDIUM":9517,
"Metal_Rifine_Ticket":9523,
"Ein_Ddbox2":9529,
"PC_Costume_Box":9530,
"Blue_Potion_B_10":9539,
"Gemstone_Of_Time":9550,
"Time_Unseal_Key":9551,
"C_CatPaw_7Day_Box_":9553,
"Festival_Noodle":9569,
"Wet_Sealed_Card":9581,
"Fancy_Spray_Of_Flowers":9582,
"Small_Spray_Of_Flowers":9585,
"2019_SStarR_Tbox":9586,
"E_Life_Potion_Pack":9587,
"E_DEF_Scroll_Box":9588,
"E_Almighty_Box":9589,
"E_LimitPowerBooster":9590,
"E_Mysterious_Water":9610,
"Frozen_Box_IL":9785,
"Comp_Job_Manual50":9862,
"DF_Adrenaline_Scroll":9894,
"DF_Abrasive":9895,
"DF_Power_Booster":9896,
"E_Glittering_Doll_B":9897,
"DF_Mental_Potion":9908,
"DF_Ex_Def_Potion":9909,
"Royal_Secret_Box":9932,
"True_Hunting_9Refine":9933,
"True_Hunting_Opt_A":9934,
"True_Hunting_Opt_B":9935,
"Arca_Cura_BR":9969,
"Arca_Palito_BR":9970,
"Arca_Batalha2_BR":9971,
"Arca_Batalha_BR":9972,
"Arca_Vida2_BR":9973,
"Arca_Vida_BR":9974,
"Arca_Divina2_BR":9975,
"Arca_Divina_BR":9976,
"Arca_Refino2_BR":9977,
"Arca_Refino_BR":9978,
"Arca_Enriquecido_BR":9979,
"Arca_Minerio_BR":9980,
"Arca_Pergaminho_BR":9981,
"Arca_Especial_BR":9982,
"Arca_Celeste2_BR":9983,
"Arca_Celeste_BR":9984,
"Arca_Status_BR":9985,
"Arca_Reset_BR":9986,
"Arca_Up2_BR":9987,
"Arca_Up_BR":9988,
"Boarding_Halter_Box_7d":9991,
"Season_Evt_Reward_2":9999,
"Skull_Helm":10001,
"Monster_Oxygen_Mask":10002,
"Transparent_Headgear":10003,
"Pacifier":10004,
"Wig":10005,
"Queen's_Hair_Ornament":10006,
"Silk_Ribbon":10007,
"Punisher":10008,
"Wild_Flower":10009,
"Battered_Pot":10010,
"Stellar_Hairpin":10011,
"Tiny_Egg_Shell":10012,
"Backpack":10013,
"Rocker_Glasses":10014,
"Green_Lace":10015,
"Golden_Bell":10016,
"Bark_Shorts":10017,
"Monkey_Circlet":10018,
"Red_Muffler":10019,
"Sword_Of_Grave_Keeper":10020,
"Round_Hair_Ornament":10021,
"Golden_Earing":10022,
"Green_Lucky_Bag":10023,
"Fashionable_Glasses":10024,
"Star_Hairband":10025,
"Wine_On_Sleeve":10026,
"Spirit_Chain_":10027,
"Nice_Badge":10028,
"Jade_Trinket":10029,
"Summer_Fan":10030,
"Death_Coil":10031,
"Queen's_Coronet":10032,
"Apro_Hair":10033,
"Ball_Mask":10034,
"Windup_Spring":10035,
"Hell_Horn":10036,
"Black_Butterfly_Mask":10037,
"Horn_Protector":10038,
"Tw_Backpack":10039,
"Red_Chorker_Bell":10040,
"Twinkle_Star_Button":10041,
"Dark_Mane":10042,
"Ep_17_2_C_Admin1_Acc":10043,
"Ep_17_2_C_Admin2_Acc":10044,
"C_Twinkle_Star_Button":10045,
"Hero_Hammer_Package_5":10625,
"Prontera_Book_01":11000,
"Adventure_Story01":11001,
"Great_Chef_Orleans01":11002,
"Legend_Of_Kafra01":11003,
"Mercenary_Rebellion":11004,
"Tyrant_Schmidt":11005,
"Blood_Flower01":11006,
"Blood_Flower02":11007,
"Barmund":11008,
"Adventure_Story02":11009,
"Reward_List_Book":11010,
"Barmund_Note":11011,
"Expedition_Report":11012,
"Expedition_Report_Vol1":11013,
"Expedition_Report_Vol2":11014,
"Expedition_Report_Vol3":11015,
"Expedition_Report_Vol4":11016,
"Reward_List_Book2":11017,
"Splendide_Selling_Item":11018,
"Manuk_Selling_Item":11019,
"Japan_Book1":11020,
"Japan_Book2":11021,
"Mix_Cook_Book":11022,
"Increase_Stamina_Study":11023,
"Vital_Drink_CB":11024,
"Swordman_Book_Basic":11025,
"Swordman_Book_Practice":11026,
"Swrodman_Book_Misc":11027,
"Thief_Book_Basic":11028,
"Thief_Book_Practice":11029,
"Thief_Book_Misc":11030,
"Archer_Book_Basic":11031,
"Archer_Book_Practice":11032,
"Archer_Book_Misc":11033,
"Acol_Book_Basic":11034,
"Acol_Book_Practice":11035,
"Acol_Book_Misc":11036,
"Mage_Book_Basic":11037,
"Mage_Book_Practice":11038,
"Mage_Book_Misc":11039,
"Mer_Book_Basic":11040,
"Mer_Book_Practice":11041,
"Mer_Book_Misc":11042,
"TK_Book_Basic":11043,
"TK_Book_Practice":11044,
"TK_Book_Misc":11045,
"Ninja_Book_Basic":11046,
"Ninja_Book_Practice":11047,
"Ninja_Book_Misc":11048,
"Gun_Book_Basic":11049,
"Gun_Book_Practice":11050,
"Gun_Book_Misc":11051,
"SN_Book_Basic":11052,
"SN_Book_Practice":11053,
"SN_Book_Misc":11054,
"Basic_Adventure":11055,
"Spiritualism_Guide":11056,
"Feb_Sweets":11057,
"Novice_Combi_Book":11058,
"WoE_TE_Rental_List":11059,
"Energy_Xtal_Combi_Book":11060,
"EP16List":11061,
"Spiritualism_Guide2":11064,
"Light_Yellow_Pot":11500,
"Light_White_Pot":11501,
"Light_Blue_Pot":11502,
"Siege_White_Potion":11503,
"Siege_Blue_Potion":11504,
"Iris":11505,
"Fanta_Orange":11506,
"Fanta_Grape":11507,
"Karada_Meguri_Tea":11508,
"Royal_Milk_Tea":11509,
"Coke_Zero":11510,
"Coke_No_Cal":11511,
"Coca_Cola":11512,
"Protect_Neck_Candy":11513,
"Enriched_Slim_Pot":11514,
"Coconut":11515,
"Asai_Fruit":11516,
"Puri_Potion":11517,
"N_Blue_Potion":11518,
"Beef_Toast":11519,
"Mora_Mandarin":11520,
"Pingui_Berry_Juice":11521,
"Red_Raffle_Sap":11522,
"Yellow_Raffle_Sap":11523,
"White_Raffle_Sap":11524,
"Mora_Hip_Tea":11525,
"Rafflecino":11526,
"Baklava":11527,
"Kanafeh":11528,
"MAAMOUL_":11529,
"Jujube":11530,
"Coffee":11531,
"Nasi_Goreng":11532,
"Satay":11533,
"Coco_Juice":11534,
"Almond_Chocolate":11535,
"Cat_Hard_Biscuit":11536,
"Rice_weevil_Bug":11537,
"Octupus_Leg":11538,
"Athale_Choco":11539,
"Shyai_Choco":11540,
"Mid_Choco":11541,
"Zonda_Choco":11542,
"Goedo_Choco":11543,
"Huike_Choco":11544,
"Rune_Choco":11545,
"Pope_Choco":11546,
"Woe_Violet_Potion":11547,
"Woe_White_Potion":11548,
"Woe_Blue_Potion":11549,
"Pumpkin_Cake":11550,
"Savory_Herb_Salad":11551,
"Apple_Carrot_Salad":11552,
"Casual_Stew":11553,
"Golden_Roasted_Apple":11554,
"Red_Potion_RG":11555,
"Blue_Potion_RG":11556,
"TE_White_Potion":11557,
"TE_White_Slim_Potion":11558,
"Pie_Fruit":11562,
"Hot_Tee":11563,
"Sweet_Canape":11564,
"White_Potion_B":11565,
"Yellow_Potion_B":11566,
"Novice_Potion_B":11567,
"Red_Slim_Potion_B":11568,
"Orange_Potion_B":11569,
"Red_Potion_B":11570,
"Green_Potion_B":11571,
"Blue_Potion_B":11572,
"White_Slim_Potion_B":11573,
"Yellow_Slim_Potion_B":11574,
"Lucky_Cookie_B":11575,
"Lucky_Candy_Cane_B":11576,
"Rice_Ball_B":11577,
"Candy_Striper_B":11578,
"Lucky_Candy_B":11579,
"Candy_B":11580,
"Piece_Of_Cake_B":11581,
"Well_Baked_Cookie_B":11582,
"Chocolate_Drink_B":11583,
"White_Chocolate_B":11584,
"HandMade_Chocolate_B":11585,
"HandMade_Chocolate_B_":11586,
"Chocolate_B":11587,
"Strawberry_":11588,
"Iceflake":11589,
"Meat_Skewer5":11590,
"Trance_Candy_R":11592,
"Trance_Candy_B":11593,
"Trance_Candy_Y":11594,
"Trance_Candy_G":11595,
"Blood_In_Skull":11596,
"Iron_Bug":11597,
"Bitter_Cacao_Bean":11598,
"superstar_potion":11599,
"ShiningHolyWater":11600,
"Tasty_Anchovy":11601,
"Nepeta_Cataria":11602,
"Fruit_Of_Mastela_":11603,
"Royal_Jelly_":11604,
"Cookies_Bat":11605,
"Light_White_Pot_":11606,
"Crepe":11607,
"Chocolate_Egg":11608,
"Yummy_Cookie_Egg":11609,
"Sweet_Melon":11610,
"Pop_Corn":11611,
"Aromatic_Pop_Corn":11612,
"Harvest_Cookie":11613,
"Fresh_Milk":11614,
"Sweet_Potato_":11615,
"Yummy_Meat":11616,
"Silvervine_Choco":11617,
"Bearopy":11620,
"High_RedPotion":11621,
"High_YelloPotion":11622,
"High_WhitePotion":11623,
"High_BluePotion":11624,
"Gourmet_Popcorn":11625,
"Kings_Melon_5":11626,
"High_Q_Beef_Jerky":11627,
"Fleshy_Larva":11628,
"Acorn_Chocoball":11629,
"Pignic_Lunch":11630,
"2401_ev_Rainbow":11631,
"2401_ev_Sesamepastry":11632,
"2401_ev_WindTteok":11633,
"2401_ev_Yugwa":11634,
"2401_ev_RedLin":11635,
"24_S_Ev_Lime_Soda":11636,
"24_S_Ev_Berry_Soda":11637,
"24_A_Ev_Choco_C":11638,
"24_A_Ev_Egg_C":11639,
"E_Deli_BBQ":11640,
"E_Leather_Bottle":11641,
"Girl_Bunch_Of_Flower":11701,
"Moon_Cookie":11702,
"Mysterious_Blood":11703,
"KETUPAT_F":11704,
"Special_White_Potion":11705,
"Steak":11706,
"Roasted_Beef":11707,
"Fore_Flank_Sirloin":11708,
"Fanta_Zero_Lemon":11709,
"Sakura_Mist":11710,
"Sakura_Milk_Tea":11711,
"First_Leaf_Tea":11712,
"Julia's_Candy":11713,
"Cold_Scroll_2_5":12000,
"Holy_Scroll_1_3":12001,
"Holy_Scroll_1_5":12002,
"Holy_Scroll_2_1":12003,
"Arrow_Container":12004,
"Iron_Arrow_Container":12005,
"Steel_Arrow_Container":12006,
"Ori_Arrow_Container":12007,
"Fire_Arrow_Container":12008,
"Silver_Arrow_Container":12009,
"Wind_Arrow_Container":12010,
"Stone_Arrow_Container":12011,
"Crystal_Arrow_Container":12012,
"Shadow_Arrow_Container":12013,
"Imma_Arrow_Container":12014,
"Rusty_Arrow_Container":12015,
"Speed_Up_Potion":12016,
"Slow_Down_Potion":12017,
"Fire_Cracker":12018,
"Holy_Egg":12019,
"Water_Of_Darkness":12020,
"Pork_Belly":12021,
"Spareribs":12022,
"Giftbox_China":12023,
"Red_Pouch_Of_Surprise":12024,
"Egg_Boy":12025,
"Egg_Girl":12026,
"Giggling_Box":12027,
"Box_Of_Thunder":12028,
"Gloomy_Box":12029,
"Box_Of_Grudge":12030,
"Sleepy_Box":12031,
"Box_Of_Storm":12032,
"Box_Of_Sunlight":12033,
"Painting_Box":12034,
"Lotto_Box01":12035,
"Lotto_Box02":12036,
"Lotto_Box03":12037,
"Lotto_Box04":12038,
"Lotto_Box05":12039,
"Stone_Of_Intelligence_":12040,
"Str_Dish01":12041,
"Str_Dish02":12042,
"Str_Dish03":12043,
"Str_Dish04":12044,
"Str_Dish05":12045,
"Int_Dish01":12046,
"Int_Dish02":12047,
"Int_Dish03":12048,
"Int_Dish04":12049,
"Int_Dish05":12050,
"Vit_Dish01":12051,
"Vit_Dish02":12052,
"Vit_Dish03":12053,
"Vit_Dish04":12054,
"Vit_Dish05":12055,
"Agi_Dish01":12056,
"Agi_Dish02":12057,
"Agi_Dish03":12058,
"Agi_Dish04":12059,
"Agi_Dish05":12060,
"Dex_Dish01":12061,
"Dex_Dish02":12062,
"Dex_Dish03":12063,
"Dex_Dish04":12064,
"Dex_Dish05":12065,
"Luk_Dish01":12066,
"Luk_Dish02":12067,
"Luk_Dish03":12068,
"Luk_Dish04":12069,
"Luk_Dish05":12070,
"Str_Dish06":12071,
"Str_Dish07":12072,
"Str_Dish08":12073,
"Str_Dish09":12074,
"Str_Dish10":12075,
"Int_Dish06":12076,
"Int_Dish07":12077,
"Int_Dish08":12078,
"Int_Dish09":12079,
"Int_Dish10":12080,
"Vit_Dish06":12081,
"Vit_Dish07":12082,
"Vit_Dish08":12083,
"Vit_Dish09":12084,
"Vit_Dish10":12085,
"Agi_Dish06":12086,
"Agi_Dish07":12087,
"Agi_Dish08":12088,
"Agi_Dish09":12089,
"Agi_Dish10":12090,
"Dex_Dish06":12091,
"Dex_Dish07":12092,
"Dex_Dish08":12093,
"Dex_Dish09":12094,
"Dex_Dish10":12095,
"Luk_Dish06":12096,
"Luk_Dish07":12097,
"Luk_Dish08":12098,
"Luk_Dish09":12099,
"Luk_Dish10":12100,
"Citron":12101,
"Meat_Skewer":12102,
"Bloody_Dead_Branch":12103,
"Random_Quiver":12104,
"Set_Of_Taiming_Item":12105,
"Accessory_Box":12106,
"Wrapped_Mask":12107,
"Bundle_Of_Magic_Scroll":12108,
"Poring_Box":12109,
"First_Aid_Kit":12110,
"Food_Package":12111,
"Tropical_Sograt":12112,
"Vermilion_The_Beach":12113,
"Elemental_Fire":12114,
"Elemental_Water":12115,
"Elemental_Earth":12116,
"Elemental_Wind":12117,
"Resist_Fire":12118,
"Resist_Water":12119,
"Resist_Earth":12120,
"Resist_Wind":12121,
"Sesame_Pastry":12122,
"Honey_Pastry":12123,
"Rainbow_Cake":12124,
"Outdoor_Cooking_Kits":12125,
"Indoor_Cooking_Kits":12126,
"High_end_Cooking_Kits":12127,
"Imperial_Cooking_Kits":12128,
"Fantastic_Cooking_Kits":12129,
"Cookie_Bag":12130,
"Lucky_Potion":12131,
"Red_Bag":12132,
"Ice_Cream_":12133,
"Red_Envelope":12134,
"Green_Ale":12135,
"Women's_Bundle":12136,
"1st_Stage_Prize":12137,
"2nd_Stage_Prize":12138,
"3rd_Stage_Prize":12139,
"4th_Stage_Prize":12140,
"5th_Stage_Prize":12141,
"Magic_Book":12142,
"Red_Can":12143,
"Sphere_Case_Wind":12144,
"Sphere_Case_Darkness":12145,
"Sphere_Case_Poison":12146,
"Sphere_Case_Water":12147,
"Sphere_Case_Fire":12148,
"Bullet_Case":12149,
"Bullet_Case_Blood":12150,
"Bullet_Case_Silver":12151,
"Special_Box":12152,
"Bow_Mercenary_Scroll1":12153,
"Bow_Mercenary_Scroll2":12154,
"Bow_Mercenary_Scroll3":12155,
"Bow_Mercenary_Scroll4":12156,
"Bow_Mercenary_Scroll5":12157,
"Bow_Mercenary_Scroll6":12158,
"Bow_Mercenary_Scroll7":12159,
"Bow_Mercenary_Scroll8":12160,
"Bow_Mercenary_Scroll9":12161,
"Bow_Mercenary_Scroll10":12162,
"SwordMercenary_Scroll1":12163,
"SwordMercenary_Scroll2":12164,
"SwordMercenary_Scroll3":12165,
"SwordMercenary_Scroll4":12166,
"SwordMercenary_Scroll5":12167,
"SwordMercenary_Scroll6":12168,
"SwordMercenary_Scroll7":12169,
"SwordMercenary_Scroll8":12170,
"SwordMercenary_Scroll9":12171,
"SwordMercenary_Scroll10":12172,
"SpearMercenary_Scroll1":12173,
"SpearMercenary_Scroll2":12174,
"SpearMercenary_Scroll3":12175,
"SpearMercenary_Scroll4":12176,
"SpearMercenary_Scroll5":12177,
"SpearMercenary_Scroll6":12178,
"SpearMercenary_Scroll7":12179,
"SpearMercenary_Scroll8":12180,
"SpearMercenary_Scroll9":12181,
"SpearMercenary_Scroll10":12182,
"Holy_Arrow_Quiver":12183,
"Mercenary_Red_Potion":12184,
"Mercenary_Blue_Potion":12185,
"Red_Box":12186,
"Green_Box":12187,
"Magical_Moon_Cake":12188,
"Red_Box_":12189,
"Moon_Cake":12190,
"Special_Moon_Cake":12191,
"Pumpkin_Pie":12192,
"Brezel":12193,
"Hometown_Gift":12194,
"Plain_Rice_Cake":12195,
"Hearty_Rice_Cake":12196,
"Salty_Rice_Cake":12197,
"Lucky_Rice_Cake":12198,
"Rice_Scroll":12199,
"Event_Cake":12200,
"Red_Box_C":12201,
"Str_Dish10_":12202,
"Agi_Dish10_":12203,
"Int_Dish10_":12204,
"Dex_Dish10_":12205,
"Luk_Dish10_":12206,
"Vit_Dish10_":12207,
"Battle_Manual":12208,
"Insurance":12209,
"Bubble_Gum":12210,
"Kafra_Card":12211,
"Giant_Fly_Wing":12212,
"Neuralizer":12213,
"Convex_Mirror":12214,
"Blessing_10_Scroll":12215,
"Inc_Agi_10_Scroll":12216,
"Aspersio_5_Scroll":12217,
"Assumptio_5_Scroll":12218,
"Wind_Walk_10_Scroll":12219,
"Adrenaline_Scroll":12220,
"Megaphone_":12221,
"Sweets_Macacake":12223,
"Sweets_Sparfait":12224,
"Sweet_Candy_Striper":12225,
"Examination1":12226,
"Examination2":12227,
"Examination3":12228,
"Examination4":12229,
"Examination5":12230,
"Examination6":12231,
"Gingerbread":12232,
"Kvass":12233,
"Cacao99":12234,
"Strawberry_Choco":12235,
"Choco_Tart":12236,
"Choco_Lump":12237,
"New_Year_Rice_Cake_1":12238,
"New_Year_Rice_Cake_2":12239,
"Old_Yellow_Box":12240,
"M_Center_Potion":12241,
"M_Awakening_Potion":12242,
"M_Berserk_Potion":12243,
"Old_Gift_Box":12244,
"Green_Ale_US":12245,
"Magic_Card_Album":12246,
"Halohalo":12247,
"Masquerade_Ball_Box":12248,
"Payroll_Of_Kafra_":12249,
"Str_Dish10_M":12250,
"Agi_Dish10_M":12251,
"Int_Dish10_M":12252,
"Dex_Dish10_M":12253,
"Luk_Dish10_M":12254,
"Vit_Dish10_M":12255,
"PRO_Gift_Box":12256,
"Cold_Medicine":12257,
"Bombring_Box":12258,
"Miracle_Medicine":12259,
"Cool_Summer_Outfit":12260,
"Secret_Medicine":12261,
"Inspector_Certificate_":12262,
"Comp_Battle_Manual":12263,
"Comp_Bubble_Gum":12264,
"Comp_Insurance":12265,
"Sesame_Pastry_":12266,
"Honey_Pastry_":12267,
"Rainbow_Cake_":12268,
"Tasty_Colonel":12269,
"Tasty_Major":12270,
"Mre_A":12271,
"Mre_B":12272,
"Mre_C":12273,
"Gold_Pill_1":12274,
"Gold_Pill_2":12275,
"Mimic_Scroll":12276,
"Disguise_Scroll":12277,
"Alice_Scroll":12278,
"Undead_Element_Scroll":12279,
"Holy_Element_Scroll":12280,
"Tresure_Box_WoE":12281,
"Internet_Cafe1":12282,
"Internet_Cafe2":12283,
"Internet_Cafe3":12284,
"Internet_Cafe4":12285,
"Masquerade_Ball_Box2":12286,
"Love_Angel":12287,
"Squirrel":12288,
"Gogo":12289,
"Mysterious_Can":12290,
"Mysterious_PET_Bottle":12291,
"Unripe_Fruit":12292,
"Dried_Yggdrasilberry":12293,
"PC_Bang_Coin_Box1":12294,
"PC_Bang_Coin_Box2":12295,
"PC_Bang_Coin_Box3":12296,
"PC_Bang_Coin_Box4":12297,
"SP_Potion":12298,
"Mega_Resist_Potion":12299,
"Wild_Rose_Scroll":12300,
"Doppelganger_Scroll":12301,
"Ygnizem_Scroll":12302,
"Water_Of_Blessing":12303,
"Picture_Diary":12304,
"Mini_Heart":12305,
"Newcomer":12306,
"Kid":12307,
"Magic_Castle":12308,
"Bulging_Head":12309,
"Spray_Of_Flowers":12310,
"Large_Spray_Of_Flowers":12311,
"Thick_Manual50":12312,
"Protection_Of_Angel":12313,
"Noive_Box":12314,
"Goddess_Bless":12315,
"Angel_Bless":12316,
"Powder_Snow":12317,
"Little_Heart":12318,
"Strawberry_Cake":12319,
"Pineapple_Juice":12320,
"Spicy_Sandwich":12321,
"Chocolate_Pie":12322,
"N_Fly_Wing":12323,
"N_Butterfly_Wing":12324,
"N_Magnifier":12325,
"J_Firecracker":12326,
"Charm_Of_Luck":12327,
"Charm_Of_Happiness":12328,
"Recall_MaleGM":12329,
"Recall_FemaleGM":12330,
"Ginseng":12331,
"Fruit_Juice":12332,
"Ansila":12333,
"Cherish_Box":12334,
"Yummy_Skewered_Dish":12335,
"Baked_Mushroom":12336,
"Grilled_Sausage":12337,
"Grilled_Corn":12338,
"Cherish_Box_Ori":12339,
"Mysterious_Rice_Powder":12340,
"Special_Alloy_Trap_Box":12341,
"Manuk's_Opportunity":12342,
"Manuk's_Courage":12343,
"Pinguicula's_fruit_Jam":12344,
"Luciola's_Honey_Jam":12345,
"Unripe_Acorn":12346,
"Acorn_Jelly":12347,
"Manuk's_Faith":12348,
"Cornus'_Tears":12349,
"Angeling_Potion":12350,
"Shout_Megaphone":12351,
"Dun_Tele_Scroll3_fr":12352,
"Tiny_Waterbottle":12353,
"Buche_De_Noel":12354,
"Xmas_Gift":12355,
"Louise_Costume_Box":12356,
"Shiny_Wing_Gown":12357,
"Fan_Of_Wind":12358,
"Very_Soft_Plant":12359,
"Very_Red_Juice":12360,
"Delicious_Shaved_Ice":12361,
"Kuloren":12362,
"Fit_Pipe":12363,
"Staff_Of_Leader":12364,
"Charming_Lotus":12365,
"Gril_Doll":12366,
"Luxury_Whisky_Bottle":12367,
"Splendid_Mirror":12368,
"Oilpalm_Coconut":12369,
"Gril's_Naivety":12370,
"Magical_Lithography":12371,
"Hell_Contract":12372,
"Boy's_Naivety":12373,
"Flaming_Ice":12374,
"Acaraje":12375,
"Mysterious_Can2":12376,
"Mysterious_PET_Bottle2":12377,
"2009_Rice_Cake_Soup":12378,
"Pope's_Cookie":12379,
"Desert_Wolf_Babe_Scroll":12380,
"ValkyrieA_Scroll":12381,
"ValkyrieB_Scroll":12382,
"Vulcan_Bullet_Magazine":12383,
"Rainbow_Ruby_Water":12384,
"Rainbow_Ruby_Fire":12385,
"Rainbow_Ruby_Wind":12386,
"Rainbow_Ruby_Earth":12387,
"Runstone_Crush":12388,
"Runstone_Storm":12389,
"Runstone_Millennium":12390,
"Lucky_Egg_C":12391,
"RepairA":12392,
"RepairB":12393,
"RepairC":12394,
"Tantanmen":12395,
"Fools_Day_Box":12396,
"Fools_Day_Box2":12397,
"PCBang_Gift_Box":12398,
"Castle_Treasure_Box":12399,
"Water_Of_Blessing_":12400,
"Rune_Kn_Test_Int":12401,
"29Fruit":12402,
"Lucky_Egg_C2":12403,
"Acti_Potion":12404,
"Underripe_Yggseed":12405,
"Psychic_ArmorS":12406,
"PCBang_Coupon_Box":12407,
"Leaf_Cat_Ball":12408,
"Pork_Belly_H":12409,
"Spareribs_H":12410,
"HE_Battle_Manual":12411,
"HE_Bubble_Gum":12412,
"PCBang_Coupon_Box2":12413,
"Guarana_Candy":12414,
"Siege_Teleport_Scroll2":12415,
"Lucky_Egg_C3":12416,
"Boost500":12417,
"Full_SwingK":12418,
"Mana_Plus":12419,
"Stamina_Up_M":12420,
"Digestive_F":12421,
"HP_Increase_PotionS":12422,
"HP_Increase_PotionM":12423,
"HP_Increase_PotionL":12424,
"SP_Increase_PotionS":12425,
"SP_Increase_PotionM":12426,
"SP_Increase_PotionL":12427,
"Enrich_White_PotionZ":12428,
"Savage_BBQ":12429,
"Wug_Blood_Cocktail":12430,
"Minor_Brisket":12431,
"Siroma_Icetea":12432,
"Drocera_Herb_Stew":12433,
"Petti_Tail_Noodle":12434,
"Black_Thing":12435,
"Vitata500":12436,
"Enrich_Celermine_Juice":12437,
"F_Giant_Fly_Wing":12438,
"F_Battle_Manual":12439,
"F_Insurance":12440,
"F_Bubble_Gum":12441,
"F_Kafra_Card":12442,
"F_Neuralizer":12443,
"F_Dun_Tele_Scroll1":12444,
"F_Str_Dish10_":12445,
"F_Agi_Dish10_":12446,
"F_Int_Dish10_":12447,
"F_Dex_Dish10_":12448,
"F_Luk_Dish10_":12449,
"F_Vit_Dish10_":12450,
"F_WOB_Rune":12451,
"F_WOB_Schwaltz":12452,
"F_WOB_Rachel":12453,
"F_WOB_Local":12454,
"F_Greed_Scroll":12456,
"F_Glass_Of_Illusion":12457,
"F_Abrasive":12458,
"F_Med_Life_Potion":12459,
"F_Small_Life_Potion":12460,
"F_Regeneration_Potion":12461,
"F_B_Mdef_Potion":12462,
"F_S_Mdef_Potion":12463,
"F_B_Def_Potion":12464,
"F_S_Def_Potion":12465,
"F_Blessing_10_Scroll":12466,
"F_Inc_Agi_10_Scroll":12467,
"F_Aspersio_5_Scroll":12468,
"F_Wind_Walk_10_Scroll":12470,
"F_Adrenaline_Scroll":12471,
"F_Convex_Mirror":12472,
"RWC_Parti_Box":12473,
"RWC_Final_Comp_Box":12474,
"Cure_Free":12475,
"PCBang_Coupon_Box3":12476,
"Gift_Bundle":12477,
"Chance_Box":12478,
"Caracas_Ring_Box":12479,
"Attend_3Day_Box":12480,
"Attend_7Day_Box":12481,
"Attend_10Day_Box":12482,
"Attend_15Day_Box":12483,
"Attend_20Day_Box":12484,
"Attend_25Day_Box":12485,
"GoldPC_First_Box":12486,
"PC_4Leaf_Clover_Box":12487,
"Ticket_Gift_Box":12488,
"Ticket_Gift_Box2":12489,
"Vivid_Notation":12490,
"Curious_Snowball":12491,
"Crumpled_Paper":12492,
"Lucky_Egg_C4":12493,
"E_Giant_Fly_Wing":12494,
"E_Battle_Manual":12495,
"E_Insurance":12496,
"E_Bubble_Gum":12497,
"E_Kafra_Card":12498,
"E_Neuralizer":12499,
"E_Dun_Tele_Scroll1":12500,
"E_Str_Dish10_":12501,
"E_Agi_Dish10_":12502,
"E_Int_Dish10_":12503,
"E_Dex_Dish10_":12504,
"E_Luk_Dish10_":12505,
"E_Vit_Dish10_":12506,
"E_WOB_Rune":12507,
"E_WOB_Schwaltz":12508,
"E_WOB_Rachel":12509,
"E_WOB_Local":12510,
"E_Siege_Teleport_Scroll":12511,
"E_Greed_Scroll":12512,
"E_Glass_Of_Illusion":12513,
"E_Abrasive":12514,
"E_Med_Life_Potion":12515,
"E_Small_Life_Potion":12516,
"E_Regeneration_Potion":12517,
"E_B_Mdef_Potion":12518,
"E_S_Mdef_Potion":12519,
"E_B_Def_Potion":12520,
"E_S_Def_Potion":12521,
"E_Blessing_10_Scroll":12522,
"E_Inc_Agi_10_Scroll":12523,
"E_Aspersio_5_Scroll":12524,
"E_Assumptio_5_Scroll":12525,
"E_Wind_Walk_10_Scroll":12526,
"E_Adrenaline_Scroll":12527,
"E_Convex_Mirror":12528,
"White_Slim_Potion_Box":12529,
"Mastela_Fruit_Box":12530,
"White_Potion_Box":12531,
"Royal_Jelly_Box2":12532,
"Blue_Herb_Box2":12533,
"Yggdrasil_Seed_Box":12534,
"Iggdrasilberry_Box":12535,
"NY_Rice_Cake_Soup":12536,
"Solo_Gift_Basket":12537,
"Couple_Event_Basket":12538,
"Splendid_Box":12539,
"GM_Warp_Box":12540,
"Fortune_Cookie1":12541,
"Fortune_Cookie2":12542,
"Fortune_Cookie3":12543,
"Mystic_Tree_Branch":12544,
"Lucky_Egg_C5":12545,
"Suspicious_Dish":12546,
"Chalcenodny_Box":12547,
"Buy_Market_Permit2":12548,
"White_Slim_Pot_Box2":12549,
"Poison_Bottle_Box2":12550,
"MVP_Tele_Scroll":12551,
"Quest_Tele_Scroll":12552,
"Brysinggamen_Piece_Box":12553,
"Asprika_Piece_Box":12554,
"Brynhild_Piece_Box":12555,
"Sleipnir_Piece_Box":12556,
"Mjolnir_Piece_Box":12557,
"Magingiorde_Piece_Box":12558,
"Tenkaippin_Strong":12559,
"Tenkaippin_Clean":12560,
"Mysterious_Seed":12561,
"Bubble_Gum_Plus":12562,
"BM75":12563,
"3D_Glasses_Box":12564,
"Cheer_Scarf_Box":12565,
"Cheer_Scarf2_Box":12566,
"Cheer_Scarf3_Box":12567,
"Cheer_Scarf4_Box":12568,
"Cheer_Scarf6_Box":12569,
"Cheer_Scarf8_Box":12570,
"Cheer_Scarf10_Box":12571,
"Cheer_Scarf10_Box2":12572,
"Fruit_Basket":12573,
"Mora_Berry":12574,
"Arrow_Of_Elf_Cntr":12575,
"Hunting_Arrow_Cntr":12576,
"Lucky_Egg_C6":12577,
"Rapid_Life_Water":12578,
"Ring_Of_Valkyrie_Box":12579,
"Vending_Search_Scroll":12580,
"Vending_Search_Scroll2":12581,
"Siege_Supply_Box":12582,
"PR_Team_Box":12583,
"Develop_Team_box":12584,
"Marketing_Team_Box":12585,
"Operating_Team_Box":12586,
"Summer_Night_box":12587,
"Summer_Night_box2":12588,
"Summer_Night_box3":12589,
"Uni_Catalog_Bz":12591,
"Cyclops_Box1":12592,
"Cyclops_Box2":12593,
"Cyclops_Box3":12594,
"Lucky_Egg_C7":12595,
"Magic_Candy":12596,
"Opor_Ayam":12597,
"Dendeng_Balado":12598,
"Kurma":12599,
"Treasure_Box_Scroll":12600,
"Cold_Watermelon_Juice":12601,
"Special_Box1":12602,
"Special_Box2":12603,
"Special_Box3":12604,
"Special_Box4":12605,
"Special_Box5":12606,
"Lolli_Pop_Box":12607,
"Splendid_Box2":12608,
"Old_Ore_Box":12609,
"Mysterious_Egg":12610,
"Old_Coin_Pocket":12612,
"High_Coin_Pocket":12613,
"Mid_Coin_Pocket":12614,
"Low_Coin_Pocket":12615,
"Sgrade_Pocket":12616,
"Agrade_Pocket":12617,
"Bgrade_Pocket":12618,
"Cgrade_Pocket":12619,
"Dgrade_Pocket":12620,
"Egrade_Pocket":12621,
"Boarding_Halter":12622,
"High_Weapon_Box":12623,
"Delicious_Jelly":12624,
"Sapa_Feat_Cert_Pack":12625,
"Wander_Man_Scroll":12626,
"Wicked_Nymph_Scroll":12627,
"Kasa_Scroll":12628,
"Salamander_Scroll":12629,
"Teddy_Bear_Scroll":12630,
"Macro_Stone_A":12631,
"Macro_Stone_B":12632,
"Malang_Cat_Can":12633,
"Macro_Stone_A1":12634,
"Macro_Stone_A2":12635,
"Malang_Sp_Can":12636,
"Gong_Bug_Pocket":12637,
"Dried_Squid_Box":12638,
"Flying_Fish_Box":12639,
"Starfish_Box":12640,
"Lucky_Egg_C8":12641,
"Fruit_Of_Mastela_Box2":12642,
"E_Coin_Pack50":12643,
"PCBang_Coupon_Box4":12644,
"J_Aspersio_5_Scroll_C":12645,
"Takoyaki":12646,
"Ink_Ball":12647,
"Special_Potion_Set":12648,
"Lv70_Imperial_Gift":12649,
"Lv90_Imperial_Gift":12650,
"Lv110_Imperial_Gift":12651,
"Lv130_Imperial_Gift":12652,
"Lv150_Imperial_Gift":12653,
"Lucky_Egg_C9":12654,
"Brain_Powder":12655,
"Magical_Powder":12656,
"Madness_Powder":12657,
"Trans_Scroll_Devi":12658,
"Trans_Scroll_Ray_Arch":12659,
"Trans_Scroll_Mavka":12660,
"Trans_Scroll_Marduk":12661,
"Trans_Scroll_Banshee":12662,
"Trans_Scroll_Poring":12663,
"Trans_Scroll_Golem":12664,
"Grovel_Buff":12665,
"Thai_Perfume_MATK":12666,
"Thai_Perfume_ATK":12667,
"Thai_Perfume_ASPD":12668,
"Thai_Perfume_CAST":12669,
"Beast_Powder":12670,
"99lv_Battle_Manual":12671,
"Start_New_Box":12672,
"Lucky_Egg_C10":12673,
"God_Material_Box":12674,
"Sg_Weapon_Supply_Box":12675,
"Sg_Violet_Potion_Box":12676,
"Siege_Arrow_Quiver_S":12677,
"Siege_Arrow_Quiver_A":12678,
"Sg_White_Potion_Box":12679,
"Sg_Blue_Potion_Box":12680,
"Nestea_Lemon":12681,
"Nestea_Blacktea":12682,
"Sg_Vi_Potion_Box200":12683,
"ASPD_Potion":12684,
"Gryphon_Egg_Scroll":12685,
"Str_Dish20":12686,
"Int_Dish20":12687,
"Vit_Dish20":12688,
"Dex_Dish20":12689,
"Old_C_Album_Helm":12690,
"Old_C_Album_Armor":12691,
"Old_C_Album_Shield":12692,
"Old_C_Album_Garment":12693,
"Old_C_Album_Shoes":12694,
"Old_C_Album_Acc":12695,
"RWC_Cele_Fire":12696,
"RWC_Cele_Fire2":12697,
"Old_C_Album_Weapon":12698,
"Tikbalang_Belt":12699,
"Insideout_Shirt":12700,
"Old_Blue_Box_F":12701,
"Old_Bleu_Box":12702,
"Holy_Egg_2":12703,
"Elixir_Of_Life":12704,
"Noble_Nameplate":12705,
"Lucky_Cookie01":12706,
"Lucky_Cookie02":12707,
"Lucky_Cookie03":12708,
"Guyak_Candy":12709,
"Guyak_Pudding":12710,
"Pretzel":12711,
"Green_Beer":12712,
"Monster_Extract":12713,
"Easter_Scroll":12714,
"Black_Treasure_Box":12715,
"Indian_Rice_Cake":12716,
"Poison_Paralysis":12717,
"Poison_Leech":12718,
"Poison_Oblivion":12719,
"Poison_Contamination":12720,
"Poison_Numb":12721,
"Poison_Fever":12722,
"Poison_Laughing":12723,
"Poison_Fatigue":12724,
"Runstone_Nosiege":12725,
"Runstone_Rhydo":12726,
"Runstone_Verkana":12727,
"Runstone_Isia":12728,
"Runstone_Asir":12729,
"Runstone_Urj":12730,
"Runstone_Turisus":12731,
"Runstone_Pertz":12732,
"Runstone_Hagalas":12733,
"Runstone_Quality":12734,
"Runstone_Ancient":12735,
"Runstone_Mystic":12736,
"Runstone_Ordinary":12737,
"Runstone_Rare":12738,
"Snow_Flower":12739,
"Inc_Str_Scroll":12740,
"Inc_Int_Scroll":12741,
"Valentine_Gift_Box1":12742,
"Valentine_Gift_Box2":12743,
"Chocotate_Box":12744,
"Skull_Scroll":12745,
"Destruction_Scroll":12746,
"Royal_Scroll":12747,
"Immune_Scroll":12748,
"Mystic_Scroll":12749,
"Battle_Scroll":12750,
"Armor_Scroll":12751,
"Prayer_Scroll":12752,
"Soul_Scroll":12753,
"New_Year_Bun":12754,
"Traditional_Firecrack":12755,
"New_Gift_Envelope":12756,
"Loyal_Ring1_Box":12757,
"Loyal_Ring2_Box":12758,
"Loyal_Ring3_Box":12759,
"Bubble_Gum_Green":12760,
"Bubble_Gum_Yellow":12761,
"Bubble_Gum_Orange":12762,
"Bubble_Gum_Red":12763,
"Fools_Day_Box_Tw":12764,
"Summer_Knight_Box":12765,
"Reward_Job_BM25":12766,
"Passion_FB_Hat_Box":12767,
"Cool_FB_Hat_Box":12768,
"Victory_FB_Hat_Box":12769,
"Glory_FB_Hat_Box":12770,
"Passion_Hat_Box2":12771,
"Cool_Hat_Box2":12772,
"Victory_Hat_Box2":12773,
"Empty_Potion_Bottle":12774,
"Ancient_Spirit_Agimat":12775,
"Agi_Dish20":12776,
"Luk_Dish20":12777,
"Bapho_Jr_Scroll":12778,
"Galapago_Scroll":12779,
"10M_Zeny_Check":12780,
"1M_Zeny_Check":12781,
"100T_Zeny_Check":12782,
"10000_Zeny_Check":12783,
"1000_Zeny_Check":12784,
"Dragon_Egg_Scroll":12785,
"Change_Slot_Card":12786,
"Diabolic_Scroll":12787,
"No100_Firecracker":12788,
"Juicy_Fruit":12789,
"Change_Name_Card":12790,
"Combat_Pill":12791,
"P_Combat_Pill":12792,
"Combat_Pill_Box10":12793,
"P_Combat_Pill_Box10":12794,
"2011_RWC_Scroll_Kr":12795,
"Red_Booster":12796,
"Wish_Maiden_Scroll":12797,
"Zealotus_Scroll":12798,
"PCBang_Coupon_Box5":12799,
"Ktullanux_Scroll":12800,
"Eddga_Scroll":12801,
"Time_Guardian_Box":12802,
"Beginner_Kit_Box":12803,
"Cru_Scroll":12804,
"Mystic_Powder":12805,
"Scaraba_Scroll":12806,
"Mercenary_Casting_":12807,
"Mother_Love_Box":12808,
"Level_Up_Box":12809,
"Event_Gift_Box":12810,
"Event_Gift_Box_":12811,
"Snow_Flip":12812,
"Peony_Mommy":12813,
"Slapping_Herb":12814,
"Yggdrasil_Dust":12815,
"Old_Ore_Box_":12816,
"Old_Card_Album_":12817,
"High_Weapon_Box_":12818,
"Zherlthsh_Tck_Box_":12819,
"Mao_Guai_Scroll":12820,
"Loli_Ruri_Scroll":12821,
"Songpyun_Box50":12822,
"Sedora_Scroll":12823,
"Chepet_Scroll":12824,
"FlipPackage":12825,
"Wind_Type_Scroll":12826,
"Water_Type_Scroll":12827,
"Fire_Type_Scroll":12828,
"Earth_Type_Scroll":12829,
"Dead_Tree_Box":12830,
"Potion_Box":12831,
"Mysterious_Water":12832,
"Union_Of_Tribe_":12833,
"Undead_Egg":12834,
"Girls_Heart":12835,
"Wooden_Treasure_Box":12837,
"Iron_Treasure_Box":12838,
"bronze_Treasure_Box":12839,
"Silver_Treasure_Box":12840,
"Golden_Treasure_Box":12841,
"Platinum_Treasure_Box":12842,
"Pearl_Treasure_Box":12843,
"Diamond_Treasure_Box":12844,
"WOB_Amatsu":12845,
"Unripe_Apple2":12846,
"Old_Equipment_Box":12847,
"Falcon_Pipe":12848,
"Combination_Kit":12849,
"Heaven_Scroll":12850,
"Vocation_Scroll":12851,
"Wisdom_Scroll":12852,
"Patron_Scroll":12853,
"Full_Spray_Of_Flowers":12854,
"Pope_Scroll":12855,
"GoldenApple_P_RG":12856,
"GoldenApple_RG":12857,
"Golden_Potion_RG":12858,
"Mommy_Day_Cake":12860,
"Treasure_Box_Scroll2":12863,
"Mysterious_Egg2":12871,
"Battle_Manual_Limit":12872,
"TE_Potion_Box":12873,
"Frost_Giant_Blood":12874,
"Golem_Stone":12875,
"Elf_Tear_Stun":12876,
"Elf_Tear_Stone_Curse":12877,
"Elf_Tear_Freezing":12878,
"Elf_Tear_Sleep":12879,
"Elf_Tear_Curse":12880,
"Elf_Tear_Silence":12881,
"Elf_Tear_Blind":12882,
"Almighty":12883,
"Infinite_Center_Potion":12884,
"Ifn_Awakening_Potion":12885,
"Infinite_Berserk_Potion":12886,
"C_Wing_Of_Fly":12887,
"Siege_Kit_Box":12888,
"Weapon_Box_Spear":12889,
"Weapon_Box_Mace":12890,
"Weapon_Box_Dagger":12891,
"Weapon_Box_Axe":12892,
"Weapon_Box_Bow":12893,
"Weapon_Box_Sword":12894,
"Weapon_Box_Fist":12895,
"Weapon_Box_Book":12896,
"Weapon_Box_Guitar":12897,
"Weapon_Box_Whip":12898,
"Weapon_Box_Wand":12899,
"Battle_Manual_Box":12900,
"Insurance_Package":12901,
"Bubble_Gum_Box":12902,
"Str_Dish_Box":12903,
"Agi_Dish_Box":12904,
"Int_Dish_Box":12905,
"Dex_Dish_Box":12906,
"Luk_Dish_Box":12907,
"Vit_Dish_Box":12908,
"Kafra_Card_Box":12909,
"Giant_Fly_Wing_Box":12910,
"Neuralizer_Box":12911,
"Convex_Mirror_Box":12912,
"Blessing_10_Scroll_Box":12913,
"Inc_Agi_10_Scroll_Box":12914,
"Aspersio_5_Scroll_Box":12915,
"Assumptio_5_Scroll_Box":12916,
"Wind_Walk_10_Scroll_Box":12917,
"Adrenaline_Scroll_Box":12918,
"Megaphone_Box":12919,
"Enriched_Elunium_Box":12920,
"Enriched_Oridecon_Box":12921,
"Token_Of_Siegfried_Box":12922,
"Pet_Egg_Scroll_Box1":12923,
"Pet_Egg_Scroll_Box2":12924,
"Pet_Egg_Scroll1":12925,
"Pet_Egg_Scroll2":12926,
"J_Aspersio_5_Scroll_Box":12927,
"J_Aspersio_5_Scroll":12928,
"Pet_Egg_Scroll_Box3":12929,
"Pet_Egg_Scroll_Box4":12930,
"Pet_Egg_Scroll_Box5":12931,
"Pet_Egg_Scroll3":12932,
"Pet_Egg_Scroll4":12933,
"Pet_Egg_Scroll5":12934,
"Infiltrator_Box":12935,
"Muramasa_Box":12936,
"Excalibur_Box":12937,
"Combat_Knife_Box":12938,
"Counter_Dagger_Box":12939,
"Kaiser_Knuckle_Box":12940,
"Pole_Axe_Box":12941,
"Mighty_Staff_Box":12942,
"Right_Epsilon_Box":12943,
"Balistar_Box":12944,
"Diary_Of_Great_Sage_Box":12945,
"Asura_Box":12946,
"Apple_Of_Archer_Box":12947,
"Bunny_Band_Box":12948,
"Sahkkat_Box":12949,
"Lord_Circlet_Box":12950,
"Elven_Ears_Box":12951,
"Steel_Flower_Box":12952,
"Critical_Ring_Box":12953,
"Earring_Box":12954,
"Ring_Box":12955,
"Necklace_Box":12956,
"Glove_Box":12957,
"Brooch_Box":12958,
"Rosary_Box":12959,
"Safety_Ring_Box":12960,
"Vesper_Core01_Box":12961,
"Vesper_Core02_Box":12962,
"Vesper_Core03_Box":12963,
"Vesper_Core04_Box":12964,
"Emergency_Box1":12965,
"Emergency_Box2":12966,
"Emergency_Box3":12967,
"Emergency_Scroll1":12968,
"Emergency_Scroll2":12969,
"Emergency_Scroll3":12970,
"Teleport_Box1":12971,
"Teleport_Box2":12972,
"Teleport_Box3":12973,
"Teleport_Box4":12974,
"Teleport_Box5":12975,
"Teleport_Box6":12976,
"Teleport_Scroll1":12977,
"Teleport_Scroll2":12978,
"Teleport_Scroll3":12979,
"Teleport_Scroll4":12980,
"Teleport_Scroll5":12981,
"Teleport_Scroll6":12982,
"Pet_Egg_Scroll_Box6":12983,
"Pet_Egg_Scroll_Box7":12984,
"Pet_Egg_Scroll_Box8":12985,
"Pet_Egg_Scroll_Box9":12986,
"Pet_Egg_Scroll_Box10":12987,
"Pet_Egg_Scroll_Box11":12988,
"Pet_Egg_Scroll6":12989,
"Pet_Egg_Scroll7":12990,
"Pet_Egg_Scroll8":12991,
"Pet_Egg_Scroll9":12992,
"Pet_Egg_Scroll10":12993,
"Pet_Egg_Scroll11":12994,
"White_Herb_Box":12995,
"Blue_Herb_Box":12996,
"Elunium_Box":12997,
"Oridecon_Box":12998,
"Branch_Of_Dead_Tree_Box":12999,
"Jujube_Dagger":13000,
"Dragon_Killer":13001,
"Ginnungagap":13002,
"Coward":13003,
"Coward_":13004,
"Counter_Dagger_IL_J":13005,
"Khukri":13006,
"Jitte":13007,
"Jitte_":13008,
"Kamaitachi":13009,
"Asura":13010,
"Asura_":13011,
"Murasame":13012,
"Murasame_":13013,
"Hakujin":13014,
"Hakujin_":13015,
"Poison_Knife_":13016,
"House_Auger_":13017,
"Sucsamad_":13018,
"Ginnungagap_":13019,
"Warrior_Balmung_":13020,
"Combat_Knife_C":13021,
"Counter_Dagger_C":13022,
"Asura_C":13023,
"Sword_Breaker_C":13024,
"Mail_Breaker_C":13025,
"Moonlight_Sword_C":13026,
"Scalpel":13027,
"Tooth_Blade":13028,
"Prinsence_Knife":13029,
"Dragon_Killer_":13030,
"Sword_Breaker_":13031,
"Mail_Breaker_":13032,
"Assasin_Dagger_":13033,
"Twilight_Desert":13034,
"Sandstorm":13035,
"BF_Dagger1":13036,
"BF_Dagger2":13037,
"Dagger_Of_Hunter":13038,
"Ivory_Knife":13039,
"N_Cutter":13040,
"N_Main_Gauche":13041,
"Krieger_Dagger1":13042,
"Fortune_Sword_I":13043,
"House_Auger_I":13044,
"Kamaitachi_I":13045,
"Krieg":13046,
"Weihna":13047,
"Damascus_C":13048,
"Lacma":13049,
"P_Dagger1":13050,
"P_Dagger2":13051,
"Tourist_Dagger":13052,
"F_Moonlight_Sword_C":13053,
"F_Combat_Knife_C":13054,
"F_Asura_C":13055,
"F_Counter_Dagger_C":13056,
"E_Moonlight_Sword_C":13057,
"E_Combat_Knife_C":13058,
"E_Asura_C":13059,
"E_Counter_Dagger_C":13060,
"Black_Wing":13061,
"Ancient_Dagger":13062,
"Adventure_Knife":13063,
"Academy_Knife":13064,
"Academy_Eti_Knife":13065,
"P_Dagger3":13066,
"Caress":13067,
"Saurel":13068,
"Aztoe_Nail":13069,
"Scarletto_Nail":13070,
"Upg_Dagger":13071,
"Velum_Damascus":13072,
"Counter_Dagger_":13073,
"Ninja_Cutter":13074,
"Kurenai":13075,
"Raksasa_Dagger":13076,
"Kagekiri":13077,
"Mikatsuki":13078,
"Metal_Dagger":13079,
"Rogue_Kinfe":13080,
"Octo_kitchen_Knife":13081,
"Ivory_Knife_":13082,
"TE_Woe_Knife":13083,
"Eihwaz_Knife":13084,
"Volcano_Knife":13085,
"Goldsmithing_Dagger":13086,
"Hagalas_Knife":13087,
"Krishnagar":13088,
"FaceWorm_Leg":13089,
"FaceWormQueen_Leg":13090,
"Owl_Cutter":13091,
"RWC_Memory_Knife":13092,
"Thanos_Dagger":13093,
"Dagger_Of_Evil_Slayer":13094,
"Half_BF_Dagger2":13096,
"Ru_Blue_Dagger":13097,
"Ru_Blue_Ashura":13098,
"Ru_Blue_Knife":13099,
"Six_Shooter":13100,
"Six_Shooter_":13101,
"Crimson_Bolt":13102,
"Crimson_Bolt_":13103,
"The_Garrison":13104,
"The_Garrison_":13105,
"Gold_Lux":13106,
"Wasteland_Outlaw":13107,
"BF_Pistol1":13108,
"Wasteland_Outlaw_C":13109,
"Krieger_Pistol1":13110,
"Sharpshooter_Revolver":13111,
"P_Revolver1":13112,
"P_Revolver2":13113,
"P_Revolver3":13114,
"Upg_Revolver":13115,
"Novice_Revolver":13116,
"TE_Woe_Pistol":13117,
"Tiny_Flame":13118,
"Freedom_Flame":13119,
"H_FEATHER_H_FIRE":13120,
"ALTAIR_ARES":13122,
"ALTAIR_ARES_":13124,
"Metal_Revolver":13125,
"Gun_Of_Infinite":13126,
"Scarlet_Revolver":13127,
"Sinister_Revolver":13128,
"Union_Revolver":13129,
"Gun_of_Trust":13130,
"Gun_of_Trust2":13131,
"Toughen_Metal_Revolver":13132,
"UnrivaledGun":13133,
"ALTAIR_ARES_J":13134,
"H_FEATHER_H_FIRE_J":13135,
"Probation_Revolver":13136,
"Avenger_Revolver":13137,
"Dark_Rose":13138,
"Blue_Gun":13139,
"Diva_Handgun":13140,
"Mirage_Handgun":13141,
"Sinister_Revolver_J":13142,
"Rebeginer_RL_Gun":13144,
"Calf_Deathadder_J":13145,
"Calf_Deathadder":13146,
"Branch":13150,
"The_Cyclone":13151,
"The_Cyclone_":13152,
"Dusk":13153,
"Rolling_Stone":13154,
"Black_Rose":13155,
"Gate_Keeper":13156,
"Drifter":13157,
"Butcher":13158,
"Butcher_":13159,
"Destroyer":13160,
"Destroyer_":13161,
"Inferno":13162,
"Long_Barrel":13163,
"Long_Barrel_":13164,
"Jungle_Carbine":13165,
"Jungle_Carbine_":13166,
"Gate_KeeperDD":13167,
"Thunder_P":13168,
"Thunder_P_":13169,
"Lever_Action_Rifle":13170,
"BF_Rifle1":13171,
"BF_Gatling_Gun1":13172,
"BF_Shotgun1":13173,
"BF_Launcher1":13174,
"Lever_Action_Rifle_C":13175,
"Krieger_Rifle1":13176,
"Krieger_Gatling1":13177,
"Krieger_Shotgun1":13178,
"Krieger_Launcher1":13179,
"Novice_Rifle":13180,
"Novice_Shotgun":13181,
"Novice_Gatling":13182,
"Novice_Grenade_Launcher":13183,
"TE_Woe_Rifle":13184,
"TE_Woe_Gatling":13185,
"TE_Woe_Shotgun":13186,
"TE_Woe_Grenade":13187,
"COLORSCOPE":13189,
"RAG203_":13190,
"DEATHFIRE":13192,
"R_THUNDER":13193,
"P_BREAKER":13194,
"RAG203":13195,
"P_BREAKER_":13196,
"MINIMAY":13197,
"TEMPEST":13198,
"TEMPEST_":13199,
"Bullet":13200,
"Silver_Bullet":13201,
"Shell_Of_Blood":13202,
"Flare_Sphere":13203,
"Lighting_Sphere":13204,
"Poison_Sphere":13205,
"Blind_Sphere":13206,
"Freezing_Sphere":13207,
"Gong_Bug":13208,
"Slug_Bullet_1":13210,
"Slug_Bullet_2":13211,
"Slug_Bullet_3":13212,
"Slug_Bullet_4":13213,
"Slug_Bullet_5":13214,
"AP_Ammo":13215,
"Blaze_Bullet":13216,
"Freezing_Bullet":13217,
"Electric_Shock_Bullet":13218,
"Magical_Stone_Bullet":13219,
"Sanctified_Bullet":13220,
"Silver_Bullet_":13221,
"Shell_Of_Blood_":13222,
"Flare_Sphere_":13223,
"Lighting_Sphere_":13224,
"Poison_Sphere_":13225,
"Blind_Sphere_":13226,
"Freezing_Sphere_":13227,
"Flare_Bullet":13228,
"Lighting_Bullet":13229,
"Ice_Bullet":13230,
"Poison_Bullet":13231,
"Blind_Bullet":13232,
"Shuriken":13250,
"Nimbus_Shuriken":13251,
"Flash_Shuriken":13252,
"Sharp_Leaf_Shuriken":13253,
"Thorn_Needle_Shuriken":13254,
"Kunai_Of_Icicle":13255,
"Kunai_Of_Black_Soil":13256,
"Kunai_Of_Furious_Wind":13257,
"Kunai_Of_Fierce_Flame":13258,
"Kunai_Of_Deadly_Poison":13259,
"Apple_Bomb":13260,
"Coconut_Bomb":13261,
"Melon_Bomb":13262,
"Pineapple_Bomb":13263,
"Banana_Bomb":13264,
"Black_Lump":13265,
"Black_Hard_Lump":13266,
"Very_Hard_Lump":13267,
"Mysterious_Powder":13268,
"Boost500_To_Throw":13269,
"Full_SwingK_To_Throw":13270,
"Mana_Plus_To_Throw":13271,
"Cure_Free_To_Throw":13272,
"Stamina_Up_M_To_Throw":13273,
"Digestive_F_To_Throw":13274,
"HP_Inc_PotS_To_Throw":13275,
"HP_Inc_PotM_To_Throw":13276,
"HP_Inc_PotL_To_Throw":13277,
"SP_Inc_PotS_To_Throw":13278,
"SP_Inc_PotM_To_Throw":13279,
"SP_Inc_PotL_To_Throw":13280,
"En_White_PotZ_To_Throw":13281,
"Vitata500_To_Throw":13282,
"En_Cel_Juice_To_Throw":13283,
"Savage_BBQ_To_Throw":13284,
"Wug_Cocktail_To_Throw":13285,
"M_Brisket_To_Throw":13286,
"Siroma_Icetea_To_Throw":13287,
"Drocera_Stew_To_Throw":13288,
"Petti_Noodle_To_Throw":13289,
"Black_Thing_To_Throw":13290,
"Starfish":13291,
"Dried_Squid":13292,
"Flying_Fish":13293,
"Explosive_Kunai":13294,
"Light_Shuriken":13295,
"Huuma_Bird_Wing":13300,
"Huuma_Giant_Wheel":13301,
"Huuma_Giant_Wheel_":13302,
"Huuma_Blaze":13303,
"Huuma_Calm_Mind":13304,
"BF_Huuma_Shuriken1":13305,
"BF_Huuma_Shuriken2":13306,
"Krieger_Huuma_Shuriken1":13307,
"Huuma_Blaze_I":13308,
"Huuma_Giant_Wheel_C":13309,
"P_Huuma_Shuriken1":13310,
"Huuma_Shadow":13311,
"Huuma_Job_Test":13312,
"Huuma_Swirling_Petal":13313,
"Huuma_Fluttering_Snow":13314,
"Huuma_Thunderstorm":13315,
"Upg_Huuma_Shuriken":13316,
"TE_Woe_Huuma":13317,
"Half_BF_Huuma_Shuriken2":13321,
"Metal_Huuma_Shuriken":13322,
"Huuma_Of_Infinite":13323,
"Scarlet_Huuma":13327,
"Sinister_Huuma":13328,
"Union_Huuma":13329,
"Toughen_Metal_Shuriken":13330,
"Huuma_Hundred_Petal":13332,
"Diva_Huuma":13333,
"Mirage_Huuma":13334,
"Sinister_Huuma_J":13335,
"Probation_Huuma":13336,
"Huuma_Flutter_Snow_IL":13337,
"Huuma_Bird_Wing_IL":13338,
"Neev_Huuma_Shuriken":13339,
"Huuma_Hundred_Petal_J":13340,
"Rebeginer_KO_Humma":13341,
"Variant_Huuma":13343,
"Humma_Clear":13345,
"Ein_BHHuuma":13346,
"R_Huuma_Shuriken":13347,
"Cutlas_":13400,
"Excalibur_C":13401,
"Cutlas_C":13402,
"Solar_Sword_C":13403,
"Platinum_Shotel":13404,
"Curved_Sword":13405,
"Edger":13406,
"Nagan_C":13407,
"Fire_Brand_C":13408,
"Immaterial_Sword_C":13409,
"BF_Sword1":13410,
"BF_Sword2":13411,
"Twin_Edge_B":13412,
"Twin_Edge_R":13413,
"Elemental_Sword":13414,
"N_Falchion":13415,
"Krieger_Onehand_Sword1":13416,
"Krieger_Onehand_Sword2":13417,
"Krieger_Onehand_Sword3":13418,
"Holy_Saber":13419,
"Honglyun's_Sword":13420,
"Ruber":13421,
"Flamberge_C":13422,
"P_Sabre1":13423,
"P_Sabre2":13424,
"Tourist_Sword":13425,
"F_Cutlas_C":13426,
"F_Solar_Sword_C":13427,
"Priest_Sword":13428,
"E_Cutlas_C":13429,
"E_Solar_Sword_C":13430,
"Chrome_Sword":13431,
"Adventure_Sword":13432,
"Academy_Sword":13433,
"P_Saber3":13434,
"Fire_Brand_":13435,
"Ice_Falchon_":13436,
"Orcish_Sword_":13437,
"Magical_Blade":13438,
"TE_Woe_Sword":13439,
"Ceremonial_Sword":13440,
"Thanos_Sword":13441,
"Old_Parasol":13442,
"Pala":13444,
"Half_BF_Sword1":13445,
"Star_Dust_Blade_":13446,
"Byeorrun_Gum_":13447,
"Magical_Blade_":13448,
"Gladius_Daemonicus":13449,
"LI_Saber":13450,
"Ru_Blue_Sword":13451,
"Ru_Gold_Sword":13452,
"Mysteltainn_S":13453,
"Scarlet_Saber":13454,
"Sinister_Saber":13455,
"Union_Sword":13456,
"Union_Dagger":13457,
"Sealed_Magic_Sword":13460,
"Sealed_Evil_Sword":13461,
"Sealed_Max_Sword":13462,
"Save_The_King":13465,
"Diva_Blade":13466,
"Mirage_Blade":13467,
"Sinister_Saber_J":13468,
"Immaterial_Sword_IL":13469,
"Sealed_Magic_SwordJ":13470,
"Sealed_Evil_SwordJ":13471,
"Sealed_Max_SwordJ":13472,
"Gods_Sword":13473,
"Sword_Z":13474,
"Falchion_Z":13475,
"Blade_Z":13476,
"Lapier_Z":13477,
"Scimiter_Z":13478,
"Tsurugi_z":13479,
"Ring_Pommel_Saber_Z":13480,
"Saber_Z":13481,
"Orcish_Blade":13482,
"Rebeginer_GN_Sword":13483,
"Sword_Of_Bluefire":13485,
"Local01_Sword":13488,
"Local02_Sword":13489,
"Woe_Onehand_Sword1_Z":13490,
"Variant_Blade":13492,
"Cannon_Rapier_OS":13493,
"Evt_Bluefire_Sword":13495,
"Edge_Z":13497,
"Nagan_Z":13498,
"Sword_Kladenets":13499,
"Insurance60_Package":13500,
"Assorted_Scroll_Box":13501,
"Drooping_Kitty_Box":13502,
"Magestic_Goat_Box":13503,
"Deviruchi_Cap_Box":13504,
"Executioner_Box":13505,
"Brood_Axe_Box":13506,
"Tomahawk_Box":13507,
"Bow_Of_Rudra_Box":13508,
"Cutlas_Box":13509,
"Solar_Sword_Box":13510,
"Sword_Breaker_Box":13511,
"Mail_Breaker_Box":13512,
"Moonlight_Sword_Box":13513,
"Spanner_Box":13514,
"Grape_Box":13515,
"Royal_Jelly_Box":13516,
"Yggdrasilberry_Box":13517,
"Weapon_Card_Scroll_Box":13518,
"Armor_Card_Scroll_Box":13519,
"Helmet_Card_Scroll_Box":13520,
"Garment_Card_Scroll_Box":13521,
"Shield_Card_Scroll_Box":13522,
"Shoes_Card_Scroll_Box":13523,
"Accy_Card_Scroll_Box":13524,
"Zeny_Card_Scroll_Box":13525,
"Pet_Egg_Scroll_Box1_":13526,
"Pet_Egg_Scroll_Box2_":13527,
"Pet_Egg_Scroll_Box3_":13528,
"Pet_Egg_Scroll_Box4_":13529,
"Pet_Egg_Scroll_Box5_":13530,
"Light_Red_Pot_Box":13531,
"Light_Orange_Pot_Box":13532,
"Light_Yellow_Pot_Box":13533,
"Light_White_Pot_Box":13534,
"Light_Center_Pot_Box":13535,
"Light_Awakening_Pot_Box":13536,
"Light_Berserk_Pot_Box":13537,
"Meteor_10_Scroll_Box":13538,
"Storm_10_Scroll_Box":13539,
"Vermilion_10_Scroll_Box":13540,
"Lex_Aeterna_Scroll_Box":13541,
"Magnificat_5_Scroll_Box":13542,
"CP_Helm_Scroll_Box":13543,
"CP_Shield_Scroll_Box":13544,
"CP_Armor_Scroll_Box":13545,
"CP_Weapon_Scroll_Box":13546,
"Repair_Scroll_Box":13547,
"Big_Bun_Box":13548,
"Pill__Box":13549,
"Superb_Fish_Slice_Box":13550,
"Chewy_Ricecake_Box":13551,
"Oriental_Pastry_Box":13552,
"Dun_Tele_Scroll1_Box":13553,
"Weapon_Card_Scroll_Box2":13554,
"Weapon_Card_Scroll_Box3":13555,
"Armor_Card_Scroll_Box2":13556,
"Accy_Card_Scroll_Box2":13557,
"Weapon_Card_Scroll":13558,
"Armor_Card_Scroll":13559,
"Helmet_Card_Scroll":13560,
"Hood_Card_Scroll":13561,
"Hood_Card_Scroll2":13562,
"Shoes_Card_Scroll":13563,
"Accy_Card_Scroll":13564,
"Weapon_Card_Scroll2":13565,
"Weapon_Card_Scroll3":13566,
"Armor_Card_Scroll2":13567,
"Accy_Card_Scroll2":13568,
"PVP_Tele_Scroll_Box":13569,
"Giant_Fly_Wing_Box50":13570,
"Giant_Fly_Wing_Box100":13571,
"Dex_Dish_Box30":13572,
"Dex_Dish_Box50":13573,
"Luk_Dish_Box30":13574,
"Luk_Dish_Box50":13575,
"Inc_Agi_10_Box30":13576,
"Inc_Agi_10_Box50":13577,
"Vit_Dish_Box30":13578,
"Vit_Dish_Box50":13579,
"Insurance_Package30":13580,
"Insurance_Package50":13581,
"Convex_Mirror_Box5":13582,
"Convex_Mirror_Box30":13583,
"Blessing10_Box30":13584,
"Blessing10_Box50":13585,
"Adrenaline10_Box30":13586,
"Adrenaline10_Box50":13587,
"Assumptio_5_Box30":13588,
"Assumptio_5_Box50":13589,
"Aspersio_5_Box30":13590,
"Aspersio_5_Box50":13591,
"Agi_Dish_Box30":13592,
"Agi_Dish_Box50":13593,
"Wind_Walk10_Box30":13594,
"Wind_Walk10_Box50":13595,
"Int_Dish_Box30":13596,
"Int_Dish_Box50":13597,
"Battle_Manual_Box1":13598,
"Battle_Manual_Box5":13599,
"Siegfried_Box5":13600,
"Siegfried_Box20":13601,
"Kafra_Card_Box30":13602,
"Kafra_Card_Box50":13603,
"Str_Dish_Box30":13604,
"Str_Dish_Box50":13605,
"Bubble_Gum_Box1":13606,
"Bubble_Gum_Box5":13607,
"Megaphone_Box1":13608,
"Megaphone_Box5":13609,
"Enriched_Elunium_Box5":13610,
"Enriched_Oridecon_Box5":13611,
"Handcuff_Box":13612,
"Super_Pet_Egg_Box1":13613,
"Super_Pet_Egg_Box2":13614,
"Super_Pet_Egg_Box3":13615,
"Super_Pet_Egg_Box4":13616,
"Super_Pet_Egg1":13617,
"Super_Pet_Egg2":13618,
"Super_Pet_Egg3":13619,
"Super_Pet_Egg4":13620,
"Greed_Box30":13621,
"Greed_Box50":13622,
"Greed_Box100":13623,
"Flee_30_Scroll_Box":13624,
"Accuracy_30_Scroll_Box":13625,
"Super_Card_Pet_Egg_Box1":13626,
"Super_Card_Pet_Egg_Box2":13627,
"Super_Card_Pet_Egg_Box3":13628,
"Super_Card_Pet_Egg_Box4":13629,
"Super_Card_Pet_Egg1":13630,
"Super_Card_Pet_Egg2":13631,
"Super_Card_Pet_Egg3":13632,
"Super_Card_Pet_Egg4":13633,
"Vigorgra_Package1":13634,
"Vigorgra_Package2":13635,
"Vigorgra_Package3":13636,
"Vigorgra_Package4":13637,
"Vigorgra_Package5":13638,
"Vigorgra_Package6":13639,
"Vigorgra_Package7":13640,
"Vigorgra_Package8":13641,
"Vigorgra_Package9":13642,
"Vigorgra_Package10":13643,
"Vigorgra_Package11":13644,
"Vigorgra_Package12":13645,
"Infiltrator_Box1":13646,
"Muramasa_Box1":13647,
"Excalibur_Box1":13648,
"Combat_Knife_Box1":13649,
"Counter_Dagger_Box1":13650,
"Kaiser_Knuckle_Box1":13651,
"Pole_Axe_Box1":13652,
"Mighty_Staff_Box1":13653,
"Right_Epsilon_Box1":13654,
"Balistar_Box1":13655,
"Diary_Of_Sage_Box1":13656,
"Asura_Box1":13657,
"Apple_Of_Archer_Box1":13658,
"Bunny_Band_Box1":13659,
"Sahkkat_Box1":13660,
"Lord_Circlet_Box1":13661,
"Elven_Ears_Box1":13662,
"Steel_Flower_Box1":13663,
"Critical_Ring_Box1":13664,
"Earring_Box1":13665,
"Ring_Box1":13666,
"Necklace_Box1":13667,
"Glove_Box1":13668,
"Brooch_Box1":13669,
"Rosary_Box1":13670,
"Safety_Ring_Box1":13671,
"Vesper_Core01_Box1":13672,
"Vesper_Core02_Box1":13673,
"Vesper_Core03_Box1":13674,
"Vesper_Core04_Box1":13675,
"Drooping_Kitty_Box1":13676,
"Magestic_Goat_Box1":13677,
"Deviruchi_Cap_Box1":13678,
"Executioner_Box1":13679,
"Brood_Axe_Box1":13680,
"Tomahawk_Box1":13681,
"Bow_Of_Rudra_Box1":13682,
"Cutlas_Box1":13683,
"Solar_Sword_Box1":13684,
"Sword_Breaker_Box1":13685,
"Mail_Breaker_Box1":13686,
"Moonlight_Sword_Box1":13687,
"Spanner_Box1":13688,
"Bok_Choy_Box":13689,
"Chung_E_Cake_Box":13690,
"Freyja_Overcoat_Box":13691,
"Freyja_Boots_Box":13692,
"Freyja_Cape_Box":13693,
"Freyja_Crown_Box":13694,
"Battle_Manual25_Box":13695,
"Battle_Manual100_Box":13696,
"J_Blessing10_Box":13697,
"J_Inc_Agi10_Box":13698,
"J_Wind_Walk10_Box":13699,
"J_Adrenaline10_Box":13700,
"Pet_Egg_Scroll12":13701,
"Pet_Egg_Scroll13":13702,
"Pet_Egg_Scroll14":13703,
"Super_Pet_Egg5":13704,
"Super_Pet_Egg6":13705,
"Super_Pet_Egg7":13706,
"Super_Pet_Egg8":13707,
"Pet_Egg_Scroll_E":13708,
"BRO_Package1":13709,
"Max_Weight_Up_Box":13710,
"Small_Life_Potion_Box":13711,
"Small_Life_Potion_Box30":13712,
"Small_Life_Potion_Box50":13713,
"Med_Life_Potion_Box":13714,
"Med_Life_Potion_Box30":13715,
"Med_Life_Potion_Box50":13716,
"Abrasive_Box5":13717,
"Abrasive_Box10":13718,
"Regeneration_Box5":13719,
"Regeneration_Box10":13720,
"Dun_Tele_Scroll_Box10":13721,
"Pecopeco_Hairband_Box":13722,
"Red_Glasses_Box":13723,
"Whisper_Mask_Box":13724,
"Ramen_Hat_Box":13725,
"Gold_Box_":13726,
"Silver_Box_":13727,
"Gold_Key1_Box":13728,
"Gold_Key5_Box":13729,
"Silver_Key1_Box":13730,
"Silver_Key5_Box":13731,
"Pecopeco_Hairband_Box1":13734,
"Red_Glasses_Box1":13735,
"Whisper_Mask_Box1":13736,
"Ramen_Hat_Box1":13737,
"Glass_Of_Illusion_Box5":13738,
"Glass_Of_Illusion_Box10":13739,
"Shadow_Armor_S_Box5":13740,
"Shadow_Armor_S_Box10":13741,
"Shadow_Armor_S_Box30":13742,
"Holy_Armor_S_Box5":13743,
"Holy_Armor_S_Box10":13744,
"Holy_Armor_S_Box30":13745,
"S_Def_Potion_Box10":13746,
"S_Def_Potion_Box30":13747,
"S_Def_Potion_Box50":13748,
"B_Def_Potion_Box10":13749,
"B_Def_Potion_Box30":13750,
"B_Def_Potion_Box50":13751,
"S_Mdef_Potion_Box10":13752,
"S_Mdef_Potion_Box30":13753,
"S_Mdef_Potion_Box50":13754,
"B_Mdef_Potion_Box10":13755,
"B_Mdef_Potion_Box30":13756,
"B_Mdef_Potion_Box50":13757,
"Battle_Manual_X3_Box":13758,
"In_Blue_Herb_Box":13759,
"Honey_Box":13760,
"Empty_Bottle_Box":13761,
"In_Royal_Jelly_Box":13762,
"5_Anniversary_Coin_Box":13763,
"Battle_Manual_Box_TW":13764,
"Certificate_TW_Box":13765,
"Nagan_Box":13766,
"Skewer_Box":13767,
"Survival_Rod_Box":13768,
"Quadrille_Box":13769,
"Great_Axe_Box":13770,
"Bloody_Roar_Box":13771,
"Hardback_Box":13772,
"Fire_Brand_Box":13773,
"Immaterial_Sword_Box":13774,
"Unholy_Touch_Box":13775,
"Cloak_Of_Survival_Box":13776,
"Masquerade_Box":13777,
"Orc_Hero_Helm_Box":13778,
"Evil_Wing_Ears_Box":13779,
"Dark_Blindfold_Box":13780,
"kRO_Drooping_Kitty_Box":13781,
"Corsair_Box":13782,
"Bloody_Iron_Ball_Box":13783,
"Spiritual_Ring_Box":13784,
"Nagan_Box1":13785,
"Skewer_Box1":13786,
"Survival_Rod_Box1":13787,
"Quadrille_Box1":13788,
"Great_Axe_Box1":13789,
"Bloody_Roar_Box1":13790,
"Hardback_Box1":13791,
"Fire_Brand_Box1":13792,
"Immaterial_Sword_Box1":13793,
"Unholy_Touch_Box1":13794,
"Cloak_Of_Survival_Box1":13795,
"Masquerade_Box1":13796,
"Orc_Hero_Helm_Box1":13797,
"Evil_Wing_Ears_Box1":13798,
"Dark_Blindfold_Box1":13799,
"kRO_Drooping_Kitty_Box1":13800,
"Corsair_Box1":13801,
"Bloody_Iron_Ball_Box1":13802,
"Spiritual_Ring_Box1":13803,
"Fire_Cracker_Love_Box":13804,
"Fire_Cracker_Wday_Box":13805,
"Fire_Cracker_Vday_Box":13806,
"Fire_Cracker_Bday_Box":13807,
"Fire_Cracker_Xmas_Box":13808,
"Blue_Gemstone_Box":13809,
"Blue_Potion_Box":13810,
"Food_Box_Lv1":13811,
"Food_Box_Lv2":13812,
"Food_Box_Lv3":13813,
"Indonesia_Box":13814,
"Knife_Goblin_Box":13815,
"Flail_Goblin_Box":13816,
"Hammer_Goblin_Box":13817,
"Red_Deleter_Box":13818,
"Diabolic_Box":13819,
"Wanderer_Box":13820,
"Green_Apple_Box":13821,
"Whole_Barbecue_Box":13822,
"Meat_Veg_Skewer_Box":13823,
"Spirit_Liquor_Box":13824,
"Green_Box_":13825,
"Power_Box1":13826,
"Power_Box2":13827,
"Resist_Box1":13828,
"Resist_Box2":13829,
"Stat_Boost1":13830,
"Stat_Boost2":13831,
"Stat_Boost3":13832,
"Stat_Boost4":13833,
"Dun_Tele_Scroll2_Box5":13834,
"Dun_Tele_Scroll2_Box10":13835,
"Mbl_Str_Dish_Box":13836,
"Mbl_Agi_Dish_Box":13837,
"Mbl_Int_Dish_Box":13838,
"Mbl_Dex_Dish_Box":13839,
"Mbl_Luk_Dish_Box":13840,
"Mbl_Vit_Dish_Box":13841,
"Mbl_Kafra_Card_Box":13842,
"Mbl_Battle_Manual_Box":13843,
"Heroic_Stone_Box":13844,
"Mysterious_Travel_Sack1":13845,
"Mysterious_Travel_Sack2":13846,
"Mysterious_Travel_Sack3":13847,
"Mysterious_Travel_Sack4":13848,
"WOB_Box_Rune5":13849,
"WOB_Box_Rune10":13850,
"WOB_Box_Schawaltz5":13851,
"WOB_Box_Schawaltz10":13852,
"WOB_Box_Rachel5":13853,
"WOB_Box_Rachel10":13854,
"WOB_Box_Local5":13855,
"WOB_Box_Local10":13856,
"Spark_Candy_Box5":13857,
"Spark_Candy_Box10":13858,
"Directive_A_Envelope":13859,
"Directive_B_Envelope":13860,
"Mini_Battle_Manual_Box":13861,
"Trial_Box":13862,
"Repair_Scroll_Box10":13863,
"Hockey_Mask_Box":13864,
"Observer_Box":13865,
"Flying_Angel_Box":13866,
"Neko_Mimi_Box":13867,
"MFH_Box":13868,
"Chick_Hat_Box":13869,
"New_Style_Box":13870,
"Mage_Card_Box":13871,
"Acolyte_Card_Box":13872,
"Archer_Card_Box":13873,
"Swordman_Card_Box":13874,
"Thief_Card_Box":13875,
"Merchant_Card_Box":13876,
"Clock_Tower_Card_Box":13877,
"Geffenia_Card_Box":13878,
"Owl_Card_Box":13879,
"Ghost_Card_Box":13880,
"Nightmare_Card_Box":13881,
"Curse_Card_Box":13882,
"Sleep_Card_Box":13883,
"Freeze_Card_Box":13884,
"Stun_Card_Box":13885,
"Silence_Card_Box":13886,
"Blind_Card_Box":13887,
"Chaos_Card_Box":13888,
"Elunium_Box_":13889,
"Oridecon_Box_":13890,
"Fire_Converter_Box":13891,
"Water_Converter_Box":13892,
"Wind_Converter_Box":13893,
"Earth_Converter_Box":13894,
"Starter_Pack":13895,
"Mimic_Scroll_Box5":13896,
"Disguise_Croll_Box5":13897,
"Alice_Scroll_Box5":13898,
"Mimic_Scroll_Box10":13899,
"Disguise_Croll_Box10":13900,
"Alice_Scroll_Box10":13901,
"Fish_Head_Hat_Box":13902,
"Santa_Poring_Hat_Box":13903,
"Bell_Ribbon_Box":13904,
"Hard_Core_Set_Box":13905,
"Kitty_Set_Box":13906,
"Soft_Core_Set_Box":13907,
"Deviruchi_Set_Box":13908,
"MVP_Hunt_Box":13909,
"Cook_Box":13910,
"Xmas_Pet_Scroll":13911,
"Party_Blessing_Box":13912,
"Party_Inc_Agi_Box":13913,
"Party_Assumptio_Box":13914,
"Love_Angel_Box":13915,
"Squirrel_Box":13916,
"Gogo_Box":13917,
"Drooping_Kitty__Box":13918,
"Magestic_Goat__Box":13919,
"Satanic__Chain_Box":13920,
"Antique_Pipe_Box":13921,
"Bunny_Band__Box":13922,
"Darkness_Helm_Box":13923,
"L_Orc_Hero_Helm_Box":13924,
"Year_Of_Mouse_Scroll":13925,
"Crusader_Card_Box":13926,
"Alchemist_Card_Box":13927,
"Rogue_Card_Box":13928,
"Bard_Dancer_Card_Box":13929,
"Sage_Card_Box":13930,
"Monk_Card_Box":13931,
"Sylph_Box":13932,
"Undine_Box":13933,
"Salamander_Box":13934,
"Soul_Box":13935,
"Noum_Bpx":13936,
"Robo_Eye_Box":13937,
"Twin_Ribbon_Box":13938,
"Diadem_Box":13939,
"Siege_Scroll_Box":13940,
"TW_Valentine_Scroll":13941,
"Love_Angel_Box_1m":13942,
"Squirrel_Box_1m":13943,
"Gogo_Box_1m":13944,
"BRO_SM_Package":13945,
"BRO_MG_Package":13946,
"BRO_AC_Package":13947,
"BRO_AR_Package":13948,
"BRO_MC_Package":13949,
"BRO_TF_Package":13950,
"Wasteland_Outlaw_Box":13951,
"Lever_Action_Rifle_Box":13952,
"All_In_One_Ring_Box":13953,
"Spiritual_Tunic_Box":13954,
"Recuperative_Armor_Box":13955,
"Shelter_Resistance_Box":13956,
"Sylphid_Manteau_Box":13957,
"Refresh_Shoes_Box":13958,
"Toast_Box":13959,
"Name_Change_Coupon_Box":13960,
"Mojji_Box":13961,
"Deprotai_Doll_Hat_Box":13962,
"Claris_Doll_Hat_Box":13963,
"Sorin_Doll_Hat_Box":13964,
"Tayelin_Doll_Hat_Box":13965,
"Binit_Doll_Hat_Box":13966,
"Debril_Doll_Hat_Box":13967,
"Bubblegum_Lower_Box":13968,
"Lucky_Clip_Box":13969,
"Iron_10_Box":13970,
"Steel_10_Box":13971,
"Coal_10_Box":13972,
"Poison_Bottle_30_Box":13973,
"TW_Scroll01":13974,
"Picture_Diary_Box":13975,
"Mini_Heart_Box":13976,
"Newcomer_Box":13977,
"Kid_Box":13978,
"Magic_Castle_Box":13979,
"Bulging_Head_Box":13980,
"Picture_Diary_Box_1m":13981,
"Mini_Heart_Box_1m":13982,
"Newcomer_Box_1m":13983,
"Kid_Box_1m":13984,
"Magic_Castle_Box_1m":13985,
"Bulging_Head_Box_1m":13986,
"Ori_Stone_5_Box":13987,
"Ori_Stone_50_Box":13988,
"Acidbomb_10_Box":13989,
"Job_Manual50_Box":13990,
"Tiger_Mask_Box":13991,
"Cat_Hat_Box":13992,
"Alice_Doll_Box":13993,
"Speed_Up_Potion_Box5":13994,
"Speed_Up_Potion_Box10":13995,
"Big_Bun_Box100":13996,
"Big_Bun_Box500":13997,
"Giant_Fly_Wing_Box500":13998,
"Pill__Box100":13999,
"Pill__Box500":14000,
"Basic_Siege_Supply_Box":14001,
"Adv_Siege_Supply_Box":14002,
"Elite_Siege_Supply_Box":14003,
"Poison_Bottle_10_Box":14004,
"Poison_Bottle_5_Box":14005,
"F_Drooping_W_Kitty_Box":14006,
"F_Rabbit_Ear_Hat_Box":14007,
"F_L_Orc_Hero_Helm_Box":14008,
"F_Love_Angel_Box":14009,
"F_Squirrel_Box":14010,
"F_Gogo_Box":14011,
"F_Love_Angel_Box_1m":14012,
"F_Squirrel_Box_1m":14013,
"F_Gogo_Box_1m":14014,
"F_Wasteland_Outlaw_Box":14015,
"F_Lever_Action_Rifle_Bo":14016,
"F_All_In_One_Ring_Box":14017,
"F_Spritual_Tunic_Box":14018,
"F_Recuperative_Box":14019,
"F_Shelter_Resist_Box":14020,
"F_Sylphid_Manteau_Box":14021,
"F_Refresh_Shoes_Box":14022,
"F_Toast_Box":14023,
"F_Robo_Eye_Box":14024,
"F_Twin_Ribbon_Box":14025,
"F_Diadem_Box":14026,
"F_Fish_Head_Hat_Box":14027,
"F_Santa_Poring_Hat_Box":14028,
"F_Bell_Ribbon_Box":14029,
"F_Mimic_Scroll_Box5":14030,
"F_Disguise_Scroll_Box5":14031,
"F_Alice_Scroll_Box5":14032,
"F_Mimic_Scroll_Box10":14033,
"F_Disguise_Scroll_Box10":14034,
"F_Alice_Scroll_Box10":14035,
"F_New_Style_Coupon_Box":14036,
"F_Repair_Scroll_Box":14037,
"F_Repair_Scroll_Box10":14038,
"F_Hockey_Mask_Box":14039,
"F_Observer_Box":14040,
"F_WOB_Rune_Box5":14041,
"F_WOB_Rune_Box10":14042,
"F_WOB_Schwaltz_Box5":14043,
"F_WOB_Schwaltz_Box10":14044,
"F_WOB_Rachel_Box5":14045,
"F_WOB_Rachel_Box10":14046,
"F_WOB_Local_Box5":14047,
"F_WOB_Local_Box10":14048,
"F_Spark_Candy_Box5":14049,
"F_Spark_Candy_Box10":14050,
"F_Dun_Tel_Scroll2_Box5":14051,
"F_Dun_Tel_Scroll2_Box10":14052,
"F_Little_Angel_Doll_Box":14053,
"F_Triple_Poring_Hat_Box":14054,
"F_Nagan_Box":14055,
"F_Skewer_Box":14056,
"F_Survival_Rod_Box":14057,
"F_Quadrille_Box":14058,
"F_Great_Axe_Box":14059,
"F_Bloody_Roar_Box":14060,
"F_Hardback_Box":14061,
"F_Fire_Brand_Box":14062,
"F_Immaterial_Sword_Box":14063,
"F_Unholy_Touch_Box":14064,
"F_Clack_Of_Servival_Box":14065,
"F_Masquerade_Box":14066,
"F_Orc_Hero_Helm_Box":14067,
"F_Ear_Of_Devil_Wing_Box":14068,
"F_Dark_Blindfold_Box":14069,
"F_K_Drooping_Kitty_Box":14070,
"F_Corsair_Box":14071,
"F_Bloody_Iron_Ball_Box":14072,
"F_Spiritual_Ring_Box":14073,
"F_G_O_I_Box5":14074,
"F_G_O_I_Box10":14075,
"F_Shadow_Armor_S_Box5":14076,
"F_Shadow_Armor_S_Box10":14077,
"F_Shadow_Armor_S_Box30":14078,
"F_Holy_Armor_S_Box5":14079,
"F_Holy_Armor_S_Box10":14080,
"F_Holy_Armor_S_Box30":14081,
"FS_Def_Potion_Box10":14082,
"FS_Def_Potion_Box30":14083,
"FS_Def_Potion_Box50":14084,
"FB_Def_Potion_Box10":14085,
"FB_Def_Potion_Box30":14086,
"FB_Def_Potion_Box50":14087,
"FS_Mdef_Potion_Box10":14088,
"FS_Mdef_Potion_Box30":14089,
"FS_Mdef_Potion_Box50":14090,
"FB_Mdef_Potion_Box10":14091,
"FB_Mdef_Potion_Box30":14092,
"FB_Mdef_Potion_Box50":14093,
"F_Flying_Angel_Box":14094,
"F_Cat_Hat_Box":14095,
"F_M_F_H_Box":14096,
"F_Chick_Hat_Box":14097,
"F_Pecopeco_Hairband_Box":14098,
"F_Red_Glasses_Box":14099,
"F_Whisper_Mask_Box":14100,
"F_Ramen_Hat_Box":14101,
"F_Dun_Tele_Scroll1_Box":14102,
"F_Max_Weight_Up_Box":14103,
"F_S_Life_Potion_Box":14104,
"F_S_Life_Potion_Box30":14105,
"F_S_Life_Potion_Box50":14106,
"F_M_Life_Potion_Box":14107,
"F_M_Life_Potion_Box30":14108,
"F_M_Life_Potion_Box50":14109,
"F_Abrasive_Box5":14110,
"F_Abrasive_Box10":14111,
"F_Regeneration_Box5":14112,
"F_Regeneration_Box10":14113,
"F_Dun_Tele_Scroll_Box10":14114,
"F_Infiltrator_Box":14115,
"F_Muramasa_Box":14116,
"F_Excalibur_Box":14117,
"F_Combat_Knife_Box":14118,
"F_Counter_Dagger_Box":14119,
"F_Kaiser_Knuckle_Box":14120,
"F_Mighty_Staff_Box":14121,
"F_Right_Epsilon_Box":14122,
"F_Balistar_Box":14123,
"F_Diary_Of_Great_Sage":14124,
"F_Asura_Box":14125,
"F_Apple_Of_Archer_Box":14126,
"F_Bunny_Band_Box":14127,
"F_Sahkkat_Box":14128,
"F_Lord_Circlet_Box":14129,
"F_Elven_Ears_Box":14130,
"F_Steel_Flower_Box":14131,
"F_Critical_Ring_Box":14132,
"F_Earring_Box":14133,
"F_Ring_Box":14134,
"F_Necklace_Box":14135,
"F_Glove_Box":14136,
"F_Brooch_Box":14137,
"F_Rosary_Box":14138,
"F_Safety_Ring_Box":14139,
"F_Vesper_Core_Box01":14140,
"F_Vesper_Core_Box02":14141,
"F_Vesper_Core_Box03":14142,
"F_Vesper_Core_Box04":14143,
"F_Vigorgra_Package1":14144,
"F_Vigorgra_Package2":14145,
"F_Vigorgra_Package3":14146,
"F_Vigorgra_Package4":14147,
"F_Vigorgra_Package5":14148,
"F_Vigorgra_Package6":14149,
"F_Vigorgra_Package7":14150,
"F_Vigorgra_Package8":14151,
"F_Vigorgra_Package9":14152,
"F_Vigorgra_Package10":14153,
"F_Vigorgra_Package11":14154,
"F_Vigorgra_Package12":14155,
"F_Battle_Manual_Box":14156,
"F_Insurance_Package":14157,
"F_Bubble_Gum_Box":14158,
"F_Str_Dish_Box":14159,
"F_Agi_Dish_Box":14160,
"F_Int_Dish_Box":14161,
"F_Dex_Dish_Box":14162,
"F_Luk_Dish_Box":14163,
"F_Vit_Dish_Box":14164,
"F_Kafra_Card_Box":14165,
"F_Giant_Fly_Wing_Box":14166,
"F_Neuralizer_Box":14167,
"F_Convex_Mirror_Box":14168,
"F_Blessing_10_Box":14169,
"F_Inc_Agi_10_Scroll_Box":14170,
"F_Aspersio_5_Scroll_Box":14171,
"F_Assumptio_5_Box":14172,
"F_Wind_Walk_10_Box":14173,
"F_Adrenaline_Scroll_Box":14174,
"F_Megaphone_Box":14175,
"F_Enriched_Elunium_Box":14176,
"F_Enriched_Oridecon_Box":14177,
"F_Siegfried_Box":14178,
"F_Giant_Fly_Wing_Box50":14179,
"F_Giant_Fly_Wing_Box100":14180,
"F_Dex_Dish_Box30":14181,
"F_Dex_Dish_Box50":14182,
"F_Luk_Dish_Box30":14183,
"F_Luk_Dish_Box50":14184,
"F_Inc_Agi_10_Box30":14185,
"F_Inc_Agi_10_Box50":14186,
"F_Vit_Dish_Box30":14187,
"F_Vit_Dish_Box50":14188,
"F_Insurance_Package30":14189,
"F_Insurance_Package50":14190,
"F_Convex_Mirror_Box5":14191,
"F_Convex_Mirror_Box30":14192,
"F_Blessing10_Box30":14193,
"F_Blessing10_Box50":14194,
"F_Adrenaline10_Box30":14195,
"F_Adrenaline10_Box50":14196,
"F_Assumptio_5_Box30":14197,
"F_Assumptio_5_Box50":14198,
"F_Aspersio_5_Box30":14199,
"F_Aspersio_5_Box50":14200,
"F_Agi_Dish_Box30":14201,
"F_Agi_Dish_Box50":14202,
"F_Wind_Walk10_Box30":14203,
"F_Wind_Walk10_Box50":14204,
"F_Int_Dish_Box30":14205,
"F_Int_Dish_Box50":14206,
"F_Battle_Manual_Box1":14207,
"F_Battle_Manual_Box5":14208,
"F_Siegfried_Box5":14209,
"F_Siegfried_Box20":14210,
"F_Kafra_Card_Box30":14211,
"F_Kafra_Card_Box50":14212,
"F_Str_Dish_Box30":14213,
"F_Str_Dish_Box50":14214,
"F_Bubble_Gum_Box1":14215,
"F_Bubble_Gum_Box5":14216,
"F_Megaphone_Box1":14217,
"F_Megaphone_Box5":14218,
"F_Enriched_Elunium_Box5":14219,
"FEnriched_Oridecon_Box5":14220,
"MP_Scroll_Box":14221,
"MP_Scroll_Box30":14222,
"MP_Scroll_Box50":14223,
"Quagmire_Scroll_Box":14224,
"Quagmire_Scroll_Box30":14225,
"Quagmire_Scroll_Box50":14226,
"Healing_Staff_Box":14227,
"Praxinus_Box":14228,
"Sakura":14229,
"Headset_OST_Box":14230,
"Novice_Set_Box":14231,
"Yggdrasilberry_Box_":14232,
"Dead_Tree_Branch_Box1":14233,
"Dead_Tree_Branch_Box2":14234,
"Battle_Manual50_Box":14235,
"Str_Dish20_Box":14236,
"Agi_Dish20_Box":14237,
"Vit_Dish20_Box":14238,
"Int_Dish20_Box":14239,
"Dex_Dish20_Box":14240,
"Luk_Dish20_Box":14241,
"Beholder_Ring_Box":14242,
"Hallow_Ring_Box":14243,
"Clamorous_Ring_Box":14244,
"Chemical_Ring_Box":14245,
"Insecticide_Ring_Box":14246,
"Fisher_Ring_Box":14247,
"Decussate_Ring_Box":14248,
"Bloody_Ring_Box":14249,
"Satanic_Ring_Box":14250,
"Dragoon_Ring_Box":14251,
"Beholder_Ring_Box2":14252,
"Hallow_Ring_Box2":14253,
"Clamorous_Ring_Box2":14254,
"Chemical_Ring_Box2":14255,
"Insecticide_Ring_Box2":14256,
"Fisher_Ring_Box2":14257,
"Decussate_Ring_Box2":14258,
"Bloody_Ring_Box2":14259,
"Satanic_Ring_Box2":14260,
"Dragoon_Ring_Box2":14261,
"FPicture_Diary_Box":14262,
"FMini_Heart_Box":14263,
"FNewcomer_Box":14264,
"FKid_Box":14265,
"FMagic_Castle_Box":14266,
"FBulging_Head_Box":14267,
"FPicture_Diary_Box_1m":14268,
"FMini_Heart_Box_1m":14269,
"FNewcomer_Box_1m":14270,
"FKid_Box_1m":14271,
"FMagic_Castle_Box_1m":14272,
"FBulging_Head_Box_1m":14273,
"FMP_Scroll_Box":14274,
"FMP_Scroll_Box30":14275,
"FMP_Scroll_Box50":14276,
"FQuagmire_Scroll_Box":14277,
"FQuagmire_Scroll_Box30":14278,
"FQuagmire_Scroll_Box50":14279,
"FHealing_Staff_Box":14280,
"FPraxinus_Box":14281,
"Empelium_Box":14282,
"Marriage_Covenant_Box":14283,
"Muffler_C_Box":14284,
"Valkyrja's_Shield_C_Box":14285,
"Skul_Ring_C_Box":14286,
"S_Barricade_Repair_Kit":14287,
"S_Gstone_Repair_Kit":14288,
"Cloth_Dye_Coupon_Box":14289,
"Cloth_Dye_Coupon2_Box":14290,
"FCloth_Dye_Coupon_Box":14291,
"FCloth_Dye_Coupon_Box2":14292,
"Mercenary_Contract_Box":14293,
"Mercenary_Contract_5Box":14294,
"Mercenary_Con_10Box":14295,
"Angel_Scroll":14296,
"Devil_Scroll":14297,
"Surprise_Scroll":14298,
"Evolved_Leaf_Box":14299,
"Mask_Of_Ifrit_Box":14300,
"Ifrit's_Ear_Box":14301,
"Filr_Hat_Box":14302,
"Angel_Spirit_Box":14303,
"Scuba_Mask_Box":14304,
"Neko_Mimi_Kafra_Box":14305,
"RWC_Special_Scroll":14306,
"RWC_Limited_Scroll":14307,
"Ardor_Scroll":14308,
"Gang_Scarf_Box":14309,
"Ninja_Scroll_Box":14310,
"FAngel_Spirit_Box":14311,
"FGang_Scarf_Box":14312,
"FNinja_Scroll_Box":14313,
"PhreeoniS_Box":14314,
"GhostringS_Box":14315,
"July7_Scroll":14316,
"Bacsojin_Scroll":14317,
"Radio_Antenna_Box":14318,
"Tiraya_Bonnet_Box":14319,
"Balloon_Hat_Box":14320,
"Holy_Saber_Box":14321,
"Book_Of_Prayer_Box":14322,
"Phenomena_Whip_Box":14323,
"Staff_Of_Darkness_Box":14324,
"Monk_Knuckle_Box":14325,
"Mace_Of_Madness_Box":14326,
"Spear_Of_Excellent_Box":14327,
"Bow_Of_Evil_Box":14328,
"Katar_Of_Speed_Box":14329,
"SS_Revolver_Box":14330,
"Guildsman_Recruiter_Box":14331,
"Party_Recruiter_Hat_Box":14332,
"Bf_Recruiter_Hat_Box":14333,
"Friend_Recr_Hat_Box":14334,
"Gf_Recruiter_Hat_Box":14335,
"Marcher_Hat_Box":14336,
"F_Guildsman_Recr_Box":14337,
"F_Party_Recr_Hat_Box":14338,
"FBf_Recruiter_Hat_Box":14339,
"F_Friend_Recr_Hat_Box":14340,
"FGf_Recruiter_Hat_Box":14341,
"FMarcher_Hat_Box":14342,
"Spiked_Scarf_Box":14343,
"Rainbow_Scarf_Box":14344,
"Animal_Scroll":14345,
"Bro_Flag_Box":14346,
"Greed_Scroll_C20Box":14347,
"Greed_Scroll_C50Box":14348,
"Mental_Potion20_Box":14349,
"Mental_Potion50_Box":14350,
"Tyr_Blessing_Box20":14351,
"Tyr_Blessing_Box50":14352,
"F_Greed_Scroll_C20Box":14353,
"F_Greed_Scroll_C50Box":14354,
"F_Mental_Potion20_Box":14355,
"F_Mental_Potion50_Box":14356,
"F_Tyr_Blessing_Box20":14357,
"F_Tyr_Blessing_Box50":14358,
"TaogunkaS_Box":14359,
"MistressS_Box":14360,
"Orc_HeroS_Box":14361,
"Orc_LoadS_Box":14362,
"Heart_Scroll":14363,
"Job_Manual25_Box1":14364,
"Job_Manual25_Box5":14365,
"Job_Manual25_Box10":14366,
"F_Job_Manual25_Box1":14367,
"F_Job_Manual25_Box5":14368,
"F_Job_Manual25_Box10":14369,
"Goddess_Bless_Box":14370,
"Angel_Bless_Box":14371,
"Powder_Snow_Box":14372,
"Little_Heart_Box":14373,
"J_Firecracker_Box":14374,
"Holy_Celestial_Axe_Box":14375,
"Angeling_Pot_Box":14376,
"Shout_Megaphone_Box":14377,
"Dun_Tele_Scroll3_Box_fr":14378,
"Love_Daddy_Box":14379,
"Anubis_Helm_Box":14380,
"Piercing_Box_M":14381,
"Lich_Bone_Box_M":14382,
"Long_Horn_Box_M":14383,
"Hunting_Spear_Box_M":14384,
"Death_Note_Box_M":14385,
"Destruction_Box_M":14386,
"Rider_Insignia_Box_M":14387,
"Mithril_Cape_Box_M":14388,
"Sniping_Box_M":14389,
"Orleans_Box_M":14390,
"Spiritual_Box_M":14391,
"Variant_Box_M":14392,
"Almighty_Charm_Box":14393,
"Santa_Hat_1_Box":14394,
"J_Captain_Hat_Box":14395,
"Coke_Hat_Box":14396,
"Bonus_Box01":14397,
"Bonus_Box02":14398,
"Bonus_Box03":14399,
"Bonus_Box04":14400,
"Bonus_Box05":14401,
"Bonus_Box06":14402,
"Bonus_Box07":14403,
"Bonus_Box08":14404,
"Bonus_Box09":14405,
"Bonus_Box10":14406,
"Xmas_Scroll":14407,
"New_Year_Scroll":14408,
"F_Santa_Hat_1_Box":14409,
"F_Captain_Hat_Box":14410,
"F_Coke_Hat_Box":14411,
"F_Bonus_Box01":14412,
"F_Bonus_Box02":14413,
"F_Bonus_Box03":14414,
"F_Bonus_Box04":14415,
"F_Bonus_Box05":14416,
"F_Bonus_Box06":14417,
"F_Bonus_Box07":14418,
"F_Bonus_Box08":14419,
"F_Bonus_Box09":14420,
"F_Bonus_Box10":14421,
"Shaman's_Old_Paper_Box":14422,
"Broken_Sword_Box":14423,
"Wing_Of_Bizofnil_Box":14424,
"Fortune_Sword_Box_I":14426,
"House_Auger_Box_I":14427,
"Kamaitachi_Box_I":14428,
"Berserk_Guitar_Box_I":14429,
"Doom_Slayer_Box_I":14430,
"Huuma_Blaze_Box_I":14431,
"Odin's_Blessing_Box_I":14432,
"Ring_Of_F_Lord_Box_I":14433,
"Ring_Of_Reson_Box_I":14434,
"Boy's_Cap_Box_I":14435,
"Ulle_Cap_Box_I":14436,
"Spinx_Helm_Box_I":14437,
"Honglyun's_Sword_Box":14438,
"Power_Of_Thor_Box":14439,
"Dice_Hat_Box":14440,
"King_Tiger_Doll_Hat_Box":14441,
"Wondering_Wolf_Helm_Box":14442,
"Pizza_Hat_Box":14443,
"Icecream_Hat_Box":14444,
"Pirate's_Pride_Box":14447,
"Necromencer's_Hood_Box":14448,
"Fugin_Egg01":14449,
"Fugin_Egg02":14450,
"Fugin_Egg03":14451,
"Fugin_Egg04":14452,
"Fugin_Egg05":14453,
"Fugin_Egg06":14454,
"Munin_Egg01":14455,
"Munin_Egg02":14456,
"Munin_Egg03":14457,
"Munin_Egg04":14458,
"Rabbit_Magic_Hat_Box":14459,
"China_Wedding_Veil_Box":14460,
"Asara_Fairy_Hat_Box":14461,
"Darkness_Helm_Box2":14462,
"New_Cowboy_Hat_Box":14463,
"F_Darkness_Helm_Box2":14464,
"F_New_Cowboy_Hat_Box":14465,
"Valentine_Pledge_Box":14466,
"Carnival_Hat_Box":14467,
"Carnival_Circlet_Box":14468,
"Ox_Tail_Scroll":14469,
"T_Nightmare_Box":14470,
"T_Loli_Ruri_Box":14471,
"T_Goblin_Leader_Box":14472,
"T_Incubus_Box":14473,
"T_Miyabi_Ningyo_Box":14474,
"T_Whisper_Box":14475,
"T_Wicked_Nymph_Box":14476,
"T_Medusa_Box":14477,
"T_Stoneshooter_Box":14478,
"T_Marionette_Box":14479,
"T_Leafcat_Box":14480,
"T_Dullahan_Box":14481,
"T_Shinobi_Box":14482,
"T_Golem_Box":14483,
"T_Civil_Servant_Box":14484,
"Academy_Badge_Box":14485,
"Academy_Fresh_Hat_Box":14486,
"Academy_Gradu_Cap_Box":14487,
"Blue_Pajamas_Hat_Box":14488,
"Pink_Pajamas_Hat_Box":14489,
"Shark_Hat_Box":14490,
"Sting_Hat_Box":14491,
"FShark_Hat_Box":14492,
"FSting_Hat_Box":14493,
"Samambaia_Box":14494,
"Aquarius_Diadem_Box":14495,
"Aquarius_Crown_Box":14496,
"Pisces_Diadem_Box":14497,
"Pisces_Crown_Box":14498,
"Peacock_Feather_Box":14499,
"Insurance60":14500,
"Dun_1HR_Voucher":14505,
"Dun_Voucher":14506,
"Zeny_Scroll":14508,
"Light_Center_Pot":14509,
"Light_Awakening_Pot":14510,
"Light_Berserk_Pot":14511,
"Meteor_10_Scroll":14512,
"Storm_10_Scroll":14513,
"Vermilion_10_Scroll":14514,
"Lex_Aeterna_Scroll":14515,
"Magnificat_5_Scroll":14516,
"CP_Helm_Scroll":14517,
"CP_Shield_Scroll":14518,
"CP_Armor_Scroll":14519,
"CP_Weapon_Scroll":14520,
"Repair_Scroll":14521,
"Big_Bun":14522,
"Pill_":14523,
"Superb_Fish_Slice":14524,
"Chewy_Ricecake":14525,
"Oriental_Pastry":14526,
"Dun_Tele_Scroll1":14527,
"PVP_Tele_Scroll":14528,
"Greed_Scroll":14529,
"Flee_30_Scroll":14530,
"Accuracy_30_Scroll":14531,
"Battle_Manual25":14532,
"Battle_Manual100":14533,
"Small_Life_Potion":14534,
"Med_Life_Potion":14535,
"Abrasive":14536,
"Regeneration_Potion":14537,
"Glass_Of_Illusion":14538,
"Shadow_Armor_S":14539,
"Holy_Armor_S":14540,
"S_Def_Potion":14541,
"B_Def_Potion":14542,
"S_Mdef_Potion":14543,
"B_Mdef_Potion":14544,
"Battle_Manual_X3":14545,
"Fire_Cracker_Love":14546,
"Fire_Cracker_Wday":14547,
"Fire_Cracker_Vday":14548,
"Fire_Cracker_Bday":14549,
"Fire_Cracker_Xmas":14550,
"Str_Dish01_":14551,
"Str_Dish02_":14552,
"Str_Dish03_":14553,
"Int_Dish01_":14554,
"Int_Dish02_":14555,
"Int_Dish03_":14556,
"Vit_Dish01_":14557,
"Vit_Dish02_":14558,
"Vit_Dish03_":14559,
"Agi_Dish01_":14560,
"Agi_Dish02_":14561,
"Agi_Dish03_":14562,
"Dex_Dish01_":14563,
"Dex_Dish02_":14564,
"Dex_Dish03_":14565,
"Luk_Dish01_":14566,
"Luk_Dish02_":14567,
"Luk_Dish03_":14568,
"Knife_Goblin_Ring":14569,
"Flail_Goblin_Ring":14570,
"Hammer_Goblin_Ring":14571,
"Holy_Marble":14572,
"Red_Burning_Stone":14573,
"Skull_Of_Vagabond":14574,
"Str_Dish05_":14575,
"Int_Dish05_":14576,
"Vit_Dish05_":14577,
"Agi_Dish05_":14578,
"Dex_Dish05_":14579,
"Luk_Dish05_":14580,
"Dun_Tele_Scroll2":14581,
"WOB_Rune":14582,
"WOB_Schwaltz":14583,
"WOB_Rachel":14584,
"WOB_Local":14585,
"Spark_Candy":14586,
"Repair_Scroll_":14587,
"Pty_Blessing_Scroll":14588,
"Pty_Inc_Agi_Scroll":14589,
"Pty_Assumptio_Scroll":14590,
"Siege_Teleport_Scroll":14591,
"Job_Manual50":14592,
"Magic_Power_Scroll":14593,
"Quagmire_Scroll":14594,
"Unsealed_Magic_Spell":14595,
"Pierre_Treasurebox":14596,
"PhreeoniS":14597,
"GhostringS":14598,
"Greed_Scroll_C":14599,
"Mental_Potion":14600,
"Tyr's_Blessing":14601,
"TaogunkaS":14602,
"MistressS":14603,
"Orc_HeroS":14604,
"Orc_LoadS":14605,
"Job_Manual25":14606,
"Luxurious_Dinner_W":14607,
"Luxurious_Dinner_E":14608,
"Spoiled_Cuisine":14609,
"M_Def_Potion":14611,
"M_Mdef_Potion":14612,
"RWC_Scroll_2012":14613,
"Ex_Def_Potion":14614,
"STR_Biscuit_Stick":14616,
"VIT_Biscuit_Stick":14617,
"AGI_Biscuit_Stick":14618,
"INT_Biscuit_Stick":14619,
"DEX_Biscuit_Stick":14620,
"LUK_Biscuit_Stick":14621,
"GoldenTreasureBox":14623,
"Blue_Scroll":14624,
"Indigo_Scroll":14626,
"Xmax_Egg_Kr":14627,
"C_Festival_Ticket":14628,
"Enchant_Stone_Box":14629,
"Violet_Scroll":14643,
"Wing_Of_Baalzebub":14645,
"Orleans_Full_Course":14646,
"Sealed_D_Lord_Scroll":14663,
"Bi_Hwang_Scroll":14664,
"Jung_Bi_Scroll":14665,
"Je_Un_Scroll":14666,
"Yong_Kwang_Scroll":14667,
"StealFighter_20Lv":14672,
"StealFighter_25Lv":14673,
"Cup_Of_Boza":14674,
"Shadow_Box2":14675,
"Sealed_Knight_WS_Scroll":14679,
"Enchant_Stone_Box2":14681,
"Sealed_Berz_Scroll":14682,
"Sealed_Kiel_Scroll":14689,
"Enchant_Stone_Box3":14695,
"Sealed_Gloom_Scroll":14696,
"Garuda_Scroll":14699,
"TW_13y_Lucky_Egg_06":14701,
"Gemstone_Shadow_Box":14704,
"Sealed_F_Bishop_Scroll":14705,
"Sealed_Ifrit_Scroll":14713,
"2013_RWC_Scroll":14717,
"Sealed_TurtleG_Scroll":14718,
"LI_Neuralizer":14723,
"LI_Neuralizer2":14724,
"Sealed_Bacsojin_Scroll":14725,
"Greed_Shadow_Box":14726,
"Heal_Shadow_Box":14727,
"Hiding_Shadow_Box":14728,
"Cloaking_Shadow_Box":14729,
"Costume_Festival_Box2":14730,
"Teleport_Shadow_Box":14731,
"Steal_Shadow_Box":14732,
"Sealed_Pharaoh_Scroll":14733,
"Costama_Egg22":14735,
"Sealed_B_Ygnizem_Scroll":14739,
"Sealed_Apo_H_Scroll":14740,
"Imortal_Midgard_Scroll":14741,
"Hero_Midgard_Scroll":14753,
"Guarantee_Relax_Scroll":14758,
"Job_Manual_Limit":14765,
"Limit_Power_Booster":14766,
"Pump_Of_Spirit_Scroll":14780,
"Happy_Balloon_Scroll":14781,
"AID_Manual_Bubble_7d":14799,
"July_Lucky_Scroll":14805,
"Dungeon_Ticket":14826,
"DF_Megaphone":14840,
"DF_Songpyun":14841,
"DF_Insurance":14843,
"DF_Kafra_Card":14844,
"DF_Blessing_10_Scroll":14845,
"DF_Inc_Agi_10_Scroll":14846,
"DF_Small_Life_Potion":14847,
"DF_Vit_Dish10":14849,
"DF_Luk_Dish10":14850,
"DF_Dex_Dish10":14851,
"DF_Int_Dish10":14852,
"DF_Agi_Dish10":14853,
"DF_Str_Dish10":14854,
"DF_GhostringS":14861,
"DF_Tyr's_Blessing":14862,
"DF_Holy_Armor_S":14866,
"DF_Red_Booster":14869,
"DF_Med_Life_Potion":14875,
"UltimateCook_S":14886,
"EF_UltimateCook":14887,
"Korea_Rice_Cake_B":14908,
"Bone_Plate":15000,
"Odin's_Blessing_I":15001,
"Rune_Plate":15002,
"Freyja_SRobe7":15003,
"Freyja_SRobe30":15004,
"Freyja_SRobe60":15005,
"Freyja_SRobe90":15006,
"Time_Keepr_Robe":15007,
"Flame_Sprits_Armor__":15008,
"Para_Team_Uniform1":15009,
"Para_Team_Uniform2":15010,
"Para_Team_Uniform3":15011,
"Puente_Robe":15012,
"Claire_Suits":15013,
"Ebone_Armor":15014,
"Upg_Adv_Suit":15015,
"Upg_Coat":15016,
"Upg_Saint_Robe":15017,
"Upg_Tights":15018,
"Upg_Thief_Cloth":15019,
"Upg_Mail":15020,
"Upg_Formal_Dress":15021,
"Brazil_Swimsuit":15022,
"Half_Brynhild":15023,
"Army_Padding":15024,
"Golden_Rod_Robe":15025,
"Aqua_Robe":15026,
"Crimson_Robe":15027,
"Forest_Robe":15028,
"Robe_Of_Affection":15029,
"Robe_Of_Judgement":15030,
"Para_Team_Armor":15031,
"Tidung":15032,
"Tutorial_Mattle":15033,
"Tutorial_Mattle_":15034,
"2010Love_Daddy":15035,
"Ur_Plate":15036,
"Peuz_Plate":15037,
"Sabah_Cloth":15038,
"Nab_Cloth":15039,
"Prison_Uniform":15040,
"Boitata_Armor":15041,
"White_Wing_Suits":15042,
"Black_Wing_Suits":15043,
"Green_Operation_Coat":15044,
"Armor_Of_Valor":15045,
"Siege_Plate":15046,
"Siege_Suits":15047,
"Siege_Robe":15048,
"Armor_Of_Faith":15049,
"Armor_Of_Sanctity":15050,
"Bakonawa_Armor":15051,
"Bayani_Bakonawa_Armor":15052,
"Special_Ninja_Suit":15053,
"Ninja_Scale_Armor":15054,
"Tenebris_Latitantes":15055,
"Special_Ninja_Suit_":15056,
"Pure_White_Apron":15057,
"Rider_Suit":15058,
"2011Love_Daddy":15059,
"Sky_Blue_Smock":15060,
"Egir_Armor":15061,
"TE_Woe_Coat":15062,
"TE_Woe_Chain_Mail":15063,
"TE_Woe_Mage_Coat":15064,
"AmeshaSpenta":15065,
"Engraved_Armor":15066,
"Rune_Suit":15067,
"Im_Angel's_Protection":15068,
"Suit_Of_Sid":15069,
"Robe_Of_Happiness":15070,
"Valkyrie_Robe":15071,
"Nectar_Suit":15072,
"Anti_Magic_Suit":15073,
"Geffen_Mage_Robe":15074,
"GC_Battle_Armor":15075,
"RA_Battle_Armor":15076,
"LG_Battle_Armor":15077,
"RK_Battle_Armor":15078,
"NC_Battle_Armor":15079,
"SC_Battle_Armor":15080,
"SR_Battle_Armor":15081,
"AB_Battle_Armor":15082,
"WL_Battle_Armor":15083,
"WA_Battle_Armor":15084,
"GN_Battle_Armor":15085,
"Vermilion_Bird_Armor":15086,
"Azure_Dragon_Armor":15087,
"School_Uniform":15088,
"Lounge_Suit":15089,
"Armor_Of_Gray":15090,
"Gray_Robe":15091,
"Black_Tortoise_Armor":15092,
"Hero_Plate":15093,
"Hero_Magic_Coat":15094,
"Hero_Judgement_Shawl":15095,
"Hero_Trade_Mail":15096,
"Hero_Hidden_Cloth":15097,
"Hero_Taget_Suits":15098,
"White_Tiger_Armor":15099,
"Frozen_Breastplate":15100,
"Harden_Breastplate":15101,
"Hunter_Mail":15102,
"Kirin_Armor":15103,
"FishingMan_Mail":15104,
"Kaftan":15105,
"Engineer_Mail":15106,
"Entomologist_Mail":15107,
"VenomInsect_Armor":15108,
"Egregori_Mail":15109,
"Supplement_Part_Str":15110,
"Upgrade_Part_Plate":15111,
"Military_Mail":15112,
"Exorcist_Mail":15113,
"Wedding_Dress_":15114,
"Rose_Robe":15115,
"Airship_Armor":15116,
"Felock_Armor":15117,
"Robe_Of_Sarah":15121,
"Botany_Mail":15122,
"Whikebain_Suit":15123,
"Father_Mail":15124,
"FemaleDiver_Clothe":15125,
"Doram_Only_Suit":15126,
"Female_Poring_Earmuff":15127,
"Excelion_Suit":15128,
"Doram_High_Suit":15129,
"Dragon_Mail":15130,
"Vicious_Cloth":15134,
"Dragon_Cloth":15135,
"Tatenasi_Armor":15136,
"Tatenasi_Armor_":15137,
"Egir_Armor_K":15138,
"Shepherd_Cloth":15139,
"Natural_Cloth":15140,
"Armor_Of_Goddess":15141,
"Orca_Cloth":15142,
"Vermin_Cloth":15143,
"Agricul_Cloth":15144,
"EvilDragon_Armor":15145,
"Robe_Of_Flattery":15146,
"Robe_Of_Vituperation":15147,
"Supplement_Part_Str_J":15148,
"Upgrade_Part_Plate_J":15149,
"White_Shirt":15150,
"White_Eco_Shirt":15151,
"Union_Mail":15152,
"Union_Mattle":15153,
"Union_Suit":15154,
"Union_Robe":15155,
"Doram_Ele_Suit":15156,
"Lounge_Suit_":15162,
"Agenda_Robe":15163,
"Consultation_Robe":15164,
"PureWhite_Marching_Hat":15165,
"Necklace_Rosary":15166,
"Toughen_Time_Keepr_Robe":15167,
"Kardui_Robe":15169,
"Goibne's_Armor_":15170,
"Angeling_Suit":15171,
"Cursed_Devils_Mail":15173,
"Supper_Swimsuit_K":15174,
"Armor_Of_Flamedragon":15175,
"Vigilante_Suits":15176,
"Robe_Of_Elemental":15177,
"Golden_Ninja_Suit":15178,
"Mine_Worker_Vest":15179,
"Hippie_Cloth":15180,
"Para_Team_Armor100":15181,
"Para_Team_Armor115":15182,
"Para_Team_Armor130":15183,
"Para_Team_Armor145":15184,
"Para_Team_Armor160":15185,
"Kafra_Suit":15186,
"Diva_Robe":15187,
"Mirage_Robe":15188,
"Einherial_Armor":15189,
"Khalitzburg_Armor":15191,
"Puente_Robe_IL":15195,
"Armor_Of_Seadragon":15196,
"Abyss_Dress":15204,
"Holy_Coat":15205,
"2017RTCRobe":15207,
"Rora_Plate_Mail":15208,
"Drake_Coat":15209,
"Rental_SupperSwimsuit":15210,
"Return_TW_1th_Armor":15211,
"YSF01_Plate":15212,
"YSF01_Plate_J":15213,
"IA_Dress":15214,
"Tatenasi_Armor_TW":15215,
"Siege_Robe_1Tier":15216,
"Siege_Suits_1Tier":15217,
"Siege_Plate_1Tier":15218,
"Ghostring_Suit_BR":15219,
"60Lv_Suits":15220,
"70Lv_Armor":15221,
"70Lv_Robe":15222,
"80Lv_Mail":15223,
"80Lv_Cloth":15224,
"80Lv_Robe":15225,
"80Lv_Dress":15226,
"90Lv_Mail":15227,
"90Lv_Cloth":15228,
"90Lv_Robe":15229,
"90Lv_Dress":15230,
"SimpleSuits10":15231,
"SimpleSuits20":15232,
"SimpleSuits30":15233,
"SuitsofKingdom40":15234,
"SuitsofKingdom50":15235,
"SuitsofKingdom60":15236,
"Gods_Armor":15237,
"EvilDragon_Armor_BR":15238,
"Angeling_Suit_BR":15239,
"ArmorOfFlamedragonBR":15240,
"Vigilante_Suits_J":15241,
"Robe_Of_Elemental_J":15242,
"Golden_Ninja_Suit_J":15243,
"Mine_Worker_Vest_J":15244,
"Hippie_Cloth_J":15245,
"True_Hunting_Mail":15246,
"R_Hunting_Mail":15247,
"Whikebain_Suit_BR":15248,
"Antonio_Coat":15249,
"Rebeginer_Suits":15250,
"D_Leather_Armor":15251,
"D_Leather_Robe":15252,
"D_Leather_Suits":15253,
"Abyss_Dress_BR":15254,
"Leather_Jacket_Z":15255,
"Adventurer_Suit_Z":15256,
"Mantle_Z":15257,
"Coat_Z":15258,
"Padded_Armor_Z":15259,
"Chain_Mail_Z":15260,
"Plate_Armor_Z":15261,
"Silk_Robe_Z":15262,
"Scapulare_Z":15263,
"Saint_Robe_Z":15264,
"Wooden_Mail_Z":15265,
"Tights_Z":15266,
"Silver_Robe_Z":15267,
"Thief_Clothes_Z":15268,
"Leaf_Robe":15269,
"Stem_Suits":15270,
"Oak_Armor":15271,
"Khalitzburg_Armor_BR":15272,
"White_Shirt_J":15273,
"White_Eco_Shirt_J":15274,
"Doram_Only_Suit_J":15275,
"Doram_High_Suit_J":15276,
"Doram_Ele_Suit_J":15277,
"Overwhelm_Str_Armor":15278,
"Overwhelm_Int_Armor":15279,
"S_CriticalHit_Armor":15280,
"Khalitzburg_Armor_Z":15281,
"Witchs_White_Shirt":15282,
"Armor_of_Rosary":15283,
"Supplement_Part_Str_":15343,
"Upgrade_Part_Plate_":15344,
"ArmorOfSeadragonBR":15345,
"Overwhelm_Luk_Armor":15346,
"Overwhelm_Vit_Armor":15347,
"Goibne_Armor_IL":15348,
"Brave_suit":15349,
"Nature_Dress":15352,
"Overwhelm_Agi_Armor":15353,
"Overwhelm_Dex_Armor":15354,
"Apollo_Armor_TW":15362,
"Mars_Armor_TW":15363,
"Vinus_Armor_TW":15365,
"Astraea_Armor":15367,
"Cylinder_Hairband_BR":15369,
"Phreeoni_Wing_BR":15372,
"lunar_eclipse_Armor_":15374,
"lunar_eclipse_Armor":15375,
"Illusion_Armor_A":15376,
"Illusion_Armor_B":15377,
"Lava_Leather_Armor":15378,
"Lava_Leather_Suits":15379,
"Lava_Leather_Robe":15380,
"Time_Overload_Robe":15383,
"Rite_Robe":15384,
"MemorialD_Assistant":15385,
"Kings_Mail":15386,
"Jirant_Dress":15387,
"Schmidt_Suits":15388,
"Schmidt_Manteau":15389,
"Regia_Hunting_Mail":15390,
"DragonA_Red":15391,
"DragonA_Green":15392,
"DragonA_Gold":15393,
"DragonA_Purple":15394,
"DragonA_Blue":15395,
"DragonA_Silver":15396,
"CassockA_STR":15397,
"CassockA_AGI":15398,
"CassockA_VIT":15399,
"CassockA_DEX":15400,
"CassockA_INT":15401,
"CassockA_LUK":15402,
"Fafnir_Scale_J":15405,
"WhiteknightArmor":15407,
"Leo_Mail_J":15408,
"Bloody_Dress":15409,
"H_AD_Suits":15410,
"Cancer_Mail_J":15412,
"Armor_of_Purple_Thread":15417,
"Libra_Mail_J":15418,
"Armor_of_White_Thread":15419,
"Icefall_Dress":15420,
"Triad_God_Mail_J_":15421,
"Scorpio_Mail_J":15424,
"Taurus_Mail_J":15425,
"Aquarius_Mail_J":15426,
"Diana_Suits":15430,
"Mercury_Suits":15431,
"Bacchus_Armor":15432,
"Neptune_Uniform":15433,
"Golden_Angel_Statue_YG":15434,
"Fierce_Physique_Armor_E":15440,
"Fierce_Magique_Armor_E":15441,
"Fierce_Physique_Manteau":15442,
"Fierce_Magique_Manteau":15443,
"Night_Owl_Shawl_EXE":15444,
"Cetrion_Ring_EXE":15446,
"Pollux_Robe_J":15447,
"Procyon_Robe_J":15448,
"Skarlet_Robe_EXE":15449,
"SKahn_Yoroi_EXE":15450,
"Albatross_Armor_EXE":15451,
"Rachel_Armor":15460,
"Apollo_Armor_TH":15461,
"Jupiter_Armor_TH":15462,
"Mars_Armor_TH":15463,
"Ceres_Armor_TH":15464,
"Vinus_Armor_TH":15465,
"Vulcan_Armor_TH":15466,
"Neptune_Armor_TH":15467,
"Neptune_ArmorDoram_TH":15468,
"aegis_15469":15469,
"aegis_15470":15470,
"ROZ_FV_CassockA_VIT":15471,
"Comp_Kafra_Suit":15472,
"Comp_Overwhelm_Str_Armo":15473,
"Comp_Overwhelm_V_Armor":15474,
"Comp_Overwh_Agi_Armor":15475,
"aegis_15476":15476,
"Comp_Overwh_D_Armor":15477,
"Comp_Overwh_L_Armor":15478,
"aegis_15479":15479,
"aegis_15480":15480,
"aegis_15481":15481,
"aegis_15482":15482,
"aegis_15483":15483,
"aegis_15484":15484,
"Magaleta_Ribbon_EXE":15822,
"Golden_Crown_J":15823,
"Phoenix_Crown_J":15824,
"C_Black_Musang_J":15825,
"Seyrandel_Hat_EXE":15826,
"Ceryne_Hat_EXE":15827,
"Germes_Hat_EXE":15828,
"Flaward_Hat_EXE":15829,
"Germes_Horn_EXE":15830,
"Kuken_Hat_EXE":15831,
"Cetrion_Circlet_EXE":15832,
"Cetrion_Bracelet_EXE":15833,
"DRaiden_Sakkat_EXE":15834,
"STsung_Speller1_EXE":15835,
"C_Skarlet_Band_EXE":15836,
"C_VesperHeadGear_J":15838,
"C_Droop_Gunslinger_J":15839,
"C_Bio_Protector":15840,
"C_Hat_of_Goggle":15841,
"C_Disapear_Time_J":15842,
"C_Hunters_Dinner":15843,
"C_Cow_Hat1_J":15844,
"Shaokahn_Helmet_EXE":15845,
"C_Artist_Silk_Hat":15846,
"C_EXE_Wing_Cap_TH":15847,
"Motaro_Horn_EXE":15848,
"Kintaro_Bracelet_EXE":15849,
"STsung_Speller2_EXE":15850,
"C_Freyja_Crown_J":15851,
"C_Gold_Ingot_Poring_J":15853,
"Ermac_Veil_EXE":15855,
"Kronika_Orb_EXE":15856,
"Shang_Rainbow_EXE":15857,
"C_Choco_Banana":15858,
"C_King_Of_Spirit_Circle":15875,
"C_RTC_Second_Best":15876,
"C_P_blossom_Hairpin":15877,
"Joker_Card_EXE":15878,
"KungJin_Headpiece_EXE":15879,
"Joker_Face_EXE":15880,
"C_Rose_Crispinette":15881,
"C_Rhythm_Hairband":15882,
"Nezuko_Eyes_EXE":15883,
"Nezuko_Bamboo_EXE":15884,
"Erron_Hat_EXE":15885,
"Odious_Robe_EXE":15887,
"C_Hand_Of_Devil":15888,
"C_Boitata_Hat_J":15889,
"C_BLACKDEATHKING_GOLDEN":15890,
"Mountain_Helmet":15891,
"Themis_Helm":15892,
"C_Helm_Of_Sun_V":15893,
"C_Rebirth_Circlet":15894,
"Rebirth_Circlet":15897,
"Kings_Crown_A":15898,
"C_Kings_Crown_A":15899,
"C_Love_Guard_V":15904,
"C_Helmet_Of_Siegfried_J":15905,
"Northern_Cross":15906,
"Charm_Of_Flame_Heart_BR":15920,
"Charm_Of_Nature_BR":15921,
"Charm_Of_Frozen_BR":15922,
"Charm_Of_Wind_BR":15923,
"Tatoo_Brush_BR":15924,
"aegis_15925":15925,
"aegis_15926":15926,
"aegis_15927":15927,
"aegis_15928":15928,
"aegis_15932":15932,
"aegis_15945":15945,
"Comp_Blue_Rear_Ribbon":15947,
"aegis_15948":15948,
"aegis_15949":15949,
"aegis_15950":15950,
"aegis_15951":15951,
"aegis_15952":15952,
"C_Somtam":15953,
"aegis_15954":15954,
"aegis_15955":15955,
"aegis_15956":15956,
"aegis_15957":15957,
"aegis_15958":15958,
"Comp_Phantom_Cap":15959,
"Comp_Scorpio_Diadem_K":15960,
"Comp_Clock_Casket_RD":15961,
"Comp_L_Sorcerer_Crown":15962,
"Comp_Ignis_CapK":15963,
"Comp_Sagi_DiademK":15964,
"Comp_Stripe_Hat":15965,
"aegis_15966":15966,
"aegis_15967":15967,
"aegis_15968":15968,
"aegis_15969":15969,
"aegis_15970":15970,
"aegis_15976":15976,
"aegis_15977":15977,
"aegis_15978":15978,
"aegis_15980":15980,
"aegis_15981":15981,
"aegis_15982":15982,
"aegis_15983":15983,
"aegis_15984":15984,
"aegis_15985":15985,
"Erde":16000,
"Red_Square_Bag":16001,
"Stunner_C":16002,
"Carga_Mace":16003,
"P_Mace1":16004,
"P_Mace2":16005,
"Tourist_Mace":16006,
"Mjolnir_C":16007,
"F_Spanner_C":16008,
"E_Spanner_C":16009,
"Red_Ether_Bag":16010,
"Adventure_Mace":16011,
"Academy_Mace":16012,
"Mace_Of_Judgement":16013,
"P_Mace3":16014,
"Cat_Club":16015,
"Tuna":16016,
"Bloody_Cross":16017,
"Mace_Of_Judgement2":16018,
"Upg_Mace":16019,
"Velum_Stunner":16020,
"Velum_Flail":16021,
"Nemesis_":16022,
"Metal_Mace":16023,
"Quadrille_":16024,
"TE_Woe_Mace":16025,
"RWC_Memory_Mace":16026,
"Hammer_Of_Evil_Slayer":16027,
"Thanos_Hammer":16028,
"Noble_Cross":16029,
"Pilebuncker_S":16030,
"Pilebuncker_P":16031,
"Pilebuncker_T":16032,
"Robot's_Arm":16033,
"Half_Mjolnir":16034,
"Half_BF_Morning_Star1":16035,
"Ru_Blue_Mace":16036,
"Ru_Gold_Mace":16037,
"Mace_Of_Infinite":16038,
"Spoon":16039,
"Scarlet_Mace":16040,
"Sinister_Mace":16041,
"Meteor_Strike":16043,
"Union_Mace":16048,
"Mace_of_Trust":16049,
"Mace_of_Trust2":16050,
"Valkyrie_Hammer":16051,
"Iron_Driver_":16052,
"Lora_Iron_Ball":16053,
"Toughen_Metal_Mace":16054,
"UnrivaledMace":16055,
"Veteran_Hammer_":16056,
"Blue_Mace":16057,
"Diva_Mace":16058,
"Mirage_Mace":16059,
"Bottle":16060,
"Sinister_Mace_J":16061,
"Long_Mace_IL":16063,
"Probation_Mace":16064,
"Iron_Driver_IL":16065,
"Rebeginer_NC_Mace":16075,
"Rebeginer_N2_Mace":16076,
"Local01_Mace":16083,
"Local02_Mace":16084,
"Woe_Club_1_Z":16085,
"Variant_Mace":16087,
"Saphir_Hall_OS":16088,
"Ultio_Spes_OS":16089,
"Engine_Pilebuncker":16092,
"Coolant_Injection":16093,
"Gene_Rod":16094,
"Lucis_Flail":16095,
"Bright_Mace":16096,
"Leo_Mace_J":16098,
"Ein_1HHAMMER":16099,
"Angry_Mouth_C_Box":16100,
"KRO_Lucky_Box":16101,
"Claymore_C_box":16102,
"Jamadhar_C_Box":16103,
"Two_Handed_Axe_C_Box":16104,
"Lance_C_Box":16105,
"Huuma_Giant_Wheel_C_Box":16106,
"Orcish_Axe_C_Box":16107,
"Pike_C_Box":16108,
"Encyclopedia_C_Box":16109,
"Fist_C_Box":16110,
"Guitar_C_Box":16111,
"Rante_C_Box":16112,
"Damascus_C_Box":16113,
"Flamberge_C_Box":16114,
"Stunner_C_Box":16115,
"F_KRO_Lucky_Box":16116,
"F_Claymore_C_box":16117,
"F_Jamadhar_C_Box":16118,
"F_Two_Handed_Axe_C_Box":16119,
"F_Lance_C_Box":16120,
"F_Huuma_Giant_C_Box":16121,
"F_Orcish_Axe_C_Box":16122,
"F_Pike_C_Box":16123,
"F_Encyclopedia_C_Box":16124,
"F_Fist_C_Box":16125,
"F_Guitar_C_Box":16126,
"F_Rante_C_Box":16127,
"F_Damascus_C_Box":16128,
"F_Flamberge_C_Box":16129,
"F_Stunner_C_Box":16130,
"Lady_Tanee_Doll_Box":16131,
"Lunatic_Hat_Box":16132,
"G_Staff_Of_Light_Box":16133,
"King_Frog_Hat_Box":16134,
"Evil's_Bone_Hat_Box":16135,
"Goddess_Bless10_Box":16136,
"Angel_Bless10_Box":16137,
"Powder_Snow10_Box":16138,
"Little_Heart10_Box":16139,
"J_Firecracker10_Box":16140,
"Golden_Earing_Box":16141,
"Green_Lucky_Bag_Box":16142,
"F_Glasses_Box":16143,
"Star_Hairband_Box":16144,
"Wine_On_Sleeve_Box":16145,
"Spirit_Chain_Box":16146,
"Nice_Badge_Box":16147,
"Jade_Trinket_Box":16148,
"Summer_Fan_Box":16149,
"Death_Coil_Box":16150,
"Queen's_Coronet_Box":16151,
"Apro_Hair_Box":16152,
"Ball_Mask_Box":16153,
"Windup_Spring_Box":16154,
"Hell_Horn_Box":16155,
"Poring_Tck_Box":16156,
"Drops_Tck_Box":16157,
"Poporing_Tck_Box":16158,
"Lunatic_Tck_Box":16159,
"Picky_Tck_Box":16160,
"Pecopeco_Tck_Box":16161,
"Savage_Baby_Tck_Box":16162,
"Spore_Tck_Box":16163,
"Poison_Spore_Tck_Box":16164,
"Chonchon_Tck_Box":16165,
"Steel_Chonchon_Tck_Box":16166,
"Petit_Tck_Box":16167,
"Deviruchi_Tck_Box":16168,
"Isis_Tck_Box":16169,
"Smokie_Tck_Box":16170,
"Dokebi_Tck_Box":16171,
"Desert_Wolf_B_Tck_Box":16172,
"Yoyo_Tck_Box":16173,
"Sohee_Tck_Box":16174,
"Rocker_Tck_Box":16175,
"Hunter_Fly_Tck_Box":16176,
"Orc_Warrior_Tck_Box":16177,
"Bapho_Jr_Tck_Box":16178,
"Munak_Tck_Box":16179,
"Bongun_Tck_Box":16180,
"Goblin_Tck_Box":16181,
"Hardtack_Tck_Box":16182,
"Zherlthsh_Tck_Box":16183,
"Alice_Tck_Box":16184,
"Raven_Cap_Box":16185,
"B_Dragon_Hat_Box":16186,
"F_Angry_Mouth_C_Box":16187,
"Bunny_Magic_Hat_Box":16188,
"Side_Cap_Box":16189,
"F_Rabbit_Magic_Hat_Box":16190,
"F_Side_Cap_Box":16191,
"Quati_Hat_Box":16192,
"Tucan_Hat_Box":16193,
"Jaguar_Hat_Box":16194,
"Tw_March_Scroll":16195,
"Freyja_Shield_Box7":16196,
"Freyja_Shield_Box30":16197,
"Freyja_Shield_Box60":16198,
"Freyja_Shield_Box90":16199,
"Freyja_Robe_Box7":16200,
"Freyja_Robe_Box30":16201,
"Freyja_Robe_Box60":16202,
"Freyja_Robe_Box90":16203,
"Freyja_Scarf_Box7":16204,
"Freyja_Scarf_Box30":16205,
"Freyja_Scarf_Box60":16206,
"Freyja_Scarf_Box90":16207,
"Freyja_Sandal_Box7":16208,
"Freyja_Sandal_Box30":16209,
"Freyja_Sandal_Box60":16210,
"Freyja_Sandal_Box90":16211,
"Freyja_Circlet_Box7":16212,
"Freyja_Circlet_Box30":16213,
"Freyja_Circlet_Box60":16214,
"Freyja_Circlet_Box90":16215,
"Freyja_Bracelet_Box7":16216,
"Freyja_Bracelet_Box30":16217,
"Freyja_Bracelet_Box60":16218,
"Freyja_Bracelet_Box90":16219,
"Marionette_C_Box":16220,
"Whisper_C_Box":16221,
"Incubus_C_Box":16222,
"F_Marionette_C_Box":16223,
"F_Whisper_C_Box":16224,
"F_Incubus_C_Box":16225,
"Aries_Diadem_Box":16226,
"Aries_Crown_Box":16227,
"RJC_Katusa_Box":16228,
"Scarlet_Rose_Box":16229,
"Taurus_Diadem_Box":16230,
"Taurus_Crown_Box":16231,
"Reginleif_Box":16232,
"Fest_Lord_Circlet_Box":16233,
"Fest_Bunny_Band_Box":16234,
"Octopus_Hat_Box":16235,
"Leaf_Cat_Hat_Box":16236,
"Fur_Seal_Hat_Box":16237,
"Wild_Rose_Hat_Box":16238,
"Saci_Hat_Box":16239,
"Whikebain_Ears_Box":16240,
"Chicken_Hat_Box":16241,
"F_Whikebain_Ears_Box":16242,
"F_Chicken_Hat_Box":16243,
"Dolor_Hat_Box":16244,
"Tw_April_Scroll":16245,
"Crown_Of_Deceit_Box":16246,
"Dragon_Arhat_Mask_Box":16247,
"Tiger_Arhat_Mask_Box":16248,
"Knight_Gift_Box":16249,
"Valkyriee_Gift":16250,
"Gemini_Diadem_Box":16251,
"Gemini_Crown_Box":16252,
"Rabbit_Scroll":16253,
"Acti_Potion_Box":16254,
"F_Acti_Potion_Box":16255,
"RO_DS_Headgear_Box":16256,
"Buddah_Scroll":16257,
"HD_Bradium_Box5":16258,
"HD_Carnium_Box5":16259,
"HD_Bradium_Box10":16260,
"HD_Carnium_Box10":16261,
"F_HD_Bradium_Box5":16262,
"F_HD_Carnium_Box5":16263,
"F_HD_Bradium_Box10":16264,
"F_HD_Carnium_Box10":16265,
"Idn_Inde_Beret_Box":16266,
"HE_Battle_Manual_Box":16267,
"HE_Bubble_Gum_Box":16268,
"Cancer_Diadem_Box":16269,
"Cancer_Crown_Box":16270,
"Hockey_Mask_Box1":16271,
"Observer_Box1":16272,
"All_In_One_Ring_Box1":16273,
"Spritual_Tunic_Box1":16274,
"Recuperative_Armor_Box1":16275,
"Shelter_Resist_Box1":16276,
"Sylphid_Manteau_Box1":16277,
"Refresh_Shoes_Box1":16278,
"Well_Baked_Toast_Box1":16279,
"Wasteland_Outlaw_Box1":16280,
"Lever_Act_Rifle_Box1":16281,
"Healing_Staff_Box1":16282,
"Praxinus_Box1":16283,
"Guild_Recruit_Box1":16284,
"Party_Recruit_Hat_Box1":16285,
"Bf_Recruit_Hat_Box1":16286,
"Gf_Recruit_Hat_Box1":16287,
"Friend_Recruit_Hat_Box1":16288,
"Claymore_C_box1":16289,
"Two_Handed_Axe_C_Box1":16290,
"Lance_C_Box1":16291,
"Jamadhar_C_Box1":16292,
"Huuma_Giant_C_Box1":16293,
"Orcish_Axe_C_Box1":16294,
"Pike_C_Box1":16295,
"Encyclopedia_C_Box1":16296,
"Fist_C_Box1":16297,
"Guitar_C_Box1":16298,
"Rante_C_Box1":16299,
"Damascus_C_Box1":16300,
"Flamberge_C_Box1":16301,
"Stunner_C_Box1":16302,
"Angry_Mouth_C_Box1":16303,
"Evil_Incarnation_Disabl":16304,
"Upg_Guard_Box":16305,
"F_Upg_Guard_Box":16306,
"Upg_Buckler_Box":16307,
"F_Upg_Buckler_Box":16308,
"Upg_Shield_Box":16309,
"F_Upg_Shield_Box":16310,
"Upg_Shoes_Box":16311,
"F_Upg_Shoes_Box":16312,
"Upg_Boots_Box":16313,
"F_Upg_Boots_Box":16314,
"Upg_Greave_Box":16315,
"F_Upg_Greave_Box":16316,
"Upg_Hood_Box":16317,
"F_Upg_Hood_Box":16318,
"Upg_Muffler_Box":16319,
"F_Upg_Muffler_Box":16320,
"Upg_Manteau_Box":16321,
"F_Upg_Manteau_Box":16322,
"Upg_Clip_Box":16323,
"F_Upg_Clip_Box":16324,
"Rune_Hairband_Box":16325,
"F_Rune_Hairband_Box":16326,
"Upg_Adv_Suit_Box":16327,
"F_Upg_Adv_Suit_Box":16328,
"Upg_Coat_Box":16329,
"F_Upg_Coat_Box":16330,
"Upg_Saint_Robe_Box":16331,
"F_Upg_Saint_Robe_Box":16332,
"Upg_Tights_Box":16333,
"F_Upg_Tights_Box":16334,
"Upg_Thief_Cloth_Box":16335,
"F_Upg_Thief_Cloth_Box":16336,
"Upg_Mail_Box":16337,
"F_Upg_Mail_Box":16338,
"Upg_Formal_Dress_Box":16339,
"F_Upg_Formal_Dress_Box":16340,
"Greed_Clip_Box":16341,
"F_Greed_Clip_Box":16342,
"Leo_Crown_Box":16343,
"Leo_Diadem_Box":16344,
"F_Leo_Crown_Box":16345,
"F_Leo_Diadem_Box":16346,
"Shooting_Star_C_Box":16347,
"Bloody_Fear_C_Box":16348,
"Ahlspiess_C_Box":16349,
"Staff_Of_Healing_C_Box":16350,
"Anti_Demon_Shield_C_Box":16351,
"F_Shooting_Star_C_Box":16352,
"F_Bloody_Fear_C_Box":16353,
"F_Ahlspiess_C_Box":16354,
"F_S_Healing_C_Box":16355,
"F_A_Demon_Shield_C_Box":16356,
"F_Evils_Bone_Hat_Box":16357,
"Mbl_Pet_Random_Box":16358,
"7th_Anni_Random_Box":16359,
"Desert_Prince_Box":16360,
"FDesert_Prince_Box":16361,
"Sigrun's_Wing_Box":16362,
"FSigrun's_Wing_Box":16363,
"Sleipnir_Box":16364,
"Magingiorde_Box":16365,
"Brysinggamen_Box":16366,
"Mjolnir_Box":16367,
"Virgo_Crown_Box":16368,
"Freyja_Ring_Box":16369,
"F_Freyja_Ring_Box":16370,
"Tw_Aug_Scroll":16371,
"Clover_Box_Mouth":16372,
"F_Clover_Box_Mouth":16373,
"Bgum_Mouth_Box":16374,
"F_BGum_Box_In_Mouth":16375,
"Odin's_Recall7":16376,
"Odin's_Recall30":16377,
"Siege_Scroll_Box30":16378,
"Tele_Scroll2_Box10":16379,
"S_Tele_Scroll2_Box30":16380,
"F_Siege_Tele_10Sc_Box":16381,
"F_Siege_Scroll_Box1_30":16382,
"F_Siege_Scroll_Box2_10":16383,
"F_Siege_Scroll_Box2_30":16384,
"Clover_Box_Mouth2":16385,
"Clover_Box_Mouth4":16386,
"F_Clover_Box_Mouth2":16387,
"F_Clover_Box_Mouth4":16388,
"BGum_Box_In_Mouth2":16389,
"BGum_Box_In_Mouth4":16390,
"F_BGum_Box_In_Mouth2":16391,
"F_BGum_Box_In_Mouth4":16392,
"HD_Ori_Box5":16393,
"HD_Ori_Box10":16394,
"HD_Elu_Box5":16395,
"HD_Elu_Box10":16396,
"Virgo_Diadem_Box":16397,
"F_Virgo_Crown_Box":16398,
"F_Virgo_Diadem_Box":16399,
"F_HD_Ori_Box5":16400,
"F_HD_Ori_Box10":16401,
"F_HD_Elu_Box5":16402,
"F_HD_Elu_Box10":16403,
"Midgard_Coin_Box":16405,
"FMidgard_Coin_Box":16406,
"Freyja_Ring_Box2":16407,
"F_Freyja_Ring_Box2":16408,
"Tw_Sep_Scroll":16409,
"Chung_Hairband_Box":16410,
"FChung_Hairband_Box":16411,
"Ice_Wing_Ear_Box":16412,
"FIce_Wing_Ear_Box":16413,
"Turtle_Hat_Box":16414,
"FTurtle_Hat_Box":16415,
"F_Giant_Fly_Wing_Box500":16418,
"F_Greed_Box30":16419,
"F_Pet_Egg_Scroll9":16420,
"F_Marriage_Covenant_Box":16421,
"F_Magestic_Goat_Box":16422,
"F_Pet_Egg_Scroll3":16423,
"F_Executioner_Box":16424,
"F_Cutlas_Box":16425,
"F_Moonlight_Sword_Box":16426,
"F_Spanner_Box":16427,
"F_Solar_Sword_Box":16428,
"F_Tomahawk_Box":16429,
"F_Bow_Of_Rudra_Box":16430,
"F_Pole_Axe_Box":16431,
"BM_Pack_Box_A":16432,
"F_BM_Pack_Box_A":16433,
"BM_Pack_Box_B":16434,
"F_BM_Pack_Box_B":16435,
"Libra_Crown_Box":16436,
"FLibra_Crown_Box":16437,
"Libra_Diadem_Box":16438,
"FLibra_Diadem_Box":16439,
"Filir_Wing_Box":16440,
"FFilir_Wing_Box":16441,
"Shaman_Hat_Box":16442,
"F_Shaman_Hat_Box":16443,
"Golden_Crown_Box":16444,
"F_Golden_Crown_Box":16445,
"Tw_October_Scroll":16446,
"Scorpio_Crown_Box":16447,
"Scorpio_Diadem_Box":16448,
"FScorpio_Crown_Box":16449,
"FScorpio_Diadem_Box":16450,
"F_Raven_Cap_Box":16451,
"Bright_Fury_Box":16452,
"Triangle_Rune_Cap_Box":16453,
"F_Bright_Fury_Box":16454,
"F_Triangle_Rune_Cap_Box":16455,
"My_Scroll1":16456,
"Tw_Nov_Scroll":16457,
"2009Love_Daddy_Box":16458,
"Queen_Ant_Diadem_Box":16459,
"FQueen_Ant_Diadem_Box":16460,
"Redwing_Hat_Box":16461,
"FRed_Wing_Hat_Box":16462,
"My_Scroll2":16466,
"Xmas_Card_Box":16467,
"F_Xmas_Card_Box":16468,
"Xmas_Card_Box2":16469,
"F_Xmas_Card_Box2":16470,
"E_S_Life_Potion_Box":16481,
"E_Abrasive_Box10":16483,
"E_Bunny_Band_Box":16492,
"E_Insurance_Package":16503,
"E_Bubble_Gum_Box":16504,
"E_Str_Dish_Box":16505,
"E_Agi_Dish_Box":16506,
"E_Int_Dish_Box":16507,
"E_Dex_Dish_Box":16508,
"E_Luk_Dish_Box":16509,
"E_Vit_Dish_Box":16510,
"E_Blessing_10_Scr_Box":16514,
"E_Inc_Agi_10_Scr_Box":16515,
"Xmas_Bless":16542,
"Snowman_Hat_Box":16543,
"FSnowman_Hat_Box":16544,
"Sagittarius_Crown_Box":16548,
"Sagittarius_Diadem_Box":16549,
"FSagittarius_Crown_Box":16550,
"FSagittarius_Diadem_Box":16551,
"E_Elven_Sunglass_Box":16554,
"Pr_Reset_Stone_Box":16555,
"FPr_Reset_Stone_Box":16556,
"CP_Helm_Scroll10":16557,
"CP_Shield_Scroll10":16558,
"CP_Armor_Scroll10":16559,
"CP_Weapon_Scroll10":16560,
"CP_Scroll_Package":16561,
"Majestic_Devil_Scroll":16562,
"BM100_Box_5":16563,
"Capricon_Crown_Box":16565,
"FCapricon_Crown_Box":16566,
"Capricon_Diadem_Box":16567,
"FCapricon_Diadem_Box":16568,
"Summber_Scroll":16569,
"Muscles_Story_J_Box":16570,
"Onigiri_Hat_Box":16571,
"Skull_Hood_Box":16573,
"F_Skull_Hood_Box":16574,
"Illusion_Nothing":16576,
"Dragon_Captain":16577,
"Lacma_Box":16580,
"F_Lacma_Box":16581,
"Red_Bunny_Band_Box":16582,
"Sloth_Hat_Box":16584,
"F_Sloth_Hat_Box":16585,
"Duneyrr_Helm_Box":16586,
"F_Duneyrr_Helm_Box":16587,
"Thoughtful_Hat_Box":16588,
"F_Thoughtful_Hat_Box":16589,
"E_Thoughtful_Hat_Box":16590,
"Summer_Scroll2":16591,
"Family_Hat_Box":16592,
"F_Family_Hat_Box":16593,
"Helm_Of_Abyss_Box":16596,
"F_Helm_Of_Abyss_Box":16597,
"Acti_Potion_Box2":16598,
"F_Acti_Potion_Box2":16599,
"Spring_Flower_Scr_Tw":16600,
"Blue_Arara_Hat_Box":16601,
"F_Blue_Arara_Hat_Box":16602,
"Drooping_Boto_Box":16603,
"F_Drooping_Boto_Box":16604,
"Tendrilion_Hat_Box":16605,
"F_Tendrilion_Hat_Box":16606,
"Yellow_Bunnyband_Box":16619,
"F_Yellow_Bunnyband_Box":16620,
"Pink_Bunnyband_Box":16621,
"F_Pink_Bunnyband_Box":16622,
"Green_Bunnyband_Box":16623,
"F_Green_Bunnyrband_Box":16624,
"Half_Asprika_Box":16625,
"Half_Megin_Box":16626,
"Half_Brysing_Box":16627,
"Half_Brynhild_Box":16628,
"Granpeco_Hairband_Box":16629,
"F_Granpeco_Hairband_Box":16630,
"Aributa_Scroll":16631,
"test_3":16632,
"Bubble_Gum_Plus_10Box":16633,
"Spiked_Scarf_Box2":16634,
"Rainbow_Scarf_Box2":16635,
"Spiked_Scarf_Box3":16636,
"Rainbow_Scarf_Box3":16637,
"Ribbon_Of_Life_Box":16638,
"Ribbon_Of_Life_Box2":16639,
"Ribbon_Of_Life_Box3":16640,
"F_Spiked_Scarf_Box":16641,
"F_Rainbow_Scarf_Box":16642,
"F_Spiked_Scarf_Box2":16643,
"F_Rainbow_Scarf_Box2":16644,
"F_Spiked_Scarf_Box3":16645,
"F_Rainbow_Scarf_Box3":16646,
"F_Ribbon_Of_Life_Box":16647,
"F_Ribbon_Of_Life_Box2":16648,
"F_Ribbon_Of_Life_Box3":16649,
"F_Gemini_Diadem_Box":16650,
"F_Gemini_Crown_Box":16651,
"Flame_Light":16652,
"BM75_10Box":16653,
"Valiant_Will":16654,
"Rapid_Life_Water_Box":16655,
"F_Rapid_Life_Water_Box":16656,
"Rapid_Life_Water_Box2":16657,
"F_Rapid_Life_Water_Box2":16658,
"Zodiac_Diadem_Pack":16659,
"Auger_Of_Spirit_Box":16660,
"F_Auger_Of_Spirit_Box":16661,
"F_Aries_Diadem_Box":16662,
"F_Aries_Crown_Box":16663,
"Leo_Scroll":16664,
"Virgo_Scroll":16665,
"Magic_Candy_Box10":16666,
"F_Magic_Candy_Box10":16667,
"Colorful_Ketupat_Box":16668,
"Battle_Manual_Box_A":16670,
"Magic_Candy_Box10_2":16671,
"F_Magic_Candy_Box10_2":16672,
"Libra_Scroll":16673,
"New_Insurance_Box":16674,
"Splash_Scroll":16675,
"Zodiac_Crown_Pack":16676,
"Vending_Scroll2_Box10":16677,
"Vending_Scroll2_Box50":16678,
"F_Vending_Scroll2_Box10":16679,
"F_Vending_Scroll2_Box50":16680,
"BR_Independence_Scrol":16681,
"Boarding_Halter_Box":16682,
"B_Halter_Box_30Days":16683,
"Wing_Of_Fly_Box10":16684,
"Wing_Of_Fly_Box50":16685,
"Wing_Of_Fly_Box100":16686,
"RWC2010_SuitcaseA":16687,
"RWC2010_SuitcaseB":16688,
"Garuda_Hat_Box":16689,
"F_Garuda_Hat_Box":16690,
"Scorpio_Scroll":16691,
"FAlice_Hat_Box":16692,
"Crescent_Helm_Box":16693,
"FCrescent_Helm_Box":16694,
"Dragon_Skull_Box":16695,
"FDragon_Skull_Box":16696,
"Drooping_Bunny_Box":16697,
"FDrooping_Bunny_Box":16698,
"Fish_On_Head_Box":16699,
"Pair_Ribbon_Box":16701,
"FPair_Ribbon_Box":16702,
"Smoking_Pipe_Box":16703,
"FSmoking_Pipe_Box":16704,
"Hibiscus_Bpx":16705,
"F_Hibiscus_Bpx":16706,
"Jumping_Poring_Box":16707,
"FJumping_Poring_Box":16708,
"Kettle_Hat_Box":16709,
"FKettle_Hat_Box":16710,
"Magic_Eyes_Box":16711,
"FMagic_Eyes_Box":16712,
"Propeller_Box":16713,
"F_Propeller_Box":16714,
"Dog_Hat_Box":16715,
"F_Dog_Hat_Box":16716,
"Sheep_Hat_Box":16717,
"FSheep_Hat_Box":16718,
"FTiger_Mask_Box":16719,
"Vacation_Hat_Box":16720,
"FVacation_Hat_Box":16721,
"Vane_Hairpin_Box":16722,
"FVane_Hairpin_Box":16723,
"Vanilmirth_Hat_Box":16724,
"FVanilmirth_Hat_Box":16725,
"Water_Lily_Crown_Box":16726,
"FWater_Lily_Crown_Box":16727,
"Pink_Fur_Hat_Box":16728,
"F_Pink_Fur_Hat_Box":16729,
"Ribbon_Green_Box":16730,
"F_Ribbon_Green_Box":16731,
"Wh_Deviruchi_Cap_Box":16732,
"F_Wh_Deviruchi_Cap_Box":16733,
"Blu_Drooping_Kitty_Box":16734,
"FBlu_Drooping_Kitty_Box":16735,
"Fantastic_Wig_Box":16736,
"F_Fantastic_Wig_Box":16737,
"Yellow_Wizard_Hat_Box":16738,
"F_Yellow_Wizard_Hat_Box":16739,
"Ptotection_Seagod_Box":16740,
"Hairtail_Box1":16741,
"Hairtail_Box2":16742,
"Spearfish_Box1":16743,
"Spearfish_Box2":16744,
"Saurel_Box1":16745,
"Saurel_Box2":16746,
"Tuna_Box1":16747,
"Tuna_Box2":16748,
"Malang_Crab_Box1":16749,
"Malang_Crab_Box2":16750,
"Brindle_Eel_Box1":16751,
"Brindle_Eel_Box2":16752,
"Unbreak_Weap_Box":16753,
"F_Unbreak_Weap_Box":16754,
"Unbreak_Def_Box":16755,
"F_Unbreak_Def_Box":16756,
"Hallo_Scroll":16757,
"Umbala_Spirit_Box":16758,
"F_Umbala_Spirit_Box":16759,
"Umbala_Spirit_Box2":16760,
"F_Umbala_Spirit_Box2":16761,
"Umbala_Spirit_Box_7day":16762,
"Ptotection_Seagod_Box2":16763,
"Ptotection_Seagod_Box3":16764,
"Octo_Hstick_Box":16765,
"Octo_Hstick_Box2":16766,
"Octo_Hstick_Box3":16767,
"Silvervine_Fruit_Box10":16770,
"Silvervine_Fruit_Box40":16771,
"Asgard_Scroll":16774,
"Sagittarius_Scroll":16775,
"C_Vending_Scroll2_Box10":16776,
"C_Vending_Scroll2_Box50":16777,
"C_Str_Dish_Box":16778,
"C_Str_Dish_Box50":16779,
"C_Agi_Dish_Box":16780,
"C_Agi_Dish_Box50":16781,
"C_Vit_Dish_Box":16782,
"C_Vit_Dish_Box50":16783,
"C_Int_Dish_Box":16784,
"C_Int_Dish_Box50":16785,
"C_Dex_Dish_Box":16786,
"C_Dex_Dish_Box50":16787,
"C_Luk_Dish_Box":16788,
"C_Luk_Dish_Box50":16789,
"C_Insurance_Package":16790,
"C_Insurance_Package50":16791,
"C_Kafra_Card_Box":16792,
"C_Kafra_Card_Box50":16793,
"C_Giant_Fly_Wing_Box":16794,
"C_Giant_Fly_Wing_Box100":16795,
"C_Siegfried_Box5":16796,
"C_Siegfried_Box20":16797,
"C_Convex_Mirror_Box5":16798,
"C_Convex_Mirror_Box30":16799,
"C_Blessing_10_Box":16800,
"C_Blessing_10_Box50":16801,
"C_Inc_Agi_10_Scroll_Box":16802,
"C_Inc_Agi_10_Box50":16803,
"C_Adrenaline_5_box":16804,
"C_Adrenaline_5_box50":16805,
"C_Aspersio_5_Scroll_Box":16806,
"C_Aspersio_5_Box50":16807,
"C_Battle_Manual_Box":16808,
"C_Battle_Manual_Box10":16809,
"C_Bubble_Gum_Box":16810,
"C_Bubble_Gum_Box10":16811,
"C_Megaphone_Box":16812,
"C_Megaphone_Box10":16813,
"C_Enriched_Elunium_Box":16814,
"C_Enriched_Elunium_Box5":16815,
"C_Enriched_Oridecon_Box":16816,
"C_Enc_Oridecon_Box5":16817,
"C_Neuralizer_Box":16818,
"C_Abrasive_Box5":16819,
"C_Abrasive_Box10":16820,
"C_Dun_Tele_Scroll_Box5":16821,
"C_Dun_Tele_Scroll_Box10":16822,
"C_Max_Weight_Up_Box":16823,
"C_Regeneration_Box5":16824,
"C_Regeneration_Box10":16825,
"Sagittarius_Scr_Box":16826,
"C_Small_Life_Potion_Box":16827,
"C_S_Life_Potion_Box50":16828,
"C_Med_Life_Potion_Box":16829,
"C_Med_Life_Potion_Box50":16830,
"C_G_Illusion_Box5":16831,
"C_G_Illusion_Box10":16832,
"C_S_ArmorBox5":16833,
"C_S_ArmorBox10":16834,
"C_Holy_Armor_S_Box5":16835,
"C_Holy_Armor_S_Box30":16836,
"C_Dun_Tele_Scroll2_Box5":16837,
"C_Dun_Tele_S2_Box10":16838,
"C_Spark_Candy_Box5":16839,
"C_Spark_Candy_Box10":16840,
"C_Repair_Scroll_Box":16841,
"C_Repair_Scroll_Box10":16842,
"C_New_Style_Box":16843,
"C_Alice_Scroll_Box5":16844,
"C_Alice_Scroll_Box10":16845,
"C_Mimic_Scroll_Box5":16846,
"C_Mimic_Scroll_Box10":16847,
"C_Disguise_Croll_Box5":16848,
"C_Disguise_Croll_Box10":16849,
"C_MP_Scroll_Box":16850,
"C_MP_Scroll_Box50":16851,
"C_Quagmire_Scroll_Box":16852,
"C_Quagmire_Scroll_Box50":16853,
"CCloth_Dye_Coupon_Box":16854,
"CCloth_Dye_Coupon2_Box":16855,
"C_Greed_Scroll_C20Box":16856,
"C_Greed_Scroll_C50Box":16857,
"C_Mental_Potion20_Box":16858,
"C_Mental_Potion50_Box":16859,
"C_Tyr_Blessing_Box20":16860,
"C_Tyr_Blessing_Box50":16861,
"C_Job_Manual25_Box1":16862,
"C_Job_Manual25_Box10":16863,
"C_Siege_Scroll_Box1_10":16864,
"C_Siege_Scroll_Box1_30":16865,
"C_Siege_Scroll_Box2_10":16866,
"C_Siege_Scroll_Box2_30":16867,
"C_HD_Bradium_Box5":16868,
"C_HD_Bradium_Box10":16869,
"C_HD_Carnium_Box5":16870,
"C_HD_Carnium_Box10":16871,
"C_HD_Ori_Box5":16872,
"C_HD_Ori_Box10":16873,
"C_HD_Elu_Box5":16874,
"C_HD_Elu_Box10":16875,
"C_Rapid_Life_Water_Box2":16876,
"C_Magic_Candy_Box102":16877,
"C_Umbala_Spirit_Box2":16878,
"C_Muramasa_Box":16879,
"C_Excalibur_Box":16880,
"C_Combat_Knife_Box":16881,
"C_Counter_Dagger_Box":16882,
"C_Mighty_Staff_Box":16883,
"C_Right_Epsilon_Box":16884,
"C_Balistar_Box":16885,
"C_D_Great_Sage_Box":16886,
"C_Asura_Box":16887,
"C_Brooch_Box":16888,
"C_Safety_Ring_Box":16889,
"C_Pecopeco_Hairband_Box":16890,
"C_Nagan_Box":16891,
"C_Skewer_Box":16892,
"C_Quadrille_Box":16893,
"C_Fire_Brand_Box":16894,
"C_Masquerade_Box":16895,
"C_Orc_Hero_Helm_Box":16896,
"C_KRO_D_Kitty_Box":16897,
"C_Bloody_Iron_Ball_Box":16898,
"C_Hockey_Mask_Box":16899,
"C_Observer_Box":16900,
"C_All_In_One_Ring_Box":16901,
"C_Spiritual_Tunic_Box":16902,
"C_Recup_Armor_Box":16903,
"C_Shelter_Resist_Box":16904,
"C_Sylphid_Manteau_Box":16905,
"C_Refresh_Shoes_Box":16906,
"C_Wasteland_Outlaw_Box":16907,
"C_Lever_Act_Rifle_Box":16908,
"C_Claymore_C_box":16909,
"C_Jamadhar_C_Box":16910,
"C_Two_Handed_Axe_C_Box":16911,
"C_Lance_C_Box":16912,
"C_Orcish_Axe_C_Box":16913,
"C_Encyclopedia_C_Box":16914,
"C_Pike_C_Box":16915,
"C_Fist_C_Box":16916,
"C_Damascus_C_Box":16917,
"C_Flamberge_C_Box":16918,
"C_Stunner_C_Box":16919,
"C_Marriage_Covenant_Box":16920,
"C_Shooting_Star_C_Box":16921,
"C_Bloody_Fear_C_Box":16922,
"C_Staff_Healing_C_Box":16923,
"C_Clover_Box_Mouth":16924,
"C_Clover_Box_Mouth2":16925,
"C_Clover_Box_Mouth4":16926,
"C_BGum_Box_In_Mouth":16927,
"C_BGum_Box_In_Mouth2":16928,
"C_BGum_Box_In_Mouth4":16929,
"C_Spiked_Scarf_Box":16930,
"C_Spiked_Scarf_Box2":16931,
"C_Spiked_Scarf_Box3":16932,
"C_Rainbow_Scarf_Box":16933,
"C_Rainbow_Scarf_Box2":16934,
"C_Rainbow_Scarf_Box3":16935,
"C_Ribbon_Of_Life_Box":16936,
"C_Ribbon_Of_Life_Box2":16937,
"C_Ribbon_Of_Life_Box3":16938,
"C_Love_Angel_Box":16939,
"C_Love_Angel_Box_1m":16940,
"C_Squirrel_Box":16941,
"C_Squirrel_Box_1m":16942,
"C_Picture_Diary_Box":16943,
"C_Picture_Diary_Box_1m":16944,
"C_Mini_Heart_Box":16945,
"C_Mini_Heart_Box_1m":16946,
"C_Newcomer_Box":16947,
"C_Newcomer_Box_1m":16948,
"C_Kid_Box":16949,
"C_Kid_Box_1m":16950,
"C_Magic_Castle_Box":16951,
"C_Magic_Castle_Box_1m":16952,
"C_Bulging_Head_Box":16953,
"C_Bulging_Head_Box_1m":16954,
"P_Upg_Guard_Box":16955,
"C_Upg_Buckler_Box":16956,
"C_Upg_Shield_Box":16957,
"C_Upg_Shoes_Box":16958,
"C_Upg_Boots_Box":16959,
"C_Upg_Greave_Box":16960,
"C_Upg_Hood_Box":16961,
"C_Upg_Muffler_Box":16962,
"C_Upg_Manteau_Box":16963,
"C_Upg_Clip_Box":16964,
"C_Upg_Adv_Suit_Box":16965,
"C_Upg_Coat_Box":16966,
"C_Upg_Saint_Robe_Box":16967,
"C_Upg_Tights_Box":16968,
"C_Upg_Thief_Cloth_Box":16969,
"C_Upg_Mail_Box":16970,
"C_Upg_Formal_Dress_Box":16971,
"Weather_Report_Box":16972,
"Yellow_Hat_Box":16973,
"Comin_Actor_Box":16974,
"Singing_Bird_Box":16975,
"Hen_Set_Box":16976,
"Red_Minicrown_Box":16977,
"C_Green_FoxtailBox":16978,
"Silvervine_Fruit_Box4":16979,
"Sagittar_Diadem_Scroll":16990,
"Sagittar_Di_Scroll_Box":16991,
"Butterfly_Wing_Box20":16992,
"Butterfly_Wing_Box50":16993,
"Old_Hat_Box":16995,
"Capri_Crown_Scroll":16996,
"Capri_Crown_Scroll_Box":16997,
"Archangel_Wing_Box":16998,
"Bravery_Bag_Box":16999,
"Wander_Man_Box5":17000,
"Wander_Man_Box10":17001,
"Wicked_Nymph_Box5":17002,
"Wicked_Nymph_Box10":17003,
"Kasa_Scroll_Box5":17004,
"Kasa_Scroll_Box10":17005,
"Salamander_Box5":17006,
"Salamander_Box10":17007,
"Teddy_Bear_Box5":17008,
"Teddy_Bear_Box10":17009,
"Capricon_Di_Scroll":17011,
"Capricon_Di_Scroll_Box":17012,
"Malang_Woe_Encard_Box":17013,
"Butterfly_ear_Box":17014,
"Stuckhead_Screw_Box":17015,
"Aquarius_Diadem_Scroll":17016,
"Aquarius_Di_Scroll_Box":17017,
"Libra_Scroll2":17018,
"Scorpio_Scroll2":17019,
"Tw_Nov_Scroll2":17020,
"Summer_Scroll3":17021,
"Super_Pet_Egg1_2":17022,
"Super_Pet_Egg4_2":17023,
"Lovely_Aquarius_Scroll":17024,
"Lovely_Aquarius_Box":17025,
"Boitata_Scroll":17026,
"Refine_Ore_Box":17027,
"Pisces_Diadem_Scroll":17028,
"Pisces_Diadem_S_Box":17029,
"St_Pat_Hat_box":17030,
"Energetic_Pisces_Scroll":17035,
"Energetic_Pisces_Box":17036,
"Trans_Box_Devi":17037,
"Trans_Box_Ray_Arch":17038,
"Trans_Box_Mavka":17039,
"Trans_Box_Marduk":17040,
"Trans_Box_Banshee":17041,
"Trans_Box_Poring":17042,
"Trans_Box_Golem":17043,
"Donation_Ribbon_Box":17044,
"Korean_Judge_Hat_Box":17045,
"Attend_C_Box":17046,
"Aries_Scroll_":17050,
"Aries_Scroll_box":17051,
"Holy_Mom_Blaze_Box":17052,
"Wiz_Card_Album":17056,
"Swordman_Card_Album":17057,
"Thief_Card_Album":17058,
"Acolyte_Card_Album":17059,
"Merchant_Card_Album":17060,
"Archer_Card_Album":17061,
"Taurus_Diadem_Scroll":17062,
"Taurus_Di_Scroll_Box":17063,
"Tw_Sagitt_Scroll":17064,
"Mbl_Taurus_Crown_Box":17065,
"Poison_Bottle_Box50":17066,
"Poison_Bottle_Box100":17067,
"Acidbomb_Box50":17068,
"Acidbomb_Box100":17069,
"Acidbomb_Box500":17070,
"Superb_Fish_Box50":17071,
"Superb_Fish_Box100":17072,
"Superb_Fish_Box500":17073,
"Empty_Bottle_Box10":17074,
"Empty_Bottle_Box100":17075,
"Empty_Bottle_Box500":17076,
"Taurus_Crown_Scroll":17077,
"Taurus_Crown_Scroll_Box":17078,
"Indonesian_Box2":17079,
"Scorpio_Scroll3":17080,
"Yggdrasil_Crown_Box":17081,
"Gemi_Diadem_Scroll":17082,
"Gemi_Diadem_Scroll_Box":17083,
"Upg_Katar_Box":17084,
"Upg_Two_Handed_Axe_Box":17085,
"Upg_Lance_Box":17086,
"Upg_Book_Box":17087,
"Upg_Staff_Box":17088,
"Upg_Dagger_Box":17089,
"Upg_Revolver_Box":17090,
"Upg_Mace_Box":17091,
"Upg_Bow_Box":17092,
"Upg_Twohand_Sword_Box":17093,
"Upg_Katar_Box2":17094,
"Upg_Two_Handed_Axe_Box2":17095,
"Upg_Lance_Box2":17096,
"Upg_Book_Box2":17097,
"Upg_Staff_Box2":17098,
"Upg_Dagger_Box2":17099,
"Upg_Revolver_Box2":17100,
"Upg_Mace_Box2":17101,
"Upg_Bow_Box2":17102,
"Upg_Twohand_Sword_Box2":17103,
"HD_Oridecon_50Box":17104,
"HD_Elunium_50Box":17105,
"Max_Weight_Up_10Box":17106,
"Gemi_Crown_Scroll":17107,
"Gemi_Crown_Scroll_Box":17108,
"Capri_Scroll":17109,
"Aquarius_Scroll":17110,
"Pisces_Scroll":17113,
"Horn_Of_Ancient_Box":17114,
"Sprout_Hat_Box":17115,
"Mercury_Helm_Box":17116,
"Aries_Scroll":17117,
"ASPD_Potion_Box10":17118,
"Taurus_Scroll":17120,
"Starry_Scroll":17121,
"Immuned_Shield_Box":17122,
"Black_Devil_Mask_Box":17123,
"Cat_Ears_Beret_Box":17124,
"Red_Bread_Hat_Box":17125,
"ASPD_Potion_Box10_2":17126,
"Leo_Scroll2":17127,
"RWC_Scroll":17134,
"Trans_A_Set":17135,
"Trans_B_Set":17136,
"Trans_C_Set":17137,
"Ms_Cancer_Scroll":17138,
"Ms_RWC_Super_Scroll":17139,
"Ms_Leo_Scroll":17140,
"Ms_Virgo_Scroll":17141,
"Ms_Scorpio_Scroll":17143,
"Made_Dish_Set":17144,
"Made_Dish_Box":17145,
"Dep_Alice_Hat_Box":17146,
"Ribbon_Chef_Hat_Box":17147,
"Bridal_Ribbon_Box":17152,
"Red_Booster_Box20":17153,
"Red_Booster_Box20_2":17154,
"Upg_Huuma_Shuriken_Box":17155,
"TCG_Card_Scroll":17156,
"Vital_Flower_Box":17157,
"Flame_Gemstone_Box":17158,
"Change_Name_Card_Box":17159,
"Change_Name_Card_Box2":17160,
"Boarding_Halter_Box7":17162,
"Mystic_Powder_Box30":17163,
"Mystic_Powder_Box30_2":17164,
"Challenge_Kit":17165,
"Hellomother_Hat_Box":17166,
"EC_Battle_Manual_Box":17171,
"EC_Job_Manual25_Box10":17172,
"Global_Hat_Fes_Box":17173,
"Global_Hat_Fes_5_Box":17174,
"Global_Hat_Fes_Box2":17175,
"Boarding_Halter_Box3":17176,
"Made_Dish_Box1":17177,
"Mysterious_Water_Box50":17178,
"C_Myst_Water_Box50":17179,
"Mysterious_Water_Box50_":17180,
"Jan_Groove_Box":17181,
"Fallen_Angel_Wing_Box":17182,
"3rd_Test_Pass_Box":17184,
"Refine_Ore_Box2":17193,
"Red_Potion_RG_Box":17194,
"Blue_Potion_RG_Box":17195,
"GoldenApple_P_RG_Box":17196,
"GoldenApple_RG_Box":17197,
"Golden_Potion_RG_Box":17198,
"RG_Noble_Hat_Box":17200,
"RG_Soft_Sheep_Hat_Box":17201,
"Baksojin_Hat_Box":17202,
"Free_Pass_Box":17203,
"Miraculous_Egg":17204,
"Special_Po_Box":17205,
"Battle_Manual_Limit_Box":17206,
"Idn_Heart_Scroll":17207,
"Tw_Rainbow_Scroll":17209,
"Tw_Red_Scroll":17210,
"Tw_Orange_Scroll":17211,
"Tw_Yellow_Scroll":17212,
"Almighty_Box":17224,
"C_Center_Pot_Box":17226,
"C_Awakening_Pot_Box":17227,
"C_Berserk_Pot_Box":17228,
"C_Wing_Of_Fly_Box":17229,
"Valerian_Scroll":17230,
"Refine_Ore_Box3":17231,
"Guarantee7_Box":17232,
"Scroll_Of_Death":17233,
"Scroll_Of_Life":17234,
"Scroll_Of_Magic":17235,
"Scroll_Of_Thews":17236,
"Scroll_Of_Darkness":17237,
"Scroll_Of_Holiness":17238,
"Horned_Scroll":17239,
"Mercury_Scroll":17240,
"Amistr_Cap_Box":17241,
"Immortal_Egg":17242,
"Almighty_Box2":17244,
"Idn_Independ_Scroll":17245,
"HD_Elunium_Box30":17246,
"HD_Oridecon_Box30":17247,
"C_Wing_Of_Fly_3Day_Box":17251,
"RWC_2012_Set_Box":17252,
"RWC_2012_Ring_Box":17253,
"RWC_2012_Pendant_Box":17254,
"Sapphire_Egg":17255,
"Good_Student_Gift_Box":17256,
"Bad_Student_Gift_Box":17257,
"Ex_Def_Potion_Box":17262,
"C_Center_Pot_3d_Box":17263,
"C_Awakening_Pot_3d_Box":17264,
"C_Berserk_Pot_3d_Box":17265,
"BM_Limit_Pack":17266,
"STR_Biscuit_Stick_Box":17270,
"VIT_Biscuit_Stick_Box":17271,
"AGI_Biscuit_Stick_Box":17272,
"INT_Biscuit_Stick_Box":17273,
"DEX_Biscuit_Stick_Box":17274,
"LUK_Biscuit_Stick_Box":17275,
"Unlimited_Box":17277,
"Unlimited_10_Box":17278,
"Unlimited_20_Box":17279,
"Refine_Ore_Box4":17281,
"Refine_Ore_Box4_Set10":17282,
"Refine_Ore_Box4_Set20":17283,
"E_Change_Name_Card_Box":17284,
"E_New_Style_Box":17285,
"E_Cloth_Dye_Coupon_Box":17286,
"E_Cloth_Dye_Coupon_Box2":17287,
"Customizing_Box":17288,
"Wing_Of_Baalzebub_Box":17289,
"Orleans_Full_Course_Box":17290,
"Shadow_Box":17292,
"Physical_S_Package":17293,
"Magical_S_Package":17294,
"Vigorgra_Package":17298,
"Vigorgra_Package_Set":17299,
"Shadow_Box2_Box":17302,
"Shadow_Box2_Set":17303,
"Neuralizer_Box_3":17304,
"Status_Reset_Coupon_Box":17306,
"Midgard_Scroll":17307,
"Half_Asprika_Box_1":17308,
"Half_Brynhild_Box_1":17311,
"C_Wing_Of_Fly_1Day_Box":17314,
"Silvervine_Box10_":17315,
"Silvervine_Box110":17316,
"Sweet_Midgard_Scroll":17317,
"Brithday_IdRO10th_Scr":17320,
"3_Life_Potion_pack":17321,
"3_Life_Potion_10pack":17322,
"Requiem_Scroll":17326,
"Almighty_Box3":17331,
"Almighty100_Box":17332,
"J_Shop_Coupon_Box":17336,
"Holy_Spirit_Scroll":17337,
"Refine_Ore_Box5":17338,
"Refine_Ore_Box5_Set10":17339,
"Old_Hat_Box_":17394,
"Half_L_Maje_Box_1day":17396,
"Half_L_Maje_Box_7day":17397,
"Half_BF_Spear1_Box_1day":17398,
"Half_BF_Spear1_Box_7day":17399,
"Half_BF_Book2_Box_1day":17400,
"Half_BF_Book2_Box_7day":17401,
"Half_BF_Staff4_Box_1day":17402,
"Half_BF_Staff4_Box_7day":17403,
"Half_BF_Staff2_Box_1day":17404,
"Half_BF_Staff2_Box_7day":17405,
"Half_BF_Knuc1_Box_1day":17406,
"Half_BF_Knuc1_Box_7day":17407,
"Half_BF_Dag2_Box_1day":17408,
"Half_BF_Dag2_Box_7day":17409,
"Half_BF_HuShu2_Box_1day":17410,
"Half_BF_HuShu2_Box_7day":17411,
"Half_BF_Sword1_Box_1day":17412,
"Half_BF_Sword1_Box_7day":17413,
"Half_Mjolnir_Box_1day":17414,
"Half_Mjolnir_Box_7day":17415,
"Half_BF_MStar1_Box_1day":17416,
"Half_BF_MStar1_Box_7day":17417,
"Half_BF_Bow1_Box_1day":17418,
"Half_BF_Bow1_Box_7day":17419,
"Half_BF_Katar2_Box_1day":17420,
"Half_BF_Katar2_Box_7day":17421,
"Half_BF_THAxe1_Box_1day":17422,
"Half_BF_THAxe1_Box_7day":17423,
"Half_BF_Rifle1_Box_1day":17424,
"Half_BF_Rifle1_Box_7day":17425,
"Half_BF_Shgun1_Box_1day":17426,
"Half_BF_Shgun1_Box_7day":17427,
"Shadow_Box3":17429,
"11th_S_Package":17430,
"Thanks_Giving_Scroll":17431,
"Silvervine_Box10_2":17432,
"Silvervine_Box110_2":17433,
"ID_Legend_hero_Scroll":17435,
"3_Life_Potion_pack2":17438,
"3_Life_Potion_10pack2":17439,
"LI_Change_Name_Box":17440,
"LI_Boarding_Halter_Box":17441,
"LI_Empelium_Box":17442,
"LI_Upg_Buckler_BOX":17443,
"Blessing_Midgard_Scroll":17447,
"Biscuit_Stick_Set":17449,
"Premium_Book_Box":17455,
"Vigorgra_Package_v2":17456,
"Vigorgra_Package_Set_V2":17457,
"Costama_Egg18":17461,
"Winter_Midgard_Scroll":17464,
"Refine_Ore_Box6":17465,
"Refine_Ore_Box6_Set10":17466,
"C_Siegfried_Box50":17467,
"LI_Neuralizer_3Box":17468,
"LI_Neuralizer_1Box":17469,
"Costama_Egg19":17470,
"Spring_Festival_Scroll":17471,
"Vigorgra_Package_v3":17472,
"Vigorgra_Package_Set_V3":17473,
"C_Wing_Of_Fly_5Day_Box":17474,
"LC_Max_Weight_Up_10Box":17475,
"Unlimited_Box2":17477,
"Unlimited_10_Box2":17478,
"Midgard_Fes_Scroll":17479,
"Costama_Egg21":17481,
"Solaris_Festival_Scroll":17482,
"3_Life_Potion_pack3":17483,
"3_Life_Potion_10pack3":17484,
"Time_Travel_Scroll":17490,
"Refine_Ore_Box7":17491,
"Refine_Ore_Box7_Set10":17492,
"Costama_Egg23":17493,
"Happy_Time_Scroll":17494,
"Silvervine_Box10_3":17495,
"Silvervine_Box110_3":17496,
"Costama_Egg24":17497,
"3_Life_Potion_pack4":17498,
"3_Life_Potion_10pack4":17499,
"Vigorgra_Package_v4":17501,
"Vigorgra_Package_Set_V4":17502,
"Nyangvine_Box4":17507,
"Nyangvine_Box10":17508,
"Nyangvine_Box40":17509,
"Refine_Ore_Box8":17510,
"Refine_Ore_Box8_Set10":17511,
"LI_HD_Elunium_Box30":17512,
"LI_HD_Oridecon_Box30":17513,
"Unlimited_Box3":17515,
"Unlimited_10_Box3":17516,
"Costama_Egg28":17517,
"Epic_Heroes_Scroll":17519,
"Limit_Manual_Box":17520,
"3_Life_Potion_pack5":17521,
"3_Life_Potion_10pack5":17522,
"Costama_Egg29":17523,
"Limit_Power_Booster_Box":17524,
"Limit_Power_Booster100":17525,
"Majestic_Lucky_Scroll":17526,
"Nyangvine_Box200":17527,
"Blessing_Lucky_Scroll":17532,
"Refine_Ore_Box9":17544,
"Refine_Ore_Box9_Set10":17545,
"2015LI_NeuralizerBox":17547,
"2015LI_S_R_C_Box":17548,
"LI_HD_BradiumBox30":17549,
"LI_HD_CarniumBox30":17550,
"Garnet_Lucky_Scroll":17552,
"Almighty_Box4":17567,
"Almighty100_Box2":17568,
"Dun_Voucher_Box1":17569,
"Dun_Voucher_Box2":17570,
"Erzulie_Lucky_Scroll":17572,
"Nyangvine_Box10_":17573,
"Nyangvine_Box100":17574,
"Service30_M_01_Box":17575,
"Service30_F_01_Box":17576,
"3_Life_Potion_pack6":17582,
"3_Life_Potion_10pack6":17583,
"Venus_Lucky_Scroll":17584,
"Refine_Ore_Box10":17586,
"Refine_Ore_Box10_Set10":17587,
"Amora_Lucky_Scroll":17588,
"Service30P_M_01_Box":17590,
"Service30P_F_01_Box":17591,
"Vigorgra_Package_v5":17592,
"Vigorgra_Package_Set_V5":17593,
"Sograt_Lucky_Scroll":17598,
"C_Greed_1Hour_Box":17599,
"C_CatPaw_1Day_Box":17600,
"Unlimited_Box4":17601,
"Unlimited_10_Box4":17602,
"Sanctuary_Lucky_Scroll":17607,
"C_Giant_Fly_1Day_Box":17608,
"Refine_Ore_Box11":17609,
"Refine_Ore_Box11_Set10":17610,
"Chronosian_Lucky_Scroll":17613,
"3_Life_Potion_pack7":17616,
"3_Life_Potion_10pack7":17617,
"Cyborg_Lucky_Scroll":17628,
"Almighty_Plus_Box":17631,
"Almighty100_PlusBox":17632,
"Undine_Lucky_Scroll":17633,
"Limit_Power_Booster2":17639,
"LimitPowerBooster2_100":17640,
"LC_Boarding_Halter_Box":17646,
"Smithy_Lucky_Scroll":17648,
"Refine_Ore_Box12":17650,
"Refine_Ore_Box12_Set10":17651,
"Ganymede_Lucky_Scroll":17659,
"Vigorgra_Plus_Package":17662,
"Vigorgra_Plus_Set":17663,
"LastAngel_LuckyScroll":17665,
"3_Life_Potion_pack8":17668,
"3_Life_Potion_10pack8":17669,
"Valkyrie_Lucky_Scroll":17671,
"Unlimited_Box5":17672,
"Unlimited_10_Box5":17673,
"Rainbow_Lucky_Scroll":17674,
"Refine_Ore_Box13":17675,
"Refine_Ore_Box13_Set10":17676,
"HD_Refine_Ore_Box":17677,
"Midgard_Lucky_Scroll":17681,
"Nyangvine_Box10_2":17683,
"Nyangvine_Box100_2":17684,
"AID_Buff_Box":17689,
"Vigorgra_Plus_Package2":17690,
"Vigorgra_Plus_Set2":17691,
"June_Lucky_Scroll":17692,
"3_Life_Potion_pack9":17712,
"3_Life_Potion_10pack9":17713,
"Refine_Ore_Box14":17716,
"Refine_Ore_Box14_Set10":17717,
"HD_Refine_Ore_Box2":17718,
"Almighty_Plus_Box2":17726,
"Almighty100_PlusBox2":17727,
"DEF_Scroll_Box":17742,
"DEF_Scroll_Box_Set":17743,
"Limit_Power_Booster3":17748,
"LimitPowerBooster3_100":17749,
"HD_High_Refine_Box":17756,
"Refine_Ore_Box15_Set10":17759,
"Refine_Ore_Box15":17760,
"HD_Refine_Ore_Box3":17761,
"Vigorgra_Plus_Package3":17764,
"Vigorgra_Plus_Set3":17765,
"C_CatPaw_7Day_Box":17766,
"Almighty_Plus_Box3":17774,
"Almighty100_PlusBox3":17775,
"3_Life_Potion_pack10":17776,
"3_Life_Potion_10pack10":17777,
"Cash_Can_Box":17780,
"Unlimited_10_Box6":17783,
"Unlimited_Box6":17784,
"Refine_Ore_Box16":17792,
"Refine_Ore_Box16_Set10":17793,
"HD_Refine_Ore_Box4":17794,
"HD_High_Refine_Box2":17795,
"DEF_Scroll_Box2":17799,
"DEF_Scroll_Box_Set2":17800,
"3_Life_Potion_pack11":17832,
"3_Life_Potion_10pack11":17833,
"RTC_Anniv_Box":17881,
"Refine_Ore_Box17_Set10":17882,
"Refine_Ore_Box17":17883,
"HD_Refine_Ore_Box5":17884,
"HD_High_Refine_Box3":17885,
"Infinity_Box":17886,
"Infinity_10_Box":17887,
"Comp_Kafra_Card_Box":17888,
"New_Vigorgra_Package":17894,
"New_Vigorgra_Set":17895,
"LimitPowerBooster4_100":17901,
"Limit_Power_Booster4":17902,
"2017_GStar_CostumeBox":17914,
"Zero_Merchant_Bell_Box":17920,
"Zero_Kafra_Bell_Box":17921,
"Refine_Ore_Box18":17923,
"Refine_Ore_Box18_Set10":17924,
"HD_Refine_Ore_Box6":17925,
"HD_High_Refine_Box4":17926,
"New_3_Potion_pack":17935,
"New_3_Potion_10pack":17936,
"Nyangvine_Box10_3":17940,
"Nyangvine_Box100_3":17941,
"Almighty_Plus_Box4":17944,
"Almighty100_PlusBox4":17945,
"Refine_Ore_Box19_Set10":17948,
"Refine_Ore_Box19":17949,
"HD_Refine_Ore_Box7":17950,
"HD_High_Refine_Box5":17951,
"DEF_Scroll_Box3":17959,
"DEF_Scroll_Box_Set3":17960,
"3_Life_Potion_pack12":17961,
"3_Life_Potion_10pack12":17962,
"Infinity_Box2":17967,
"Infinity_10_Box2":17968,
"A_Vigorgra_Set":17969,
"A_Vigorgra_Package":17970,
"A_3_Life_Potion_10pack":17971,
"A_3_Life_Potion_pack":17972,
"A_Almighty100_Box":17973,
"A_Almighty_Box":17974,
"A_Refine_Ore_Box_Set":17975,
"A_Refine_Ore_Box":17976,
"A_HD_Refine_Ore_Box":17977,
"A_HD_High_Refine_Box":17978,
"A_LimitPowerBooster_100":17979,
"A_LimitPowerBooster":17980,
"A_Infinity_10_Box":17981,
"A_Infinity_Box":17982,
"A_DEF_Scroll_Box_Set":17983,
"A_DEF_Scroll_Box":17984,
"A_Unlimited_10_Box":17985,
"A_Unlimited_Box":17986,
"Inventory_Ex_Box":17999,
"Cannon_Ball":18000,
"Holy_Cannon_Ball":18001,
"Dark_Cannon_Ball":18002,
"Soul_Cannon_Ball":18003,
"Iron_Cannon_Ball":18004,
"Ice_Cannon_Ball":18005,
"Lightning_Cannon_Ball":18006,
"Stone_Cannon_Ball":18007,
"Flare_Cannon_Ball":18008,
"Poisoning_Cannon_Ball":18009,
"Shooting_Star_C":18100,
"F_Bow_Of_Rudra_C":18101,
"E_Bow_Of_Rudra_C":18102,
"Mystic_Bow":18103,
"Adventure_Bow":18104,
"Academy_Bow":18105,
"P_Bow3":18106,
"Malang_Snow_Crab":18107,
"Brindle_Eel":18108,
"Catapult":18109,
"Big_CrossBow":18110,
"Creeper_Bow":18111,
"Upg_Bow":18112,
"Velum_Arbalest":18113,
"Velum_CrossBow":18114,
"Orc_Archer_Bow_":18115,
"Metal_Bow":18116,
"Royal_Bow":18117,
"TE_Woe_Bow":18118,
"Thanos_Bow":18119,
"Bow_Of_Evil_Slayer":18120,
"Sinister_Bow":18121,
"Gigantic_Bow":18122,
"Bow_Of_Storm":18123,
"Half_BF_Bow1":18124,
"Arcus_Daemonicus":18125,
"Ru_Blue_Bow":18126,
"Ru_Gold_Bow":18127,
"Bow_Of_Infinite":18128,
"Ixion_Wing_S":18129,
"Scarlet_Bow":18130,
"Union_Bow":18132,
"Bow_of_Trust":18133,
"Burning_Bow_":18137,
"Frozen_Bow_":18138,
"Earth_Bow_":18139,
"Gust_Bow_":18140,
"Toughen_Metal_Bow":18141,
"UnrivaledBow":18142,
"Avenger_Hunter_Bow":18143,
"Blue_Bow":18144,
"Vigilante_Bow":18145,
"Diva_Wing":18146,
"Mirage_Wing":18147,
"Sinister_Bow_J":18148,
"Balistar_IL":18149,
"Probation_CrossBow":18150,
"Probation_Bow":18151,
"Neev_Bow_Of_Rogue":18153,
"Neev_Hunter_Bow":18154,
"Neev_CrossBow":18155,
"Vigilante_Bow_J":18163,
"Royal_Bow_K":18164,
"Rebeginer_RN_Bow":18165,
"Rebeginer_WM_Bow":18166,
"Narcis_Bow":18170,
"Local01_Bow":18172,
"Local02_Bow":18173,
"Hunter_Bow_IL":18174,
"Woe_Bow1_Z":18175,
"Sky_Lightning_Bow":18176,
"Variant_Wing":18177,
"Virtual_Bow_OS":18178,
"MH_P89_OS":18179,
"AC_B44_OS":18180,
"Evt_Royal_Bow_K":18182,
"Evt_Narcis_Bow":18183,
"Rapid_Fire_C_Bow":18184,
"Sharp_Star_Bow":18185,
"Aiming_Bow":18186,
"Falken_Shooter":18187,
"Wind_Gale":18188,
"Ein_BHBOW":18190,
"G_Knight_Bow":18191,
"Rapid_Fire_C_Bow_J":18193,
"Sharp_Star_Bow_J":18194,
"Aiming_Bow_J":18195,
"Falken_Shooter_J":18196,
"Wind_Gale_J":18197,
"G_Knight_Archer_Bow":18198,
"Realgar_Shooter_EXE":18200,
"Comp_Scalet_DragonL_Bow":18201,
"Comp_Narcis_Bow":18202,
"Cheer_Scarf6":18500,
"Cheer_Scarf8":18501,
"Cheer_Scarf10":18502,
"Small_Horn_Of_Devil":18503,
"Anubis_Helm_J":18504,
"Umbala_Spirit":18505,
"Hattah_Black":18506,
"Elven_Ears_":18507,
"Garuda_Hat":18508,
"RWC2010_Indonesia":18509,
"Blood_Angel_Hair_Band":18510,
"Blood_Angel_Wing_Ear":18511,
"Necktie_Of_Tippler":18512,
"Shining_Sunflower":18513,
"Para_Team_Hat2":18514,
"RTC_Winner_Headgear":18515,
"RTC_2nd_Headgear":18516,
"RTC_3rd_Headgear":18517,
"Ear_Of_Angel's_Wing_":18518,
"Ear_Of_Devil's_Wing_":18519,
"Jaty_C":18520,
"Lucky_Clover":18521,
"Evil_Marcher_Hat":18522,
"Super_Scell":18523,
"Dokkebi_Mask":18524,
"Watermelon_Hat":18525,
"Yummy_Lollipop":18526,
"Gloomy_Pumpkin_Hat":18527,
"Tare_Neko_Cru":18528,
"Drooping_Wild_Rose":18529,
"Tha_Despero_Mask":18530,
"Drooping_Permeter":18531,
"Heart_Ribbon_Band":18532,
"Honeybee_Hat":18533,
"Fancy_Phantom_Mask":18534,
"Pumpkin_Hat_2010":18535,
"Foxtail":18536,
"Malangdo_Hat":18537,
"Devil_Whisper":18538,
"Skull_Cap":18539,
"Evil_Mask":18540,
"Little_Fhat":18541,
"Love_Guard":18542,
"Witchs_Hat":18543,
"Blrabbit_Hband":18544,
"Whrabbit_Hband":18545,
"Lover_In_Mouth":18546,
"Campus_Festival":18547,
"Tiny_Hat":18548,
"Butterfly_Hairpin":18549,
"Asgard_Blessing":18550,
"Galaxy_Circlet":18551,
"Proba_Angel_Blessing":18552,
"Mini_Tree":18553,
"King_Prawn_Hat":18554,
"General_Helmet":18555,
"Angel_Helmet":18556,
"Devil_Helmet":18557,
"Sinsuncho_Hat":18558,
"Fafnir_Skin":18559,
"Fafnir_Mask":18560,
"B_Feather_Beret":18561,
"Bone_Hat":18562,
"Heart_Wing_Hairband":18563,
"Love_Piece":18564,
"St_Pat_Hat":18565,
"Nut_Donut_In_Mouth":18566,
"Stretched_Nose":18567,
"Humming_Bird":18568,
"Soft_Sheep_Hat":18569,
"Ancient_Gold_Deco":18570,
"Lucky_Hat":18571,
"Korean_Judge_Hat":18572,
"White_Feather":18573,
"Lord_of_Death":18574,
"Wunderkammer":18575,
"YinYang_Earring":18576,
"24_Bolt":18577,
"Helm_Of_Valor":18578,
"9th_Anni_Hat":18579,
"Yggdrasil_Crown":18580,
"Red_Tiger_Mask":18581,
"Blue_Tiger_Mask":18582,
"Navy_Drooping_Kitty":18583,
"Brown_Drooping_Kitty":18584,
"Orange_Bunny_Hairband":18585,
"Violet_Bunny_Hairband":18586,
"Blue_Bunny_Hairband":18587,
"Silvah_Bunny_Hairband":18588,
"Strawberry_Hat":18589,
"Gemma_Hairband":18590,
"Mini_Glasses_":18591,
"Nestea_Hat":18592,
"Fancy_Mini_Crown":18593,
"Magni_Cap_":18594,
"Horn_Of_Ancient":18595,
"Sprout_Hat":18596,
"Mercury_Helm":18597,
"Mini_Tree_J":18598,
"Black_Devil_Mask":18599,
"Cat_Ears_Beret":18600,
"Red_Bread_Hat":18601,
"Watermelon_Slice":18602,
"Black_Devil_Mask_":18603,
"Falcon_Mask":18604,
"Dark_Age":18605,
"Tear_Drop":18606,
"Blush_":18607,
"Pair_Of_Red_Ribbon2":18608,
"Dark_Blindfold_":18609,
"7th_Anni_Hat_B":18610,
"Black_Glasses_":18611,
"White_Musang_Hat":18612,
"Black_Musang_Hat":18613,
"Grim_Reaper_Hat":18614,
"Injured_Eyepatch":18615,
"Long_Tongue":18616,
"Onigiri_In_Mouth":18617,
"Airplane_Hat":18618,
"Thief_Bandana":18619,
"Heart_Eyepatch":18620,
"Gangster_Mask_A":18621,
"Rocket_Helm1":18622,
"Rocket_Helm2":18623,
"Rocket_Helm3":18624,
"Rocket_Helm_RWC":18625,
"Gelato_Hat":18626,
"Dried_Leaf":18627,
"Tare_Domovoi":18628,
"B_Desert_Wolf_Hat":18629,
"Alicel_Drooping_Doll":18630,
"Ribbon_Chef_Hat":18631,
"Yellow_Poring_Clip":18632,
"Pink_Poring_Clip":18633,
"Green_Poring_Clip":18634,
"Blue_Poring_Clip":18635,
"Bridal_Ribbon":18636,
"Ancient_Admiral_Helm":18637,
"Citron_Hat":18638,
"Naval_Officer_Hat":18639,
"Starfish_Headband":18640,
"Ribbon_Magic_Hat":18641,
"Scissorhand_Model":18642,
"Rockhand_Model":18643,
"Paperhand_Model":18644,
"Sailor_Hat":18645,
"Cow_Hat":18646,
"Star_Eyepatch":18647,
"Tongue_Charm":18648,
"Lude_Mask":18649,
"RWC_Shouting_Mouth":18650,
"Ignis_Cap":18651,
"Vanargand_Helm":18652,
"Deviruchi_Headphone":18653,
"Goedo_Monocle":18655,
"Wit_Pumpkin_Hat":18656,
"Pegasus_Wing_Ears":18657,
"Holy_Santa_Beard":18658,
"Boitata_Hat":18659,
"Indi_Feather_Band":18660,
"Trident_Helmet":18661,
"Antler_Fedora":18662,
"Sunglasses_Bball_Hat":18663,
"Blind_Glasses":18664,
"Orange_In_Mouth":18665,
"CD_In_Mouth":18666,
"Cat_Lace_Hairband":18667,
"Droopy_Turtle_Hat":18668,
"Cowhide_Hat":18669,
"Hankie_In_Mouth":18670,
"Rudolf_Hairband":18671,
"Tare_Pope":18672,
"Tare_Pope_":18673,
"Planewing_Hat":18674,
"Green_Apple_Hat":18675,
"Hexagon_Spectacles":18676,
"Cherry_Twig_In_Mouth":18677,
"Leek_In_Mouth":18678,
"Abacus_In_Mouth":18679,
"Tw_Frog_Hat":18680,
"Puppy_Ears_Hat":18681,
"Teardrop":18682,
"Carrot_In_Mouth":18683,
"Showy_High_Cap":18684,
"Stardust_Hairband":18685,
"2011_RMSC_1":18686,
"2011_RMSC_2":18687,
"2011_RMSC_3":18688,
"2011_RMSC_4":18689,
"Sirt_Evil_Eye":18690,
"Rising_Black_Dragon":18691,
"Mike_Hat":18692,
"Sleeping_Kitty_Cat":18693,
"Red_Hood":18694,
"Phoenix_Crown":18695,
"Orange_Hat":18696,
"Syringe_In_Mouth":18697,
"Cheesy_Snack_In_Mouth":18698,
"Starving_Fish_Hat":18699,
"Rabbit_Ribbon":18700,
"Ancient_Civil_Man":18701,
"Shaving_Cream":18702,
"Stem_In_Mouth":18703,
"Drosera_Hairpin":18704,
"FlipHat":18705,
"Can_Hat":18706,
"Maneater_Flower_Hat":18707,
"Candy_Hat":18708,
"Black_Knitted_Hat":18709,
"Sugared_Fruit_Stick":18710,
"Electric_Sunglass":18711,
"Fan_In_Mouth":18712,
"Monkey_On_Fur_Hat":18713,
"Hippo_Hat":18714,
"Helm_Of_Thoth":18715,
"Strawberry_In_Mouth":18716,
"Rose_Hairband":18718,
"Magical_Booster":18720,
"L_Magestic_Goat_":18724,
"Rabbit_Ear_Knit_Hat":18725,
"Sky_Helm":18726,
"Sedora_Hat":18727,
"Egir_Helm":18728,
"MVP_Basketball":18729,
"Cryptura_Academy_Hat":18730,
"Valkyrie_Outing_Helm":18731,
"TE_Woe_Cap":18732,
"TE_Woe_Bone_Helm":18733,
"TE_Woe_Magic_Eyes":18734,
"Drooping_Elven_Ears":18735,
"Censor_Bar_":18736,
"Fortier_Mask":18737,
"White_Boys_Hat":18738,
"Carnation_Hairband":18739,
"C_Hair_Of_The_Strong":18740,
"C_Will_O_Wisp":18741,
"C_MoonStar_Accessory":18742,
"C_Spirit_Of_Chung_E":18743,
"C_World_Star":18744,
"Choco_Stick_In_Mouth":18745,
"Chilly_Breath":18746,
"Eyes_Of_Ifrit":18747,
"Gold_Ingot_Poring_Hat":18748,
"Majoruros_Horn":18749,
"Poker_Card_In_Mouth":18750,
"Extreme_Luck_Clover":18751,
"Cursed_Book":18752,
"Tw_Rice_Ball":18753,
"Blood_Sucker":18754,
"Feather_Beret_":18755,
"Black_Shiba_Inu_Hat":18756,
"Hat_Of_Scrat":18758,
"Stretched_Nose_M":18759,
"Remodel_Wizardry_Hat":18760,
"Remodel_Magician_Hat":18761,
"Remodel_Mask_Of_Fox":18762,
"Remodel_Joker_Jester":18763,
"Remodel_Bunny_Band":18764,
"Enhanced_Corsair":18765,
"Enhanced_Helm_Of_Angel":18766,
"Enhanced_Helm_Of_Sun":18767,
"Enhanced_Bone_Helm":18768,
"Remodel_Munak_Turban":18769,
"Remodel_Bongun_Hat":18770,
"Remodel_Opera_Mask":18771,
"Improved_Binoculars":18772,
"Improved_Fin_Helm":18773,
"Improved_Assassin_Mask":18774,
"Improved_Welding_Mask":18775,
"Improved_Kiss_Of_Angel":18776,
"Aladdin_Lamp":18777,
"Pink_Bunny_Band_J":18778,
"RWC_Champ_Crown_Red":18779,
"RWC_Champ_Crown_Blue":18780,
"RWC_Champ_Crown_Black":18781,
"Butterfly_Wing_Ear_J":18782,
"Rose_Crown":18783,
"Elder_Devil_Horn":18784,
"King_Poring_Hat":18785,
"Anemos_Mask":18786,
"Goal_Tender_Mask":18787,
"Starlight_Scope":18788,
"Poison_Spore_Hat":18789,
"Rainbow_Poring_Hat":18790,
"Shrine_Maiden_Hat":18791,
"Idn_Sakkat":18792,
"Sorc_Night_Cap":18793,
"RWC_Champ_Crown_QF":18796,
"Deep_Angel_Hairband":18797,
"Pink_Angel_Hairband":18798,
"Nero_Mask":18799,
"Gale_Hairband":18801,
"Boss_Hat":18802,
"Rose_Cascade":18803,
"Thornbush_Hairband":18804,
"Eclipse_Hat":18805,
"Black_Rabbit_Hat":18806,
"Yellow_Yuzu_Hat":18807,
"Wing_Form_Spectacle":18808,
"8th_Anni_Hat_B":18809,
"Hell_Pumpkin_Hat":18810,
"JRO_White_Snake":18811,
"Elder_Crown":18812,
"New_Wave_Sunglasses":18813,
"Angel_School_Cap":18814,
"Devil_School_Cap":18815,
"Adv_Angel_School_Cap":18816,
"Adv_Devil_School_Cap":18817,
"Red_Pencil_In_Mouth":18818,
"Blue_Pencil_In_Mouth":18819,
"Gray_Helmet":18820,
"Rainbow_Feather_Deco":18821,
"Flame_Wing_Ear":18822,
"Imperial_Feather":18823,
"Mask_Of_Bankrupt":18824,
"Money_Lost_Spirit":18825,
"Valkyrie_Circlet":18827,
"2012RMSCNO1":18828,
"2012RMSCNO2":18829,
"2012RMSCNO3":18830,
"2012RMSCNO4":18831,
"Rolf_Von_Gigue_666":18832,
"Marin_Crown":18833,
"Sakura_Hairband":18834,
"Angeling_Woolly_Hat":18838,
"Poring_Sunglasses":18839,
"Small_Poring_Band":18841,
"Hat_Of_Girl":18842,
"Small_Deviling_Hat":18843,
"Blue_Poring_Bubble":18844,
"Banshee_Master_Kiss":18845,
"C_Guard_Of_Neptune":18846,
"Jolly_Roger":18847,
"Lush_Rose":18848,
"Celines_Ribbon":18849,
"Polar_Bear_Cap":18850,
"ValentineHeart":18851,
"D_Strawberry_Hat":18852,
"D_Strawberry_Hat_":18853,
"ValentineYellowHeart":18854,
"Aviator_Hat":18855,
"W_King_Tiger_Doll_Hat":18856,
"Curupira_Hat":18857,
"Pink_Angeling_Bubble":18858,
"Angeling_Bubble":18859,
"Preschool_Hat":18860,
"Zaha_Doll_Hat_J":18861,
"Armor_Chiu_J":18862,
"Exorcist_Robe":18863,
"Earth_Goddess_Flower_J":18864,
"Sword_Master_Crown":18865,
"Owlduke_Silk_Hat":18866,
"Vajra":18867,
"Assassin_Skull_Mask":18868,
"Donut_In_Mouth_J":18869,
"Event_Sweet_Candy":18870,
"Event_Sweet_Candy2":18871,
"Snake_Hat":18872,
"Sweet_Valentine_Out":18873,
"One_Eyed_Glass_":18874,
"Baron_Evil_Eye":18877,
"Palace_Guard_Cap":18878,
"Angry_Scorpion_Hat":18879,
"BLACKDEATHKING_GOLDEN":18880,
"Yggdrasil_Hat":18881,
"Kannam_On_Head":18882,
"Black_Witch_Hat":18883,
"Tatenasi_Helmet":18884,
"Jejecap":18885,
"Aqua_Bunny_Band":18887,
"Maroon_Bunny_Band":18888,
"Golden_Bunny_Band":18889,
"Gray_Bunny_Band":18890,
"Husky_Hat":18891,
"Ufo_Poring_Hat":18892,
"Dragon_Claw_Helm":18893,
"Rainbow_Star":18894,
"Celestial_Dark_Flame":18895,
"Pterios_Fins":18896,
"Azure_Diadem":18897,
"Yggdrasil_Herald_Crown":18898,
"Weisswurst":18900,
"Seppl_Hat":18901,
"Shovel_Hat":18902,
"Frozen_Land_Rose":18903,
"Man_Medal":18904,
"Butterfly_Barrettes":18905,
"Holy_Rosario":18906,
"Isabella_Red_Ear":18908,
"Isabella_Brown_Ear":18909,
"Isabella_Blue_Ear":18910,
"Bell_Pigeon":18912,
"Gossip_Raven":18913,
"Kid_Deviling":18914,
"Blood_Buffterfly":18915,
"Bear_Balloon":18916,
"LoveLove_Balloon":18917,
"Long_Octopus_Balloon":18918,
"Jack_Castle_Bat":18919,
"Bork":18920,
"C_Aladdin_Lamp":18921,
"ILCHONGOM":18922,
"RokBlackCat":18923,
"Fez_Of_Gentle":18924,
"GodOfWinds_Fan":18925,
"Green_Foxtail":18926,
"Elephant_Model_Hat":18929,
"Gorilla_Model_Hat":18930,
"Lion_Model_Hat":18931,
"Rhino_Model_Hat":18932,
"Mechanical_Plant_Hat":18933,
"Fox_Ears_Bell_Ribbon":18934,
"There_Is_Something":18935,
"Golden_Fish":18936,
"Memories_Of_Lovers":18937,
"Astro_Circle":18938,
"Black_Cat_Ears_Beret":18939,
"10_Gallon_Hat_Of_Flame":18940,
"Hunting_Cap_Of_Gust":18941,
"Knit_Cap_Of_Water":18942,
"Silk_Hat_Of_Earth":18943,
"Pipe_Of_Jiraiya":18947,
"Mask_Of_Orochimaru":18948,
"Scroll_Of_Tsunade":18949,
"Gerhard_Von_Devi":18950,
"Rabbit_Head_Dress":18954,
"Pirates_Foolish":18955,
"Chocolate_Bomb":18956,
"Old_Pink_Poo_Hat":18959,
"Love_Daddy_2013":18960,
"Panda_Balloon":18962,
"Shaving_Foam":18965,
"Jinn_Marin_Balloon":18968,
"Boss_Beret":18969,
"Moon_Cat_Magic":18970,
"Old_Rune_Circlet":18971,
"Old_Mitra":18972,
"Old_Driver_Band_R":18973,
"Old_Driver_Band_Y":18974,
"Old_Shadow_Handicraft":18975,
"Old_Minstrel_Song_Hat":18976,
"Old_Midas_Whisper":18977,
"Old_Magic_Stone_Hat":18978,
"Old_Blazing_Soul":18979,
"Old_Wind_Whisper":18980,
"Old_Dying_Swan":18981,
"Old_Circlet_Of_Bone":18982,
"Old_Protect_Of_Crown":18983,
"Old_Camo_RabbitHood":18984,
"Falconer_Flute":18985,
"RWC13_Jormungandr_Hat":18987,
"New_Year_Hairpin":18992,
"Flower_Hat":18993,
"Riot_Chip":18997,
"Happy_Balloon":19004,
"Victory_Ear_Accessary":19006,
"Baby_Dragon_Hat":19010,
"Little_Devil_S_Horn":19011,
"Gravekeeper_Blinker":19014,
"C_Gemma_Hairband":19015,
"White_Choco_Bear":19018,
"Elemental_Crown":19019,
"Survive_Circlet":19020,
"Gigant_Helm":19021,
"Floating_Stone_Of_Int":19022,
"Q_Scaraba_Crown":19023,
"Protect_Feathers":19024,
"Puppy_Ears_Hat_Jp":19025,
"Egir_Helm_K":19026,
"10_Type_Glasses":19027,
"Minions_Of_Devil":19028,
"Pretty_Rabbit_Hood":19030,
"Fallen_Angel_Blessing":19031,
"Accessories_Of_Goddess":19033,
"37_Sculpt":19034,
"Otter_Hat":19035,
"Brabery_Hat":19036,
"93_BloodyWing":19037,
"12th_Crown":19038,
"12th_ElvenEars":19039,
"666_DevilEar":19041,
"Maneater_Flower_Hairpin":19042,
"Goibne's_Helmet_S":19043,
"Morrigane's_Helm_S":19044,
"14_RainbowWing":19045,
"DeadlyPoison_Manteau":19046,
"Angeling_KnitCap":19047,
"Elemental_Clothe":19048,
"Loki_Nidhogg_Hat":19050,
"Moon_Cat_Warrior":19051,
"Sigrun's_Wing_C":19052,
"Moon_Cat_Fighter":19053,
"CelestialWoman_Flower":19079,
"NettyHeart_BalloonGum":19080,
"Faceworm_Egg_Shell":19081,
"Bio_Protector":19082,
"Mask_of_Hero":19083,
"Parfait_V_Hat":19084,
"Sigrun's_Wing_":19085,
"Robo_Eye_":19086,
"Angel_Spirit_":19087,
"Binoculars_":19088,
"Blinker_":19089,
"Alarm_Mask_":19090,
"Opera_Ghost_Mask_":19091,
"Machoman_Glasses_":19092,
"Spinning_Eyes_":19093,
"Mr_Smile_":19094,
"Happy_Balloon_K":19095,
"Special_Kapra_Hat":19096,
"Ribbon_Piamat_K":19097,
"Piamette_Hood":19098,
"Glastheim_Onlooker":19101,
"Pale_Moon_Hat":19102,
"Kings_Crown":19103,
"YDragon_SkyWing":19104,
"Explosion_Gum":19105,
"Magicstone_Of_Grace":19106,
"Mad_Hatter":19107,
"Wild_Poring_Rider":19108,
"Valhalla_Idol":19109,
"Valhalla_Idol_":19110,
"Laser_Of_Eagle":19111,
"Tengu_Scroll":19112,
"Gemini_Eyes":19113,
"Sting_Silk_Ribbon":19114,
"Republic_Hat":19115,
"Red_Baby_Dragon":19116,
"Poring_Sunglasses_K":19117,
"Poring_Sunglasses_K_":19118,
"Toughen_Time_Keeper_Hat":19119,
"Cylinder_Hairband":19125,
"Shadow_Booster_":19126,
"Zherlthsh_Mask_":19127,
"Ifrit's_Ear_":19128,
"Chick_Hat_":19129,
"Magic_Eyes_":19130,
"Radio_Antenna_":19131,
"Masquerade_":19132,
"Odin_Mask_":19133,
"Whikebain_Ears_K":19134,
"Spirit_Of_Chung_E":19135,
"Spirit_Of_Chung_E_":19136,
"Strawberry_In_Mouth_":19137,
"SeraphimCoronet":19138,
"SurviveOrb":19139,
"Squirrel_Ear_Hat":19140,
"Tha_Maero_Mask_J":19141,
"Droop_Gunslinger_J":19142,
"Poring_Balloon":19143,
"Felock_Cap_":19144,
"Whistle":19145,
"Marin_Balloon":19146,
"Drops_Balloon":19147,
"SantaPoring_Balloon":19148,
"Poporing_Balloon":19149,
"Metaling_Balloon":19150,
"Deviling_Balloon":19151,
"Angeling_Balloon":19152,
"Ghostring_Balloon":19153,
"Archangeling_Balloon":19154,
"Demons_Eye":19155,
"Lunar_Rainbow":19156,
"Droop_Gunslinger":19157,
"C_Gemini_Eyes":19158,
"Barrel_Helm":19159,
"Scuba_Mask_K":19162,
"CatharinaPawnBrad60":19163,
"Para_Team_Hat100":19164,
"Para_Team_Hat160":19165,
"RoCelebrationHat":19166,
"Kafra_Employee_Band":19168,
"K_King_Tiger_Doll_Hat":19169,
"Guardian_Processor":19170,
"Magician_Knithat":19171,
"PoPe_Osuwari_Head":19172,
"Luwmin_Ice":19173,
"Flying_Drone":19174,
"Jack_Head":19175,
"Fallen_Angel_Blessing_":19176,
"Elemental_Crown_K":19177,
"Elemental_Crown_K_":19178,
"Rabbit_Magic_Hat_":19179,
"Anubis_Helm_":19180,
"New_Wave_Sunglasses_":19181,
"Blackhand_Of_Fate":19185,
"Racing_C_Mecha":19189,
"Racing_C_Gene":19190,
"Racing_C_Cross":19191,
"Racing_C_Chaser":19192,
"Racing_C_Warlock":19193,
"Racing_C_Sorcer":19194,
"Racing_C_Rune":19195,
"Racing_C_Royal":19196,
"Racing_C_Bishop":19197,
"Racing_C_Sura":19198,
"Racing_C_Ranger":19199,
"Racing_C_Mins":19200,
"Racing_C_Wander":19201,
"Racing_C_Gunner":19202,
"Racing_C_Ninja":19203,
"Racing_C_Super":19204,
"Racing_C_Doram":19205,
"Nurse_Cap_IL":19209,
"Apple_Of_Archer_IL":19210,
"Magical_Feather_K":19211,
"Malangdo_Pirate":19212,
"TW_Cock_Hat":19217,
"Time_Keeper_Glasses":19218,
"JP_EV12":19219,
"Golden_Angel_Band_TH":19221,
"Cap_IL":19223,
"PoringTownOnion":19238,
"PoringTownCarrot":19239,
"Toy_Syringe_K":19240,
"Magical_Booster_K":19241,
"Cat_Lace_Hairband_K":19242,
"Blue_Rear_Ribbon":19243,
"Necklace_Rosary_K":19244,
"Crimson_Booster":19245,
"Royalguard_Necklace":19246,
"Fancy_Flower_IL":19247,
"Spell_Circuit":19249,
"KarduiEar_BR":19252,
"Mobile_BeginnerMark":19256,
"2017RTCSymbole":19261,
"Jirant_Circlet":19262,
"General_Helmet_":19263,
"GoldFish_Hat":19264,
"Smoky_TransformHat":19265,
"Survive_Circlet_K":19266,
"SurviveOrb_K":19267,
"FaceWorm_Breath":19268,
"Angel_Of_Happiness_J":19269,
"Garden_Of_Eden":19272,
"Gemini_RedEyes":19273,
"OpenAir_Headset":19274,
"Rental_Scuba_Mask":19275,
"Return_TW_1th_Hat":19276,
"Soda_In_Mouth":19277,
"Agenda_RobeJ":19281,
"Consultation_RobeJ":19282,
"K_Heart_Wing_Hairband":19283,
"K_New_Wave_Sunglasses":19284,
"Helmet_Of_Siegfried_J":19285,
"IA_Choker":19286,
"C_Cat_Poring_Balloon":19287,
"C_Gigant_Helm":19288,
"C_Moon_Eyepatch":19289,
"C_Elder_Devil_Horn":19290,
"C_Shiba_Inu":19291,
"C_Wildcat_Knit_Cap":19292,
"C_SmartUnderRim_Glasses":19293,
"C_CatEars_Cyber_HeadP_R":19294,
"Red_Baby_Dragon_TW":19295,
"Classical_Fhat":19296,
"Tatenasi_Helmet_TW":19298,
"Tree_Of_Sprout_JP":19299,
"Dog_Officer":19300,
"Heart_Card_In_Mouth":19306,
"Willothewisp":19307,
"Amistr_Beret":19308,
"Rebeginer_Cap":19310,
"Greater_Dracul_Horn":19311,
"Neev_Barrette":19312,
"Neev_Barrette_":19313,
"Royal_Mantle":19314,
"Squirrel_Ear_Hat_BR":19316,
"Royalguard_Necklace_BR":19318,
"Beelzebub_Hat":19319,
"Dwarf_Beard_J":19320,
"Bell_Pigeon_J":19321,
"Book_of_Soyga":19326,
"Feather_Of_Seraphim":19327,
"Spider_Temp_TW":19328,
"Hand_Of_Devil":19329,
"Hat_of_Goggle":19337,
"Clover_Silkhat":19338,
"Egg_Crispinette":19339,
"Saint_Egg_Shell":19340,
"Devil_Egg_Shell":19341,
"Bull_Hat":19342,
"Circlet_Of_Phoenix":19343,
"Headband_Of_Power_IL":19344,
"Clinging_Doram_1":19347,
"Pizza_Hat_J":19349,
"Carrot_In_Mouth_J":19350,
"C_BearBalloon_TW":19353,
"Engineer_Cap_K":19364,
"Goibne_Helmet_IL":19366,
"Burst_Flame":19367,
"C_BaphoJ_Parachute_TW":19371,
"Sparkler_Stick_TH":19373,
"Striking_hat":19379,
"Floating_Ball":19380,
"Protect_cloth":19381,
"Pop_Popcorn_Hat":19382,
"Exa_Goat_Cap":19387,
"Crow_Tengu_Mask_Z":19388,
"E_Oxygen_Mask":19389,
"Mira_Tower_Hat":19390,
"Eyes_Of_Illusion":19391,
"Magic_Star_TW":19393,
"Racing_C_Star":19396,
"Racing_C_Soul":19397,
"Falcon_Feather":19398,
"Grand_Peco_Band_Z":19399,
"Sleepr_Hat_Z":19400,
"Gothic_Heart_Wing_TW":19401,
"Many_StarsJ":19402,
"Memory_Of_Noodle":19403,
"Biting_Off_Rideword":19404,
"Autumnal_Flavor":19405,
"Harvest_Festa_Hat":19406,
"Work_Cap":19407,
"Charm_Of_Misticfrozen":19408,
"Black_Feather":19409,
"Kings_Mini_Melon":19410,
"Floating_Gioia":19411,
"Flame_Bird":19412,
"White_Bird_Rose":19415,
"C_Master_Cat":19424,
"Master_Cat":19425,
"King_Of_Spirit_Circlet":19426,
"RabbitFamilyBalloon":19427,
"Morpheus_Hood_IL":19428,
"Zarathustra":19429,
"ResonateTaego_TW":19433,
"PoringBeret_TW":19435,
"VesperHeadGear":19436,
"LittleGarden":19437,
"ZilantNecklace":19438,
"Subject_Aura":19439,
"Star_Eyepatch_JP":19443,
"Star_Eyepatch_JP_":19444,
"Injured_Eyepatch_JP":19445,
"Injured_Eyepatch_JP_":19446,
"Leo_Crown_J":19447,
"Cancer_Crown_J":19449,
"Heavenly_Order":19451,
"Heavenly_Order_":19452,
"Jejecap_JP":19453,
"C_Luna_On_Shoulder":19459,
"Black_Veil_J":19460,
"Cat_In_Mouth_J":19462,
"Melon_Cap":19463,
"C_Melon_Cap":19464,
"Cherry_Blossom_Hat_YL":19465,
"C_Small_ocean":19466,
"Libra_Diadem_J":19468,
"Crown_Of_Saint_Jp":19469,
"Scorpio_Crown_J":19471,
"C_S_Circlet_Of_Time":19472,
"Taurus_Diadem_J":19473,
"S_Circlet_Of_Time_RK":19474,
"S_Circlet_Of_Time_LG":19475,
"S_Circlet_Of_Time_NC":19476,
"S_Circlet_Of_Time_GN":19477,
"S_Circlet_Of_Time_GC":19478,
"S_Circlet_Of_Time_SC":19479,
"S_Circlet_Of_Time_AB":19480,
"S_Circlet_Of_Time_SR":19481,
"S_Circlet_Of_Time_WL":19482,
"S_Circlet_Of_Time_SO":19483,
"S_Circlet_Of_Time_RA":19484,
"S_Circlet_Of_Time_WM":19485,
"S_Circlet_Of_Time_SJ":19486,
"S_Circlet_Of_Time_SP":19487,
"S_Circlet_Of_Time_RL":19488,
"S_Circlet_Of_Time_OB":19489,
"S_Circlet_Of_Time_KG":19490,
"S_Circlet_Of_Time_NV":19491,
"S_Circlet_Of_Time_SU":19492,
"Diabolus_Wing":19495,
"Aquarius_Crown_J":19496,
"Phantom_Of_Masquerade":19497,
"CitrusRibbon":19498,
"FortunetellinSealed":19499,
"T_Mr_Smile":19500,
"T_Spinx_Helm":19501,
"T_Goggle":19502,
"T_Munak_Hat":19503,
"T_Sunglasses":19504,
"T_Cigarette":19505,
"T_Valkyrie_Feather_Band":19506,
"Clear_Sun":19507,
"T_Gemmed_Sallet":19508,
"Butterfly_Wing_Ear":19509,
"Nut_On_Head":19510,
"Heart_Eye_Patch1":19511,
"Heart_Eye_Patch2":19512,
"Chicken_Beak":19513,
"Charlie_Beard":19514,
"Yellow_Hat":19515,
"Singing_Bird":19516,
"Cocks_Comb":19517,
"Rainbow":19518,
"Lightning_Cloud":19519,
"Rain_Cloud":19520,
"Charlie_Hat":19521,
"Mini_Crown1":19522,
"Donation_Ribbon":19523,
"C_Green_Feeler":19524,
"C_Jack_A_Dandy":19525,
"C_Helm":19526,
"C_Sharp_Gear":19527,
"C_Iron_Cane":19528,
"C_Angelic_Chain":19529,
"C_Wild_Rose":19530,
"C_Cube_Mask":19531,
"C_Red_Bunny_Band":19532,
"C_Spore_Hat":19533,
"C_Tha_Despero_Mask":19534,
"C_Sinsuncho_Hat":19535,
"C_Rose_Corsage":19536,
"C_Gryphon_Hat":19537,
"Full_Moon":19538,
"C_Reginleif_Hairband":19539,
"C_Rabbit_Earplug":19540,
"C_Romantic_White_Flower":19541,
"C_Devil_Whisper":19542,
"Oliver_Wolf_Hood":19543,
"C_Tare_Neko_Cru":19544,
"C_Boys_Cap":19545,
"C_Valkyrie_Helm":19546,
"C_Deviruchi_Cap":19547,
"C_Frog_Cap":19548,
"C_Magestic_Goat":19549,
"C_Blush":19550,
"C_Elven_Ears":19551,
"C_Centimental_Flower":19552,
"C_Assassin_Mask_":19553,
"C_Hahoe_Mask":19554,
"C_Crescent_Helm":19555,
"C_Kabuki_Mask":19556,
"C_Ayothaya_Hat":19557,
"C_Raven_Cap":19558,
"C_B_Dragon_Hat":19559,
"C_Quati_Hat":19560,
"C_Tucan_Hat":19561,
"C_Jaguar_Hat":19562,
"C_Dragon_Arhat_Mask":19563,
"C_Tiger_Arhat_Mask":19564,
"C_Chung_Hairband":19565,
"C_Samurai_Mask":19566,
"C_Hattah_Black":19567,
"C_Horn_Of_Ancient":19568,
"C_Sprout_Hat":19569,
"C_Mercury_Helm":19570,
"C_White_Musang_Hat":19571,
"C_Black_Musang_Hat":19572,
"C_Heart_Wing_Hairband":19573,
"C_Lord_of_Death":19574,
"C_Rising_Black_Dragon":19575,
"C_Tare_Pope":19576,
"10th_Anni_Poring_Hat":19577,
"C_Goggle":19578,
"C_Red_Wing_Hat":19579,
"C_Sphinx_Helm":19580,
"C_Brabery_Hat":19581,
"C_Cowboy_Hat":19582,
"C_Gangster_Patch":19583,
"C_Pirate_Dagger":19584,
"C_Feather_Beret":19585,
"C_Pink_Bunny_Band_J":19586,
"C_King_Poring_Hat":19587,
"C_Cat_Hat_J":19588,
"C_Fallen_Angel_Lost_J":19589,
"C_Twin_Ribbon_J":19590,
"C_Red_Ribbon_J":19591,
"C_Hibiscus_J":19592,
"C_Laurel_Wreath_J":19593,
"C_Geographer_J":19594,
"C_Dress_Hat_J":19595,
"C_Flying_Angel_J":19596,
"C_Magic_Eyes_J":19597,
"C_Wondering_Wolf_Helm":19598,
"C_Imp_Hat":19599,
"Drooping_Kiehl":19600,
"Drooping_Aliot":19601,
"C_Invisible_Cap":19602,
"C_Invisible_Sunglasses":19603,
"C_Invisible_Mask":19604,
"C_Gang_Scarf":19605,
"C_Ninja_Scroll":19606,
"C_Love_Chick_Hat":19607,
"C_Chick_Hat":19608,
"C_Red_Glasses":19609,
"C_Whisper_Mask":19610,
"C_Pecopeco_Wing_Ears":19611,
"C_Headset_OST":19612,
"C_Valkyrie_Feather_Band":19613,
"C_Super_Novice_Hat":19614,
"C_Loki_Mask":19615,
"C_Ear_Of_Black_Cat":19616,
"C_Ear_Of_Puppy":19617,
"C_Mask_Of_Fox":19618,
"C_Corsair":19619,
"C_Detective_Hat":19620,
"C_Ear_Of_Devils_Wing":19621,
"C_First_Moon_Hair_Pin":19622,
"C_Bizofnil_Wing_Deco":19623,
"C_Round_Eyes":19624,
"C_Bunny_Band":19625,
"C_Chullos":19626,
"C_Satellite_Hairband":19627,
"C_Headset":19628,
"C_Tiara":19629,
"C_Crown":19630,
"C_Boss_Hat":19631,
"C_Hat":19632,
"C_Flower_Hairband":19633,
"C_Flu_Mask":19634,
"C_Mini_Propeller":19635,
"C_Pierrot_Nose":19636,
"C_Nurse_Cap":19637,
"C_Mr_Smile":19638,
"C_Sahkkat":19639,
"C_Charming_Ribbon":19640,
"C_Helm_Of_Darkness":19641,
"C_Moonlight_Flower_Hat":19642,
"C_Whikebain_Ears":19643,
"C_Takius_Blindfold":19644,
"C_Chinese_Crown":19645,
"C_Ramen_Hat":19646,
"C_Red_Deviruchi_Cap":19647,
"C_Fallen_Leaves":19648,
"C_White_Baby_Cat_Ears":19649,
"C_Rainbow_Feather_Deco":19650,
"C_RWC_Shouting_Mouth":19651,
"C_Rabbit_Magic_Hat":19652,
"C_Marcher_Hat":19653,
"C_J_Captain_Hat":19654,
"C_Tiraya_Bonnet":19655,
"C_Minstrel_Hat":19656,
"C_Captain_Hat":19657,
"C_Vacation_Hat":19658,
"C_Gray_Fur_Hat":19659,
"C_Coppola":19660,
"C_Sweet_Bonnet":19661,
"C_Magician_Hat":19662,
"Wishing_Sky_Lantern":19663,
"C_Campus_Festival":19664,
"C_Poring_Cake_Cap":19665,
"C_Cookie_Hat":19666,
"C_Helm_Of_Dragoon":19667,
"C_Wind_Milestone":19668,
"C_Reginleif_Wings_J":19669,
"C_Southern_Cross":19670,
"C_Pig_Moneybox":19671,
"C_Poring_Letter":19672,
"C_Love_Guard":19673,
"C_Evil_Mask":19674,
"C_Jumping_Poring":19675,
"C_Rainbow_Poring_Hat":19676,
"C_Soulless_Wing":19677,
"C_Bell_Ribbon":19678,
"C_Round_Eyes_J":19679,
"C_Tongue_Mask":19680,
"C_Silver_Tiara":19681,
"C_Santa_Poring_Hat":19682,
"C_Sweet_Candy":19683,
"C_Happy_Wig":19684,
"C_ShineSantaPoring":19685,
"C_SantaHairband":19686,
"C_Lush_Rose":19687,
"C_RJC_Katusa":19688,
"C_Ati_Atihan_Hat":19689,
"C_Dark_Snake_Lord_Hat_J":19690,
"C_Blue_Ribbon":19691,
"C_Antique_Pipe_J":19692,
"C_Triple_Poring_Hat":19693,
"C_Vane_Hairpin":19694,
"C_Kettle_Hat":19695,
"C_Friend_Mochiring_Hat":19696,
"C_Rudolph_Santa_Hat":19697,
"C_Bf_Recruiter_Hat":19698,
"C_Gf_Recruiter_Hat":19699,
"RWC12_ChampCrown_J":19700,
"C_Red_Bonnet":19701,
"C_Santa_Hat_1":19702,
"C_Afro_Wig_Black":19703,
"C_Afro_Wig_Red":19704,
"C_Afro_Wig_Yellow":19705,
"C_Red_Dress_Hat":19706,
"C_Polar_Bear_Cap":19707,
"Elizabeth":19708,
"C_Yellow_Ribbon":19709,
"C_Wings_Of_Victory":19710,
"C_Kafra_Band":19711,
"C_Little_Angel_Doll":19712,
"C_Lucky_Clover":19713,
"C_Lady_Tanee_Doll":19714,
"C_Scarf":19715,
"C_Alice_Doll":19716,
"C_Ribbon_Pink":19717,
"C_Gothic_Head_Dress":19718,
"C_Coronet":19719,
"C_Oldman's_Romance":19720,
"C_Darkness_Helm":19721,
"C_Black_Glasses":19722,
"C_Sacred_Torch_Coronet":19723,
"C_Deprotai_Doll_Hat":19724,
"C_Bread_Bag2":19725,
"C_Scarlet_Rose":19726,
"C_Deviling_Hat":19727,
"C_Tare_Zonda":19728,
"C_Neko_Mimi_Kafra":19729,
"C_Snake_Hat":19730,
"C_Satanic_Chain":19731,
"C_Goblin_Mask_04":19732,
"C_Panda_Cap":19733,
"C_Binoculars":19734,
"C_Fin_Helm":19735,
"C_Gas_Mask":19736,
"C_Corsair_K":19737,
"C_Detective_Hat_K":19738,
"C_Sleeping_Kitty_Cat":19739,
"C_Guildsman_Recruiter":19740,
"C_Majestic_Evil_Horn":19741,
"Little_Golden_Wing":19742,
"C_Anubis_Helm_J":19743,
"C_Black_Tail_Ribbon":19744,
"C_Holy_Marching_Hat_J":19745,
"C_Cap_Of_Blindness":19746,
"C_Tha_Despero_Mask_J":19747,
"C_Diadem":19748,
"C_Gold_Spirit_Chain":19749,
"C_Saint_Frill_Ribbon":19750,
"C_Light_Darkness_Crown":19751,
"C_Shelter_Wing_Ears":19752,
"C_Celestial_Hat":19753,
"C_Good_Wedding_Veil":19754,
"C_YinYang_Earring":19755,
"C_Holy_Mom_Love":19756,
"C_Water_Lily_Crown":19757,
"C_King_Frog_Hat":19758,
"C_Umbrella_Hat":19759,
"C_Rainbow_Veil":19760,
"C_White_Lily":19761,
"C_Happy_Peace_Proof":19762,
"C_Leaf_Cat_Hat":19763,
"C_Card_In_The_Mouth":19764,
"C_Ear_Of_Angel's_Wing":19765,
"C_Yggdrasil_Hat":19766,
"C_Home_Cherry_Blossom":19767,
"C_Sakura_Coronet":19768,
"C_Mischievous_Fairy":19769,
"C_Japan_Winecup":19770,
"C_Butterfly_Hairpin":19771,
"C_Honeybee_Hat":19772,
"C_Angeling_Hairpin":19773,
"C_Emperor_Wreath_J":19774,
"C_Marvelous_Wig":19775,
"C_Tomboy_Fairy":19776,
"C_Twinkle_Little_Star":19777,
"C_King_Berry":19778,
"C_Persika":19779,
"C_Rabbit_Ear_Knit_Hat":19780,
"C_Ear_Of_Angel's_Wing_":19781,
"C_Drooping_Kitty":19782,
"C_Granpa_Beard":19783,
"C_Morrigane's_Helm":19784,
"C_Well_Baked_Toast":19785,
"C_Mistress_Crown":19786,
"C_Devoted_Eyes":19787,
"C_Heart_Eyepatch":19788,
"C_Sweet_Gents":19789,
"C_Wedding_Veil":19790,
"C_Alarm_Mask":19791,
"C_Goblin_Mask_01":19792,
"C_Goblin_Mask_02":19793,
"C_Goblin_Mask_03":19794,
"C_Lord_Circlet":19795,
"C_Bone_Helm":19796,
"C_Apple_Of_Archer":19797,
"C_Angry_Mouth":19798,
"C_Golden_Gear":19799,
"C_Carnation_Hairband":19800,
"C_Fox_Hat_J":19801,
"C_Drooping_Nine_Tail":19802,
"C_Pinwheel_Cap":19803,
"C_Red_Vane_Hairpin":19804,
"C_Taboo_Curse_Scroll":19805,
"C_Full_Bloom_Hairpin":19806,
"C_Majestic_Helmet":19807,
"C_Blazing_Sun":19808,
"C_Cowboy_Hat_J":19809,
"C_Ifrit's_Ear":19810,
"C_Beer_Cap":19811,
"C_Large_Hibiscus":19812,
"C_Icecream_Hat":19813,
"C_Shiny_Wig":19814,
"C_Lolita_Ten_Gallon_Hat":19815,
"C_Pecopeco_Cap":19816,
"C_Ifrits_Breath":19817,
"C_Droop_Morocc_Minion":19818,
"C_Necromencer_Hood":19819,
"C_Bone_Hat":19820,
"C_Hyegun_Hat":19821,
"C_Yellow_Bandana":19822,
"C_White_Cat_Hood":19823,
"C_Evil_Druid_Hat":19824,
"C_Vicious_Stop_Bandage":19825,
"C_Ice_Wing_Ear":19826,
"C_Amistr_Cap":19827,
"C_Fedora":19828,
"C_Straw_Hat":19829,
"C_Sunglasses":19830,
"C_Filir_Hat":19831,
"C_Poring_Hat":19832,
"C_Fillet":19833,
"C_Baseball_Cap":19834,
"C_Lif_Doll_Hat":19835,
"C_L_Magestic_Goat":19836,
"C_Asara_Fairy_Hat":19837,
"C_Fox_Hat":19838,
"C_Vanilmirth_Hat":19839,
"C_Helm_Of_Sun":19840,
"C_Dragonhelm_Copper":19841,
"C_Puppy_Hat":19842,
"C_Cat_Hairband":19843,
"C_Turban":19844,
"C_Hair_Protector":19845,
"C_Opera_Ghost_Mask":19846,
"C_Big_Sis_Ribbon":19847,
"C_Angeling_Hat":19848,
"C_Munak_Turban":19849,
"C_Bongun_Hat":19850,
"C_Brown_Bear_Cap":19851,
"C_Galapago_Cap":19852,
"C_Filir_Wing_Ears":19853,
"C_Ear_Of_Black_Cat_":19854,
"C_Happy_Summer_Wig":19855,
"C_Iceflake_Hat":19856,
"C_King_Prawn_Hat":19857,
"C_Leaf_Headgear":19858,
"C_Flying_Angel":19859,
"C_Cryptura_Hair_Cap":19860,
"C_Heart_Hair_Pin":19861,
"C_Horn_Of_Succubus":19862,
"C_Inccubus_Horn":19863,
"C_Afro_Wig":19864,
"C_Joker_Jester":19865,
"C_Blue_Pajamas_Hat":19866,
"C_Pink_Pajamas_Hat":19867,
"aegis_19868":19868,
"C_Ancient_Civil_Man":19869,
"C_Black_Rabbit_Hat":19870,
"C_Music_Decoration":19871,
"C_Phantom_Of_Opera":19872,
"C_Carnival_Hat":19873,
"C_Carnival_Circlet":19874,
"C_Love_Rabbit_Hood":19875,
"C_Rabbit_Ear_Hat":19876,
"C_Eyes_Of_Darkness":19877,
"C_Drooping_Bunny":19878,
"C_Black_Bunny_Band":19879,
"C_Gold_Tiara":19880,
"C_Pretty_Rabbit_Hood":19881,
"C_Flowerpot_Mask":19882,
"C_Piamette_Hood":19883,
"C_Vanargandr_Helm":19884,
"C_Blinker":19885,
"C_Luxury_Sunglasses":19886,
"C_One_Eyed_Glass":19887,
"C_Glasses":19888,
"C_Pair_Of_Red_Ribbon":19889,
"C_Wizardry_Hat":19890,
"C_Fried_Egg_Hat":19891,
"C_Night_Sparrow_Hat":19892,
"C_Black_Mage_Hat":19893,
"C_Shrine_Maiden_Hat":19894,
"C_Sorc_Night_Cap":19895,
"C_Ph_Ro_10th_Cap":19896,
"RPC13_1ST_Wreath":19897,
"RPC13_2ND_Wreath":19898,
"RPC13_3RD_Wreath":19899,
"Special_Eyepatch":19900,
"C_Viking_Helm":19901,
"C_Cigar":19902,
"C_Witchs_Hat":19903,
"C_Skull_Cap":19904,
"C_Secret_Society_Hood":19905,
"C_24_Bolt":19906,
"C_Fancy_Phantom_Mask":19907,
"C_Joker_Jester_":19908,
"C_White_Deviruchi_Cap":19909,
"C_Halloween_Hat":19910,
"C_Triangular_Roof_Hat":19911,
"C_Cat_Eye":19912,
"C_Poo_Poo_Hat":19913,
"Felock_Cap":19914,
"C_Little_Devil_S_Horn":19915,
"C_Black_Cat_Hat":19916,
"C_Gloomy_Pumpkin_Hat":19917,
"C_Lude_Mask":19918,
"C_Cube_Mask_":19919,
"C_Adv_Whisper_Mask":19920,
"C_Drooping_Wild_Rose":19921,
"C_Noah_Hat":19922,
"C_Dark_Age":19923,
"C_Odin_Mask":19924,
"C_One_Eyed_Glasses":19925,
"C_Ribbon_Black":19926,
"C_Gray_Drooping_Kitty":19927,
"C_Gothic_Heart_Wing":19928,
"C_Classical_Ribbon":19929,
"C_Angel_Mini_Silk_Hat":19930,
"C_Lazy_Raccoon":19931,
"C_Cap_Of_Concentration":19932,
"C_711_Headphone":19933,
"C_10Gallon_Hat_Of_Flame":19934,
"C_Hunting_Cap_Of_Gust":19935,
"C_Knit_Cap_Of_Water":19936,
"C_Silk_Hat_Of_Earth":19937,
"LI_C_Love_Rabbit_Hood":19938,
"C_Antler":19939,
"C_Event_Pierrot_Nose":19940,
"C_Ear_Mufs":19941,
"C_Orchid_Hairband":19942,
"C_Hat_Of_Judge":19943,
"C_RTC_Third_Best":19944,
"C_RTC_Third":19945,
"C_Rocket_Helm_RWC":19946,
"C_Rainbow_Scarf":19947,
"C_Globe_Hat":19948,
"C_RWC_2013_Hat":19949,
"C_RWC_Champ_Crown":19950,
"C_Solo_Play_Box2":19951,
"C_Bubble_Gum_In_Mouth":19952,
"C_Parade_Cap":19953,
"C_3D_Glasses":19954,
"C_Mini_Tree_J":19955,
"C_Soldier_Hat":19956,
"C_Scooter_Hat_J":19957,
"C_Choir_Hat":19958,
"C_Drooping_Argiope":19959,
"C_Chain_Puppet":19960,
"C_Rune_Circlet":19961,
"C_Mitra":19962,
"C_Driver_Band_R":19963,
"C_Driver_Band_Y":19964,
"C_Shadow_Handicraft":19965,
"C_Minstrel_Song_Hat":19966,
"C_Midas_Whisper":19967,
"C_Magic_Stone_Hat":19968,
"C_Blazing_Soul":19969,
"C_Wind_Whisper":19970,
"C_Dying_Swan":19971,
"C_Protect_Of_Crown":19972,
"C_Circlet_Of_Bone":19973,
"C_Camouflage_RabbitHood":19974,
"C_Boss_Beret":19975,
"C_Cat_Santa_Hat":19976,
"C_Golden_Exclamation":19977,
"C_Silver_Exclamation":19978,
"C_Golden_Question":19979,
"C_Silver_Question":19980,
"C_Santa_Beard":19981,
"C_Santa's_Hat":19982,
"C_Flower_Hairpin":19983,
"C_Winter_Hat":19984,
"C_Aura_Quartz_Crown":19985,
"C_Lunatic_Hat":19986,
"C_Blue_Fur_Hat":19987,
"C_Elder_Crown":19988,
"C_Mouton_Life":19989,
"C_Snow_Rabbit_Knit_Hat":19990,
"C_Galanthus_Guard":19991,
"C_Chilly_Breath":19992,
"C_Onigiri_In_Mouth":19993,
"C_saLUsalo_Cap":19994,
"Flower_Blossom":19995,
"Horse_King":19996,
"C_Bomb_Hat":19997,
"C_Dragon_Turtle_Hat":19998,
"C_Mouse_Hat1":19999,
"C_Mouse_Hat2":20000,
"C_Mouse_Hat3":20001,
"C_Mouse_Hat4":20002,
"C_Mouse_Hat5":20003,
"C_Big_Golden_Bell":20004,
"C_Pegasus_Wing_Ears":20005,
"C_Dark_Knight_Mask":20006,
"C_Bullock_Helm_J":20007,
"C_General_Helmet":20008,
"C_Dragon_Skull":20009,
"C_Rainbow_Wing_Ears":20010,
"C_Lightning_Speed":20011,
"C_Double_Horn_Helm":20012,
"C_Hat_Of_Cook":20013,
"Lincoln_Hat":20014,
"Lincoln_Beard":20015,
"Lobster_Hat":20016,
"C_Marionette_Doll":20017,
"Horo_Ears":20018,
"Beret_Of_Artist":20019,
"C_Zaha_Doll_Hat_J":20020,
"C_Heart_Ribbon_Band":20021,
"C_Love_Piece":20022,
"C_Red_Beret":20023,
"C_Ribbon_Orange":20024,
"C_Cow_Hat1":20025,
"C_Cow_Hat2":20026,
"C_Cow_Hat3":20027,
"C_Cow_Hat4":20028,
"C_Donut_In_Mouth_J":20029,
"C_Choco_Donut_In_Mouth":20030,
"C_Bunny_Head_Dress":20031,
"C_Firinto_Scarf":20032,
"C_Buddhist_Priest_Crown":20033,
"C_Jack_Castle_Bat":20034,
"C_Miracle_Blue_Rose":20035,
"C_Sword_Master_Crown":20036,
"C_Owlduke_Silk_Hat":20037,
"Alphonse_Helmet":20038,
"C_Butterfly_Wing_Ear_J":20039,
"C_Rose_Crown":20040,
"C_Earth_Goddess_Flower":20041,
"C_Hermose_Cap":20042,
"C_Red_Cherry_Blossom":20043,
"C_Carmen_Miranda_Hat":20044,
"C_Samambaia":20045,
"C_Decoration_bluerose":20046,
"C_Pray_Cherry_Blossom":20047,
"C_Wind_Of_The_Prairie":20048,
"C_Plaster":20049,
"C_Ph.D_Hat":20050,
"C_Stop_Post":20051,
"C_Notice_Board":20052,
"C_White_Tiger_Hat":20053,
"C_Baby_Pacifier":20054,
"C_Ghost_Bandana":20055,
"C_Bride_Corolla":20056,
"C_Feather_Bonnet":20057,
"C_Headband_Of_Power":20058,
"C_Welding_Mask":20059,
"C_Safety_Helmet":20060,
"C_Ganster_Mask":20061,
"C_Angel_Stairs":20062,
"Yellow_Brain_Hat":20063,
"Blue_Brain_Hat":20064,
"C_Hairband_Of_Grandpeco":20065,
"C_Pecopeco_Hairband":20066,
"C_Whrabbit_Hband":20067,
"C_Blrabbit_Hband":20068,
"C_Gryphon_Hairband":20069,
"C_Alpaca_Hood":20070,
"C_Worg_In_Mouth":20071,
"C_Deviruchi_Cap_":20072,
"C_Hair_Band":20073,
"C_Biretta":20074,
"C_Little_Fhat":20075,
"C_Idun_Wing_Ears":20076,
"C_Wing_Form_Spectacle":20077,
"C_White_Feather":20078,
"C_Love_Daddy_2013":20079,
"C_Shaman's_Hair_Orna":20080,
"MetalDragon_Helm":20081,
"MetalDragon_Hat":20082,
"Mythlit_Hat":20083,
"C_Clover_Coronet":20084,
"C_Clover_Silkhat":20085,
"C_DragonCintamani_Hat1":20086,
"C_DragonCintamani_Hat2":20087,
"C_DragonCintamani_Hat3":20088,
"C_DragonCintamani_Hat4":20089,
"C_Egg_Shell":20090,
"C_Smoking_Pipe":20091,
"C_Sales_Signboard":20092,
"C_Star_Sparkling":20093,
"C_Fillet_Green":20094,
"C_Fillet_Red":20095,
"C_Fillet_Blue":20096,
"C_Fillet_White":20097,
"C_Vampire_Hairband":20098,
"C_Ljosalfar":20099,
"C_Volume_Fhat":20100,
"C_Bragi_Wing_Ears":20101,
"C_Horse_King":20102,
"C_Drooping_Panda":20103,
"C_Picky_Egg_Shell":20104,
"C_Fish_Head_Hat":20105,
"C_Classic_Hat":20106,
"C_Fish_In_Mouth":20107,
"C_Blind_Glasses":20108,
"C_Jolly_Roger":20109,
"C_Coiledup_Snake_Hat1":20110,
"C_Coiledup_Snake_Hat2":20111,
"C_Aqua_Ten_Gallon_Hat":20112,
"C_Star_Reading_Hat":20113,
"C_Funeral_Costume":20114,
"C_Under_Rim_Glasses":20115,
"C_Mermaid_Headphone":20116,
"C_Raspberry_Mousse_Hat":20117,
"C_Hat_Of_Cake":20118,
"C_Fur_Hat":20119,
"C_Antenna":20120,
"C_Lotus_Flower_Hat":20121,
"Happy_Summer_Ribbon":20122,
"C_Eagle_Eyes":20123,
"C_Masquerade":20124,
"C_Mini_Glasses":20125,
"C_Thanatos_Mal_Mask":20126,
"C_Helm_Of_Abyss":20127,
"C_Remover_Hat":20128,
"C_Poporing_Cap":20129,
"C_Whisper_Tall_Hat":20130,
"C_C_Tower_Manager_Incom":20131,
"C_Subject_Aura":20132,
"C_Poring_Mascot_Costume":20133,
"C_Helm_Of_Abyss_White":20134,
"C12th_Crown":20135,
"C12th_ElvenEars":20136,
"C_Bomb_Wick":20137,
"C_Sea_Otter_Cap":20138,
"C_Horse_Hairpin1":20139,
"C_Horse_Hairpin2":20140,
"C_Observer":20141,
"C_Machoman_Glasses":20142,
"C_Candy_Cane_In_Mouth":20143,
"C_Ancient_Elven_Ear":20144,
"C_Robo_Eye":20145,
"C_Angel_Spirit":20146,
"C_Bell_Pigeon":20147,
"C_Noble_Hat":20148,
"C_Hexagon_Spectacles":20149,
"C_GodOfWinds_Fan":20150,
"C_Poison_Spore_Hat":20151,
"C_Straw_Rice_Bag":20152,
"C_Monochrome_Cap":20153,
"C_Maple_Which_Falls":20154,
"C_Ladys_Feather_Hat":20155,
"C_Fan_In_Mouth":20156,
"C_Fish_On_Head":20157,
"C_Circlet":20158,
"C_Blue_Hair_Band":20159,
"C_Fried_Egg":20160,
"C_Prontera_Army_Cap":20161,
"C_Lamb_Hat1":20162,
"C_Lamb_Hat2":20163,
"C_Duneyrr_Helm":20164,
"C_Tendrilion_Hat":20165,
"C_Hockey_Mask":20166,
"C_Devi_Headphone":20167,
"C_Skull_Jhood":20168,
"C_Long_Tongue":20169,
"C_Gray_Deviruchi_Cap":20170,
"C_Sepia_Cap":20171,
"C_Pumpkin_Head":20172,
"C_Lude_Hood":20173,
"C_Halloween_Hat_Orange":20174,
"C_Diabolic_Headphone":20175,
"Happy_Pierrot_Mask":20176,
"C_Drooping_Dorasuke":20177,
"C_Puppy_Love":20178,
"C_Monkey_On_Fur_Hat":20179,
"C_Westren_Grace":20180,
"C_Mistic_Rose":20181,
"C_Mottled_Egg_Shell":20182,
"C_There_Is_Something":20183,
"C_Party_Hat":20184,
"C_Fashion_Sunglass":20185,
"C_Magni_Cap":20186,
"C_Fricca_Circlet":20187,
"C_Morpheus_Hood":20188,
"C_Goibne_Helmet":20189,
"C_Chicken_Hat":20190,
"C_Black_Cat_Ears_Beret":20191,
"C_Green_Foxtail":20192,
"C_Foxtail":20193,
"C_Lion_Mask":20194,
"C_Scratching_Cat":20195,
"C_Leopard_Ear_Hat":20196,
"C_Amistr_Beret":20197,
"C_Misty_Ears":20198,
"C_Evil_Marcher_Hat":20199,
"C_Rabbit_Head_Dress":20200,
"C_Banshee_Master_Kiss":20201,
"C_Deviruchi_Balloon":20202,
"C_Bandana":20203,
"C_Hunting_Cap":20204,
"C_Fancy_Flower":20205,
"C_Cock_Hat1":20206,
"C_Stripe_Band":20207,
"C_Necktie":20208,
"C_Mermaid_Longing":20209,
"C_Cock_Hat2":20210,
"C_Cock_Hat3":20211,
"C_Loki_Nidhogg_Hat":20212,
"C_Sirt_Evil_Eye":20213,
"C_Evil_Marcher_Hat_J":20214,
"C_Black_Devil_Mask":20215,
"C_Rideword_Hat":20216,
"C_Arabian_Veil":20217,
"C_Spell_Circuit":20218,
"C_Angel_Marcher_Hat":20219,
"C_Dark_Night_Veil":20220,
"C_Eyes_Of_Ifrit":20221,
"C_Santa_Hat_2":20222,
"C_Centimental_Leaf":20223,
"C_Red_Tailed_Ribbon":20224,
"C_Pumpkin_Hat":20225,
"C_Hair_Brush":20226,
"C_Puppy_Hat2":20227,
"C_Pig_Moneybox2":20228,
"C_New_Year_Hairpin":20229,
"C_Mask_Of_Bankrupt":20230,
"C_Snowman_Hat":20231,
"C_Celines_Ribbon":20232,
"C_Gold_Angel_Sculpture":20233,
"C_Baphomet_Hat":20234,
"C_Frozen_Land_Rose":20235,
"C_Hellomother_Hat":20236,
"C_Pink_Fur_Hat":20237,
"C_Blue_Drooping_Kitty":20238,
"C_Large_Ribbon_Muffler":20239,
"C_Gift_Of_Snow":20240,
"C_Eclipse_Hat":20241,
"C_Snownow_Hat":20242,
"C_Choco_Mint_Bonnet":20243,
"C_Zherlthsh_Mask":20244,
"C_Cat_Foot_Hairpin":20245,
"C_Time_Accessory":20246,
"C_Blackhand_Of_Fate":20247,
"C_Black_Strong_Hair":20248,
"C_Red_Strong_Hair":20249,
"C_White_Strong_Hair":20250,
"C_Rose_Cascade":20251,
"C_Accessory_of_Ascetic":20252,
"C_Droopy_Alice_Doll":20253,
"C_Ribbon_Yellow":20254,
"C_Love_Cheek":20255,
"C_Honey_Pancakes":20256,
"C_Black_Rabbit_Bonnet":20257,
"C_Blue_Head_Dress":20258,
"C_Pink_Clover":20259,
"C_Star_Dust":20260,
"C_Cross_Band":20261,
"C_Fox_Ears_Bell_Ribbon":20262,
"C_Hat_Of_Drowsy_Cat":20263,
"C_Blood_Sucker":20264,
"C_Bird_Nest_Hat":20265,
"C_Secret_Zipper":20266,
"C_Penguin_Cap":20267,
"C_Sleep_Eclipse_Family":20268,
"C_White_Fox_Ear_Ribbon":20269,
"C_Gryphon_Wing_Ears":20270,
"C_Sunflower":20271,
"C_Snowy_Horn":20272,
"C_Soft_Sheep_Hat":20273,
"C_White_Choco_Bear":20274,
"C_Light_Bulb_Band":20275,
"C_Mushroom_Band":20276,
"C_Balloon_Hat":20277,
"C_Man_Medal":20278,
"C_Cheering_Whistle_J":20279,
"C_Pencil_In_Mouth":20280,
"C_Preschool_Hat":20281,
"C_White_Boys_Hat":20282,
"C_Over_Protector":20283,
"C_Cherry_Blossom_Hat":20284,
"C_Blossom_Fluttering":20285,
"C_Under_Rim_Glasses_Red":20286,
"C_Man_Medal_Gold":20287,
"C_BIJOUHAT":20288,
"C_Wing_Ear_Black":20289,
"C_Evil_Druid_Hat_Black":20290,
"C_Thoth_Mask":20291,
"C_Sara_Ramen_Hat":20292,
"C_Sleepr_Hat":20293,
"C_Savage_Baby_Hat_Jp":20294,
"C_Poring_Sunglasses_J":20295,
"C_Yoyo_Hat":20296,
"C_Cactus_Hat":20297,
"C_Happy_Lunatic_Ear":20298,
"C_Face_Crusher":20299,
"C_Hill_Wind_Mask":20300,
"C_Golden_Savage_Hat":20301,
"C_Beelzebub_Crown":20302,
"C_Mandragora_Cap":20303,
"C_Smokie_Hat":20304,
"C_NettyHeart_BalloonGum":20305,
"C_Artist_Hat":20306,
"C_BeginnerMark":20307,
"C_Koneko_Hat":20308,
"C_Dip_Schmitz":20309,
"C_Cute_Parrot":20310,
"C_Magical_Booster":20311,
"C_Baron_Evil_Eye":20312,
"C_CD_In_Mouth":20313,
"C_New_Wave_Sunglass":20314,
"C_Analyze_Eye":20315,
"C_Seraph_Wing_Helm":20316,
"C_CatEars_Cyber_HeadP":20317,
"C_Charleston_Antenna":20318,
"C_Crimson_Booster":20319,
"C_Red_Bandana":20320,
"C_37_Sculpt":20321,
"C_Otter_Hat":20322,
"C_Music_Decoration_J":20323,
"C_Pigeon_Hat":20324,
"C_Little_Aquarium":20325,
"C_Sailor_Collar":20326,
"C_Marine_Cap":20327,
"C_Golden_Fish":20328,
"C_Tare_HSchool_Doll_Hat":20329,
"C_Sombrero":20330,
"C_Desert_Prince":20331,
"C_Ribbon_Of_Lady":20332,
"C_Family_Hat":20333,
"C_Joystick_Hat":20334,
"C_Teardrop":20335,
"C_Sugared_Fruit_S":20336,
"C_Mahican":20337,
"C_Rainbow_L_Octopus":20338,
"C_Flower_Summer_Hat":20339,
"C_Straight_Pony_BL":20340,
"C_Cowlick_BL":20341,
"C_Loose_Wave_Twin_BL":20342,
"C_Melon_Helmet":20343,
"C_Happy_Balloon_J":20344,
"C_Guard_Of_Neptune_":20345,
"C_Drooping_Permeter":20346,
"C_Poring_Pirate":20347,
"C_Picnic_Hat":20348,
"C_FlyingGalapago":20349,
"C_Cowlick_YL":20350,
"C_Cowlick_GN":20351,
"C_Cowlick_PP":20352,
"C_Cowlick_RD":20353,
"C_Cowlick_OM":20354,
"C_Cowlick_BU":20355,
"C_Cowlick_WH":20356,
"C_Straight_Pony_YL":20357,
"C_Straight_Pony_GN":20358,
"C_Straight_Pony_PP":20359,
"C_Straight_Pony_RD":20360,
"C_Straight_Pony_OM":20361,
"C_Straight_Pony_BU":20362,
"C_Straight_Pony_WH":20363,
"C_Loose_Wave_Twin_YL":20364,
"C_Loose_Wave_Twin_GN":20365,
"C_Loose_Wave_Twin_PP":20366,
"C_Loose_Wave_Twin_RD":20367,
"C_Loose_Wave_Twin_OM":20368,
"C_Loose_Wave_Twin_BU":20369,
"C_Loose_Wave_Twin_WH":20370,
"C_Special_Kapra_Hat":20371,
"C_Hat_Of_Girl":20372,
"C_Watermelon_Hat":20373,
"C_Mechanical_Plant_Hat":20374,
"C_Ignis_Cap":20375,
"C_Memories_Of_Lovers":20376,
"C_Flying_Helmet":20377,
"C_Sky_Helm":20378,
"C_PocketWatch_Hair_Orna":20379,
"C_Mech_Feather_Hairband":20380,
"C_Steampunk_Hat":20381,
"C_Silversniper_Doll":20382,
"C_Magicdecoy_Doll":20383,
"C_PurpleCrystal_Tiara":20384,
"C_Orc_Hero_Helm":20385,
"C_Victory_Wing_Helm":20386,
"C_Crossed_Hair_Band":20387,
"C_Ayam":20388,
"C_Censor_Bar":20389,
"C_Goblini_Mask":20390,
"C_Silent_Executer":20391,
"C_Sniper_Goggle":20392,
"C_Schmidt_Helm":20393,
"C_Pumpkin_Cock_Hat":20394,
"C_Black_Witch_Hat":20395,
"C_Woodie_Hat":20396,
"C_Jakk":20397,
"C_Niflheim_Bunny_Hat":20398,
"C_Crow_Tengu_Mask":20399,
"C_Holy_Rosario":20400,
"C_Angel_Spirit_Guides":20401,
"C_Holy_Klobuk":20402,
"C_Dolor_Hat":20403,
"C_Blessing_Of_Angels":20404,
"C_Eremes_Scarf":20405,
"C_Commandments_Of_Chain":20406,
"C_Subject_Aura_Red":20407,
"C_Bldy_Light_Dark_Crown":20408,
"C_There_Is_Something_JP":20409,
"C_Bone_Head":20410,
"C_Claris_Doll_Hat":20411,
"C_Tayelin_Doll_Hat":20412,
"C_Isabella_Brown_Ear":20413,
"C_Crown_Of_Deceit":20414,
"C_RTC_Winner_Only":20415,
"C_1Grade_Balloon":20416,
"C_2Grade_Balloon":20417,
"C_3Grade_Balloon":20418,
"C_4Grade_Balloon":20419,
"C_5Grade_Balloon":20420,
"C_6Grade_Balloon":20421,
"C_7Grade_Balloon":20422,
"C_8Grade_Balloon":20423,
"C_9Grade_Balloon":20424,
"C_10Grade_Balloon":20425,
"C_11Grade_Balloon":20426,
"C_12Grade_Balloon":20427,
"C_13Grade_Balloon":20428,
"C_Piamette_BowTie":20429,
"C_Morocc_Kid_Servant":20430,
"C_Maggi_Head_Dress":20431,
"C_Khalitzburg_KN_Helm":20432,
"C_Louise_Red_Hat":20433,
"C_Droop_Gunslinger":20434,
"C_Camellia_Hair_Pin":20435,
"C_Angeling_KnitCap":20436,
"C_Sakura_Hairband":20437,
"C_Abacus_In_Mouth":20438,
"C_Glow_Of_New_Year":20439,
"C_Tone_Of_Gold":20440,
"C_L_RibbonMuff_Red":20441,
"C_RW_Mochiring_Hat":20442,
"C_Unicorn_Helm":20443,
"C_Aniv_Star_Hat":20444,
"C_Candle":20445,
"C_Rabbit_Ear_Eggshell":20446,
"C_Small_Poring_Band":20447,
"C_Cons_Of_Water":20448,
"C_White_Black_Temp":20449,
"C_Gram_Peony":20450,
"C_Sky_Of_Memory":20451,
"C_berry_Prince_Crown":20452,
"C_Hat_Of_Bundle":20453,
"C_Headgear_Of_Queen":20454,
"C_Republic_Hat":20455,
"C_Combat_Vestige":20456,
"C_Feather_Fluttering":20457,
"C_Wild_Poring_Rider":20458,
"C_Valhalla_Idol":20459,
"C_Thornbush_Hairband":20460,
"C_93_BloodyWing":20461,
"C_Cat_Ears_Cape":20462,
"C_Two_Tone_Beret":20463,
"C_Monochrome_RibbonHat":20464,
"C_Glasses_Without_Lens":20465,
"C_Crimson_Ribbon":20466,
"C_Elemental_Crown":20467,
"C_Youinone_Mask":20468,
"C_Bogy_Horn":20469,
"C_SweetChocolate_Hat":20470,
"C_Tulip_Hairpin":20471,
"C_Helm_Of_Angel":20472,
"C_Mine_Helm":20473,
"C_Banana_Hat":20474,
"C_Bridal_Ribbon":20475,
"C_Costume01_L":20476,
"C_Costume02_L":20477,
"C_Costume03_L":20478,
"C_Costume04_L":20479,
"C_Costume05_L":20480,
"C_Mask_of_Ifrit":20481,
"C_Heaven_Cage":20482,
"C_Butterfly_Barrettes":20483,
"C_Sunflower_Hairpin":20484,
"C_Maneater_Flower_Hp":20485,
"C_Twin_Margaret":20486,
"C_Floral_Waltz":20487,
"C_Pope_Ribbon":20488,
"C_Pope_Crown":20489,
"C_Full_Bloom_Hp_Blue":20490,
"C_Laser_Of_Eagle":20491,
"C_Whistle":20492,
"C_Wing_Headphone":20493,
"C_Ufo_Poring_Hat":20494,
"C_Quati_Hat_J":20495,
"C_Black_Shiba_Inu_Hat":20496,
"C_Umbala_Spirit":20497,
"C_Elephant_Hat":20498,
"C_Cat_Ear_Hat":20499,
"T_Archangel_Wing":20500,
"C_Mechanic_Wing":20501,
"C_Devil_Wing":20502,
"C_Bag_Of_Antonio":20503,
"C_Cupid_Wing_Pink":20504,
"C_Cupid_Wing_Skyblue":20505,
"C_Invisible_Manteau":20506,
"C_Poring_Bag":20507,
"C_Poster_Girl_Hat":20508,
"C_Wings_of_Uriel":20509,
"C_SwordWing":20510,
"C_Blue_Fairy_Wing":20511,
"C_Bravery_Bag":20512,
"C_EXE_Backpack":20513,
"C_Thanatos_Sword":20514,
"C_Magic_Circle":20515,
"C_Wings_of_Michael":20516,
"C_GiantCatBag_TW":20517,
"C_Gerhard_Von_Devi_Bag":20518,
"C_Full_BloomCherry_Tree":20519,
"C_Costume07_L":20520,
"C_BlackCatBag_TW":20521,
"C_Blessings_Of_Soul":20522,
"C_2018_RTC_Cape_TW":20523,
"C_Shining_Angel_Wing":20524,
"C_Bloody_Wing":20525,
"C_BlueAngeling_Wing":20526,
"C_PinkButterfly_Wing":20527,
"C_GoldButterfly_Wing":20528,
"C_2018_RTC_Cape_ROS":20529,
"C_Wings_of_Gabriel":20530,
"C_Invisible_Manteau_TW":20531,
"C_Exploding_Wave_Sca_V":20532,
"C_PinkButterfly_Wing_T":20533,
"C_GiantCatBag_JP":20534,
"C_Digital_Space":20535,
"C_Violet_Halo":20536,
"C_Maple_Which_Falls_Rd":20537,
"C_Magic_Circle_Rainbow":20538,
"C_CherryFesRibbon_TW":20539,
"C_SnackParty_TW":20540,
"C_AngelRibbonWing_TW":20541,
"C_BlackBearBackpack_TW":20542,
"C_Halloween_Poring_Bag":20543,
"C_Gold_Shower_J":20544,
"C_Chrismas_Tree":20545,
"C_Backside_Ribbon_Bell":20546,
"C_Ghost_Effect":20547,
"C_Popping_Poring_Aura":20548,
"C_99LV_Royal_Guard_Blue":20549,
"C_99LV_Warlock_Violet":20550,
"C_99LV_Sorcerer_LBlue":20551,
"C_99LV_Ranger_Green":20552,
"C_99LV_Minstrel_Pink":20553,
"C_99LV_Archbishop_White":20554,
"C_99LV_Guill_Silver":20555,
"C_99LV_ShadowC_Black":20556,
"C_99LV_Mechanic_Gold":20557,
"C_99LV_Genetic_YGreen":20558,
"C_160LV_Rune_Red":20559,
"C_160LV_Royal_G_Blue":20560,
"C_160LV_Warlock_Violet":20561,
"C_160LV_Sorcerer_LBlue":20562,
"C_160LV_Ranger_Green":20563,
"C_160LV_Minstrel_Pink":20564,
"C_160LV_Archb_White":20565,
"C_160LV_Guill_Silver":20566,
"C_160LV_ShadowC_Black":20567,
"C_160LV_Mechanic_Gold":20568,
"C_160LV_Genetic_YGreen":20569,
"C_HeartChocoBag":20570,
"C_Valkyrie_Wing":20571,
"C_WingOfHeart":20572,
"C_VioletHalo":20573,
"C_School_Bag_RD":20574,
"C_School_Bag_BL":20575,
"C_Cat_Fork":20576,
"C_Balloon_Wing":20577,
"C_Wings_Of_Raguel":20578,
"C_Wings_Of_Raphael":20579,
"C_Heart_Wing_Backpack":20580,
"C_Soldier_Backpack":20581,
"C_T_Bear_Bag":20582,
"C_Magic_Star_TW":20583,
"C_Big_Foxtail":20584,
"C_Ru_Bear_Bag":20585,
"C_Loli_Ruri_Moon":20586,
"C_Light_Darkness_Wing":20587,
"C_Nifl_Bloom":20588,
"C_Gimmick_One_Feather":20589,
"C_Evil_Druid_Cross":20590,
"C_Bow_On_the_Back":20591,
"C_Santa_Backpack":20592,
"C_Ice_Wing":20593,
"C_Big_Ribbon_Cloak":20594,
"C_School_Bag_RD_E":20595,
"C_BlackBear_Back_TW":20596,
"C_Evil_Scythe":20597,
"C_GiantCatBag_JP_BL":20598,
"C_Sakura_Wing":20599,
"Fantastic_Aura":20600,
"C_99LV_Rune_Red":20601,
"C_Seraphim_Wing_TW":20602,
"C_P_Ulysses_Feather":20603,
"C_Blessed_Veil":20604,
"C_Leaf_Umbrella":20605,
"C_Golden_Angel_Wing":20606,
"C_Baldr_Wing_TW":20607,
"C_99LV_Star_E_MBlue":20608,
"C_160LV_Star_E_MBlue":20609,
"C_99LV_Soul_R_Gray":20610,
"C_160LV_Soul_R_Gray":20611,
"C_Ten_G_Shield_TW":20612,
"C_Wing_Of_Spider":20613,
"C_Kyel_hyre_Ulti_TW":20614,
"C_School_Bag_BU":20615,
"C_School_Bag_PU":20616,
"C_Wing_Of_Eutaxy":20617,
"C_Big_B_Rabbit":20618,
"C_Phaya_Ploeng_Suriyan":20619,
"C_Songkran_Watergun":20620,
"C_Dark_Lord_Manteau":20621,
"C_2023RTC_S_Robe1":20622,
"C_2023RTC_S_Robe2":20623,
"C_2023RTC_S_Robe3":20624,
"C_ROS2023_Cape_1":20625,
"C_ROS2023_Cape_2":20626,
"C_Pitaya_R_Bag":20627,
"C_Pitaya_B_Bag":20628,
"C_Pitaya_Y_Bag":20629,
"Egir_Manteau":20700,
"Sol_Manteau":20701,
"TE_Woe_Muffler":20702,
"TE_Woe_Manteau":20703,
"TE_Woe_Magic_Manteau":20704,
"Lumiere_Manteau":20705,
"Amistr_Bag":20706,
"Kirin_Wing":20707,
"Poison_Manteau":20708,
"Mana_Manteau":20709,
"Impr_Angel's_Warmth":20710,
"Manteau_Of_Diego":20711,
"Valkyrie_Cape":20712,
"Manteau_Of_Torrent":20713,
"Assassin_Muffler":20714,
"Earthquake_Manteau":20715,
"Esprit_Manteau":20716,
"FaceWorm_Skin":20717,
"FaceWorm_Skin_":20718,
"BF_Hood":20719,
"Manteau_Of_Storm":20720,
"Cloak_Of_Gray":20721,
"Soul_Of_Tree":20722,
"Manteau_Of_Hunter":20723,
"Love_Dad_Wings_2012":20724,
"Ribbon_Piamat":20725,
"Fire_Dragon_Coat":20726,
"Brilliant_Golden_Wings":20727,
"Water_Dragon_Coat":20728,
"Wind_Dragon_Coat":20729,
"Loyalists_Hood":20730,
"Ground_Dragon_Coat":20731,
"Supplement_Part_Con":20732,
"Upgrade_Part_Engine":20733,
"Manteau_Of_Leafwind":20734,
"Manteau_Of_Flame_Heart":20735,
"C_Kirin_Wing":20737,
"Airship_Cape":20743,
"Felock_Cape":20744,
"Manteau_Of_Mistic_Froz":20745,
"C_Rudra_Wing":20746,
"Manteau_Great_Nature":20747,
"Manteau_Of_Fallen":20748,
"Manteau_Of_Fallen_":20749,
"Rouban_Manteau":20750,
"Lian_Robe":20753,
"Egir_Manteau_K":20756,
"C_Wing_Of_Happiness":20761,
"C_GreatDevilWing":20762,
"C_Amistr_Bag":20763,
"C_Fallen_Angel_Wing":20764,
"C_Archangel_Wing":20765,
"Beam_Of_Light_Manteau":20766,
"Bravery_Bag_J":20767,
"Archangel_Wing_J":20768,
"Small_Hut_Manteau":20769,
"Limnil_Cape":20770,
"Choas_Manteau":20771,
"Grudge_Manteau":20772,
"Excelion_Wing":20773,
"Cutoff_Manteau":20774,
"Supplement_Part_Con_J":20776,
"Upgrade_Part_Engine_J":20777,
"RedLotus_Stole":20778,
"ManteauOfCracks":20779,
"Union_MHP_Manteau":20780,
"Union_FLEE_Manteau":20781,
"Union_SP_Muffler":20782,
"Hero_Cape":20783,
"Amistr_Bag_J":20784,
"Union_CRI_Muffler":20787,
"Doram_Only_Cape":20788,
"Doram_High_Cape":20789,
"Doram_Ele_Cape":20790,
"Soheon_Winged_Robe":20796,
"Etran_Shirt":20797,
"GrimReaper_Protection":20798,
"Elemental_Towel":20799,
"Enforcer_cape":20800,
"Toughen_Time_Keepr_MT":20801,
"AmistrBag_Teleport":20802,
"AmistrBag_Heal":20803,
"AmistrBag_Greed":20804,
"AmistrBag_Incagi":20805,
"AmistrBag_Magnum":20806,
"AmistrBag_Endure":20807,
"AmistrBag_Sight":20808,
"AmistrBag_Concentrate":20809,
"AmistrBag_Hiding":20811,
"Kirin_Wing_J":20812,
"Clack_Of_Servival_":20813,
"Wakwak_Manteau":20814,
"SeraphimRobe":20815,
"Yoichi_Muffler":20816,
"Diffusion_Bravery_Bag":20817,
"Cursed_Devils_Manteau":20818,
"Oxygen_Bomb_K":20819,
"Cloak_Of_Elemental":20820,
"Golden_Scarf":20821,
"Mine_Worker_Backpack":20822,
"Para_Team_Manteau100":20823,
"Para_Team_Manteau130":20824,
"Para_Team_Manteau160":20825,
"Angel_feather":20826,
"Diva_Manteau":20827,
"Mirage_Manteau":20828,
"Seraphim_Wing_J2":20830,
"Elder_Spirit":20831,
"Fallen_Angel_Wing_TH":20833,
"Manteau_Of_Vagabond":20834,
"K_Fallen_Angel_Wing":20835,
"Skin_Of_Lindwurm":20836,
"Skin_Of_Gwiber":20837,
"Muffler_IL":20838,
"Cape_Of_Ancient_Lord_IL":20840,
"Golden_Angel_Wing_TH":20841,
"Bag_Of_Antonio_Melee":20842,
"Bag_Of_Antonio_Range":20843,
"Bag_Of_Antonio_Magic":20844,
"Skin_Of_Marraco":20845,
"Temporal_Manteau":20846,
"Clack_Of_Servival_IL":20847,
"Jirant_Cloak":20852,
"Rudo_Black_Wings":20853,
"Medical_Cape":20854,
"Rental_Oxygen_Bomb":20855,
"YSF01_Manteau":20856,
"VeilCoyote":20857,
"YSF01_Manteau_J":20858,
"Phreeoni_Wing":20859,
"BattleSurcoat":20860,
"SwordWing_J":20861,
"EXE_Backpack":20862,
"MenblattWing":20863,
"Siege_Manteau_1Tier":20864,
"Siege_Muffler_1Tier":20865,
"Golden_Angel_Wing_TW":20866,
"60Lv_Hood":20867,
"70Lv_Manteau":20868,
"70Lv_Muffler":20869,
"80Lv_Manteau":20870,
"80Lv_Cloak":20871,
"80Lv_Muffler":20872,
"80Lv_Cape":20873,
"90Lv_Manteau":20874,
"90Lv_Cloak":20875,
"90Lv_Muffler":20876,
"90Lv_Cape":20877,
"Golden_Scarf_J":20900,
"True_Hunting_Manteau":20902,
"R_Hunting_Manteau":20903,
"Etran_Shirt_BR":20904,
"Astrea_Cape":20905,
"Rebeginer_Manteau":20906,
"Fairy_Cloth":20907,
"Jirant_Cloak_BR":20908,
"BattleSurcoat_BR":20909,
"Etran_Shirt_TW":20910,
"Doram_Only_Cape_J":20915,
"Doram_High_Cape_J":20916,
"Doram_Ele_Cape_J":20917,
"Angel_Poring_Wing":20918,
"Leviathan_muffler":20922,
"Goibne_Shoulder_IL":20923,
"Brave_muffler":20924,
"Commander_manteau_J":20925,
"2018_RTC_Cape4_TW":20926,
"2018_RTC_Cape1_TW":20927,
"2018_RTC_Cape2_TW":20928,
"2018_RTC_Cape3_TW":20929,
"Rainbow_Scarf_Jp":20931,
"Old_Moc_Shawl":20932,
"Illusion_Engine_A":20933,
"Illusion_Engine_B":20934,
"Lava_Leather_Manteau":20935,
"Lava_Leather_Muffler":20936,
"Lava_Leather_Hode":20937,
"Rudra_Wing":20938,
"Time_Overload_Hood":20939,
"Violet_Halo":20940,
"Phoenix_Muffler":20941,
"Manteau_Of_Guardsman":20942,
"Geffen_Magic_Muffler":20943,
"Anti_Magic_Manteau":20944,
"Regia_Hunting_Manteau":20945,
"Drag_Manteau":20946,
"Cassock_Manteau":20947,
"Morpheus_Shawl_IL":20948,
"Skin_Of_Ladon_J":20949,
"Leo_Mantle_J":20951,
"Anony_As_Muffler":20952,
"H_AD_Hood":20953,
"Cancer_Manteau_J":20954,
"Chrismas_Tree":20955,
"Skin_Of_Typhon":20962,
"Temporal_M_Str":20963,
"Temporal_M_Agi":20964,
"Temporal_M_Vit":20965,
"Temporal_M_Int":20966,
"Temporal_M_Dex":20967,
"Temporal_M_Luk":20968,
"Rainbow_Muffler_Jp":20969,
"Libra_Manteau_J":20970,
"Taurus_Manteau_J":20971,
"Aquarius_Manteau_J":20972,
"Spiritual_Cloth":20973,
"Scorpio_Manteau_J":20976,
"Pollux_Mantle_J":20983,
"Procyon_Mantle_J":20984,
"C_Gourd_bottle_J":20985,
"Scientist_Mantle":20986,
"C_Heart_Wing_Bag_J":20987,
"C_Mechanical_Butterfly":20988,
"C_Mainspring_Screw":20989,
"C_Rotating_Gears":20990,
"Fairy_Of_Eden":20991,
"C_Fairy_Of_Eden":20992,
"Avoidance_Cape":20993,
"Ancient_Megalith_Mantle":20994,
"Upg_Twohand_Sword":21000,
"Velum_Claymore":21001,
"Velum_Katzbalger":21002,
"Muramasa_":21003,
"Alca_Bringer_":21004,
"Metal_Two_Hand_Sword":21005,
"TE_Woe_Two_Hand_Sword":21006,
"Heavy_Sword":21007,
"Kogarasu_Maru":21008,
"Thanos_Great_Sword":21009,
"Tw_Sword_Of_Evil_Slayer":21010,
"Giant_Blade":21011,
"Some_Wizard_MagicSword":21012,
"Hetairoi_Sword":21013,
"D_Sword_Of_Infinite":21014,
"Scarlet_Twohand_Sword":21015,
"Sinister_Twohand_Sword":21016,
"Two_Hand_Spear_170":21018,
"Onimaru":21019,
"Toughen_Metal_TH_Sword":21023,
"Veteran_Sword_":21024,
"Diva_Claymore":21026,
"Mirage_Claymore":21027,
"Sinister_Thand_Sword_J":21028,
"Probation_TH_Sword":21030,
"Neev_Claymore":21031,
"Rebeginer_RK_T_Sword":21037,
"Oriental_Sword":21038,
"T_Sword_Of_Kingdom":21039,
"Local01_T_Sword":21041,
"Onimaru_BR":21042,
"Local02_T_Sword":21043,
"Woe_Twohand_Sword1_Z":21044,
"Variant_Claymore":21046,
"Beam_Claymore_OS":21047,
"Evt_Oriental_Sword":21049,
"Taegoolyeon_IL":21050,
"Volar":21051,
"Vernan":21052,
"FullForce":21053,
"Ein_BHSWORD":21054,
"G_Knight_Sword":21055,
"Volar_J":21056,
"Vernan_J":21057,
"Up_Dragonic_Slayer":21058,
"Solid_Claymore":21063,
"aegis_21064":21064,
"Comp_Oriental_Sword":21065,
"Comp_Dragonic_Slayer":21066,
"C_Tear_Drop":21200,
"Eat_Coin":21201,
"C_Eat_Coin":21202,
"Nut_Cracker":21205,
"C_Nut_Cracker":21206,
"C_bullhead":21207,
"C_Guardian_Lion_Mask":21300,
"aegis_21400":21400,
"Temporal_Str_Boots":22000,
"Temporal_Int_Boots":22001,
"Temporal_Agi_Boots":22002,
"Temporal_Vit_Boots":22003,
"Temporal_Dex_Boots":22004,
"Temporal_Luk_Boots":22005,
"Temporal_Str_Boots_":22006,
"Temporal_Vit_Boots_":22007,
"Temporal_Dex_Boots_":22008,
"Temporal_Int_Boots_":22009,
"Temporal_Agi_Boots_":22010,
"Temporal_Luk_Boots_":22011,
"Mana_Boots":22012,
"test_5":22013,
"Enhanced_Variant_Shoes":22014,
"Impr_Angel's_Arrival":22015,
"Assassin_Shoes":22016,
"Fisherman_Shoes":22017,
"Shoes_Of_Wise_Man":22018,
"Immuned_Boots":22019,
"GC_Battle_Boots":22020,
"RA_Battle_Boots":22021,
"LG_Battle_Boots":22022,
"RK_Battle_Boots":22023,
"NC_Battle_Boots":22024,
"SC_Battle_Boots":22025,
"SR_Battle_Boots":22026,
"AB_Battle_Boots":22027,
"WL_Battle_Boots":22028,
"WA_Battle_Boots":22029,
"GN_Battle_Boots":22030,
"Aurelian_Shoes":22031,
"Shoes_Of_Exorcism":22032,
"Boots_Of_Gray":22033,
"Scarlet_Gaites":22034,
"Vet_Nepen_Heel":22035,
"Vet_SliverFox_Boots":22036,
"Vet_Ungo_Boots":22037,
"Shoes_Of_Hope":22038,
"Talaria_Shoes":22042,
"Supplement_Part_Agi":22043,
"Upgrade_Part_Booster":22044,
"Beach_Sandals":22045,
"Airship_Boots":22046,
"Felock_Boots":22047,
"Sombre_Shoes":22048,
"Sol_Shoes":22049,
"Gardener_Shoes":22050,
"Ramor_Shoes":22051,
"Gravekeepr_Shoes":22052,
"Sharel_Shoes":22055,
"Fallen_Angel_Shoes":22056,
"Flow_Shoes":22057,
"DragonTrainer_Shoes":22058,
"Egir_Shoes_K":22059,
"Boots_Of_Hunter":22060,
"Lumiere_Shoes":22061,
"Mechanic_Shoes":22062,
"Rouban_Shoes":22063,
"Thorny_Shoes":22064,
"Poison_Shoes":22065,
"Esprit_Shoes":22066,
"Witch_Shoes":22067,
"Santa's_Shoes":22068,
"Lian_Shoes":22069,
"Applause_Sandal":22070,
"Applause_Sandal_":22071,
"Hikingboots":22072,
"Supplement_Part_Agi_J":22073,
"Upgrade_Part_Booster_J":22074,
"Shoes_Of_Cracks":22075,
"Hardwood_Slipper":22076,
"Red_Eco_Boots":22077,
"Union_STR_Boots":22078,
"Union_AGI_Boots":22079,
"Union_DEX_Shoes":22080,
"Union_INT_Shoes":22081,
"Polyhedron_Shoes":22082,
"Doram_Only_Shoes":22083,
"Doram_High_Shoes":22084,
"Doram_Ele_Shoes":22085,
"Scarlet_Gaites_":22089,
"Fisherman_Shoes_":22091,
"Aurelian_Shoes_":22092,
"Shoes_Of_Exorcism_":22093,
"Gardener_Shoes_":22094,
"Gravekeepr_Shoes_":22095,
"Fallen_Angel_Shoes_":22096,
"DragonTrainer_Shoes_":22097,
"Boots_Of_Hunter_":22098,
"Mechanic_Shoes_":22099,
"Medical_Boots_":22100,
"AngelPoring_Boots":22101,
"Toughen_Time_Keepr_Bts":22102,
"Excelion_Leg":22103,
"Pororoca_Shoes":22104,
"Cuffs_":22105,
"Giant_Boots":22106,
"Modify_Str_Boots":22107,
"Modify_Int_Boots":22108,
"Modify_Agi_Boots":22109,
"Modify_Vit_Boots":22110,
"Modify_Dex_Boots":22111,
"Modify_Luk_Boots":22112,
"Modify_Str_Boots_":22113,
"Modify_Int_Boots_":22114,
"Modify_Agi_Boots_":22115,
"Modify_Vit_Boots_":22116,
"Modify_Dex_Boots_":22117,
"Modify_Luk_Boots_":22118,
"Cursed_Devils_Boots":22119,
"Shoes_Of_Punishment":22120,
"Para_Team_Boots100":22122,
"Para_Team_Boots115":22123,
"Para_Team_Boots130":22124,
"Para_Team_Boots145":22125,
"Para_Team_Boots160":22126,
"Diva_Shoes":22127,
"Mirage_Shoes":22128,
"ShoesOfHero":22129,
"Cowboy_Boots":22131,
"Nergal_Shoes":22132,
"Shoes_IL":22133,
"Enforcer_Shoes":22134,
"Demonist_Shoes":22138,
"2017RTCShoes":22139,
"Elvira_Boots":22140,
"YSF01_Greave":22141,
"ShoesOfGuardsman":22142,
"YSF01_Greave_J":22143,
"IA_Boots":22144,
"TenguShoes":22145,
"Siege_Shoes_1Tier":22146,
"Siege_Boots_1Tier":22147,
"Siege_Greave_1Tier":22148,
"Thorny_Shoes_BR":22149,
"60Lv_Sandal":22150,
"70Lv_Boots":22151,
"70Lv_Shoes":22152,
"80Lv_Greave":22153,
"80Lv_Boots":22154,
"80Lv_Shoes":22155,
"80Lv_Sandal":22156,
"90Lv_Greave":22157,
"90Lv_Boots":22158,
"90Lv_Shoes":22159,
"90Lv_Sandal":22160,
"Astraea_Shoes":22167,
"True_Hunting_Boots":22168,
"R_Hunting_Boots":22169,
"Shoes_Of_Servival":22170,
"Ancient_Hero_Boots":22171,
"Gray_Wing_Boots":22172,
"Rebeginer_Boots":22173,
"Scaraba_High_Heels":22174,
"Anony_Sm_Shoes":22178,
"Shoes_Of_Punishment_BR":22182,
"Doram_Only_Shoes_J":22185,
"Doram_High_Shoes_J":22186,
"Doram_Ele_Shoes_J":22187,
"Shoes_Of_Pilgrim":22189,
"Boots_IL":22190,
"Nergal_Shoes_TW":22191,
"Goibne_Boots_IL":22192,
"Brave_shoes":22193,
"Loli_Ruri_Shoes":22194,
"Booster_shoes":22195,
"Illusion_Leg_A":22196,
"Illusion_Leg_B":22197,
"Traveler_Shoes":22198,
"Lava_Leather_Boots":22199,
"Lava_Leather_Shoes":22200,
"Lava_Leather_Sandle":22201,
"Temporal_Boots_TW":22202,
"Space_shoes_JP":22203,
"Time_Overload_Boots":22204,
"Regia_Hunting_Boots":22206,
"Imperial_Boots":22207,
"Dragon_Boots":22208,
"Cassock_Boots":22209,
"Fluffy_FishShoes_J":22210,
"BuddhistShoes":22211,
"Hollow_Shoes":22212,
"Leo_Shoes_J":22213,
"Authority_Sandals":22214,
"H_AD_Sandle":22215,
"Cancer_Shoes_J":22216,
"Demonist_Shoes_":22221,
"Agenda_Shoes_TW":22222,
"Shoes_Of_Punishment_":22225,
"Libra_Shoes_J":22227,
"Triad_God_Shoes_J_":22228,
"Taurus_Shoes_J":22230,
"Aquarius_Shoes_J":22231,
"Scorpio_Shoes_J":22233,
"FrontiaBoots":22234,
"Great_Hero_Boots":22238,
"Fierce_Physique_Boots":22240,
"Fierce_Magique_Boots":22241,
"Procyon_Shoes_J":22242,
"Mamaragan":22243,
"Chic_Silent_Shoes":22244,
"Space_shoes_JP_":22245,
"Insidious_Shoes_EXE":22249,
"aegis_22257":22257,
"Comp_Temporal_Boots_TW":22258,
"aegis_22259":22259,
"ShabbyOldScroll":22507,
"Para_Team_Mark_":22508,
"WolfKing_Scroll":22510,
"Fenrir_Card__":22511,
"Kings_Gift":22513,
"Candy_Holder":22514,
"Key_Of_Twisted_Time":22515,
"Dark_Red_Clot":22516,
"Loki_Summon_Scroll":22517,
"Idn_Wisdom_Egg":22518,
"Pc_Stop":22519,
"Pc_Stop_Cancel":22520,
"80LVUP":22521,
"100LVUP":22522,
"120LVUP":22523,
"130LVUP":22524,
"140LVUP":22525,
"150LVUP":22526,
"160LVUP":22527,
"Pet_Ticket_Box":22528,
"Shadow_Mix_Recipe":22529,
"Christmas_Box":22530,
"Special_Christmas_Box":22531,
"Santa_Gift":22532,
"New_Year_Gift_Box":22533,
"Closedmind_Box":22534,
"WorkerScroll_A":22535,
"WorkerScroll_B":22536,
"PrizeOfHero":22537,
"Hanbok_bag":22538,
"Made_Dish_Box2":22539,
"Runstone_Lux":22540,
"PCBang_Coupon_Box6":22541,
"Center_Potion_B":22542,
"Berserk_Potion_B":22543,
"Awakening_Potion_B":22544,
"Speed_Up_Potion_B":22545,
"Slow_Down_Potion_B":22546,
"Anodyne_B":22547,
"Water_Of_Darkness_B":22548,
"Poison_Bottle_B":22549,
"Cookie_Bag_B":22550,
"Sesame_Pastry_B":22551,
"Honey_Pastry_B":22552,
"Rainbow_Cake_B":22553,
"First_Aid_Kit_B":22554,
"HQ_Chocolate":22555,
"LuxuryChocolate":22556,
"ArtisanChocolate":22557,
"Lucky_Bag":22558,
"Mock_Strawberry":22559,
"Lucky_Bag_Of_New_Era":22563,
"Frost_Crystal":22566,
"Squad_Prize":22567,
"Nyd_Summon_Scroll":22568,
"Kings_Gift2":22569,
"Easter_Egg":22571,
"Savage_Ora":22589,
"Grand_Peco_Ora":22590,
"Dest_Wolf_Ora":22591,
"Happy_Call_Box":22592,
"Gingerbread2":22605,
"Beginning_Box":22610,
"Packing_Envelope":22611,
"Decomposition_Potion":22612,
"Polluted_Potion":22613,
"Premium_Manual":22614,
"ClearBox_S":22617,
"ClearBox_A":22618,
"Ghost_Summon_Scroll":22619,
"Memorial_Box":22620,
"Squid_Bbq":22621,
"Beginning_Box2":22623,
"Riesen_Bretzel":22624,
"Oktoberfest_Bag":22625,
"JanuaryGiftBox_":22626,
"FebruaryGiftBox_":22627,
"Green_Package":22628,
"Green_Package40":22629,
"Green_Package80":22630,
"Green_Package99":22631,
"17173_Green_Package":22640,
"17173_Green_Package40":22641,
"17173_Green_Package80":22642,
"17173_Green_Package99":22643,
"S_Green_Package":22644,
"S_Green_Package40":22645,
"S_Green_Package80":22646,
"S_Green_Package99":22647,
"Angeling_Package":22648,
"Deviling_Package":22649,
"Brilliant_Hat_Box":22652,
"Wet_CardAlbum":22653,
"Golden_Card":22654,
"Honey_Rice_Cake_":22657,
"BraisedShortRibs":22658,
"BraisedSpareribs":22659,
"Sealed_Letter":22660,
"Guyak_Pudding_20_Box":22668,
"HALLOWEEN_G_BOX":22669,
"DARK_INVITATION":22670,
"MarchGiftBox_":22671,
"AprilGiftBox_":22672,
"MayGiftBox_":22673,
"JuneGiftBox_":22674,
"Mystery_Scroll":22675,
"HangulDay_Box":22676,
"Chest_Of_Death":22679,
"Solo_Christmas_Gift":22685,
"Solo_Cookie":22686,
"Pieces_Of_Sentiment":22687,
"Piece_Of_Record1":22691,
"Piece_Of_Record2":22692,
"Piece_Of_Record3":22693,
"Piece_Of_Record4":22694,
"Piece_Of_Record5":22695,
"Test_Reagent":22699,
"Jumping_Kit_Box":22700,
"Pegasus_Cotton_Candy":22701,
"Minus_Str":22702,
"Minus_Agi":22703,
"Minus_Vit":22704,
"Minus_Int":22705,
"Minus_Dex":22706,
"Minus_Luk":22707,
"Pitapat_Box":22708,
"Ball_Wanderer":22717,
"Ball_Rude":22718,
"Ball_Tatacho":22719,
"Ball_Novus":22720,
"Question_Box":22721,
"QuizRevol_Box":22734,
"Sealed_M_Flower_Scroll":22735,
"JulyGiftBox_":22736,
"Bullet_Case_Blood_":22737,
"Bullet_Case_Silver_":22738,
"Sphere_Case_Wind_":22739,
"Sphere_Case_Darkness_":22740,
"Sphere_Case_Poison_":22741,
"Sphere_Case_Water_":22742,
"Sphere_Case_Fire_":22743,
"Bullet_Case_AP":22744,
"Bullet_Case_Blaze":22745,
"Bullet_Case_Fleeze":22746,
"Bullet_Case_Electric":22747,
"Bullet_Case_Stone":22748,
"Sanctified_Bullet_Case":22749,
"Trans_Scroll_Sca":22750,
"Trans_Scroll_Wander":22751,
"Trans_Scroll_Gazeti":22752,
"Trans_Scroll_Karcher":22753,
"Trans_Scroll_Necro":22754,
"Trans_Scroll_Wghost":22755,
"AugustGiftBox_":22756,
"Matk_Trans_Scroll":22757,
"Ratk_Trans_Scroll":22758,
"Aspd_Trans_Scroll":22759,
"Argiope_CaptureBox":22760,
"LuciolaVespa_CaptureBox":22761,
"Centipede_CaptureBox":22762,
"PetTradeTicket_Box":22764,
"Shark_Skewered":22770,
"Tuna_Skewered":22771,
"Snapper_Skwered":22772,
"Piranha_Skewered":22773,
"Salmon_Skewered":22774,
"Eel_Skewered":22775,
"Carp_Skewered":22776,
"BuffGiftBox":22777,
"PC_NomalBox":22781,
"PC_WoodenBox":22782,
"PC_GoldenBox":22783,
"PC_PlatinumBox":22784,
"Guarantee6_Box":22802,
"NoviceBox":22808,
"Sealed_Dracula_Scroll":22812,
"Bearers_Shadow_Box":22813,
"CatPaw_Ticket":22814,
"G_Mysterious_Water":22816,
"G_Small_Life_Potion":22817,
"G_Med_Life_Potion":22818,
"G_Almighty":22819,
"G_ASPD_Potion":22820,
"G_Red_Booster":22821,
"SW_Wear2014":22822,
"Sealed_B_Shecil_Scroll":22823,
"Costume_Set1_Kr":22825,
"Enchant_Stone_Box4":22826,
"Shadow_Cube":22827,
"Sealed_Scroll":22828,
"Sealed_Card":22829,
"Essence_Of_Time":22837,
"Something_Candy_Holder":22838,
"Happy_Box_J":22839,
"Pumpkin_Candy":22841,
"Sealed_Dracula_Scroll2":22842,
"superstar_cake":22843,
"Sealed_Dracula_Album":22844,
"Sealed_Mysterious_Egg":22845,
"Sealed_Dracula_Card_":22846,
"BadgeOfProntera":22847,
"KeysPrison":22848,
"P_Temporal_Crystal":22849,
"JanuaryGiftBox":22850,
"FebruaryGiftBox":22851,
"MarchGiftBox":22852,
"AprilGiftBox":22853,
"MayGiftBox":22854,
"JuneGiftBox":22855,
"JulyGiftBox":22856,
"AugustGiftBox":22857,
"SeptemberGiftBox":22858,
"OctoberGiftBox":22859,
"NovemberGiftBox":22860,
"DecemberGiftBox":22861,
"Enchant_Stone_Box5":22868,
"LuckyRouletteTickets":22869,
"Xmas_Package_14":22870,
"Sealed_Berz_Scroll2":22873,
"Sealed_Berz_Album":22874,
"Sealed_Berz_Card_":22875,
"Shabby_Purse":22876,
"Binding_Rope":22881,
"Choco_Tteokguk":22882,
"SeptemberGiftBox_":22883,
"OctoberGiftBox_":22884,
"NovemberGiftBox_":22885,
"DecemberGiftBox_":22886,
"2015GoldPCBox":22887,
"2015_New_Year_Scroll":22888,
"New_Year_Shadow_Cube":22893,
"2015LI_Neuralizer":22894,
"2015LI_R_S_C":22895,
"2015LI_R_S_C_":22896,
"DowntownMap":22899,
"BlueboxOfQuestions":22901,
"Sealed_Scroll2":22902,
"Enchant_Stone_Box6":22905,
"Sealed_Scroll3":22906,
"Service30_M_01_Call":22907,
"Service30_F_01_Call":22908,
"Weapon_5Up_Box":22909,
"Weapon_6Up_Box":22910,
"Weapon_7Up_Box":22911,
"Weapon_8Up_Box":22912,
"Weapon_9Up_Box":22913,
"Bubble_Gum_24h":22914,
"Weapon_11Up_Box":22915,
"Weapon_12Up_Box":22916,
"Weapon_13Up_Box":22917,
"Weapon_14Up_Box":22918,
"Weapon_15Up_Box":22919,
"Weapon_16Up_Box":22920,
"Weapon_17Up_Box":22921,
"Weapon_18Up_Box":22922,
"Weapon_19Up_Box":22923,
"Armor_5Up_Box":22924,
"Armor_6Up_Box":22925,
"Armor_7Up_Box":22926,
"Armor_8Up_Box":22927,
"Armor_9Up_Box":22928,
"Job_Manual25_24h":22929,
"Armor_11Up_Box":22930,
"Armor_12Up_Box":22931,
"Armor_13Up_Box":22932,
"Armor_14Up_Box":22933,
"Armor_15Up_Box":22934,
"Armor_16Up_Box":22935,
"Armor_17Up_Box":22936,
"Armor_18Up_Box":22937,
"Armor_19Up_Box":22938,
"Armor_10Up_Box":22943,
"Weapon_10Up_Box":22944,
"Cherry_Blossom_Cake":22945,
"Status_Decrease_Scroll":22946,
"Minus_Str_Box":22947,
"Minus_Agi_Box":22948,
"Minus_Vit_Box":22949,
"Minus_Int_Box":22950,
"Minus_Dex_Box":22951,
"Minus_Luk_Box":22952,
"Enchant_Stone_Box7":22953,
"Mad_Bunny_Scroll":22971,
"Sealed_Hat_Box":22972,
"Shadow_Cube_Weapon":22973,
"Shadow_Cube_Armor":22974,
"Shadow_Cube_Shield":22975,
"Shadow_Cube_Shoes":22976,
"Shadow_Cube_Pendant":22977,
"Shadow_Cube_Earing":22978,
"Comp_Battle_Bubble":22979,
"InfinityD_ReturnScroll":22980,
"Service30P_M_01_Call":22982,
"Service30P_F_01_Call":22983,
"Dr_Life_Potion_01":22984,
"Dr_Life_Potion_02":22985,
"Sealed_Hat_Box2":22988,
"Improved_NomalBox":22989,
"Soccer_Cake":22991,
"Comp_Neuralizer":22996,
"C_Greed_Scroll":22997,
"C_CatPaw_Ticket":22998,
"Comp_Trans_Scroll":22999,
"Enchant_Stone_Box8":23001,
"Improved_WoodenBox":23007,
"AID_Bubble_Gum_24h":23008,
"AID_Manual_24h":23010,
"AID_Insurance_24h":23011,
"Comp_Small_Mana_Potion":23012,
"Improved_GoldenBox":23013,
"Improved_PlatinumBox":23014,
"Red_Slim_Pot_Box":23015,
"Pieces_Of_Grudge":23016,
"13thCelebrateBox":23021,
"CrossEventBox":23022,
"C_Giant_Fly_Wing":23023,
"Piamette_Scroll":23024,
"Pope_Merc_Scroll":23025,
"CasualPope_Merc_Scroll":23026,
"Dandelion_Ring":23027,
"Capture_Rope":23028,
"Cowlick_Box":23029,
"Straight_Pony_Box":23030,
"Loose_Wave_Twin_Box":23031,
"Minus_Status_Box":23032,
"Invisible_Box":23033,
"Invisible_Scroll":23034,
"Pope_Merc_Scroll2":23036,
"CasualPope_Merc_Scroll2":23037,
"White_Slim_Potion_Box_":23038,
"Mastela_Fruit_Box_":23039,
"White_Potion_Box_":23040,
"Royal_Jelly_Box2_":23041,
"Seed_Of_Yggdrasil_":23042,
"Yggdrasil_Seed_Box_":23043,
"Elvira_Candy":23044,
"Mont_Blanc_Cake":23045,
"Comp_Mystic_Powder":23046,
"Comp_Tyr's_Blessing":23047,
"Comp_Regenerate_Potion":23048,
"Comp_Spark_Candy":23049,
"Comp_Magic_Candy":23050,
"New_Hat_Scroll":23051,
"New_Hat_Box":23052,
"Enchant_Stone_Box9":23058,
"Face_Paint_Box":23059,
"Surface_Paint_Box":23060,
"Incisive_Arrow_Cntr":23061,
"CokingOpenBox":23062,
"Freeze_Dream":23063,
"2015_Special_Scroll":23069,
"2015_Special_Box":23070,
"2015_Angel_Scroll":23072,
"AngelPoring_Box":23073,
"DecemberGiftBox_2016":23074,
"NovemberGiftBox_2016":23075,
"Build_Up_Potion_SS":23076,
"Build_Up_Potion_SC":23077,
"Build_Up_Potion_AC":23078,
"Strawberry_CreamCake":23079,
"Crystal_Of_Grudge":23080,
"Kunai_Scroll_Of_Flame":23081,
"Kunai_Scroll_Of_Icicle":23082,
"Kunai_Scroll_Of_Wind":23083,
"Kunai_Scroll_Of_Soil":23084,
"Kunai_Scroll_Of_Poison":23085,
"Enchant_Stone_Box10":23086,
"Small_Leather_Bag":23087,
"Comp_Glass_Of_Illusion":23094,
"Poring_Scroll":23095,
"MOBI_Support_Box":23096,
"Time_Guardian_Box2":23097,
"Assorted_ShdowBox":23098,
"Gunslinger_Enchant":23100,
"Amistr_Scroll":23106,
"Amistr_Box":23107,
"Class_Shadow_Cube":23115,
"Shadow_Scroll":23116,
"Spirit_Scroll":23119,
"Sealed_Hat_Box3":23120,
"Bullet_Case_Flare":23123,
"Bullet_Case_Lighting":23124,
"Bullet_Case_Ice":23125,
"Bullet_Case_Poison":23126,
"Bullet_Case_Blind":23127,
"Cachua_Weapon":23128,
"Cachua_Robe":23129,
"Cachua_Mail":23130,
"Cachua_Shoes":23131,
"Cachua_Shield":23132,
"Cachua_Helm":23133,
"Balloon_Scroll":23134,
"Poring_Balloon_Box":23135,
"WOB_Box":23136,
"Ribel_Jumping_Box":23137,
"EXPUP_Potion1":23142,
"JEXPUP_Potion1":23143,
"EXPUP_Potion1Box":23144,
"JEXPUP_Potion1Box":23145,
"Premium_Box_2d":23148,
"Premium_Box_3d":23149,
"Lapine_DdukddakBox":23150,
"EnchantStone_Recipe":23151,
"EventItem_Recipe":23152,
"PetEgg_Recipe":23153,
"Nyang_Costume_Recipe":23154,
"Poison_Pack2":23159,
"Shadow_Cube_Sak":23160,
"Gunslinger_Box":23161,
"Gunslinger_Scroll":23162,
"Service30_AID_Buff":23165,
"Green_Scroll_K":23167,
"Mini_Fan_Box":23168,
"Alchemist_Box":23169,
"Fan_Upgrade_Kit":23170,
"Sealed_Gloom_Card_":23171,
"Sealed_Pharaoh_Card_":23172,
"Sealed_Kiel_Card_":23173,
"Enchant_Stone_Box11":23174,
"Suit_Upgrade_Kit":23175,
"Kafra_Scroll":23176,
"Comp_Kafra_Card":23177,
"Kafra_Box":23178,
"Sap_Jelly":23187,
"Airship_Part":23188,
"Little_Dall_Needle":23189,
"Varetyr_5_Scroll":23191,
"DiamondDust5_Scroll":23192,
"CrimsonRock_5_Scroll":23193,
"Sienna_5_Scroll":23194,
"Sigrun_Scroll":23195,
"Agust_Lucky_Scroll":23196,
"PremiumWoodenBox":23198,
"PremiumGoldenBox":23199,
"PremiumPlatinumBox":23200,
"PremiumNomalBox":23201,
"Vin_Chaud":23202,
"Small_Mana_Potion":23203,
"M_DEFScroll":23204,
"New_Hat_Scroll2":23205,
"New_Hat_Box2":23206,
"Premium_Box":23207,
"Premium_Box_1d":23209,
"Premium_Box_4d":23210,
"Premium_Box_5d":23211,
"Premium_Box_6d":23212,
"Premium_Box_5d7":23213,
"Premium_Box_8d":23214,
"Premium_Box_9d":23215,
"Premium_Box_10d":23216,
"2016_Special_Scroll":23217,
"2016_Special_Box":23218,
"EF_DEX_Biscuit_Stick":23221,
"EF_LUK_Biscuit_Stick":23222,
"EF_STR_Biscuit_Stick":23223,
"EF_VIT_Biscuit_Stick":23224,
"EF_AGI_Biscuit_Stick":23225,
"EF_INT_Biscuit_Stick":23226,
"Biscuit_Stick_2Set":23227,
"HazyMooncake":23228,
"FallenAngelWing_Reset":23229,
"Racing_Exchange":23234,
"Candlelight_Scroll":23235,
"JobShadow_Mix_Weapon":23236,
"JobShadow_Mix_Armor":23237,
"JobShadow_Mix_Shoes":23238,
"JobShadow_Mix_Shield":23239,
"JobShadow_Mix_Pendant":23240,
"JobShadow_Mix_Earing":23241,
"Fried_Chicken":23242,
"Fried_Chicken_1":23243,
"Lapine_Scroll":23245,
"LI_Lapine_DdukddakBox":23246,
"StatusShadow_Mix":23247,
"GemstoneShadow_Mix":23248,
"BearersShadow_Mix":23249,
"ComposeShadow_Mix":23250,
"Rose_Bundle_A":23251,
"Orleans_Bundle_A":23252,
"Black_Shiba_Bundle_A":23253,
"Valkyrie_Bundle_A":23254,
"Kardui_Bundle_A":23255,
"Elixir_Bandage":23256,
"Dew_Of_Old_Tree":23257,
"Foul_Rotten_Meat":23258,
"St_Cupcake":23259,
"Parfait":23260,
"Macaron":23261,
"Hair_Bun_Box":23262,
"Roll_Twin_Box":23263,
"Long_Pony_Box":23264,
"Sprint_Bundle_A":23265,
"Etran_Bundle_A":23266,
"1LVUP":23267,
"10LVUP":23268,
"20LVUP":23269,
"30LVUP":23270,
"40LVUP":23271,
"50LVUP":23272,
"60LVUP":23273,
"70LVUP":23274,
"90LVUP":23275,
"175LVUP":23276,
"Mado_Box":23277,
"HelpmeShorty":23278,
"N_Fly_Wing2":23280,
"RaceShadow_Mix":23281,
"Biscuit_Stick_2Set_":23282,
"Love_Scroll":23283,
"Advanced_Taiming_Item":23284,
"Candy_Box_Melee":23285,
"Candy_Box_Range":23286,
"Candy_Box_Magic":23287,
"Cps_Fly_Wing":23288,
"Candy_Bag_Scroll_Melee":23289,
"Candy_Bag_Scroll_Range":23290,
"Candy_Bag_Scroll_Magic":23291,
"Pororoca_Shoes_Bundle_A":23294,
"Lian_Bundle_B":23295,
"D_Buger":23296,
"Lovely_Egg_Box":23297,
"Enchant_Stone_Box12":23299,
"PoringsPreciousBox":23302,
"C_CatPaw_1Day_Para":23303,
"C_Wing_Of_Fly_1Day_Para":23304,
"Cat_Scroll":23305,
"Comp_M_DEFScroll":23307,
"Booster_Amplifier":23308,
"Magical_Booster_Box":23309,
"Cat_Head_Dress_Basket":23310,
"Magical_Cat_Hand":23311,
"Chemicals_Bag":23312,
"Comp_Cherryblossom_C":23317,
"Shadow_Scroll2":23318,
"Melon_Juice":23320,
"Sweet_Melon_Juice":23321,
"Melon_Parfait":23322,
"C_Wing_Of_Fly_3Day_Box_":23323,
"StabilityShadow_Mix":23324,
"Mobile_Novice_Box":23325,
"Asha_Vahishta":23328,
"C_Wing_Of_Fly_5Day_Box_":23329,
"C_Giant_Fly_1Day_Box_":23330,
"C_Wing_Of_Fly_Box_":23331,
"May_Gold_Scroll":23332,
"New_Hat_Box3":23333,
"ExShadow_DdukddakBox":23334,
"Material_Shadow_Cube":23335,
"Mysterious_Medal_Box":23336,
"Comp_Wing_Of_Fly":23338,
"Comp_Megaphone":23340,
"Vend_Arbeit1_1Lv":23342,
"Vend_Arbeit1_2Lv":23343,
"Vend_Arbeit1_3Lv":23344,
"Buy_Arbeit1_1Lv":23345,
"Buy_Arbeit1_2Lv":23346,
"Buy_Arbeit1_3Lv":23347,
"Vend_Arbeit_1Lv":23348,
"Vend_Arbeit_2Lv":23349,
"Vend_Arbeit_3Lv":23350,
"Buy_Arbeit_1Lv":23351,
"Buy_Arbeit_2Lv":23352,
"Buy_Arbeit_3Lv":23353,
"Vend_Arbeit3_1Lv":23354,
"Vend_Arbeit3_2Lv":23355,
"Vend_Arbeit3_3Lv":23356,
"Buy_Arbeit3_1Lv":23357,
"Buy_Arbeit3_2Lv":23358,
"Buy_Arbeit3_3Lv":23359,
"Psychotropic":23360,
"Serum":23361,
"Pig_Potato":23362,
"E_Watermelon_Pudding":23363,
"Cryptura_Cookie":23364,
"Cryptura_Giftbox":23365,
"Tamato_Noodle":23367,
"Store_Search1":23368,
"Fire_Armor_S":23374,
"Cold_Armor_S":23375,
"Wind_Armor_S":23376,
"Earth_Armor_S":23377,
"General_Scroll":23383,
"CookingBox10":23388,
"Green_Scroll_K2":23405,
"Shadow_Refine_Hammer":23436,
"New_Shadow_Cube":23438,
"Sentimental_Scroll":23440,
"July_Hair_Box":23444,
"Grilled_Turkey":23445,
"Savage_Trap":23446,
"Infinity_Scroll":23473,
"InfinityShadow_Mix":23474,
"Infinity_Drink":23475,
"Firstaid_Box_5":23484,
"Firstaid_Box_10":23485,
"Firstaid_Box_15":23486,
"Firstaid_Box_20":23487,
"Firstaid_Box_25":23488,
"Firstaid_Box_30":23489,
"Firstaid_Box_35":23490,
"Firstaid_Box_40":23491,
"Firstaid_Box_45":23492,
"Firstaid_Box_50":23493,
"Firstaid_Box_55":23494,
"Firstaid_Box_60":23495,
"Firstaid_Box_65":23496,
"Firstaid_Box_70":23497,
"Firstaid_Box_75":23498,
"Firstaid_Box_80":23499,
"Firstaid_Box_85":23500,
"Firstaid_Box_90":23501,
"Firstaid_Box_95":23502,
"Red_Potion_B_20":23503,
"Orange_Potion_B_20":23504,
"Yellow_Potion_B_20":23505,
"White_Potion_B_20":23506,
"Enchant_Stone_Box13":23524,
"Vote_Rose":23533,
"Bloody_Scroll":23537,
"BloodyKnight_Shield_Box":23538,
"Silver_Statue":23545,
"Cursed_Blood":23546,
"Gold_Statue":23547,
"Ice_Candy":23548,
"Snow_Cookie":23549,
"Winter_Cookie":23550,
"Festi_Cookie":23551,
"Flora_Cookie":23552,
"Snow_Festa_Box":23553,
"Snow_Festa_CardPack":23554,
"Hunter_Food":23556,
"Adventurer_Box_1":23575,
"Adventurer_Box_15":23576,
"Adventurer_Box_30":23577,
"Adventurer_Box_45":23578,
"Adventurer_Box_60":23579,
"Adventurer_Box_75":23580,
"Adventurer_Box_90":23581,
"E_Wing_Of_Fly_3Day_Box":23582,
"Rebeginer_Box":23583,
"Rebeginer_S_Box":23584,
"Rebeginer_Box_100":23585,
"Rebeginer_Box_110":23586,
"Rebeginer_Box_120":23587,
"Main_Dish_Course":23604,
"Challenge_Drink":23605,
"Power_Drink":23606,
"Unlimited_Drink":23607,
"Mimir_Spring_Water":23611,
"Baldrs_Blessing":23612,
"2017_Special_Scroll":23618,
"2017_Special_Box":23619,
"Enchant_Stone_Box14":23629,
"Zero_Merchant_Bell":23647,
"Zero_Kafra_Bell":23648,
"Ice_Scroll":23650,
"Dogly_Bottle_Z":23660,
"2018_New_Year_Scroll":23661,
"2018_Year_Shadow_Cube":23662,
"2018_Material_Cube":23663,
"2018_Lapine_DdukddakBox":23664,
"PhysicalMagical_Mix":23665,
"ImmunedAthena_Mix":23666,
"HardChamption_Mix":23667,
"KingbirdAncient_Mix":23668,
"CriticalHit_Mix":23669,
"Sweets_Evt_Box":23674,
"Geffen_Magic_Scroll":23675,
"Gray_Charcoal_Melee":23676,
"Gray_Charcoal_Magic":23677,
"Gray_Charcoal_Range":23678,
"Geffen_Magic_Scroll2":23679,
"Enchant_Stone_Box15":23682,
"EVT_JAN02KR":23683,
"2018_Visionary_Card":23684,
"Lunar_New_Year_Scroll":23700,
"Charleston_Parts_W":23706,
"Charleston_Parts_R":23707,
"February_Hair_Box":23708,
"2018_Spring_Scroll":23710,
"Booby_Trap_Box":23711,
"2018_Sakura_Scroll":23718,
"Sealed_Card2":23719,
"Shadow_Random_Mix":23720,
"Melon_Bread":23723,
"Celebrate_Egg":23724,
"E_Main_Dish_C":23725,
"E_Challenge_Drink":23726,
"E_Unlimited_Drink":23727,
"E_Power_Drink":23728,
"E_Mimir_Spring_W":23732,
"E_Baldrs_Blessing":23733,
"Noodle_Festa_Can":23743,
"Cream_Noodle":23744,
"Comp_AID_Buff_Box":23751,
"Comp_Box":23752,
"Comp_All_Ring_Box":23754,
"Advanced_Taiming_Item2":23761,
"Mysterious_Egg3":23763,
"Comp_Box2":23764,
"May_Rainbow_Scroll":23765,
"Overwhelm_Armor_Box":23766,
"Powerful_Helm_Box":23767,
"Enchant_Stone_Box16":23770,
"Mysterious_Plastic":23771,
"EP17_1_SPC01":23772,
"EP17_1_SPC02":23773,
"EP17_1_SPC03":23774,
"EP17_1_SPC04":23775,
"EP17_1_SPC05":23776,
"EP17_1_SPC06":23777,
"EP17_1_SPC07":23778,
"EP17_1_SPC08":23779,
"EP17_1_SPC09":23780,
"EP17_1_SPC10":23781,
"Sweet_Candy_Box":23784,
"Pump_Of_Spirit_Scroll2":23804,
"Spirit_Hat_Box":23805,
"Hero_Weapon_Box":23806,
"Magma_Essence":23815,
"Bs_Making_S":23817,
"Bs_Item_M_S_2":23818,
"Bs_Item_M_S_8":23819,
"Bs_Item_M_S_10":23820,
"Bs_Item_M_S_11":23821,
"Bs_Item_M_S_34":23822,
"Bs_Item_M_S_41":23823,
"Bs_Item_M_S_42":23824,
"Bs_Item_M_S_43":23825,
"Bs_Item_M_S_44":23826,
"Bs_Sha_M_S_1":23827,
"Bs_Sha_M_S_17":23828,
"Bs_Sha_M_S_18":23829,
"Bs_Sha_M_S_19":23830,
"Bs_Sha_M_S_20":23831,
"Bs_Item_M_S_4":23832,
"Bs_Item_M_S_6":23833,
"Bs_Item_M_S_7":23834,
"Bs_Item_M_S_12":23835,
"Bs_Item_M_S_13":23836,
"Bs_Item_M_S_15":23837,
"Bs_Item_M_S_28":23838,
"Bs_Item_M_S_29":23839,
"Bs_Item_M_S_31":23840,
"Bs_Item_M_S_32":23841,
"Bs_Item_M_S_33":23842,
"Bs_Item_M_S_36":23843,
"Bs_Item_M_S_37":23844,
"Bs_Item_M_S_38":23845,
"Bs_Item_M_S_39":23846,
"Bs_Item_M_S_40":23847,
"Bs_Item_M_S_45":23848,
"Bs_Item_M_S_46":23849,
"Bs_Item_M_S_47":23850,
"Bs_Item_M_S_48":23851,
"Bs_Item_M_S_49":23852,
"Bs_Item_M_S_50":23853,
"Bs_Sha_M_S_2":23854,
"Bs_Sha_M_S_5":23855,
"Bs_Sha_M_S_6":23856,
"Bs_Sha_M_S_7":23857,
"Bs_Sha_M_S_8":23858,
"Bs_Sha_M_S_13":23859,
"Bs_Sha_M_S_15":23860,
"Bs_Sha_M_S_16":23861,
"Bs_Sha_M_S_23":23862,
"Bs_Item_M_S_5":23863,
"Bs_Item_M_S_9":23864,
"Bs_Item_M_S_14":23865,
"Bs_Item_M_S_16":23866,
"Bs_Item_M_S_17":23867,
"Bs_Item_M_S_19":23868,
"Bs_Item_M_S_27":23869,
"Bs_Item_M_S_35":23870,
"Bs_Sha_M_S_9":23871,
"Bs_Sha_M_S_10":23872,
"Bs_Sha_M_S_11":23873,
"Bs_Sha_M_S_21":23874,
"Bs_Sha_M_S_22":23875,
"Bs_Item_M_S_1":23876,
"Bs_Item_M_S_3":23877,
"StarSoul_Scroll":23878,
"Bs_Item_M_S_18":23879,
"Bs_Item_M_S_20":23880,
"Bs_Item_M_S_21":23881,
"Bs_Item_M_S_22":23882,
"Bs_Item_M_S_23":23883,
"Bs_Item_M_S_24":23884,
"Bs_Item_M_S_25":23885,
"Bs_Item_M_S_26":23886,
"Bs_Item_M_S_30":23887,
"Bs_Sha_M_S_3":23888,
"Bs_Sha_M_S_4":23889,
"Bs_Sha_M_S_12":23890,
"Bs_Sha_M_S_14":23891,
"Bs_Sha_M_S_24":23892,
"Bs_Sha_M_S_25":23893,
"Bs_Item_M_S_51":23894,
"Comp_ConnectError":23896,
"2018_Jump_Thx_Box":23897,
"Comp_Power_Booster":23898,
"Comp_Almighty":23899,
"Time_Overload_Box":23900,
"110LVUP":23901,
"Season_Evt_Reward_3":23905,
"Season_Evt_Reward_4":23906,
"Season_Evt_Reward_5":23907,
"Job_Enchant_Stone_Box":23913,
"Main_Lucky_Box":23914,
"K_Secret_Key":23919,
"Season_Evt_Reward":23921,
"Candy_Box":23922,
"Poring_Sunglasses_Box":23923,
"Sigrun_Shadow_Box":23924,
"Mad_Bunny_Box":23925,
"Shadow_9_Refine_Hammer":23926,
"Level_Achievement_Box":23949,
"Sillit_Pong_Box":23952,
"Malang_Cat_Can2":23962,
"EnchantStone_Recipe_9m":23967,
"Abyss_Ddbox":23981,
"Abyss_itembox":23985,
"Odin_itembox":23986,
"Bio_W_Box":23992,
"Bio_Docu_Box":23993,
"Bio_Reactant_Box":23994,
"T_Str1_Armor_S":24000,
"T_Dex1_Weapon_S":24001,
"T_Luk1_Shield_S":24002,
"T_Agi1_Shoes_S":24003,
"T_Vit1_Acc_R_S":24004,
"T_Int1_Acc_L_S":24005,
"T_Str2_Armor_S":24006,
"T_Dex2_Weapon_S":24007,
"T_Luk2_Shield_S":24008,
"T_Agi2_Shoes_S":24009,
"T_Vit2_Acc_R_S":24010,
"T_Int2_Acc_L_S":24011,
"S_Promotion_Weapon":24012,
"S_Promotion_Armor":24013,
"S_Promotion_Shoes":24014,
"S_Promotion_Shield":24015,
"S_Promotion_Earring":24016,
"S_Promotion_Pendant":24017,
"S_Physical_Earring":24018,
"S_Physical_Weapon":24019,
"S_Physical_Pendant":24020,
"S_Magical_Earring":24021,
"S_Magical_Weapon":24022,
"S_Magical_Pendant":24023,
"S_Breezy_Armor":24024,
"S_Champion_Shoes":24025,
"S_Athena_Shield":24026,
"S_Immune_Armor":24027,
"S_Hard_Armor":24028,
"S_Ancient_Armor":24029,
"S_Critical_Armor":24030,
"S_Kingbird_Weapon":24031,
"S_Cri_Hit_Weapon":24032,
"S_Healing_Weapon":24033,
"S_Lucky_Weapon":24034,
"S_Power_Earring":24035,
"S_Int_Pendant":24036,
"S_Dexterous_Armor":24037,
"S_Vital_Shoes":24038,
"S_Athletic_Shield":24039,
"S_Lucky_Armor":24040,
"S_Power_Pendant":24041,
"S_Int_Earring":24042,
"S_Dexterous_Weapon":24043,
"S_Vital_Shield":24044,
"S_Athletic_Shoes":24045,
"S_Resist_Spell_Pendant":24046,
"S_Rapid_Pendant":24047,
"S_Caster_Pendant":24048,
"S_Hard_Earring":24049,
"S_Wise_Earring":24050,
"S_Athena_Earring":24051,
"S_Cranial_Shield":24052,
"S_Safeguard_Shield":24053,
"S_Brutal_Shield":24054,
"S_Gargantua_Shield":24055,
"S_Homers_Shield":24056,
"S_Dragoon_Shield":24057,
"S_Satanic_Shield":24058,
"S_Flameguard_Shield":24059,
"S_Requiem_Shield":24060,
"S_Cadi_Shield":24061,
"S_Bloody_Shoes":24062,
"S_Liberation_Shoes":24063,
"S_Chemical_Shoes":24064,
"S_Clamorous_Shoes":24065,
"S_Insecticide_Shoes":24066,
"S_Fisher_Shoes":24067,
"S_Seraphim_Shoes":24068,
"S_Beholder_Shoes":24069,
"S_Divine_Shoes":24070,
"S_Dragoon_Shoes":24071,
"S_Big_Armor":24072,
"S_Medium_Armor":24073,
"S_Small_Armor":24074,
"S_Big_Weapon":24075,
"S_Medium_Weapon":24076,
"S_Small_Weapon":24077,
"S_Spiritual_Weapon":24078,
"S_Spiritual_Earring":24079,
"S_Spiritual_Pendent":24080,
"S_Malicious_Armor":24081,
"S_Malicious_Shoes":24082,
"S_Malicious_Shield":24083,
"S_Gemstone_Armor":24084,
"S_Gemstone_Shoes":24085,
"S_Gemstone_Shield":24086,
"S_Gemstone_Weapon":24087,
"S_Gemstone_Earring":24088,
"S_Gemstone_Pendent":24089,
"S_Stability_Shield":24090,
"S_Plasterer's_Armor":24091,
"S_Plasterer's_Shoes":24092,
"S_Insomniac_Armor":24093,
"S_Insomniac_Shoes":24094,
"S_Peerless_Armor":24095,
"S_Peerless_Shoes":24096,
"S_Adurate_Armor":24097,
"S_Adurate_Shoes":24098,
"Unfreez_Weapon_S":24099,
"Unfreeze_Earing_S":24100,
"Unfreeze_Pendent_S":24101,
"Vitality_Earing_S":24102,
"Vitality_Pendant_S":24103,
"S_Neutral_Weapon":24104,
"S_Neutral_Earring":24105,
"S_Neutral_Pendent":24106,
"S_Curse_Lift_Earring":24107,
"S_Curse_Lift_Pendent":24108,
"S_Caster_earring":24109,
"S_Caster_Weapon":24110,
"S_Spell_Flow_Shoes":24111,
"S_Spell_Flow_Armor":24112,
"S_Spell_Flow_Shield":24113,
"S_Greed_Armor":24114,
"S_Greed_Shoes":24115,
"S_Greed_Shield":24116,
"S_Greed_Weapon":24117,
"S_Greed_Earring":24118,
"S_Greed_Pendant":24119,
"S_Heal_Armor":24120,
"S_Heal_Shoes":24121,
"S_Heal_Shield":24122,
"S_Heal_Weapon":24123,
"S_Heal_Earring":24124,
"S_Heal_Pendant":24125,
"S_Hiding_Armor":24126,
"S_Hiding_Shoes":24127,
"S_Hiding_Shield":24128,
"S_Hiding_Weapon":24129,
"S_Hiding_Earring":24130,
"S_Hiding_Pendant":24131,
"S_Cloaking_Armor":24132,
"S_Cloaking_Shoes":24133,
"S_Cloaking_Shield":24134,
"S_Cloaking_Weapon":24135,
"S_Cloaking_Earring":24136,
"S_Cloaking_Pendant":24137,
"S_Teleport_Armor":24138,
"S_Teleport_Shoes":24139,
"S_Teleport_Shield":24140,
"S_Teleport_Weapon":24141,
"S_Teleport_Earring":24142,
"S_Teleport_Pendant":24143,
"S_Steal_Armor":24144,
"S_Steal_Shoes":24145,
"S_Steal_Shield":24146,
"S_Steal_Weapon":24147,
"S_Steal_Earring":24148,
"S_Steal_Pendant":24149,
"S_Infinity_Earring":24150,
"S_Infinity_Pendant":24151,
"S_Solid_Weapon":24152,
"S_Solid_Earring":24153,
"S_Immortal_Armor":24154,
"S_Immortal_Pendant":24155,
"S_Executioner_Weapon":24156,
"S_Exorcist_Weapon":24157,
"S_Hunting_Weapon":24158,
"S_Insect_Net_Weapon":24159,
"S_Fishing_Weapon":24160,
"S_Dragon_Killer_Weapon":24161,
"S_Corrupt_Weapon":24162,
"S_Vibration_Weapon":24163,
"S_Holy_Water_Weapon":24164,
"S_Scissors_Weapon":24165,
"S_Penetration_Earring":24166,
"S_Penetration_Pendent":24167,
"S_Tempest_Earring":24168,
"S_Tempest_Pendent":24169,
"S_M_Executioner_Weapon":24170,
"S_M_Exorcist_Weapon":24171,
"S_M_Hunting_Weapon":24172,
"S_M_Insect_Net_Weapon":24173,
"S_M_Fishing_Weapon":24174,
"S_M_Dragon_K_Weapon":24175,
"S_M_Corrupt_Weapon":24176,
"S_M_Vibration_Weapon":24177,
"S_M_Holy_Water_Weapon":24178,
"S_M_Scissors_Weapon":24179,
"S_Bearers_Armor":24180,
"S_Bearers_Shoes":24181,
"S_Bearers_Shield":24182,
"S_Bearers_Weapon":24183,
"S_Bearers_Earring":24184,
"S_Bearers_Pendent":24185,
"S_Basis_Armor":24186,
"S_Hallowed_Armor":24187,
"S_Saharic_Armor":24188,
"S_Underneath_Armor":24189,
"S_Flam_Armor":24190,
"S_Windy_Armor":24191,
"S_Envenom_Armor":24192,
"S_Damned_Armor":24193,
"S_Geist_Armor":24194,
"S_Divine_Armor":24195,
"S_Hasty_Shoes":24196,
"S_Hasty_Armor":24197,
"S_Basis_Shield":24198,
"S_Hallowed_Shield":24199,
"S_Saharic_Shield":24200,
"S_Underneath_Shield":24201,
"S_Flam_Shield":24202,
"S_Windy_Shield":24203,
"S_Envenom_Shield":24204,
"S_Damned_Shield":24205,
"S_Geist_Shield":24206,
"S_Divine_Shield":24207,
"S_Expert_Shoes":24208,
"S_Expert_Shield":24209,
"S_Beginner_Shoes":24210,
"S_Beginner_Shield":24211,
"S_Rookie_Shoes":24212,
"S_Rookie_Shield":24213,
"S_Advanced_Shoes":24214,
"S_Advanced_Shield":24215,
"S_Attack_Armor":24216,
"S_Blitz_Earring":24217,
"S_Blitz_Pendent":24218,
"S_ColdBolt_Armor":24219,
"S_FireBolt_Armor":24220,
"S_LightingBolt_Armor":24221,
"S_EarthSpike_Armor":24222,
"S_Enhance_Force_Weapon":24223,
"S_Force_Weapon":24224,
"S_Force_Earring":24225,
"S_Force_Pendant":24226,
"S_Enhance_Spirit_Weapon":24227,
"S_Spirit_Weapon":24228,
"S_Spirit_Earring":24229,
"S_Spirit_Pendant":24230,
"S_Blitz_Shoes":24231,
"S_Blitz_Shield":24232,
"S_Exceed_Weapon":24233,
"S_Titan_Earring":24234,
"S_Titan_Pendant":24235,
"S_Boned_Earring":24236,
"S_Boned_Pendant":24237,
"S_Gigantic_Earring":24238,
"S_Gigantic_Pendant":24239,
"S_Caster_Shoes":24240,
"S_Caster_Shield":24241,
"S_Caster_Armor":24242,
"S_Reload_Shoes":24243,
"S_Reload_Shield":24244,
"S_Reload_Armor":24245,
"S_Swordman_earring":24246,
"S_Merchant_earring":24247,
"S_Acolyte_earring":24248,
"S_Magician_earring":24249,
"S_Swordman_Pendant":24250,
"S_Merchant_Pendant":24251,
"S_Acolyte_Pendant":24252,
"S_Thief_Pendant":24253,
"S_Magician_Pendant":24254,
"S_Archer_Pendant":24255,
"S_Knight_Shoes":24256,
"S_Crusader_Shoes":24257,
"S_Blacksmith_Shoes":24258,
"S_Alchemist_Shoes":24259,
"S_Priest_Shoes":24260,
"S_Monk_Shoes":24261,
"S_Assassin_Shoes":24262,
"S_Rogue_Shoes":24263,
"S_Wizard_Shoes":24264,
"S_Sage_Shoes":24265,
"S_Hunter_Shoes":24266,
"S_Bard_Shoes":24267,
"S_Dancer_Shoes":24268,
"S_Knight_Armor":24269,
"S_Crusader_Armor":24270,
"S_Blacksmith_Armor":24271,
"S_Alchemist_Armor":24272,
"S_Priest_Armor":24273,
"S_Monk_Armor":24274,
"S_Assassin_Armor":24275,
"S_Rogue_Armor":24276,
"S_Wizard_Armor":24277,
"S_Sage_Armor":24278,
"S_Hunter_Armor":24279,
"S_Bard_Armor":24280,
"S_Dancer_Armor":24281,
"S_SuperNovice_Weapon":24282,
"S_Gunslinger_Weapon":24283,
"S_Taekwon_Weapon":24284,
"S_Ninja_Weapon":24285,
"S_DoramMagical_Weapon":24286,
"S_DoramPhysical_Weapon":24287,
"S_Runeknight_Weapon":24288,
"S_Royalguard_Weapon":24289,
"S_Mechanic_weapon":24290,
"S_Genetic_Weapon":24291,
"S_Archbishop_Weapon":24292,
"S_Sura_weapon":24293,
"S_Guillotine_Weapon":24294,
"S_Shadowchaser_Weapon":24295,
"S_Warlock_Weapon":24296,
"S_Sorcerer_Weapon":24297,
"S_Ranger_Weapon":24298,
"S_Minstrel_Weapon":24299,
"S_Wanderer_Weapon":24300,
"S_Runeknight_Shield":24301,
"S_Royalguard_Shield":24302,
"S_Mechanic_Shield":24303,
"S_Genetic_Shield":24304,
"S_Archbishop_Shield":24305,
"S_Sura_Shield":24306,
"S_Guillotine_Shield":24307,
"S_Shadowchaser_Shield":24308,
"S_Warlock_Shield":24309,
"S_Sorcerer_Shield":24310,
"S_Ranger_Shield":24311,
"S_Minstrel_Shield":24312,
"S_Wanderer_Shield":24313,
"S_Ninja_Shield":24314,
"S_Taekwon_Shield":24315,
"S_DoramPhysical_Shield":24316,
"S_DoramMagical_Shield":24317,
"S_SuperNovice_Shield":24318,
"S_Gunslinger_Shield":24319,
"S2_Hasty_Shoes":24320,
"S2_Bearers_Pendent":24321,
"S2_Gemstone_Earring":24322,
"S2_Spell_Flow_Shield":24323,
"S2_Spiritual_Weapon":24324,
"S2_Malicious_Armor":24325,
"S_Sigrun_Armor":24326,
"S_Sigrun_Shield":24327,
"S2_Force_Ex_Weapon":24328,
"S2_Spirit_M_E_Weapon":24329,
"S2_Caster_Armor":24330,
"S2_Reload_Armor":24331,
"S_Critical_Shield":24332,
"S_Critical_Shoes":24333,
"S_MagicCompose_Armor":24334,
"S2_Gemstone_Weapon":24335,
"S2_Gemstone_Shield":24336,
"S2_Bearers_Armor":24337,
"S2_Bearers_Shoes":24338,
"S_AllMighty_Earring":24339,
"S_AllMighty_Pendant":24340,
"S_AllRace_Shoes":24341,
"S_AllRace_Shield":24342,
"S_Blitz_Weapon":24343,
"S_Blitz_Armor":24344,
"S_Tempest_Shield":24345,
"S_Tempest_Shoes":24346,
"S_M_ExeHoly_Armor":24347,
"S_M_ExoCorrupt_Armor":24348,
"S_M_DragonVib_Armor":24349,
"S_M_SciHunting_Armor":24350,
"S_M_FishInsect_Armor":24351,
"S2_Plasterer's_Armor":24352,
"S2_Insomniac_Shoes":24353,
"S2_Peerless_Armor":24354,
"S2_Adurate_Shoes":24355,
"Unfreez_Weapon_S2":24356,
"Vitality_Earing_S2":24357,
"S2_Neutral_Weapon":24358,
"S2_Curse_Lift_Pendent":24359,
"S_Tension_Weapon":24360,
"S_Tension_Earring":24361,
"S_Tension_Pendent":24362,
"S_Elegant_Weapon":24363,
"S_Elegant_Earring":24364,
"S_Elegant_Pendent":24365,
"S_Healing_Shield":24366,
"S_Healing_Shoes":24367,
"S_Restore_Earring":24368,
"S_Restore_Pendent":24369,
"S_MortalBlow_Weapon":24370,
"S_MortalBlow_Earring":24371,
"S_MortalBlow_Pendent":24372,
"S_Penetration_Shoes":24373,
"S_Penetration_Shield":24374,
"S_ExeHoly_Armor":24375,
"S_ExoCorrupt_Armor":24376,
"S_DragonVib_Armor":24377,
"S_SciHunting_Armor":24378,
"S_FishInsect_Armor":24379,
"Sentimental_Weapone_S":24380,
"Sentimental_Earring_S":24381,
"Sentimental_Pendant_S":24382,
"Enchanting_Weapone_S":24383,
"Enchanting_Earring_S":24384,
"Enchanting_Pendant_S":24385,
"S_Infinity_Weapon":24386,
"Rebeginer_Armor_S":24387,
"Rebeginer_Shield_S":24388,
"Rebeginer_Shoes_S":24389,
"Rebeginer_Weapon_S":24390,
"Rebeginer_Earring_S":24391,
"Rebeginer_Pendant_S":24392,
"S_Physical_Shoes":24393,
"S_Physical_Shield":24394,
"S_Physical_Armor":24395,
"S_Magical_Shoes":24396,
"S_Magical_Shield":24397,
"S_Magical_Armor":24398,
"S_ImmunedAthena_Shield":24399,
"S_HardChamption_Shoes":24400,
"S_KingbirdAncient_Armor":24401,
"S_Rebellion_Armor":24402,
"S_Kagerou_Armor":24403,
"S_Oboro_Armor":24404,
"S_Rebellion_Shoes":24405,
"S_Kagerou_Shoes":24406,
"S_Oboro_Shoes":24407,
"S_DoramPhysical_Armor":24408,
"S_DoramPhysical_Shoes":24409,
"S_DoramMagical_Armor":24410,
"S_DoramMagical_Shoes":24411,
"S_Star_Emperor_Armor":24412,
"S_Star_Emperor_Shoes":24413,
"S_Soul_Reaper_Armor":24414,
"S_Soul_Reaper_Shoes":24415,
"S_Timeoverload_Weapon":24416,
"S_Timeoverload_Armor":24417,
"S_Timeoverload_Shield":24418,
"S_Timeoverload_Shoes":24419,
"S_Timeoverload_Earing":24420,
"S_Timeoverload_Pandent":24421,
"S_Tempest_Weapon":24423,
"S_Tempest_Armor":24424,
"S_PerfectSize_Weapon":24425,
"S_PerfectSize_Armor":24426,
"S_M_Exo_Co_Weapon":24427,
"S_M_Viv_Dr_Weapon":24428,
"S_M_Sci_Hu_Weapon":24429,
"S_M_Fis_In_Weapon":24430,
"S_M_Exe_Ho_Weapon":24431,
"S_Penetration_Weapon":24432,
"S_Penetration_Armor":24433,
"S_Exe_Ho_Weapon":24434,
"S_Fis_In_Weapon":24435,
"S_Sci_Hu_Weapon":24436,
"S_Viv_Dr_Weapon":24437,
"S_Exo_Co_Weapon":24438,
"S_Hasty_Weapon":24439,
"S_Sonic_Armor":24440,
"S_Sonic_Shield":24441,
"S_Sonic_Shoes":24442,
"S_Ignition_Weapon":24443,
"S_Ignition_Pendant":24444,
"S_Ignition_Earing":24445,
"S_W_Breath_Armor":24446,
"S_W_Breath_Shield":24447,
"S_W_Breath_Shoes":24448,
"S_F_Breath_Weapon":24449,
"S_F_Breath_Pendant":24450,
"S_F_Breath_Earing":24451,
"S_Cluster_Armor":24452,
"S_Cluster_Shield":24453,
"S_Cluster_Shoes":24454,
"S_Aimed_Weapon":24455,
"S_Aimed_Pendant":24456,
"S_Aimed_Earing":24457,
"S_Arrow_Armor":24458,
"S_Arrow_Shield":24459,
"S_Arrow_Shoes":24460,
"S_Shooting_Weapon":24461,
"S_Shooting_Pendant":24462,
"S_Shooting_Earing":24463,
"S_Tornado_Armor":24464,
"S_Tornado_Shield":24465,
"S_Tornado_Shoes":24466,
"S_Boomerang_Weapon":24467,
"S_Boomerang_Pendant":24468,
"S_Boomerang_Earing":24469,
"S_Vulcan_Armor":24470,
"S_Vulcan_Shield":24471,
"S_Vulcan_Shoes":24472,
"S_Arms_Weapon":24473,
"S_Arms_Pendant":24474,
"S_Arms_Earing":24475,
"S_Rampage_Armor":24476,
"S_Rampage_Shield":24477,
"S_Rampage_Shoes":24478,
"S_Skynetblow_Weapon":24479,
"S_Skynetblow_Pendant":24480,
"S_Skynetblow_Earing":24481,
"S_Knucklearrow_Armor":24482,
"S_Knucklearrow_Shield":24483,
"S_Knucklearrow_Shoes":24484,
"S_TigerCannon_Weapon":24485,
"S_Tigercannon_Pendant":24486,
"S_Tigercannon_Earing":24487,
"S_Duplelight_Armor":24488,
"S_Duplelight_Shield":24489,
"S_Duplelight_Shoes":24490,
"S_Adoramus_Weapon":24491,
"S_Adoramus_Pendant":24492,
"S_Adoramus_Earing":24493,
"S_Judex_Armor":24494,
"S_Judex_Shield":24495,
"S_Judex_Shoes":24496,
"S_Magnus_Weapon":24497,
"S_Magnus_Pendant":24498,
"S_Magnus_Earing":24499,
"S_Rainstorm_Armor":24500,
"S_Rainstorm_Shield":24501,
"S_Rainstorm_Shoes":24502,
"S_Arrowvulcan_Weapon":24503,
"S_Arrowvulcan_Pendant":24504,
"S_Arrowvulcan_Earing":24505,
"S_Metalic_Armor":24506,
"S_Metalic_Shield":24507,
"S_Metalic_Shoes":24508,
"S_Reverberation_Weapon":24509,
"S_Reverberation_Pendant":24510,
"S_Reverberation_Earing":24511,
"S_Jack_Armor":24512,
"S_Jack_Shield":24513,
"S_Jack_Shoes":24514,
"S_Strain_Weapon":24515,
"S_Strain_Pendant":24516,
"S_Strain_Earing":24517,
"S_Crimson_Armor":24518,
"S_Crimson_Shield":24519,
"S_Crimson_Shoes":24520,
"S_Chain_Weapon":24521,
"S_Chain_Pendant":24522,
"S_Chain_Earing":24523,
"S_Triangle_Armor":24524,
"S_Triangle_Shield":24525,
"S_Triangle_Shoes":24526,
"S_Shadowspell_Weapon":24527,
"S_Shadowspell_Pendant":24528,
"S_Shadowspell_Earing":24529,
"S_Menace_Armor":24530,
"S_Menace_Shield":24531,
"S_Menace_Shoes":24532,
"S_Paint_Weapon":24533,
"S_Paint_Pendant":24534,
"S_Paint_Earing":24535,
"S_Rolling_Armor":24536,
"S_Rolling_Shield":24537,
"S_Rolling_Shoes":24538,
"S_Katar_Weapon":24539,
"S_Katar_Pendant":24540,
"S_Katar_Earing":24541,
"S_Slash_Armor":24542,
"S_Slash_Shield":24543,
"S_Slash_Shoes":24544,
"S_Ripper_Weapon":24545,
"S_Ripper_Pendant":24546,
"S_Ripper_Earing":24547,
"S_Dust_Armor":24548,
"S_Dust_Shield":24549,
"S_Dust_Shoes":24550,
"S_Grave_Weapon":24551,
"S_Grave_Pendant":24552,
"S_Grave_Earing":24553,
"S_Psychic_Armor":24554,
"S_Psychic_Shield":24555,
"S_Psychic_Shoes":24556,
"S_Varetyr_Weapon":24557,
"S_Varetyr_Pendant":24558,
"S_Varetyr_Earing":24559,
"S_Cart_Tornado_Armor":24560,
"S_Cart_Tornado_Shield":24561,
"S_Cart_Tornado_Shoes":24562,
"S_Cannon_Cart_Weapon":24563,
"S_Cannon_Cart_Pendant":24564,
"S_Cannon_Cart_Earing":24565,
"S_Spore_Bomb_Armor":24566,
"S_Spore_Bomb_Shield":24567,
"S_Spore_Bomb_Shoes":24568,
"S_Crazy_Weapon":24569,
"S_Crazy_Pendant":24570,
"S_Crazy_Earing":24571,
"S_Brand_Armor":24572,
"S_Brand_Shield":24573,
"S_Brand_Shoes":24574,
"S_Chain_Press_Weapon":24575,
"S_Chain_Press_Pendant":24576,
"S_Chain_Press_Earing":24577,
"S_Banish_Cannon_Armor":24578,
"S_Banish_Cannon_Shield":24579,
"S_Banish_Cannon_Shoes":24580,
"S_Genesis_Weapon":24581,
"S_Genesis_Pendant":24582,
"S_Genesis_Earing":24583,
"S_Booster_Armor":24584,
"S_Booster_Shield":24585,
"S_Booster_Shoes":24586,
"S_Booster_Earing":24587,
"S_Booster_Pandent":24588,
"S_RK_B_Weapon":24589,
"S_LG_B_Weapon":24590,
"S_NC_B_Weapon":24591,
"S_GN_B_Weapon":24592,
"S_GC_B_Weapon":24593,
"S_SC_B_Weapon":24594,
"S_WL_B_Weapon":24595,
"S_SO_B_Weapon":24596,
"S_AB_B_Weapon":24597,
"S_SR_B_Weapon":24598,
"S_RA_B_Weapon":24599,
"S_WM_B_Weapon":24600,
"S_Tail_Dragon_Weapon":24601,
"S_Tail_Dragon_Shield":24602,
"S_Tail_Dragon_Armor":24603,
"S_Flare_Dance_Earing":24604,
"S_Flare_Dance_Pendant":24605,
"S_Flare_Dance_Shoes":24606,
"S_God_Hammer_Weapon":24607,
"S_God_Hammer_Shield":24608,
"S_God_Hammer_Armor":24609,
"S_Shatter_Buster_Earing":24610,
"S_Shatter_B_Pendant":24611,
"S_Shatter_Buster_Shoes":24612,
"S_Trip_Weapon":24613,
"S_Trip_Shield":24614,
"S_Trip_Armor":24615,
"S_Super_Magic_Shield":24616,
"S_Super_Magic_Armor":24617,
"S_Super_Magic_Shoes":24618,
"S_Super_Power_Weapon":24619,
"S_Super_Power_Pendant":24620,
"S_Super_Power_Earing":24621,
"S_Kunai_Weapon":24622,
"S_Kunai_Shield":24623,
"S_Kunai_Armor":24624,
"S_Syuriken_Earing":24625,
"S_Syuriken_Pendant":24626,
"S_Syuriken_Shoes":24627,
"S_Kamaenraku_Weapon":24628,
"S_Kamaenraku_Shield":24629,
"S_Kamaenraku_Armor":24630,
"S_Huusouka_Earing":24631,
"S_Huusouka_Pendant":24632,
"S_Huusouka_Shoes":24633,
"S_Pickyrush_Weapon":24634,
"S_Pickyrush_Shield":24635,
"S_Pickyrush_Armor":24636,
"S_SavageRabbit_Earing":24637,
"S_SavageRabbit_Pendant":24638,
"S_SavageRabbit_Shoes":24639,
"S_Catnip_Weapon":24640,
"S_Catnip_Shield":24641,
"S_Catnip_Armor":24642,
"S_Silvervine_Earing":24643,
"S_Silvervine_Pendant":24644,
"S_Silvervine_Shoes":24645,
"S_Sunshine_Weapon":24646,
"S_Sunshine_Shield":24647,
"S_Sunshine_Armor":24648,
"S_Moonlight_Earring":24649,
"S_Moonlight_Pendant":24650,
"S_Moonlight_Shoes":24651,
"S_Stardust_Weapon":24652,
"S_Stardust_Shield":24653,
"S_Stardust_Armor":24654,
"S_S_Weapon":24655,
"S_S_Shield":24656,
"S_S_Armor":24657,
"S_Evilcurse_Earring":24658,
"S_Evilcurse_Pendant":24659,
"S_Evilcurse_Shoes":24660,
"S_FullPene_Earring":24661,
"S_FullPene_Pendant":24662,
"S_FullPene_Armor":24663,
"S_FullPene_Shoes":24664,
"S_FullTemp_Earring":24665,
"S_FullTemp_Shoes":24666,
"S_FullTemp_Armor":24667,
"S_FullTemp_Pendant":24668,
"S_Mammoth_Armor":24669,
"S_Mammoth_Shoes":24670,
"S_Mammoth_Pendant":24671,
"S_Mammoth_Earring":24672,
"S_Mammoth_Weapon":24673,
"S_Mammoth_Shield":24674,
"S_TrueGem_Armor":24675,
"S_TrueGem_Shoes":24676,
"S_TrueGem_Earring":24677,
"S_TrueGem_Pendant":24678,
"S_M_Mammoth_Armor":24679,
"S_M_Mammoth_Shoes":24680,
"S_M_Mammoth_Earring":24681,
"S_M_Mammoth_Pendant":24682,
"S_EXP_Shield":24683,
"S_SNV_Weapon":24684,
"S_Absorb_Shield":24685,
"S_Absorb_Weapon":24686,
"S_1Para_Weapon":24687,
"S_1Para_Shield":24688,
"S_1Para_Armor":24689,
"S_1Para_Shoes":24690,
"S_1Para_Earing":24691,
"S_1Para_Pendant":24692,
"S_2Para_Shield":24693,
"S_2Para_Armor":24694,
"S_2Para_Shoes":24695,
"S_2Para_Earing":24696,
"S_2Para_Pendant":24697,
"S_2Para_RK_Weapon":24698,
"S_2Para_LG_Weapon":24699,
"S_2Para_NC_Weapon":24700,
"S_2Para_GN_Weapon":24701,
"S_2Para_GC_Weapon":24702,
"S_2Para_SC_Weapon":24703,
"S_2Para_WL_Weapon":24704,
"S_2Para_SO_Weapon":24705,
"S_2Para_AB_Weapon":24706,
"S_2Para_SR_Weapon":24707,
"S_2Para_RA_Weapon":24708,
"S_2Para_WM_Weapon":24709,
"S_2Para_KO_Weapon":24710,
"S_2Para_RL_Weapon":24711,
"S_2Para_SJ_Weapon":24712,
"S_2Para_SP_Weapon":24713,
"S_2Para_SU_Weapon":24714,
"S_2Para_NV_Weapon":24715,
"S_AutoSpell_Shield":24722,
"S_AutoSpell_Armor":24723,
"S_AutoSpell_Shoes":24724,
"S_AutoSpell_Weapon":24725,
"S_AutoSpell_Pendant":24726,
"S_AutoSpell_Earring":24727,
"S_M_AutoSpell_Armor":24728,
"S_M_AutoSpell_Shoes":24729,
"S_M_AutoSpell_Earring":24730,
"S_M_AutoSpell_Pendant":24731,
"S_Hasty_Shield":24732,
"S_Infinity_Shield":24733,
"S_Durable_Weapon":24734,
"S_Durable_Shield":24735,
"S_Clever_Weapon":24736,
"S_Clever_Shield":24737,
"S_CriticalHit_Weapon":24738,
"S_SU_Weapon":24739,
"S_SJ_Weapon":24740,
"S_KO_Weapon":24741,
"S_RL_Weapon":24742,
"S_SP_Weapon":24743,
"S_NV_Weapon":24744,
"S_KingbirdAnc_Weapon":24745,
"S_S_Reload_Shield":24746,
"S_SpellCaster_Armor":24747,
"S_SpellCaster_Shoes":24748,
"S_SpellCaster_Earring":24749,
"S_SpellCaster_Pendant":24750,
"S_P_Power_Weapon":24751,
"S_P_Power_Shield":24752,
"S_M_Spell_Weapon":24753,
"S_M_Spell_Shield":24754,
"S_Concentration_Weapon":24755,
"S_Concentration_Shield":24756,
"S_Wisdom_Weapon":24757,
"S_Wisdom_Shield":24758,
"S_Stamina_Weapon":24759,
"S_Stamina_Shield":24760,
"S_Creative_Weapon":24761,
"S_Creative_Shield":24762,
"S_R_Bearers_Shoes":24763,
"S_R_Bearers_Armor":24764,
"S_R_Bearers_Pendant":24765,
"S_R_Bearers_Earring":24766,
"S_Mega_Blitz_Shield":24767,
"S_Mega_Blitz_Weapon":24768,
"S_EXP_Weapon":24770,
"aegis_24778":24778,
"aegis_24779":24779,
"aegis_24780":24780,
"aegis_24781":24781,
"aegis_24782":24782,
"aegis_24783":24783,
"S_Master_Weapon":24792,
"S_Master_Shield":24793,
"S_DK_Armor":24800,
"S_DK_Shoes":24801,
"S_DK_Earring":24802,
"S_DK_Pendant":24803,
"S_IG_Armor":24804,
"S_IG_Shoes":24805,
"S_IG_Earring":24806,
"S_IG_Pendant":24807,
"S_SHC_Armor":24808,
"S_SHC_Shoes":24809,
"S_SHC_Earring":24810,
"S_SHC_Pendant":24811,
"S_ABC_Armor":24812,
"S_ABC_Shoes":24813,
"S_ABC_Earring":24814,
"S_ABC_Pendant":24815,
"S_CD_Armor":24816,
"S_CD_Shoes":24817,
"S_CD_Earring":24818,
"S_CD_Pendant":24819,
"S_IQ_Armor":24820,
"S_IQ_Shoes":24821,
"S_IQ_Earring":24822,
"S_IQ_Pendant":24823,
"S_MT_Armor":24824,
"S_MT_Shoes":24825,
"S_MT_Earring":24826,
"S_MT_Pendant":24827,
"S_BO_Armor":24828,
"S_BO_Shoes":24829,
"S_BO_Earring":24830,
"S_BO_Pendant":24831,
"S_WH_Armor":24832,
"S_WH_Shoes":24833,
"S_WH_Earring":24834,
"S_WH_Pendant":24835,
"S_TR_Armor":24836,
"S_TR_Shoes":24837,
"S_TR_Earring":24838,
"S_TR_Pendant":24839,
"S_AG_Armor":24840,
"S_AG_Shoes":24841,
"S_AG_Earring":24842,
"S_AG_Pendant":24843,
"S_EM_Armor":24844,
"S_EM_Shoes":24845,
"S_EM_Earring":24846,
"S_EM_Pendant":24847,
"S_NW_Armor":24848,
"S_NW_Shoes":24849,
"S_NW_Earring":24850,
"S_NW_Pendant":24851,
"S_SH_Armor":24852,
"S_SH_Shoes":24853,
"S_SH_Earring":24854,
"S_SH_Pendant":24855,
"S_SS_Armor":24856,
"S_SS_Shoes":24857,
"S_SS_Earring":24858,
"S_SS_Pendant":24859,
"S_SKE_Armor":24860,
"S_SKE_Shoes":24861,
"S_SKE_Earring":24862,
"S_SKE_Pendant":24863,
"S_SOA_Armor":24864,
"S_SOA_Shoes":24865,
"S_SOA_Earring":24866,
"S_SOA_Pendant":24867,
"S_HN_Armor":24868,
"S_HN_Shoes":24869,
"S_HN_Earring":24870,
"S_HN_Pendant":24871,
"S_Full_Power_Armor":24872,
"S_Full_Power_Shoes":24873,
"S_Full_Rate_Armor":24874,
"S_Full_Rate_Shoes":24875,
"S_Focusing_Pendant":24876,
"S_Focusing_Earring":24877,
"S_Stout_Pendant":24878,
"S_Stout_Earring":24879,
"S_Full_Spell_Armor":24883,
"S_Full_Spell_Shoes":24884,
"S_Centering_Pendant":24885,
"S_Centering_Earring":24886,
"S_Witty_Pendant":24887,
"S_Witty_Earring":24888,
"S_SHC_EC_Earring":24906,
"S_SHC_EC_Pendant":24907,
"S_SHC_SI_Armor":24908,
"S_SHC_SI_Shoes":24909,
"S_WH_GS_Earring":24910,
"S_WH_GS_Pendant":24911,
"S_WH_CB_Armor":24912,
"S_WH_CB_Shoes":24913,
"S_SS_SR_Earring":24914,
"S_SS_SR_Pendant":24915,
"S_SS_KR_Armor":24916,
"S_SS_KR_Shoes":24917,
"S_DK_SS_Earring":24918,
"S_DK_SS_Pendant":24919,
"S_DK_HS_Armor":24920,
"S_DK_HS_Shoes":24921,
"S_TR_RW_Earring":24922,
"S_TR_RW_Pendant":24923,
"S_TR_MF_Armor":24924,
"S_TR_MF_Shoes":24925,
"S_NW_SO_Earring":24926,
"S_NW_SO_Pendant":24927,
"S_NW_WB_Armor":24928,
"S_NW_WB_Shoes":24929,
"S_MT_MS_Earring":24936,
"S_MT_MS_Pendant":24937,
"S_MT_PR_Armor":24938,
"S_MT_PR_Shoes":24939,
"S_BO_EP_Earring":24940,
"S_BO_EP_Pendant":24941,
"S_BO_MD_Armor":24942,
"S_BO_MD_Shoes":24943,
"S_HN_VJ_Earring":24944,
"S_HN_VJ_Pendant":24945,
"S_HN_TB_Armor":24946,
"S_HN_TB_Shoes":24947,
"S_IG_OC_Earring":24948,
"S_IG_OC_Pendant":24949,
"S_IG_RF_Armor":24950,
"S_IG_RF_Shoes":24951,
"S_IQ_EB_Earring":24952,
"S_IQ_EB_Pendant":24953,
"S_IQ_BFB_Armor":24954,
"S_IQ_BFB_Shoes":24955,
"S_SU_CS_Earring":24956,
"S_SU_CS_Pendant":24957,
"S_SU_HB_Armor":24958,
"S_SU_HB_Shoes":24959,
"S_CD_AR_Earring":24967,
"S_CD_AR_Pendant":24968,
"S_CD_DF_Armor":24969,
"S_CD_DF_Shoes":24970,
"S_AG_FB_Earring":24971,
"S_AG_FB_Pendant":24972,
"S_AG_SH_Armor":24973,
"S_AG_SH_Shoes":24974,
"S_SKE_NS_Earring":24975,
"S_SKE_NS_Pendant":24976,
"S_SKE_SB_Armor":24977,
"S_SKE_SB_Shoes":24978,
"S_EM_CO_Earring":24979,
"S_EM_CO_Pendant":24980,
"S_EM_LS_Armor":24981,
"S_EM_LS_Shoes":24982,
"S_ABC_AF_Earring":24983,
"S_ABC_AF_Pendant":24984,
"S_ABC_FA_Armor":24985,
"S_ABC_FA_Shoes":24986,
"S_SOA_TOWB_Earring":24987,
"S_SOA_TOWB_Pendant":24988,
"S_SOA_TOFG_Armor":24989,
"S_SOA_TOFG_Shoes":24990,
"S_Magical_M_Armor":24993,
"S_Magical_M_Shoes":24994,
"S_Magical_M_Earring":24995,
"S_Magical_M_Pendant":24996,
"S_Spell_M_Armor":24997,
"S_Spell_M_Shoes":24998,
"S_Spell_M_Earring":24999,
"SPdrainStone_Top":25000,
"DEFStone_Middle":25001,
"ChangeLUK_Middle":25002,
"ChangeSTR_Middle":25003,
"ChangeAGI_Middle":25004,
"ChangeINT_Middle":25005,
"ChangeVIT_Middle":25006,
"ChangeDEX_Middle":25007,
"ChangeVIT_Bottom":25008,
"ChangeAGI_Bottom":25009,
"ChangeDEX_Bottom":25010,
"ChangeLUK_Bottom":25011,
"ChangeSTR_Bottom":25012,
"ChangeINT_Bottom":25013,
"MDEFStone_Bottom":25014,
"EXPStone_Bottom":25015,
"ATKStone_Bottom":25016,
"MATKStone_Bottom":25017,
"Breaked_Trap":25038,
"Captured_Trap":25039,
"Pump_Of_Spirit":25041,
"Service_30_Egg_Shell":25042,
"Thorn_Vines_Pipe":25043,
"Hard_Thorn_Vines":25044,
"High_Quality_Cloth":25045,
"Embark_Warrant":25046,
"Carlou_Nyac":25047,
"Full_Lunch":25048,
"Basil_Rac":25049,
"Union_Token":25051,
"TwinkleEffect_Top":25058,
"GhostEffect_Middle":25059,
"Critical_Stone":25060,
"Range_Stone":25061,
"Greed_Stone":25062,
"MaxHP2_Stone":25063,
"MaxSP2_Stone":25064,
"Detoxify_Stone":25065,
"Recovery_Stone":25066,
"CastingStone_Robe":25067,
"ASPDStone_Top":25068,
"ReloadStone_Top":25069,
"ReloadStone_Middle":25070,
"ReloadStone_Bottom":25071,
"Kyrie_Stone":25072,
"Worn_Out_Papyrus":25073,
"Antique_Coin":25074,
"Sword_Of_Admiral":25075,
"QouSeraSera":25076,
"KnightsSupply":25077,
"Liqueur_Of_Lotus":25078,
"FaintBreathing":25079,
"FoxBeads":25080,
"MRabbit_SHair":25083,
"Captured_MRabbit":25084,
"MRabbit_Hair":25085,
"Gift_Wrapping_Ribbon":25086,
"Old_Doll":25087,
"Dream_Piece":25088,
"Gift_Wrapping_Wing":25089,
"Jobmap_1st":25098,
"Jobmap_su":25099,
"Jobmap_sword":25100,
"Jobmap_magic":25101,
"Jobmap_Merch":25102,
"Jobmap_acol":25103,
"Jobmap_thief":25104,
"Jobmap_archer":25105,
"Jobmap_taekwon":25106,
"Jobmap_rune":25107,
"Jobmap_royal":25108,
"Jobmap_war":25109,
"Jobmap_socer":25110,
"Jobmap_mecha":25111,
"Jobmap_gene":25112,
"Jobmap_bishop":25113,
"Jobmap_sura":25114,
"Jobmap_cross":25115,
"Jobmap_chaser":25116,
"Jobmap_ranger":25117,
"Jobmap_mins":25118,
"Jobmap_wander":25119,
"Jobmap_ninja":25120,
"Jobmap_gun":25121,
"Jobmap_super2":25122,
"Jobmap_karma2":25123,
"Particles_Of_Energy1":25127,
"Particles_Of_Energy2":25128,
"Particles_Of_Energy3":25129,
"Particles_Of_Energy4":25130,
"Particles_Of_Energy5":25131,
"Pumpkin_Decorations":25132,
"Dry_White_Stem":25133,
"Comp_Auger_Of_Spirit":25135,
"ElectricEffect_Middle":25136,
"GreenFloor_Bottom":25137,
"ShrinkEffect_Middle":25138,
"Identify_Stone":25139,
"Resurrection_Stone":25140,
"EXPStone_Middle":25141,
"DoramToken":25142,
"Gift_Stuffed_Doll":25143,
"Bridge_Stuffed_Doll":25144,
"Burned_Specter_Doll":25145,
"Relentless_Queen_Doll":25146,
"Meal_Done_Ribbit_Doll":25147,
"Cute_Eat_Machine_Doll":25148,
"Hot_Muffler_Doll":25149,
"Alice_Hug_Pillow":25150,
"Rachels_Revolver":25151,
"Cherish_Bouquet":25152,
"Broken_Gun_Wreck":25153,
"Antique_Powder":25154,
"Swz_Honor_Token":25155,
"Piece_Of_Chimera":25156,
"Fallen_Leaves_Branch":25157,
"Core_Jelly":25158,
"Heart_Hunter_Seal":25159,
"Borrow_Book":25160,
"Handmade_cookie2":25161,
"Anchovy_cookie":25162,
"Arms_Shop_AD":25163,
"Fresh_Tea_Leaves":25164,
"High_Class_Tea":25165,
"Very_Shining_Ring":25166,
"Old_Letter":25167,
"Sticky_Slime":25169,
"MinorCastingStone_Robe":25170,
"EXPStone_Top":25171,
"CastingStone_Top":25172,
"CastingStone_Middle":25173,
"CastingStone_Bottom":25174,
"LexAeternaStone_Middle":25175,
"BlueAuraEffect_Middle":25176,
"ShadowEffect_Middle":25177,
"PinkGlowEffect_Middle":25178,
"Blessing_Star":25179,
"Old_Couple_Ring":25180,
"Wood_Rosary":25181,
"Assassin_PT_Dagger":25182,
"Deco_Thimble_Archer":25183,
"Portable_Sewingbox":25184,
"Locket_Pendant":25185,
"Slug_Bullet":25187,
"Handkerchief_of_Girl":25188,
"Cloud_Fluff":25200,
"Arcane_Toenail":25201,
"ShrinkEffect_Bottom":25205,
"ElectricEffect_Top":25206,
"Upg_SPdrainStone_Top":25207,
"Upg_SPdrainStone_Robe":25208,
"Upg_HPdrainStone_Robe":25209,
"Upg_HPdrainStone_Top":25210,
"Coagulated_Blood":25212,
"Tree_Branches":25218,
"WindowPaper":25219,
"Moonlight_KiteString":25220,
"MoonScent_Tree_Branches":25221,
"MoonPattern_WindowPaper":25222,
"Para_Team_Coin":25223,
"WhiteBodyEffect_Middle":25224,
"ExplodingEffect_Middle":25225,
"WaterFieldEffect_Bottom":25226,
"Heal_Stone":25227,
"Teleport_Stone":25228,
"Steal_Stone":25229,
"Suspicious_Bottle":25231,
"Cheap_Lubricant":25232,
"Wad_Of_Cotton":25233,
"StoneForWork":25235,
"General_Lubricant_":25238,
"High_RankLubricant_":25239,
"Independence_Permit":25240,
"Little_Skel_Bone":25245,
"Juice_Package":25246,
"Violet_Stone":25247,
"Violet_Stone_Box":25248,
"Mane_Of_Cow":25249,
"Coin_Of_Rr":25250,
"Fermented_Grapes":25251,
"Sprig_Of_Holly":25252,
"Sugar_Box":25253,
"Firewood":25254,
"HazyDream":25256,
"Bloody_LoveLetter":25257,
"BrokenArrow":25258,
"SubjugationFlyer":25259,
"Violet_Stone_Chip":25260,
"Torn_Diary":25261,
"Dried_Clover":25262,
"Short_Bat_Fur":25263,
"NightmareOfLump":25264,
"Shining_Spore":25265,
"Dried_Leaf_Of_Ygg":25266,
"SuspiciousMagicCircle":25267,
"Sticky_Blood":25268,
"Mushroom_Sap":25269,
"Swaying_Mane":25270,
"IllusionStone":25271,
"IllusoryStone":25272,
"Mysterious_Medal":25273,
"Racing_Thx_Ticket":25274,
"CleanBone":25276,
"DeadlyPoisonPowder":25277,
"BanditsScarf":25278,
"CrudeAmmo":25279,
"BrokenShotgun":25280,
"CrudeScimiter":25281,
"WornRevolver":25282,
"BrownMuffler":25283,
"SwampBugPeelings":25284,
"BrownRatTail":25285,
"Octo_Octo_Fluid":25286,
"Mysterious_Feather":25287,
"Sweets_Coin":25290,
"Fac_Choco":25291,
"Stolen_Cacao":25292,
"Clover_Ticket":25294,
"Happiness_Clover":25295,
"Fatal_Thing":25296,
"Frozen_PieceOfRock":25297,
"SpritJewel":25298,
"Snowball":25299,
"KTULLANUXsEye":25300,
"DoubleAttack_Stone":25302,
"Critical_Stone_Robe":25303,
"Critical_Stone_Top":25304,
"Critical_Stone_Bottom":25305,
"CastStone_Robe":25306,
"Private_M_Ticket":25307,
"Cash_Can":25308,
"Dry_Branch":25309,
"DF_Token_Of_Siegfried":25310,
"PieceOfBlackSpirit":25311,
"OldDoll":25312,
"OldShell":25313,
"ShipsLog":25314,
"Piece_Of_Shell":25315,
"Shabby_Metal_Chip":25316,
"Dalcom_Skin":25318,
"Ice_Box":25319,
"Suspicious_Melon":25320,
"Golden_Corn":25340,
"Red_Hot_Marble":25341,
"Healthful_Herb":25342,
"Flat_Round_Stone":25344,
"Retrieve_Datacard":25358,
"Slightly_Old_Bax":25359,
"Receipt":25360,
"Thin_Noodle":25365,
"Noodle_Festa_Coupon":25366,
"Promotion_Fan":25367,
"Mightysoul_Essence":25375,
"Pet_Coin":25376,
"High_Class_Pet_food":25377,
"Hardly_Sealed_Letter":25378,
"Hardly_Sealed_Letter2":25379,
"DragonMustacheNoodle":25380,
"Breath_Fired_Dumpling":25381,
"Dragon_Head_Cookie":25382,
"Dragon_Mustache_Candy":25383,
"Captured_Savage":25390,
"Goodly_Bough":25391,
"Free_Pass_Ticket":25392,
"Delicious_Corn":25393,
"Fruit_Lunch":25394,
"Small_Embers":25395,
"Black_Fur":25401,
"Memory_Of_Gyol":25408,
"SuraStone_Top":25409,
"SuraStone_Middle":25410,
"SuraStone_Bottom":25411,
"SuraStone_Robe":25412,
"RangerStone_Top":25413,
"RangerStone_Middle":25414,
"RangerStone_Bottom":25415,
"RangerStone_Robe":25416,
"SorcererStone_Top":25417,
"SorcererStone_Middle":25418,
"SorcererStone_Bottom":25419,
"SorcererStone_Robe":25420,
"Pumpkin_Decor":25421,
"White_Thin_Stem":25422,
"SnowFlower_Of_Spell":25425,
"Warm_Cotton":25426,
"Rebeginer_W_Coupon":25427,
"Rebeginer_W_7Up":25428,
"RuneknightStone_Top":25445,
"RuneknightStone_Middle":25446,
"RuneknightStone_Bottom":25447,
"RuneknightStone_Robe":25448,
"GeneticStone_Robe":25449,
"GeneticStone_Top":25450,
"GeneticStone_Middle":25451,
"GeneticStone_Bottom":25452,
"WarlockStone_Top":25453,
"WarlockStone_Middle":25454,
"WarlockStone_Bottom":25455,
"WarlockStone_Robe":25456,
"Special_Tool_Box_Coupon":25461,
"World_Tour_Ticket":25464,
"Dogly_Bottle":25479,
"Earth_Card_BZ":25482,
"Fire_Card_BZ":25483,
"Water_Card_BZ":25484,
"Wind_Card_BZ":25485,
"Fire_Badge_BZ":25486,
"Water_Badge_BZ":25487,
"Wind_Badge_BZ":25488,
"Earth_Badge_BZ":25489,
"ShadowchaserStone_Top":25490,
"ShadowchaseStone_Middle":25491,
"ShadowchaseStone_Bottom":25492,
"ShadowchaserStone_Robe":25493,
"MechanicStone_Top":25494,
"MechanicStone_Middle":25495,
"MechanicStone_Bottom":25496,
"MechanicStone_Robe":25497,
"WanderMinstrelStone_Top":25498,
"WanderMinstStone_Middle":25499,
"WanderMinstStone_Bottom":25500,
"WanderMinstreStone_Robe":25501,
"EVT_JAN01KR":25502,
"Flower_V":25503,
"Visionary_Ticket":25504,
"Jokers_Wild":25505,
"Cute_Broom":25506,
"Showy_Coral_Reef":25507,
"Token_of_OrcGeneral":25508,
"Shining_Round_Shell":25509,
"Evt_March04_KR":25511,
"Evt_March05_KR":25512,
"NasariansSoulstone":25615,
"Green_Bearopy":25616,
"Chonchon_Doll_HQ":25617,
"Gothic_China_Doll":25618,
"Clay_Doll":25619,
"White_Snake_Tear":25622,
"Gold_Card":25627,
"Konts_Letter":25629,
"Token_Of_Wootan":25633,
"Wootan_D_S_Piece":25634,
"Wootan_F_Fur":25635,
"Shooting_Stone":25636,
"Hair_Leaf":25637,
"Token_Of_Bigstone":25638,
"Fragment_Of_Rock":25639,
"Pot_Stone":25640,
"Hard_Mud":25641,
"Weak_Worm":25642,
"Autographed_Book":25643,
"Evt_May01_KR":25655,
"Evt_June01_KR":25656,
"Evt_July01_KR":25657,
"Evt_July02_KR":25658,
"Evt_May02_KR":25659,
"Evt_July03_KR":25664,
"Dienes_Envelope":25665,
"Id_Card":25666,
"EP17_1_EVT01":25668,
"EP17_1_EVT02":25669,
"EP17_1_EVT03":25670,
"EP17_1_EVT04":25671,
"EP17_1_EVT05":25672,
"EP17_1_EVT06":25673,
"EP17_1_EVT07":25674,
"EP17_1_EVT08":25675,
"EP17_1_EVT09":25676,
"EP17_1_EVT10":25677,
"EP17_1_EVT11":25678,
"EP17_1_EVT12":25679,
"EP17_1_EVT13":25680,
"EP17_1_EVT14":25681,
"EP17_1_EVT15":25682,
"EP17_1_EVT16":25683,
"EP17_1_EVT17":25684,
"EP17_1_EVT18":25685,
"EP17_1_EVT19":25686,
"EP17_1_EVT20":25687,
"EP17_1_EVT21":25688,
"EP17_1_EVT22":25689,
"EP17_1_EVT23":25690,
"EP17_1_EVT24":25691,
"EP17_1_EVT25":25692,
"EP17_1_EVT26":25693,
"EP17_1_EVT27":25694,
"EP17_1_EVT28":25695,
"EP17_1_EVT29":25696,
"EP17_1_EVT30":25697,
"EP17_1_EVT31":25698,
"EP17_1_EVT32":25699,
"EP17_1_EVT33":25700,
"EP17_1_EVT34":25701,
"EP17_1_EVT35":25702,
"EP17_1_EVT36":25703,
"EP17_1_EVT37":25704,
"EP17_1_EVT38":25705,
"HighpriestStone_Top":25706,
"HighpriestStone_Middle":25707,
"HighpriestStone_Bottom":25708,
"ArchbishopStone_Robe":25709,
"PaladinStone_Top":25710,
"PaladinStone_Middle":25711,
"PaladinStone_Bottom":25712,
"RoyalguardStone_Robe":25713,
"AssacrossStone_Top":25714,
"AssacrossStone_Middle":25715,
"AssacrossStone_Bottom":25716,
"GuillcrossStone_Robe":25717,
"EP17_1_EVT39":25723,
"Shadowdecon_Ore":25728,
"Shadowdecon":25729,
"Zelunium_Ore":25730,
"Zelunium":25731,
"EP17_1_Open_Event":25733,
"Sealed_Weapon_Ticket":25734,
"Unsealing_Token":25735,
"J_Shop_Coupon2":25736,
"GH_Cursed_Crystal":25739,
"GH_Cursed_Gemstone":25740,
"Dragenergy_Green":25759,
"Dragenergy_Blue":25760,
"Dragenergy_Red":25761,
"Dragenergy_Gold":25762,
"Dragenergy_Purple":25763,
"Dragenergy_Silver":25764,
"Drabone_L":25765,
"Drabone_S":25766,
"Angel_Dream":25767,
"Shard_Blue":25768,
"Shard_Gold":25769,
"Valkyrie_Armor2":25770,
"Valkyrie_Armor3":25771,
"Delicious_Juice":25772,
"Snake_Deadly_Poison":25773,
"Mantis_Flower":25774,
"Soft_Scarf":25775,
"Purple_Solid_Shell":25776,
"Suspicious_Sap":25777,
"Brilliant_Jelly":25778,
"Short_Rope":25779,
"Essence_Of_Demon":25780,
"Little_Lovely_Candle":25781,
"Medicinal_Stuff":25782,
"Cold_Holy_Water":25783,
"Small_Flashlight":25784,
"Bio_Reseearch_Docu":25786,
"Bio_Test_Fragment":25787,
"Inventory_Ex_Evt":25791,
"Inventory_Ex_Dis":25792,
"Inventory_Ex":25793,
"SuraStone_Robe2":25797,
"SuraStone_Bottom2":25798,
"SuraStone_Middle2":25799,
"SuraStone_Top2":25800,
"SorcererStone_Robe2":25801,
"SorcererStone_Bottom2":25802,
"SorcererStone_Middle2":25803,
"SorcererStone_Top2":25804,
"ShadowchaserStone_Robe2":25805,
"ShadowchasStone_Bottom2":25806,
"ShadowchasStone_Middle2":25807,
"ShadowchaserStone_Top2":25808,
"Ein_REDIUM":25809,
"Ein_RINDIUM":25810,
"Ein_ODIUM":25811,
"Ein_PURDIUM":25812,
"Ein_WHIDIUM":25813,
"Ein_DYNITE":25814,
"Ein_SOLIDDUST":25815,
"Ein_RUSTHELM":25816,
"Ein_EYEROCK":25817,
"Metal_W_Ticket":25820,
"PayPromotion_Coupon":25840,
"Smooth_Noodle":25841,
"SoulreaperStone_Robe":25842,
"SoullinkerStone_Top":25843,
"SoullinkerStone_Middle":25844,
"SoullinkerStone_Bottom":25845,
"GladiatorStone_Top":25846,
"GladiatorStone_Middle":25847,
"GladiatorStone_Bottom":25848,
"StaremperorStone_Robe":25849,
"NinjaStone_Top":25850,
"NinjaStone_Middle":25851,
"NinjaStone_Bottom":25852,
"KagerouStone_Robe":25853,
"OboroStone_Robe":25854,
"GunslingerStone_Top":25855,
"GunslingerStone_Middle":25856,
"GunslingerStone_Bottom":25857,
"RebellionStone_Robe":25858,
"DoramStone_Top":25859,
"DoramStone_Middle":25860,
"DoramStone_Bottom":25861,
"DoramStone_Robe":25862,
"2019_SStarR_Ticket":25863,
"S_Circlet_Of_Time":25864,
"Jewel_Of_Time_Ore":25865,
"Spell_Of_Time":25866,
"Fragment_Of_Time":25867,
"Harvest_Lottery_Ticket":25876,
"Abysmal_Clam":25892,
"Deepsea_Fish_Tail":25893,
"Rotten_Deepseafish":25894,
"Deep_Sea_Starfish":25895,
"Deep_Sea_Crab":25896,
"Crown_Of_Witch":25897,
"Siroods_Fish_Rod":25898,
"E_Abyss1":25899,
"Armor_Ore_3":25920,
"Mature_Cacao":25921,
"Boost_C_Enchant_1":25924,
"Evt_NY2023_Enc_C_1":25928,
"Evt_NY2023_Enc_C_2":25929,
"Loft_StoneSTR":25934,
"Loft_StoneLUK":25935,
"Loft_StoneDEX":25936,
"Loft_StoneINT":25937,
"Loft_StoneVIT":25938,
"Loft_StoneAGI":25939,
"Loft_StoneUltimate":25940,
"Toughen_Metal_Lance":26001,
"Diva_Lance":26004,
"Mirage_Lance":26005,
"Sinister_Lance_J":26006,
"Spectral_Spear_IL":26007,
"Neev_Glaive":26008,
"Rebeginer_LG_Lance":26015,
"T_Lance_Of_Kingdom":26016,
"Local01_T_Spear":26017,
"Local02_T_Spear":26018,
"Woe_T_Lance1_Z":26019,
"Variant_Lance":26021,
"Ein_BHSPEAR":26024,
"P_Foxtail2":26100,
"P_Foxtail3":26101,
"UnrivaledStaff":26102,
"JP_Rod01_L":26103,
"Blue_Staff":26104,
"Diva_Wand":26105,
"Mirage_Wand":26106,
"Staff_Of_Elder":26107,
"Sinister_Rod_J":26108,
"Staff_Of_Bordeaux_IL":26109,
"CandyCaneRod":26110,
"Metal_Foxtail":26111,
"Probation_Foxtail":26112,
"Shadow_Staff_K":26118,
"Rebeginer_SO_Rod":26119,
"Rebeginer_DO_Rod":26120,
"Wand_Of_Flame":26138,
"Wand_Of_Ice":26139,
"WitchsBroomStick":26140,
"Local01_Wand":26142,
"Diva_Foxtail":26143,
"Mirage_Foxtail":26144,
"Local02_Wand":26145,
"Woe_Healstaff1_Z":26146,
"Woe_Wand1_Z":26147,
"Owl_D_Stick":26148,
"Variant_Wand":26149,
"Variant_Foxtail":26150,
"Rutilus_Stick_OS":26151,
"Staff_Of_Puffy_jp":26152,
"SoulWeight":26154,
"MeawFoxtail":26155,
"Evt_Shadow_Staff_K":26156,
"Crimson_Rose_Stick":26158,
"Psychic_Spear_Rod":26159,
"Dust_Grave":26160,
"Ponitendtia":26161,
"Ein_1HWAND":26162,
"Rainbow_Foxtail":26163,
"ElectricFox_OS":26164,
"R_Cleric_Staff":26165,
"R_Magician_Wand":26166,
"Aquarius_Staff_J":26167,
"Crimson_Rose_Stick_J":26168,
"Psychic_Spear_Rod_J":26169,
"Dust_Grave_J":26170,
"Ponitendtia_J":26171,
"R_Foxtail_rod":26172,
"Chromium_Staff_EXE":26175,
"Karlite_Staff_EXE":26176,
"Wizards_Memory":26177,
"Comp_Shadow_Staff_K":26178,
"Hippie_Rope":26200,
"Diva_Blade_Whip":26201,
"Mirage_Blade_Whip":26202,
"Sinister_Wire_J":26203,
"Hippie_Rope_J":26204,
"Local01_Book":26207,
"Local01_Whip":26208,
"Local02_Whip":26209,
"Woe_Whip1_Z":26210,
"Heart_Whip":26212,
"Scarlet_Ribbon":26213,
"Ein_1HWHIP":26215,
"R_Wheep":26216,
"Heart_Whip_J":26217,
"Scarlet_Ribbon_J":26218,
"Dark_Illu_Whips_TH":26221,
"XM_Mystcase_Card_J":27002,
"XM_Celine_Kimi_Card_J":27007,
"AmdaraisH_Card_J":27008,
"CorruptionRootH_Card_J":27009,
"Kick_Step_Card":27012,
"KickAndKick_Card":27013,
"GreenCenere_Card":27014,
"RepairRobot_T_Card":27015,
"ExplorationRover_T_Card":27016,
"Scr_MT_Robots_Card":27017,
"GC109_Card":27018,
"DR815_Card":27019,
"T_W_O_Card":27020,
"Lich_Lord_Card":27025,
"Fire_Condor_Card":27026,
"Fire_Sand_Man_Card":27027,
"Fire_Frilldora_Card":27028,
"Fire_Golem_Card":27029,
"Fulbuk_Card":27030,
"Labyrinth_Bapho_Card":27031,
"Labyrinth_Dra_Card":27032,
"As_Ragged_Golem_Card_J":27035,
"Bijou_Card_J":27040,
"Sorcerer_Card_J":27055,
"Sura_Card_J":27056,
"Minstrel_Card_J":27057,
"GuillotineCross_Card_J":27058,
"Archbishop_Card_J":27059,
"Ranger_Card_J":27060,
"Mechanic_Card_J":27061,
"Warlock_Card_J":27062,
"RuneKnight_Card_J":27063,
"RoyalGuard_Card_J":27064,
"Genetic_Card_J":27065,
"ShadowChaser_Card_J":27066,
"Wanderer_Card_J":27067,
"Real_Eremes_Card_J":27068,
"Real_Magaleta_Card_J":27069,
"Real_Katrinn_Card_J":27070,
"Real_Shecil_Card_J":27071,
"Real_Harword_Card_J":27072,
"Real_Seyren_Card_J":27073,
"Real_Randel_Card_J":27074,
"Real_Flamel_Card_J":27075,
"Real_Ceila_Card_J":27076,
"Real_Chen_Card_J":27077,
"Real_Gertie_Card_J":27078,
"Real_Trentini_Card_J":27079,
"Real_Alphoccio_Card_J":27080,
"AngerMoonlight_Card":27081,
"AngerNineTail_Card":27082,
"BitterBonGun_Card":27083,
"BitterSohee_Card":27084,
"BitterMunak_Card":27085,
"BitterArcherSk_Card":27086,
"WizardOfVeritas_Card":27087,
"FuryHero_Card":27088,
"T_W_O_Card_J":27089,
"Charleston_Card_J":27092,
"SweetNightM_Card":27101,
"MattDrainliar_Card":27102,
"LivingDead_Card":27103,
"Ill_Dracula_Card":27104,
"Bomi_Card":27105,
"Grand_Pere_Card":27106,
"PlayingPere_Card":27107,
"SingingPere_Card":27108,
"JitterbugCard":27109,
"AngerGazeti_Card":27110,
"AngerSnowier_Card":27111,
"AngerIceTitan_Card":27112,
"AwakenKtullanux_Card":27113,
"OminousSolider_Card":27114,
"OminousPermeter_Card":27115,
"OminousHeater_Card":27116,
"OminousAssulter_Card":27117,
"OminousFreezer_Card":27118,
"OminousTurtleG_Card":27119,
"Iara_Card":27120,
"Piranha_Card":27121,
"Curupira_Card":27122,
"Toucan_Card":27123,
"Jaguar_Card":27124,
"Headless_Mule_Card":27125,
"Boitata_Card":27126,
"AncientKing_Groza_Card":27127,
"Abyss_AncientKing_Card":27128,
"Card_Of_Justice":27129,
"Card_Of_Star":27130,
"Card_Of_Temperance":27131,
"Card_Of_Tram":27132,
"Card_Of_Reaper":27133,
"Card_Of_Hermit":27134,
"Card_Of_Emperor":27135,
"Card_Of_Moon":27136,
"Card_Of_Lover":27137,
"Card_Of_Hierophant":27138,
"Card_Of_Devil":27139,
"Card_Of_Power":27140,
"Evil_Card_J":27141,
"Chimera_1_Card_J":27143,
"CUITE_Card_J":27146,
"Human_Kimera_Card":27147,
"Matter_Kimera_Card":27148,
"Heart_Hunter_Card":27149,
"Venom_Kimera_Card":27150,
"Evil_Card":27151,
"Cutie_Card":27152,
"Wood_Goblin_Card":27157,
"Les_Card":27158,
"Uzhas_Card":27159,
"Vavayaga_Card":27160,
"Mavka_Card":27161,
"Gopinich_Card":27162,
"Faceworm_Card":27163,
"Faceworm_Q_Card":27164,
"Faceworm_D_Card":27165,
"Faceworm_Egg_Card":27166,
"Faceworm_L_Card":27167,
"Irene_Elder_Card":27168,
"Payon_Soldier_Card":27169,
"Cowraiders1_Card":27170,
"Cowraiders2_Card":27171,
"Cowraiders3_Card":27172,
"E_Cowraiders1_Card":27173,
"E_Cowraiders2_Card":27174,
"E_Cowraiders3_Card":27175,
"Rr_Cramp_Card":27176,
"Rr_Arclouse_Card":27177,
"Gaster_Card":27178,
"Coyote_Card":27179,
"Mechaspider_Card":27180,
"AirShip_Raid_Card":27181,
"Felock_Card":27182,
"Gigantes_Card":27183,
"Knight_Sakray_Card":27184,
"Gaster_Card_J":27191,
"S_Nihil_Card":27196,
"S_Agnes_Card":27197,
"S_Jurgen_Card":27198,
"S_Spica_Card":27199,
"Nihil_Card":27200,
"Agnes_Card":27201,
"Jurgen_Card":27202,
"Spica_Card":27203,
"SLD_Q_Scaraba_Card":27209,
"SLD_Thanatos_Card":27210,
"SLD_Baphomet_Card":27211,
"SLD_Maya_Card":27212,
"SLD_Clown_Card":27213,
"SLD_Professor_Card":27214,
"SLD_Champion_Card":27215,
"SLD_Creator_Card":27216,
"SLD_Stalker_Card":27217,
"SLD_Paladin_Card":27218,
"SLD_Gypsy_Card":27219,
"SLD_Daehyon_Card":27220,
"SLD_Gioia_Card":27221,
"SLD_Pyuriel_Card":27222,
"SLD_Kades_Card":27224,
"SLD_Timeholder_Card":27225,
"Big_Eggring_Card_J":27228,
"Faceworm_Q_Card_J":27237,
"Grand_Pere_Card_J":27247,
"Sarah_Card_J":27248,
"Archi_Card":27249,
"Dio_Anemos_Card":27250,
"Geffen_Gang_Card":27251,
"Geffen_Thug_Card":27252,
"Geffen_Thief_Card":27253,
"Pa_Monk_Card":27254,
"Ordre_Card":27255,
"Blut_Hase_Card":27256,
"Kuro_Akuma_Card":27257,
"Hyper_Death_Card":27258,
"Rechenier_Card":27259,
"Odorico_Card":27260,
"Jew_Card":27261,
"Dy_Card":27262,
"Fei_Kanabian_Card":27263,
"Evil_Shadow_Card":27264,
"Evil_Fanatics_Card":27265,
"Colorful_T_Bear_Card":27286,
"Shining_T_Bear_Card":27287,
"Pitman_Worker_Card":27288,
"Fragment_Of_Soul_Card":27289,
"Sinister_Obsidian_Card":27290,
"Ancient_Trijoint_Card":27291,
"Ancient_Sta_Golem_Card":27292,
"Ancient_Megalith_Card":27293,
"Ancient_Tao_Gunka_Card":27294,
"Ancient_S_Shooter_Card":27295,
"Ancient_W_Shooter_Card":27296,
"Ancient_W_Fighter_Card":27297,
"Ancient_W_Deffend_Card":27298,
"Labyrinth_Dop_Card":27301,
"E_EA2S_Card":27304,
"EL_A17T_Card":27305,
"Bellare_Card":27306,
"High_Bellare_Card":27307,
"Sanare_Card":27308,
"High_Sanare_Card":27309,
"Plaga_Card":27310,
"Mutant_Plaga_Card":27311,
"Dolor_Card":27312,
"Mt_Dolor_Card":27313,
"Venenum_Card":27314,
"Mt_Venenum_Card":27315,
"Caput_Card":27316,
"Mt_Caput_Card":27317,
"Miguel_Card":27318,
"R48_85_Bestia_Card":27319,
"E_EA1L_Card":27320,
"DespairGodMorocc_Card":27321,
"Ahat_Card":27322,
"Shnaim_Card":27323,
"Brinaranea_Card":27324,
"Muspellskoll_Card":27325,
"MinionOfMorocc_Card":27326,
"ReaperAnkou_Card":27327,
"LivingDeath_Card":27328,
"Schmidt_Card":27329,
"Kronecker_Card":27330,
"S_Kronecker_Card":27331,
"Skia_Card":27332,
"S_Skia_Card":27333,
"Chaos_Baphomet_Card":27334,
"Chaos_Ba_Jr_Card":27335,
"Chaos_S_Winder_Card":27336,
"Chaos_H_Fly_Card":27337,
"Chaos_Mantis_Card":27338,
"Chaos_Goring_Card":27339,
"Chaos_K_Mantis_Card":27340,
"Chaos_Poporing_Card":27341,
"Chaos_Stem_W_Card":27342,
"Chaos_Acolyte_Card":27343,
"Witch_Zilant_Card":27344,
"Dragon_Zilant_Card":27345,
"Firm_Muspell_Card":27346,
"Firm_Kaho_Card":27347,
"Firm_Lava_G_Card":27348,
"Firm_Explosion_Card":27349,
"Firm_Deleter1_Card":27350,
"Firm_Deleter2_Card":27351,
"Firm_Nightmare_T_Card":27352,
"Firm_Blazzer_Card":27353,
"Polluted_Raydric_Card":27354,
"Polluted_Ray_A_Card":27355,
"Frozen_Gargoyle_Card":27356,
"Polluted_Sting_Card":27357,
"Prison_Breaker_Card":27358,
"Ice_Ghost_Card":27359,
"Flame_Ghost_Card":27360,
"Polluted_W_Man_Card":27361,
"Polluted_Spi_Q_Card":27362,
"Polluted_Dark_L_Card":27363,
"Card_Of_Fool":27364,
"Card_Of_WheelOfF":27365,
"Card_Of_TheHangedM":27366,
"Card_Of_TheWorld":27367,
"Colorful_T_Bear_Card_J":27368,
"Shining_T_Bear_Card_J":27369,
"Pitman_Worker_Card_J":27370,
"Fragment_Of_Soul_Card_J":27371,
"Sinister_Obsidian_Card_":27372,
"Ancient_Trijoint_Card_J":27373,
"Anc_Sta_Golem_Card_J":27374,
"Anc_Megalith_Card_J":27375,
"Anc_Tao_Gunka_Card_J":27376,
"Anc_S_Shooter_Card_J":27377,
"Anc_W_Shooter_Card_J":27378,
"Anc_W_Fighter_Card_J":27379,
"Anc_W_Deffend_Card_J":27380,
"C_Himel_Card":27381,
"C_CorruptionRoot_Card":27382,
"C_Amdarais_Card":27383,
"C_White_Knight_Card":27384,
"C_Khaliz_Knight_Card":27385,
"C_Raydric_Card":27386,
"C_Raydric_Archer_Card":27387,
"C_Cursed_Butler":27388,
"Wolf_Card_EV":27389,
"S_Wolf_Card_E":27390,
"Poe_Card_E":27391,
"S_Poe_Card_E":27392,
"Kathryn_Card":27393,
"S_Kathryn_Card":27394,
"Isaac_Card":27395,
"S_Issac_Card":27396,
"E_Imune":27397,
"Dodge3_J":27398,
"Offering_to_God":27399,
"Resistance_Long_Dis5":27400,
"Absorbsprits_Lv1":27401,
"Latent_Release_SU":27402,
"Latent_Release_SJ":27403,
"Latent_Release_SP":27404,
"Latent_Release_KG":27405,
"Latent_Release_OB":27406,
"Latent_Release_RL":27407,
"Immun_Fire":27408,
"Immun_Water":27409,
"Immun_Wind":27410,
"Immun_Earth":27411,
"MHP15":27412,
"Big_Fire_BR":27413,
"Sky_Ground_BR":27414,
"Storm_BR":27415,
"Water_Sky_BR":27416,
"aegis_27417":27417,
"Shard_Jewelry_Str":27421,
"Shard_Jewelry_Agi":27422,
"Shard_Jewelry_Dex":27423,
"Shard_Jewelry_Luk":27424,
"Shard_Jewelry_Vit":27425,
"Shard_Jewelry_Int":27426,
"Thanos_Katar":28000,
"Katar_Of_Evil_Slayer":28001,
"Half_BF_Katar2":28002,
"Ru_Blue_Katar":28005,
"Ru_Gold_Katar":28006,
"Scarlet_Katar":28007,
"Sinister_Katar":28008,
"Katar_170":28010,
"Union_Katar":28011,
"Kings_Double_Edge":28014,
"Toughen_Metal_Katar":28015,
"Diva_Katar":28018,
"Mirage_Katar":28019,
"Sinister_Katar_J":28020,
"Infiltrator_IL":28022,
"Ghoul_Leg_IL":28023,
"Probation_Katar":28024,
"Neev_Various_Jur":28026,
"Rebeginer_GC_Katar":28027,
"Local01_Katar":28034,
"Local02_Katar":28035,
"Woe_Katar1_Z":28036,
"Variant_Katar":28037,
"Meuchler_OS":28038,
"Shiver_Katar_K":28039,
"Evt_Shiver_Katar_K":28040,
"Reaper_Cross":28042,
"Agudo_Filo":28044,
"Ein_BHKATAR":28045,
"R_Katar":28046,
"Scorpio_Katar_J":28047,
"Reaper_Cross_J":28048,
"Agudo_Filo_J":28049,
"Comp_Shiver_Katar_K_TH":28053,
"Thanos_Axe":28100,
"Tornado_Axe":28101,
"Half_BF_Two_Handed_Axe1":28102,
"Ru_Blue_Axe_M":28103,
"Ru_Gold_Axe_M":28104,
"Axe_Of_Infinite":28105,
"Scarlet_Twohand_Axe":28106,
"Sinister_Twohand_Axe":28107,
"Union_Twohand_Axe":28110,
"Toughen_Metal_THand_Axe":28113,
"Veteran_Axe_":28114,
"Mine_Worker_Pickax":28116,
"Diva_Twohand_Axe":28117,
"Mirage_Twohand_Axe":28118,
"Sinister_Twohand_Axe_J":28119,
"Probation_TH_Axe":28120,
"Neev_Guillotine":28121,
"Neev_Buster":28122,
"Mine_Worker_Pickax_J":28127,
"Avenger":28130,
"Local01_T_Axe":28131,
"Local02_T_Axe":28132,
"Woe_Twohand_Axe1_Z":28133,
"Variant_Twohand_Axe":28135,
"Blasti_OS":28136,
"Evt_Avenger":28137,
"Maxi_Spanner":28138,
"Ein_BHAXE":28140,
"G_Knight_BattleAxe":28141,
"Maxi_Spanner_J":28142,
"aegis_28144":28144,
"END_OF_HORIZON":28200,
"Southern_Cross_R":28201,
"Southern_Cross_R_":28202,
"Half_BF_Rifle1":28203,
"Half_BF_Shotgun1":28204,
"EXODUS_JOKER_XIII":28214,
"Probation_Rifle":28215,
"Probation_Gatling_Gun":28216,
"Probation_Launcher":28217,
"Probation_Shotgun":28218,
"Just_Finish":28223,
"Dust_Fire":28224,
"Burning_Rose":28225,
"Revenger":28226,
"Diva_Rifle":28227,
"Mirage_Rifle":28228,
"Diva_Gatling_Gun":28229,
"Mirage_Gatling_Gun":28230,
"Diva_Launcher":28231,
"Mirage_Launcher":28232,
"Diva_Shotgun":28233,
"Mirage_Shotgun":28234,
"Neev_Rifle":28235,
"Calf_Kingcobra_J":28236,
"Calf_Diamondback_J":28237,
"Calf_Anaconda_J":28238,
"Calf_Python_J":28239,
"Calf_Kingcobra":28240,
"Calf_Diamondback":28241,
"Calf_Anaconda":28242,
"Calf_Python":28243,
"Gate_KeeperDD_IL":28244,
"Variant_Rifle":28249,
"Variant_Gatling_Gun":28250,
"Variant_Shotgun":28251,
"Variant_Launcher":28252,
"HR_S55_OS":28253,
"Butcher_IL":28254,
"Master_Soul_Rifle":28255,
"Demon_S_Shot":28256,
"Golden_L_Launcher":28257,
"The_Black_Gatling":28258,
"Comp_Demon_S_Shot":28261,
"Kotone_Of_Ninja":28300,
"Ball_Of_Huuma":28301,
"Vesper_Core01_":28302,
"Vesper_Core02_":28303,
"Vesper_Core03_":28304,
"Vesper_Core04_":28305,
"Bless_Of_Moon":28306,
"Earring_Of_Sarah_L":28310,
"Earring_Of_Sarah_R":28311,
"Platinum_Ring":28312,
"Operation_Glove":28313,
"Hand_Of_Glory":28314,
"RCC2013_ARMLET":28315,
"RCC2013_ARMLET_":28316,
"RCC2013_RING":28317,
"RCC2013_RING_":28318,
"Cauda_Daemonica":28319,
"Assassin_Acc":28320,
"Falconer_Claw":28321,
"Falconer_Glove":28322,
"Exorcist_Gloves":28323,
"Steam_Starter_Ring":28324,
"Broken_Chip_1":28326,
"Broken_Chip_2":28327,
"Jewel_Ring":28332,
"Gold_PC_Ring":28333,
"A_Drop_Of_Heal":28340,
"Sachet":28341,
"Critical_Anklet":28342,
"Star_Egg_Badge":28346,
"Icarus_Wing_S":28347,
"Bowman_Scarf_S":28348,
"Cursed_Star_S":28349,
"Shinobi's_Sash_S":28350,
"Whike_Black_Tail_S":28351,
"VesperGear1":28352,
"VesperGear2":28353,
"DowntownMap_":28354,
"ShiningHolyWater_":28355,
"BadgeOfProntera_":28356,
"VesperGear3":28357,
"Cursed_Lucky_Clover":28358,
"VesperGear4":28359,
"Supplement_Part_Dex_J":28368,
"Upgrade_Part_Gun_B_J":28369,
"Broken_Chip_1_J":28370,
"Broken_Chip_2_J":28371,
"Imperial_Ring":28372,
"Foxtail_Ring":28374,
"Magical_Ring":28377,
"Shadow_Ring":28379,
"Fresh_G_Necklace":28380,
"Pretty_G_Necklace":28381,
"Charm_G_Necklace":28382,
"Fallen_Monk_Rosary":28386,
"Bishop_Necklace":28387,
"Bloody_Iron_Ball_":28388,
"S_Thief_earring":28391,
"S_Archer_earring":28392,
"King_of_Spirit_Ring":28394,
"Sapphire_Wrist":28410,
"Emerald_Earring":28411,
"The_One_Apple_Ring":28412,
"LowSaurelCharm":28413,
"MiddleSaurelCharm":28414,
"HigherSaurelCharm":28415,
"LowLeafCharm":28416,
"MiddleLeafCharm":28417,
"HigherLeafCharm":28418,
"LowRabbitCharm":28419,
"MiddleRabbitCharm":28420,
"HigherRabbitCharm":28421,
"ShiningTwigCharm":28422,
"FreshTunaCharm":28423,
"PlumpyWormCharm":28424,
"Mercenary_Ring_A":28425,
"Mercenary_Ring_B":28426,
"Blue_4leaf_Necklace":28427,
"4SeasonsClover":28428,
"Arquien's_Necklace":28429,
"Archpriest_Ring":28430,
"Sprint_Ring_":28431,
"Spiritual_Ring_":28432,
"Luminous_Blue_Stone":28433,
"Boxer_Glove":28434,
"Secret_Scroll_Of_Ninja":28435,
"Elvira_Pendant":28436,
"ArchPriest_Glove":28437,
"Fairy_Leaf_Powder":28438,
"SeeOtter_Fan":28439,
"FurSeal_Fan":28440,
"Vigilante_Bedge":28441,
"Hippie_Feather":28442,
"Para_Team_Ring100A":28443,
"Para_Team_Necklace100A":28444,
"Para_Team_Ring115A":28445,
"Para_Team_Necklace115A":28446,
"Para_Team_Ring130A":28447,
"Para_Team_Necklace130A":28448,
"Para_Team_Ring145A":28449,
"Para_Team_Necklace145A":28450,
"Para_Team_Ring160A":28451,
"Para_Team_Necklace160A":28452,
"Para_Team_Ring100B":28453,
"Para_Team_Necklace100B":28454,
"Para_Team_Ring115B":28455,
"Para_Team_Necklace115B":28456,
"Para_Team_Ring130B":28457,
"Para_Team_Necklace130B":28458,
"Para_Team_Ring145B":28459,
"Para_Team_Necklace145B":28460,
"Para_Team_Ring160B":28461,
"Para_Team_Necklace160B":28462,
"Para_Team_Ring100C":28463,
"Para_Team_Necklace100C":28464,
"Para_Team_Ring115C":28465,
"Para_Team_Necklace115C":28466,
"Para_Team_Ring130C":28467,
"Para_Team_Necklace130C":28468,
"Para_Team_Ring145C":28469,
"Para_Team_Necklace145C":28470,
"Para_Team_Ring160C":28471,
"Para_Team_Necklace160C":28472,
"Para_Team_Ring100D":28473,
"Para_Team_Necklace100D":28474,
"Para_Team_Ring115D":28475,
"Para_Team_Necklace115D":28476,
"Para_Team_Ring130D":28477,
"Para_Team_Necklace130D":28478,
"Para_Team_Ring145D":28479,
"Para_Team_Necklace145D":28480,
"Para_Team_Ring160D":28481,
"Para_Team_Necklace160D":28482,
"ProtectRingofKing":28483,
"Scarf_Of_Rebellion":28484,
"Shinobi's_Sash_H":28485,
"Matagi_Swordaxe":28491,
"Tip_Of_Thief_Vol1":28492,
"Badge_Of_Vigilante1":28495,
"Badge_Of_Vigilante2":28496,
"BadgeOfProntera__J":28499,
"Fanatic_Necklace":28500,
"Horn_Of_Kirin":28501,
"Mob_Scarf":28502,
"Keraunos":28503,
"RingOfDevil":28505,
"StormStone":28506,
"Glove_Of_Wizard":28507,
"Skul_Ring_IL":28508,
"Ring_IL":28509,
"Vampire's_Servant":28510,
"Time_Keeper_Ring":28511,
"Celine_Brooch":28513,
"Bless_Flower_Ring":28514,
"Imperial_Ring_BR":28515,
"2017RTCRING":28516,
"Ring_Of_The_Abyss_King":28517,
"Cursed_Demon_Ring":28518,
"So_Heon_Saber":28519,
"EgirRing":28520,
"Giant_Protection":28521,
"Ring_Of_Fallen":28522,
"Ring_Of_Disaster":28523,
"Glove_Of_Smith":28531,
"ChemicalGlove":28533,
"RKC_2017_Pendant":28534,
"RKC_2017_Ring":28535,
"Emerald_Earring_TW":28536,
"Arquiens_Necklace_BR":28537,
"Glove_Of_Wizard_BR":28538,
"60Lv_Ring":28539,
"70Lv_Ring":28540,
"70Lv_Mring":28541,
"80Lv_Aring":28542,
"80Lv_Gloves":28543,
"80Lv_Mring":28544,
"80Lv_Necklace":28545,
"90Lv_Aring":28546,
"90Lv_Gloves":28547,
"90Lv_Mring":28548,
"90Lv_Necklace":28549,
"Imperial_Glove":28551,
"Two_Dragon_Ring":28552,
"Shinobi_Sash_H_BR":28553,
"YinYang_Talisman":28560,
"Ring_Of_Brave":28561,
"True_Hunting_Ring1":28562,
"True_Hunting_Ring2":28563,
"Valkyrie_Drop":28564,
"Perverse_Demon_Mask":28565,
"Rebeginer_Ring":28566,
"King_of_Spirit_Ring_TW":28567,
"Emerald_Ring":28573,
"Verus_Core":28575,
"Fresh_G_Necklace_J":28577,
"Pretty_G_Necklace_J":28578,
"Charm_G_Necklace_J":28579,
"LowSaurelCharm_J":28580,
"MiddleSaurelCharm_J":28581,
"HigherSaurelCharm_J":28582,
"LowLeafCharm_J":28583,
"MiddleLeafCharm_J":28584,
"HigherLeafCharm_J":28585,
"LowRabbitCharm_J":28586,
"MiddleRabbitCharm_J":28587,
"HigherRabbitCharm_J":28588,
"ShiningTwigCharm_J":28589,
"FreshTunaCharm_J":28590,
"PlumpyWormCharm_J":28591,
"Angel_Poring_Earing":28592,
"Angel_Poring_Ring":28593,
"Temporal_Ring":28594,
"BlueDragonRing_TW":28595,
"Toy_Ring":28596,
"CherryBlossom_Badge_TW":28597,
"Supplement_Part_Chip":28598,
"Ru_Blue_Book":28600,
"Ru_Gold_Book":28601,
"Demon_Hunting_Bible":28602,
"Scarlet_Bible":28604,
"Sinister_Book":28605,
"Union_Bible":28606,
"Toughen_Metal_Book":28607,
"Origin_Of_Elemental":28608,
"Diva_Book":28609,
"Mirage_Book":28610,
"Sinister_Book_J":28611,
"Book_Of_The_Apo_IL":28612,
"Probation_Magicbook":28613,
"Probation_Bible":28614,
"Origin_Of_Elemental_J":28615,
"Rebeginer_AB_Bible":28616,
"Demon_Hunting_Bible_BR":28617,
"Time_Kamiji":28618,
"Prisoner_Dairy":28619,
"Local02_Book":28625,
"Tablet_IL":28626,
"Variant_Book":28627,
"Prohibited_Grimoire":28628,
"Circuit_Board_OS":28629,
"Demon_Hunting_Bible_K":28630,
"OneSkyOneSun":28631,
"Evt_D_H_Bible_K":28632,
"Boltigin":28633,
"Ein_1HBOOK":28635,
"R_Sage_Book":28636,
"Boltigin_J":28637,
"Pollux_Book_J":28643,
"aegis_28645":28645,
"Comp_D_Hunt_Bible_K":28646,
"Ru_Gold_Dagger":28700,
"Ru_Gold_Knife":28701,
"Ru_Gold_Ashura":28702,
"Dagger_Of_Infinite":28703,
"Scarlet_Dagger":28705,
"Sinister_Dagger":28706,
"Dagger_of_Trust":28708,
"Kings_Eager":28712,
"Kings_Bless":28713,
"Toughen_Metal_Dagger":28714,
"UnrivaledDagger":28715,
"Tooth_Blade_":28716,
"Valkyrie_Knife":28717,
"Diffusion_Lacma":28719,
"Blue_Dagger":28720,
"Monokage":28721,
"Diva_Dagger":28722,
"Mirage_Dagger":28723,
"Sinister_Dagger_J":28724,
"Moonlight_Sword_IL":28725,
"Probation_Dagger":28726,
"Mist_Sword":28737,
"Monokage_J":28738,
"Rebeginer_SC_Dagger":28740,
"Magic_Sword":28744,
"Counter_Dagger_IL":28745,
"Local01_Dagger":28747,
"Local01_Asura":28748,
"Local02_Dagger":28749,
"Local02_Asura":28750,
"Woe_Knife1_Z":28751,
"Variant_Dagger":28753,
"Koikiri":28754,
"Kuroiro_OS":28755,
"Evt_Magic_Sword":28759,
"Scarlet_Athame":28761,
"Bazerald_IL":28762,
"Sharp_Wind_Sword":28763,
"Fog_Dew_Sword":28764,
"Judgement_Slasher":28765,
"Repent_Slasher":28766,
"Jack_The_Knife":28767,
"Platinum_Dagger":28768,
"Ein_1HDAGGER":28771,
"Ein_1HMAGGER":28772,
"R_Gladius_R":28774,
"R_Gladius_L":28775,
"R_Magician_Dagger":28776,
"Judgement_Slasher_J":28777,
"Repent_Slasher_J":28778,
"Jack_The_Knife_J":28779,
"Platinum_Dagger_J":28780,
"Procyon_Dagger_J":28784,
"Time_Gap_ABC_Dagger":28785,
"Comp_Magic_Sword":28786,
"aegis_28787":28787,
"Time_Gap_SS_Dagger1":28789,
"ShieldOfGuardsman":28900,
"Mad_Bunny_K":28901,
"Mad_Bunny_K_":28902,
"Scutum":28903,
"Union_Guard":28904,
"Union_Buckler":28905,
"Shield_Of_Flame":28906,
"Shield_Of_Gust":28907,
"BIgShield_Of_Water":28908,
"Shield_Of_Earth":28909,
"Imuke_Upper_Shield":28910,
"Rudo_Heart_Roll":28912,
"Ultra_Light_MShield":28913,
"Toughen_Time_Keepr_Shd":28914,
"Bunker_Shield_":28915,
"Gaia_Shield":28916,
"JP_Shield01_L":28917,
"Shield_Of_Chaos":28918,
"ShieldOfGuardsman_J":28920,
"Anemos_Shield":28921,
"Herald_Of_GOD_IL":28922,
"Kings_Guard":28927,
"Ultra_Light_MShieldJ":28928,
"HappyShield":28929,
"Excelion_Shield":28941,
"Bloody_Knight_Shield":28942,
"Forbidden_Grimoire":28943,
"Scutum_BR":28944,
"Bloody_Knight_Shield_":28945,
"Bloody_Knight_Shield__":28946,
"Gaia_Shield_BR":28947,
"Doram_Shield":28948,
"Jewel_Shield":28949,
"Variant_Shield":28950,
"Nero_Shield":28951,
"Poring_B_Shield":28953,
"Fotia_Shield":28955,
"Jirant_Mirror":28956,
"Haurvatat":28962,
"Rachel_Sheild_Cru":28970,
"aegis_28972":28972,
"aegis_28973":28973,
"aegis_28974":28974,
"aegis_28977":28977,
"aegis_28979":28979,
"aegis_28980":28980,
"aegis_28982":28982,
"aegis_28983":28983,
"aegis_28984":28984,
"aegis_28985":28985,
"Neev_INT_1":29000,
"Neev_INT_2":29001,
"Neev_INT_3":29002,
"Neev_DEX_1":29003,
"Neev_DEX_2":29004,
"Neev_DEX_3":29005,
"Neev_LUK_1":29006,
"Neev_LUK_2":29007,
"Neev_LUK_3":29008,
"Neev_VIT_1":29009,
"Neev_VIT_2":29010,
"Neev_VIT_3":29011,
"HPdrain3":29013,
"STR3INT":29014,
"STR3DEX":29015,
"INT3DEX":29016,
"INT3VIT":29017,
"DEX3VIT":29018,
"DEX3AGI":29019,
"VIT3AGI":29020,
"VIT3LUK":29021,
"AGI3LUK":29022,
"AGI3STR":29023,
"LUK3STR":29024,
"LUK3INT":29025,
"Def20":29026,
"EXP2":29027,
"Atk1p_Top":29028,
"Atk1p_Bottom":29029,
"Matk1p_Top":29030,
"Matk1p_Bottom":29031,
"SPdrain1_Top":29032,
"Mdef4_Bottom":29033,
"Ghost_Effect":29040,
"Twinkle_Effect":29041,
"Storm":29045,
"Greed":29046,
"Fatal0":29047,
"Expert_Archer0":29048,
"HP100_":29049,
"SP50_":29050,
"Detoxify":29051,
"Recovery":29052,
"Skill_Delay1_Top":29053,
"Skill_Delay1_Middle":29054,
"Skill_Delay1_Bottom":29055,
"FixedCasting05":29056,
"Kyrie":29057,
"Mettle1":29061,
"Mettle2":29062,
"Mettle3":29063,
"Mettle4":29064,
"Mettle5":29065,
"Mettle6":29066,
"Mettle7":29067,
"Mettle8":29068,
"Mettle9":29069,
"Mettle10":29070,
"MagicEessence1":29071,
"MagicEessence2":29072,
"MagicEessence3":29073,
"MagicEessence4":29074,
"MagicEessence5":29075,
"MagicEessence6":29076,
"MagicEessence7":29077,
"MagicEessence8":29078,
"MagicEessence9":29079,
"MagicEessence10":29080,
"Acute1":29081,
"Acute2":29082,
"Acute3":29083,
"Acute4":29084,
"Acute5":29085,
"Acute6":29086,
"Acute7":29087,
"Acute8":29088,
"Acute9":29089,
"Acute10":29090,
"MasterArcher1":29091,
"MasterArcher2":29092,
"MasterArcher3":29093,
"MasterArcher4":29094,
"MasterArcher5":29095,
"MasterArcher6":29096,
"MasterArcher7":29097,
"MasterArcher8":29098,
"MasterArcher9":29099,
"MasterArcher10":29100,
"Adamatine1":29101,
"Adamatine2":29102,
"Adamatine3":29103,
"Adamatine4":29104,
"Adamatine5":29105,
"Adamatine6":29106,
"Adamatine7":29107,
"Adamatine8":29108,
"Adamatine9":29109,
"Adamatine10":29110,
"Affection1":29111,
"Affection2":29112,
"Affection3":29113,
"Affection4":29114,
"Affection5":29115,
"Affection6":29116,
"Affection7":29117,
"Affection8":29118,
"Affection9":29119,
"Affection10":29120,
"JusticeOfGoddess_A":29121,
"JusticeOfGoddess_S":29122,
"LoveOfGoddess_A":29123,
"LoveOfGoddess_S":29124,
"InsightOfGoddess_A":29125,
"InsightOfGoddess_S":29126,
"Mana_Vermilion":29127,
"Mana_Braze":29128,
"Mana_Chrome":29129,
"Mana_Twilight":29130,
"Mana_Chaos":29131,
"Mana_Rise":29132,
"Mana_Heal":29133,
"Heart_Of_Winner":29134,
"Keen1":29135,
"Keen2":29136,
"Keen3":29137,
"Keen4":29138,
"Keen5":29139,
"Orcish_Hero_Of_Anger":29140,
"Roar_Of_Baphomet":29141,
"Electric_Effect":29142,
"Green_Floor_Effect":29143,
"Shrink_Effect":29144,
"EXP2MIDDLE":29145,
"Identify":29146,
"Resurrection":29147,
"AngelPoring_Purple":29148,
"AngelPoring_SkyBlue":29149,
"AngelPoring_Green":29150,
"AngelPoring_Pink":29151,
"AngelPoring_DeepRed":29152,
"AngelPoring_Clear":29153,
"FixedCasting03":29154,
"LexAeterna":29155,
"Casting_Top":29156,
"Casting_Middle":29157,
"Casting_Bottom":29158,
"EXP2TOP":29159,
"BlueAura_Effect":29160,
"Pink_Glow_Effect":29161,
"Shadow_Effect":29162,
"Reactor_A_Tolerance":29166,
"Reactor_A_HIT":29167,
"Reactor_A_FLEE":29168,
"Reactor_A_MDEF":29169,
"Reactor_S_ATK":29170,
"Reactor_S_MATK":29171,
"Reactor_S_Avoid":29172,
"Reactor_S_MHP":29173,
"Reactor_S_Quick":29174,
"Reactor_S_CRI":29175,
"Sky_Ground":29176,
"Kyoukou1":29177,
"Kyoukou2":29178,
"Kyoukou3":29179,
"Kyoukou4":29180,
"Kyoukou5":29181,
"Atk_Race_0":29182,
"Atk_Race_1":29183,
"Atk_Race_2":29184,
"Atk_Race_3":29185,
"Atk_Race_4":29186,
"Atk_Race_5":29187,
"Atk_Race_6":29188,
"Atk_Race_7":29189,
"Atk_Race_8":29190,
"Atk_Race_9":29191,
"Atk_Property_0":29192,
"Atk_Property_1":29193,
"Atk_Property_2":29194,
"Atk_Property_3":29195,
"Atk_Property_4":29196,
"Atk_Property_5":29197,
"Atk_Property_6":29198,
"Atk_Property_7":29199,
"Atk_Property_8":29200,
"Atk_Property_9":29201,
"Atk_Size_0":29202,
"Atk_Size_1":29203,
"Atk_Size_2":29204,
"Atk_Class_1":29205,
"Atk_Range":29206,
"Atk_Drain_HP":29207,
"SPdrain2_Top":29208,
"SPdrain2":29209,
"HPdrain23":29210,
"HPdrain23_Top":29211,
"HIT3":29212,
"HIT6":29213,
"E_Flameguard":29214,
"E_Warmth":29215,
"E_Genie":29216,
"E_Glorious":29217,
"E_Ghost":29218,
"E_Angelic":29219,
"E_Innoxious":29220,
"E_Divine":29221,
"E_Holy":29222,
"Water_Sky":29223,
"WhiteBody_Effect":29224,
"WaterField_Effect":29225,
"ExplodingWave_Effect":29226,
"Heal":29227,
"Steal":29228,
"Teleport":29229,
"JP_EV02":29230,
"Energy_Drop4":29231,
"Energy_Drop5":29232,
"Energy_Drop6":29233,
"Energy_Drop7":29234,
"Dodge1_J":29235,
"Dodge2_J":29236,
"Evasion5":29237,
"Evasion10":29238,
"Hit5":29239,
"Hit10":29240,
"Critical10":29241,
"IndestructibleArmor1":29242,
"NoDispell1":29243,
"PlayerTolerance1":29244,
"PlayerTolerance2":29245,
"PlayerTolerance3":29246,
"PlayerTolerance4":29247,
"PlayerTolerance5":29248,
"Neev_Rest_1":29249,
"Neev_Rest_2":29250,
"Neev_Rest_3":29251,
"Neev_Rest_4":29252,
"Neev_Eternity1":29253,
"Neev_Eternity2":29254,
"Neev_Eternity3":29255,
"Neev_Eternity4":29256,
"Neev_Eternity5":29257,
"Neev_Eternity6":29258,
"Neev_Eternity7":29259,
"Neev_Wound1":29260,
"Neev_Wound2":29261,
"Neev_Wound3":29262,
"Neev_Wound4":29263,
"Neev_Wound5":29264,
"Neev_Wound6":29265,
"Neev_Wound7":29266,
"Neev_Wound8":29267,
"Neev_Wound9":29268,
"Neev_Wound10":29269,
"Neev_Blood1":29270,
"Neev_Blood2":29271,
"Neev_Blood3":29272,
"Neev_Blood4":29273,
"Neev_Blood5":29274,
"Neev_Blood6":29275,
"Neev_Honor1":29276,
"Neev_Honor2":29277,
"Neev_Honor3":29278,
"Neev_Death1":29279,
"Neev_Death2":29280,
"Neev_Death3":29281,
"Neev_Death4":29282,
"Jade_J":29300,
"Armor_Water":29302,
"Armor_Wind":29303,
"Armor_Ground":29304,
"Armor_Fire":29305,
"Armor_Darkness":29306,
"Armor_Saint":29307,
"Armor_Undead":29308,
"Armor_Poison":29309,
"Racing_E_Rune1":29310,
"Racing_E_Rune2":29311,
"Racing_E_Rune3":29312,
"Racing_E_Royal1":29313,
"Racing_E_Royal2":29314,
"Racing_E_Royal3":29315,
"Racing_E_Mecha1":29316,
"Racing_E_Mecha2":29317,
"Racing_E_Mecha3":29318,
"Racing_E_Gene1":29319,
"Racing_E_Gene2":29320,
"Racing_E_Gene3":29321,
"Racing_E_Cross1":29322,
"Racing_E_Cross2":29323,
"Racing_E_Cross3":29324,
"Racing_E_Chaser1":29325,
"Racing_E_Chaser2":29326,
"Racing_E_Chaser3":29327,
"Racing_E_Warlock1":29328,
"Racing_E_Warlock2":29329,
"Racing_E_Warlock3":29330,
"Racing_E_Sorcer1":29331,
"Racing_E_Sorcer2":29332,
"Racing_E_Sorcer3":29333,
"Racing_E_Bishop1":29334,
"Racing_E_Bishop2":29335,
"Racing_E_Bishop3":29336,
"Racing_E_Sura1":29337,
"Racing_E_Sura2":29338,
"Racing_E_Sura3":29339,
"Racing_E_Ranger1":29340,
"Racing_E_Ranger2":29341,
"Racing_E_Ranger3":29342,
"Racing_E_Wand_Min1":29343,
"Racing_E_Wand_Min2":29344,
"Racing_E_Wand_Min3":29345,
"Racing_E_Gunner1":29346,
"Racing_E_Gunner2":29347,
"Racing_E_Gunner3":29348,
"Racing_E_Ninja1":29349,
"Racing_E_Ninja2":29350,
"Racing_E_Ninja3":29351,
"Racing_E_Super1":29352,
"Racing_E_Super2":29353,
"Racing_E_Super3":29354,
"Racing_E_Doram1":29355,
"Racing_E_Doram2":29356,
"Racing_E_Doram3":29357,
"Casting_Robe":29358,
"Fatal_Top":29359,
"Fatal_Bottom":29360,
"Fatal_Robe":29361,
"DoubleAttack":29362,
"Strong_Blow1":29366,
"Strong_Blow2":29367,
"Strong_Blow3":29368,
"Strong_Blow4":29369,
"Strong_Blow5":29370,
"Release_Of_Magic":29371,
"CastFixed_Delay50":29372,
"Skill_DelaySP":29373,
"ThriftSP":29374,
"PlayerTolerance6":29375,
"PlayerTolerance7":29376,
"PlayerTolerance8":29377,
"PlayerTolerance9":29378,
"PlayerTolerance10":29379,
"ATK5":29380,
"MATK5":29381,
"Neev_Honor_Hit":29382,
"Neev_Honor_Flee":29383,
"Neev_Honor_Luk":29384,
"Neev_Death_Tech":29385,
"Neev_Death_Luk":29386,
"Sura_Top":29423,
"Sura_Middle":29424,
"Sura_Bottom":29425,
"Sura_Robe":29426,
"Sura_Robe2":29427,
"Ranger_Top":29428,
"Ranger_Middle":29429,
"Ranger_Bottom":29430,
"Ranger_Robe":29431,
"Sorcerer_Top":29432,
"Sorcerer_Middle":29433,
"Sorcerer_Bottom":29434,
"Sorcerer_Robe":29435,
"Dynast":29436,
"ReactorZ_Knockback":29438,
"ReactorZ_Immortal":29439,
"ReactorZ_Killgain":29440,
"ReactorZ_Reincarnation":29441,
"ReactorZ_NoDispell":29442,
"ReactorZ_Clairvoyance":29443,
"ReactorZ_CastFixed":29444,
"Amplification1":29445,
"Amplification2":29446,
"Amplification3":29447,
"Amplification4":29448,
"Amplification5":29449,
"Runeknight_Top":29460,
"Runeknight_Middle":29461,
"Runeknight_Bottom":29462,
"Runeknight_Robe":29463,
"Genetic_Top":29464,
"Genetic_Middle":29465,
"Genetic_Bottom":29466,
"Genetic_Robe":29467,
"Warlock_Top":29468,
"Warlock_Middle":29469,
"Warlock_Bottom":29470,
"Warlock_Robe":29471,
"Shadowchaser_Top":29477,
"Shadowchaser_Middle":29478,
"Shadowchaser_Bottom":29479,
"Shadowchaser_Robe":29480,
"Mechanic_Top":29481,
"Mechanic_Middle":29482,
"Mechanic_Bottom":29483,
"Mechanic_Robe":29484,
"WanderMinstrel_Top":29485,
"WanderMinstrel_Middle":29486,
"WanderMinstrel_Bottom":29487,
"WanderMinstrel_Robe":29488,
"Hero":29509,
"Neev_Wound11":29510,
"Reactor_A_Player":29511,
"Endurance":29512,
"Highpriest_Top":29513,
"Highpriest_Middle":29514,
"Highpriest_Bottom":29515,
"Archbishop_Robe":29516,
"Paladin_Top":29517,
"Paladin_Middle":29518,
"Paladin_Bottom":29519,
"Royalguard_Robe":29520,
"Assassincross_Top":29521,
"Assassincross_Middle":29522,
"Assassincross_Bottom":29523,
"Guillotinecross_Robe":29524,
"NJ_1":29525,
"NJ_2":29526,
"Improve_Orb_Def":29527,
"Improve_Orb_Mdef":29528,
"Improve_Orb_HealHP":29529,
"Improve_Orb_Spirit":29530,
"Improve_Orb_Health":29531,
"Improve_Orb_HealSP":29532,
"Improve_Orb_Heal":29533,
"Improve_Orb_Atk":29534,
"Improve_Orb_Matk":29535,
"Improve_Orb_Archer":29536,
"Improve_Orb_Speed":29537,
"Improve_Orb_Cast":29538,
"Improve_Orb_Cri":29539,
"Improve_Orb_Delay":29540,
"Improve_Orb_Fix":29541,
"Improve_Orb_Above":29542,
"Improve_Orb_Life":29543,
"Improve_Orb_Soul":29544,
"Improve_Orb_M_Heal":29545,
"Improve_Orb_M_Soul":29546,
"Improve_Orb_L_Vit":29547,
"Improve_Orb_L_INT":29548,
"Improve_Orb_L_DEX":29549,
"Improve_Orb_L_STR":29550,
"Improve_Orb_L_AGI":29551,
"Improve_Orb_L_LUK":29552,
"Racing_E_Star1":29579,
"Racing_E_Star2":29580,
"Racing_E_Star3":29581,
"Racing_E_Soul1":29582,
"Racing_E_Soul2":29583,
"Racing_E_Soul3":29584,
"Arcana":29585,
"PlayerTolerance12":29586,
"Gh_md_agi":29587,
"Gh_md_str":29588,
"Gh_md_dex":29589,
"Gh_md_int":29590,
"Gh_md_vit":29591,
"Gh_md_luk":29592,
"Unfrozen_JP":29593,
"Seyren_Memory":29594,
"Harword_Memory":29595,
"Eremes_Memory":29596,
"Katrinn_Memory":29598,
"Magaleta_Memory":29599,
"Shecil_Memory":29600,
"Randel_Memory":29601,
"Flamel_Memory":29602,
"Gertie_Memory":29603,
"Celia_Memory":29604,
"Chen_Memory":29605,
"Tren_Memory":29606,
"Alpho_Memory":29607,
"Sura_Bottom2":29611,
"Sura_Middle2":29612,
"Sura_Top2":29613,
"Sorcerer_Robe2":29614,
"Sorcerer_Bottom2":29615,
"Sorcerer_Middle2":29616,
"Sorcerer_Top2":29617,
"Shadowchaser_Robe2":29618,
"Shadowchaser_Bottom2":29619,
"Shadowchaser_Middle2":29620,
"Shadowchaser_Top2":29621,
"Lucky_Amulet6":29646,
"Lucky_Amulet7":29647,
"Lucky_Amulet8":29648,
"IgnoreDef50":29649,
"IgnoreMdef50":29650,
"Soullinker_Top":29651,
"Soullinker_Middle":29652,
"Soullinker_Bottom":29653,
"Soulreaper_Robe":29654,
"Gladiator_Top":29655,
"Gladiator_Middle":29656,
"Gladiator_Bottom":29657,
"Staremperor_Robe":29658,
"Ninja_Top":29659,
"Ninja_Middle":29660,
"Ninja_Bottom":29661,
"Kagerou_Robe":29662,
"Oboro_Robe":29663,
"Gunslinger_Top":29664,
"Gunslinger_Middle":29665,
"Gunslinger_Bottom":29666,
"Rebellion_Robe":29667,
"Doram_Top":29668,
"Doram_Middle":29669,
"Doram_Bottom":29670,
"Doram_Robe":29671,
"Time_Jewely_Str_1":29672,
"Time_Jewely_Str_2":29673,
"Time_Jewely_Str_3":29674,
"Time_Jewely_Agi_1":29675,
"Time_Jewely_Agi_2":29676,
"Time_Jewely_Agi_3":29677,
"Time_Jewely_Vit_1":29678,
"Time_Jewely_Vit_2":29679,
"Time_Jewely_Vit_3":29680,
"Time_Jewely_Int_1":29681,
"Time_Jewely_Int_2":29682,
"Time_Jewely_Int_3":29683,
"Time_Jewely_Dex_1":29684,
"Time_Jewely_Dex_2":29685,
"Time_Jewely_Dex_3":29686,
"Time_Jewely_Luk_1":29687,
"Time_Jewely_Luk_2":29688,
"Time_Jewely_Luk_3":29689,
"Wepon_Property_Fire":29690,
"Wepon_Property_Water":29691,
"Wepon_Property_Wind":29692,
"Wepon_Property_Ground":29693,
"Wepon_Property_Darkness":29695,
"Wepon_Property_Telekine":29696,
"Wepon_Property_Poison":29697,
"Matk_Race_0":29698,
"Matk_Race_2":29699,
"Matk_Race_7":29700,
"Matk_Property_1":29701,
"Matk_Property_7":29702,
"Matk_Property_9":29703,
"Matk_Size_0":29704,
"Matk_Class_1":29705,
"Tenacity1":29706,
"Tenacity2":29707,
"Tenacity3":29708,
"Tenacity4":29709,
"Tenacity5":29710,
"Tenacity6":29711,
"Tenacity7":29712,
"Tenacity8":29713,
"Tenacity9":29714,
"Tenacity10":29715,
"StarE_Enchant_1":29716,
"StarE_Enchant_2":29717,
"StarE_Enchant_3":29718,
"SoulR_Enchant_1":29719,
"SoulR_Enchant_2":29720,
"SoulR_Enchant_3":29721,
"Curse_Effect_J":29722,
"Star_Effect_J":29723,
"Murderous_Grudge":29724,
"aegis_29725":29725,
"aegis_29727":29727,
"Rudo_Card_J":31000,
"Lora_Card_J":31001,
"Elvira_Card_J":31002,
"Gioia_Card_J":31003,
"Soheon_Card_J":31004,
"Daehyon_Card_J":31005,
"LoVA_Hades_Card":31006,
"LoVA_R_Hades_Card":31007,
"LoVA_Lulu_Card":31008,
"LoVA_R_Lulu_Card":31009,
"LoVA_Kima_Card":31010,
"LoVA_R_Kima_Card":31011,
"LoVA_Bahamut_Card":31012,
"LoVA_R_Bahamut_Card":31013,
"LoVA_Ragnarok_Card":31014,
"LoVA_R_Ragnarok_Card":31015,
"XM_Tree_Card":31016,
"XM_Cookie_Card":31017,
"XM_Mystcase_Card":31018,
"XM_Lude_Card":31019,
"XM_Hylozoist_Card":31020,
"XM_Marionette_Card":31021,
"XM_Teddy_Bear_Card":31022,
"XM_Celine_Kimi_Card":31023,
"As_Bdy_Knight_Card":31024,
"As_Wind_Ghost_Card":31025,
"As_Ragged_Golem_Card":31026,
"C_Pretty_Bear":31027,
"C_Black_Cat_Hood":31028,
"C_Pig_Nose":31029,
"C_Tiger_Face":31030,
"C_Tare_Pope_Casual":31031,
"C_Tare_Luwmin":31032,
"C_BelieversCap":31033,
"C_Pirate_Bandana":31034,
"C_Bankruptcy_Of_Heart":31035,
"C_Satto_Hat":31036,
"C_Beret":31037,
"C_Cheks_Vandana":31038,
"C_Kings_Crown":31039,
"C_Magical_Feather":31040,
"C_Cat_Lace_Hairband":31041,
"C_Survive_Circlet":31042,
"C_Ribbon_White":31043,
"C_Pink_Drooping_Kitty":31044,
"C_Blue_Rear_Ribbon":31045,
"C_White_Rose_Princess":31046,
"C_First_Love_Cheek":31047,
"C_White_Lily_Balck":31048,
"C_Marin_Crown":31049,
"C_Flower_Poring_Hat":31050,
"C_HappySummer_SunVisor":31051,
"C_Alchemist_Mask":31052,
"C_King_Tiger_Doll_Hat":31053,
"C_Sting_Hat":31054,
"C_Poring_Soap_Pipe":31055,
"C_Exploding_Wave_Red":31056,
"C_Eremes_Scarf_Black":31057,
"C_Gelato_Hat":31058,
"C_Sailor_Hat":31059,
"C_Starfish_Headband":31060,
"C_Forceps_Hairpin":31061,
"C_Eleanor_Wig":31062,
"C_Hair_Bun_BU":31063,
"C_Hair_Bun_RD":31064,
"C_Hair_Bun_YL":31065,
"C_Hair_Bun_GN":31066,
"C_Hair_Bun_BL":31067,
"C_Hair_Bun_WH":31068,
"C_Hair_Bun_OM":31069,
"C_Hair_Bun_PP":31070,
"C_Roll_Twin_BU":31071,
"C_Roll_Twin_RD":31072,
"C_Roll_Twin_YL":31073,
"C_Roll_Twin_GN":31074,
"C_Roll_Twin_BL":31075,
"C_Roll_Twin_WH":31076,
"C_Roll_Twin_OM":31077,
"C_Roll_Twin_PP":31078,
"C_Long_Pony_BU":31079,
"C_Long_Pony_RD":31080,
"C_Long_Pony_YL":31081,
"C_Long_Pony_GN":31082,
"C_Long_Pony_BL":31083,
"C_Long_Pony_WH":31084,
"C_Long_Pony_OM":31085,
"C_Long_Pony_PP":31086,
"C_Dwarf_Beard":31087,
"C_Mad_Hatter":31088,
"C_Exploding_Wave_Sca":31089,
"C_Angeling_Wanna_Fly":31090,
"C_Gold_Shower":31091,
"C_Rabbit_Ribbon":31092,
"C_Underlamp":31093,
"C_Dice_Hat":31094,
"C_JP_EV01":31095,
"C_JP_EV02":31096,
"C_JP_EV03":31097,
"C_JP_EV04":31098,
"C_JP_EV05":31099,
"C_JP_EV06":31100,
"C_JP_EV07":31101,
"C_JP_EV08":31102,
"C_JP_EV09":31103,
"C_JP_EV10":31104,
"C_RoCelebrationHat":31105,
"Eye_Patch_Blue":31106,
"Eye_Patch_Red":31107,
"C_Free_Hug_BR":31108,
"C_Guildsman_Recruit_BR":31109,
"C_Party_Seeker_BR":31110,
"C_Party_Mem_Recruit_BR":31111,
"C_Begging_Board_BR":31112,
"C_Doctor_Cap":31113,
"C_Pretend_Murdered":31114,
"C_Truemoney_TH":31115,
"C_Truemoney_TH7":31116,
"C_Hoplite_Helmet":31117,
"C_Assassin_Skull_Mask":31118,
"C_Blue_Wizardry_Hat":31119,
"C_Vampire_Familiar":31120,
"C_Stall_Of_Bat":31121,
"C_Bloody_Stop_Bandage":31122,
"C_Ghostring_Tall_Hat":31123,
"C_Ribbon_Chef_Hat":31124,
"C_QueenAnzRevenge":31125,
"C_Nestea_Hat":31126,
"C_Taiwan_Flag_Hat":31127,
"C_Bride_Mask":31128,
"C_Mr_Scream":31129,
"C_Indian_Hair_Piece":31130,
"C_Holy_Bonnet":31131,
"C_Christmas_Wreath":31132,
"C_Gambler_Seal":31133,
"C_Chatty_Parrot":31134,
"C_Fancy_Mini_Crown":31135,
"C_Clock_Casket":31136,
"C_Blue_Rose_Ornament":31137,
"C_Piamette_Hood_Red":31138,
"C_White_Rabbit_Ear":31139,
"C_Cowboy_Hat_B":31140,
"C_Cactus_Corsage":31141,
"C_Time_Accessory_J":31142,
"C_Krathong_Crown_TH":31143,
"C_Indi_Feather_Band":31144,
"C_AliceFriesinger_Hat69":31145,
"C_KarduiEar":31146,
"C_Tare_Domovoi":31147,
"C_Debril_Doll_Hat":31148,
"C_Nydhog_Wig":31149,
"C_Shalosh_Head_Dress":31150,
"C_Chasher_Ear":31151,
"C_Piamette_BowTie_Red":31152,
"C_Aniv_Star_Hat2":31153,
"C_Cap":31154,
"C_Spinning_Eyes":31155,
"C_Fruit_Shell":31156,
"C_Spirit_Chain":31157,
"C_Squirrel_Ear_Hat":31158,
"C_Jormungandr_Hat":31159,
"C_Rune_Helm":31160,
"C_Tiger_Mask":31161,
"C_Shaving_Foam":31162,
"C_Sheep_Hat":31163,
"C_Brown_Stall":31164,
"C_Piggyback":31165,
"C_Teddy_Bear_Hood":31166,
"C_Lunatic_Ear_Black":31167,
"C_Mouton_Life_BL":31168,
"C_Hat_Of_Outlaw":31169,
"C_Power_Of_Thor":31170,
"C_Cat_Hat":31171,
"C_Roast_Memory":31172,
"C_Crown_Parrot":31173,
"C_Weird_Bread_Bag":31174,
"C_Strawberry_Hat":31175,
"C_Looking":31176,
"C_Tail_Hat":31177,
"C_Flame_Muffler":31178,
"C_Wolf_Masquerade":31179,
"C_Shura_King_Pledge":31180,
"C_Necklace_Rosary":31181,
"C_Side_Cap":31182,
"C_Fallen_Angel_Blessing":31183,
"C_Hawkeyes":31184,
"C_Engineer_Cap":31185,
"C_Black_Cat":31186,
"C_War_Princess_Ribbon":31187,
"C_Mono_Gothic_Bonnet":31188,
"C_Cat_Ears_Cape_Red":31189,
"C_Angel_Mini_Silk_Hat_B":31190,
"C_Whikebain_Ears_TW":31191,
"C_Baby_Cat_Ears_TW":31192,
"C_Tare_Ahat":31193,
"C_Spinning_Propeller":31194,
"C_Choco_Minihat":31195,
"C_JP_EV12":31196,
"C_Egg_Crispinette":31197,
"C_Octopus_Hat_J":31198,
"C_Weird_Goatee":31199,
"C_Wrapping_Ribbon":31200,
"C_Royal_Rabbit_Crown":31201,
"C_Dog_Officer":31202,
"C_Charcoal_Stove":31203,
"C_Drooping_White_Kitty":31204,
"C_L_Orc_Hero_Helm":31205,
"C_Rune_Hairband":31206,
"C_Dokkebi_Mask":31207,
"C_Straight_Long_YL":31208,
"C_Straight_Long_WH":31209,
"C_Side_Pigtail_BU":31210,
"C_Side_Pigtail_RD":31211,
"C_Side_Pigtail_YL":31212,
"C_Side_Pigtail_GN":31213,
"C_Side_Pigtail_BL":31214,
"C_Side_Pigtail_WH":31215,
"C_Side_Pigtail_OM":31216,
"C_Side_Pigtail_PP":31217,
"C_Low_Pony_BU":31218,
"C_Low_Pony_RD":31219,
"C_Low_Pony_YL":31220,
"C_Low_Pony_GN":31221,
"C_Low_Pony_BL":31222,
"C_Low_Pony_WH":31223,
"C_Low_Pony_OM":31224,
"C_Low_Pony_PP":31225,
"C_Long_Twin_BU":31226,
"C_Long_Twin_RD":31227,
"C_Long_Twin_YL":31228,
"C_Long_Twin_GN":31229,
"C_Long_Twin_BL":31230,
"C_Long_Twin_WH":31231,
"C_Long_Twin_OM":31232,
"C_Long_Twin_PP":31233,
"C_Persika_J":31234,
"C_Large_Ribbonmuffler_V":31235,
"C_Subject_Aura_V":31236,
"C_Pope_Ribbon_V":31237,
"C_Good_Wedding_Veil_V":31238,
"C_Love_Rabbithood_V":31239,
"C_Whisper_Mask_V":31240,
"C_Blazing_Sun_V":31241,
"C_Anubis_Helm_V":31242,
"C_Tongue_Mask_V":31243,
"C_Sky_Helm_V":31244,
"C_Bell_Flower":31245,
"C_Humming_Bird":31246,
"C_Hippo_Hat":31247,
"C_Isabella_Red_Ear":31248,
"C_Rabbit_Hopping":31249,
"C_Wonderful_Beast_Ear":31250,
"C_Cat_Mouth":31251,
"C_Cat_Ear_Hat_White":31252,
"C_Bright_Fury":31253,
"C_Horse_King_Red":31254,
"C_Dalcom_Helmet":31255,
"C_Jaguar_Hat_J":31256,
"C_Clay_Poring_Jar":31257,
"C_White_Clay_Filler":31258,
"C_Bubble_A_Angel_H":31259,
"C_Observer_J":31260,
"C_Soda_In_Mouth":31261,
"C_Disposable_3D_Glass":31262,
"C_Disposable_Popcorn":31263,
"C_Shelterwing_Ears_V":31264,
"C_Straightpony_BU_V":31265,
"C_Straightpony_RD_V":31266,
"C_Straightpony_YL_V":31267,
"C_Straightpony_GN_V":31268,
"C_Straightpony_BL_V":31269,
"C_Straightpony_WH_V":31270,
"C_Straightpony_OM_V":31271,
"C_Straightpony_PP_V":31272,
"C_Cowlick_BU_V":31273,
"C_Cowlick_RD_V":31274,
"C_Cowlick_YL_V":31275,
"C_Cowlick_GN_V":31276,
"C_Cowlick_BL_V":31277,
"C_Cowlick_WH_V":31278,
"C_Cowlick_OM_V":31279,
"C_Cowlick_PP_V":31280,
"C_Loosewavetwin_BU_V":31281,
"C_Loosewavetwin_RD_V":31282,
"C_Loosewavetwin_YL_V":31283,
"C_Loosewavetwin_GN_V":31284,
"C_Loosewavetwin_BL_V":31285,
"C_Loosewavetwin_WH_V":31286,
"C_Loosewavetwin_OM_V":31287,
"C_Loosewavetwin_PP_V":31288,
"C_Wing_Ear_BL_V":31289,
"C_Adv_Ang_SchCap":31290,
"C_Adv_Dev_SchCap":31291,
"C_Invisible_Mask_TW":31292,
"C_Kings_Crown_Purple":31293,
"C_Jirant_Circlet_Red":31294,
"C_Priest_Hat_J":31295,
"C_Strawberry_In_Mouth":31296,
"C_Love_Berry":31297,
"C_Para_Team_Hat2":31298,
"C_White_Rabbit":31299,
"C_Warm_Cat_Muffler":31300,
"C_Blinking_Eyes":31301,
"C_Black_Magenta_Ribbon":31302,
"C_Memory_Of_Noodle":31303,
"C_Fan_Of_Summer":31304,
"C_TW_1th_Balloon":31305,
"C_Tucan_Hat_JP":31306,
"C_Blue_Arara_Hat":31307,
"C_Protect_Feathers":31308,
"C_PW_Marching_Hat":31309,
"C_666_DevilEar":31310,
"C_Tha_Maero_Mask_J":31311,
"C_Hades_Helm":31312,
"C_FallenAngelWingEar":31313,
"C_Ghost_Holiday":31314,
"C_Stall_Of_Angel":31315,
"C_FlutterButterfly_BL":31316,
"C_15th_Anniversary_Wing":31317,
"C_Gerhard_Von_Devi":31318,
"C_Fan_Of_Summer_R":31319,
"C_Pinwheel_Cap_R":31320,
"C_Shining_Sunflower":31321,
"C_Candy_Hat":31322,
"C_Love_Daddy":31323,
"C_DJ_Kitty":31324,
"C_Q_Scaraba_Crown":31325,
"C_Rolf_Von_Gigue_666":31326,
"C_Stretched_Nose_M":31327,
"C_Faceworm_Egg_Shell":31328,
"C_Alice_Wig":31329,
"C_Fallen_Angel_Valletta":31330,
"C_Chung_E_Shinyon_Cap":31331,
"C_Khalitzburg_Helm_BL":31332,
"C_Straight_Pony_WH_V":31333,
"C_Straight_Pony_BU_V":31334,
"C_Straight_Pony_OM_V":31335,
"C_Straight_Pony_RD_V":31336,
"C_Straight_Pony_PP_V":31337,
"C_Straight_Pony_GN_V":31338,
"C_Straight_Pony_YL_V":31339,
"C_Straight_Pony_BL_V":31340,
"C_Low_Pony_BU_V":31341,
"C_Low_Pony_RD_V":31342,
"C_Low_Pony_YL_V":31343,
"C_Low_Pony_GN_V":31344,
"C_Low_Pony_BL_V":31345,
"C_Low_Pony_WH_V":31346,
"C_Low_Pony_OM_V":31347,
"C_Low_Pony_PP_V":31348,
"C_Roll_Twin_BU_V":31349,
"C_Roll_Twin_RD_V":31350,
"C_Roll_Twin_YL_V":31351,
"C_Roll_Twin_GN_V":31352,
"C_Roll_Twin_BL_V":31353,
"C_Roll_Twin_WH_V":31354,
"C_Roll_Twin_OM_V":31355,
"C_Roll_Twin_PP_V":31356,
"Oliver_Wolf_Hood_CN":31357,
"C_Hahoe_Mask_CN":31358,
"C_Assassin_Mask_CN":31359,
"C_Centimental_Flower_CN":31360,
"C_Blush_CN":31361,
"C_Magestic_Goat_CN":31362,
"C_Frog_Cap_CN":31363,
"C_Deviruchi_Cap_CN":31364,
"C_Boys_Cap_CN":31365,
"C_Valkyrie_Helm_CN":31366,
"C_Wish_Tree_Hat":31367,
"C_Harvest_Festa_Hat":31368,
"C_Straight_Long_WHK":31369,
"C_Straight_Long_YLK":31370,
"C_Sorin_Doll_Hat":31371,
"C_Binit_Doll_Hat":31372,
"C_Kings_Crown_":31373,
"C_Explosion_Gum":31374,
"C_Demons_Eye":31375,
"C_Jirant_Circlet":31376,
"C_Glastheim_Onlooker":31377,
"C_CatharinaPawnBrad60":31378,
"C_Drama_Clockwork":31379,
"C_Gossip_Raven":31380,
"C_Diabolic_Lapel":31381,
"C_Cat_Ears_Punkish":31382,
"C_Volume_Low_Twin":31383,
"C_False_Ears":31384,
"C_Gothic_Pumpkin_Head":31385,
"C_SurviveOrb":31386,
"C_Jjakk":31387,
"C_Garden_Of_Eden":31388,
"C_White_Bird_Rose":31389,
"C_Let_It_Snow":31390,
"C_Floating_Stone_Of_Int":31391,
"C_Radio_Antenna":31392,
"C_Vajra":31393,
"C_White_Wizardry_Hat":31394,
"C_Book_Of_Magic":31395,
"C_Sorcerer_Hood":31396,
"C_Pope_Sitting_Head":31397,
"C_Blinking_Thin_Eyes":31398,
"C_Darkness_Veil":31399,
"C_Ribbon":31400,
"C_Blue_Coif":31401,
"C_Idun_Green_Apple":31402,
"C_Wall":31403,
"C_Poring_Traffic_Light":31404,
"C_Eleanor_Wig_YL":31405,
"C_Nydhog_Wig_WH":31406,
"C_Alice_Wig_PK":31407,
"C_RORush_Goat":31408,
"C_Barrel_Helm":31409,
"C_Gods_Helm":31410,
"C_Leo_Diadem":31411,
"C_Virgo_Crown":31412,
"C_Taurus_Crown":31413,
"C_Cancer_Diadem":31414,
"C_Wanderer_Sakkat":31415,
"C_SeraphimCoronet":31416,
"C_Onigiri_Hat":31417,
"C_Leek_In_Mouth":31418,
"C_Angel_Of_Happiness":31419,
"C_SantaPoring_Promo":31420,
"C_Pink_Angeling_Bubble":31421,
"C_Angeling_Bubble":31422,
"C_Bear_Balloon":31423,
"C_LoveLove_Balloon":31424,
"C_Long_Octopus_Balloon":31425,
"C_Male_Poring_Balloon":31426,
"C_Fmale_Poring_Balloon":31427,
"C_Panda_Balloon":31428,
"C_Blue_Poring_Bubble":31429,
"C_Seppl_Hat_TW":31430,
"C_Curupira_Hat_TW":31431,
"C_Luwmin_Ice":31432,
"C_Astro_Circle":31433,
"C_Cloud_Buster":31434,
"C_Magician_Knithat":31435,
"C_White_Drooping_Kitty":31436,
"C_Baby_Penguin":31437,
"C_Fluffy_Angel_Cape":31438,
"C_Fluffy_Heart_Earmuffs":31439,
"C_Snow_Bear_Food":31440,
"C_Penguin_Cap_BU":31441,
"C_Mr_Smile_V":31442,
"C_Munak_Turban_V":31443,
"C_Bongun_Hat_V":31444,
"Feather_Fedora_TW":31445,
"C_Toy_Syringe":31446,
"C_Pale_Moon_Hat":31447,
"C_Sting_Silk_Ribbon":31448,
"C_Blue_Rose_Eyepatch":31449,
"C_Lolita_Two_Side_Up":31450,
"C_Blue_Frill_Ribbon":31451,
"C_White_Cat":31452,
"C_L_RibbonMuff_Black":31453,
"C_Love_Feeling":31454,
"Enchanted_Dog":31455,
"C_Baby_Leopard_Cat":31456,
"C_Husky_Hat":31457,
"C_1Grade_Balloon_TW":31458,
"C_Sweets_Bonbon":31459,
"C_Blessing_Sky_Lantern":31460,
"C_Male_Poring_Earmuff":31461,
"C_Female_Poring_Earmuff":31462,
"C_Flying_Drone":31463,
"C_Mike_Hat":31464,
"C_Egg_Minihat":31465,
"C_Holy_Egg_Hat":31466,
"C_Mimic_Egg_Shell":31467,
"C_Stripe_Hat":31468,
"C_Costume08_L":31469,
"C_Tengu_Scroll":31470,
"C_CelestialWoman_Flower":31471,
"C_Fairy_Feathers":31472,
"C_Tipsy":31473,
"C_Straight_Long_BL":31474,
"C_Black_Fox_Ear_Ribbon":31475,
"C_Cherry_Blossom_Hat_YL":31476,
"C_Costume06_L":31477,
"C_Eleanor_Wig_V":31478,
"C_ManyStars_TW":31479,
"C_Jioia_TW":31480,
"C_CatCoffeeCup_TW":31481,
"C_LunaticMuffler_TW":31482,
"C_CatEarRibbon_TW":31483,
"C_JP_EV13":31484,
"C_JP_EV14":31485,
"C_Diver's_Goggles":31486,
"C_Eye_Bandage":31487,
"C_Mvp":31488,
"C_Bouquet_Hat":31489,
"C_Poring_Muffler":31490,
"C_Orange_Tabby_Cat":31491,
"C_Cat_Ears_Cape_Brown":31492,
"C_Volume_Low_Twin_WH":31493,
"C_Volume_Low_TwinK":31494,
"C_Lolita_Two_Side_UpK":31495,
"C_Yggdrasil_Crown":31496,
"C_Flowery_Vision_TH":31497,
"C_Elephangel_TH":31498,
"C_Easter_Egg_Shell":31499,
"C_Sparkler_Stick_TH":31500,
"C_Sparkler_Fountain_TH":31501,
"C_Aches_Love_Cobra_TH":31502,
"C_TW_2th_Balloon":31503,
"C_Starving_Fish_Hat":31504,
"C_Falcon_Mask":31505,
"C_Malangdo_Pirate":31506,
"C_Yellow_Drooping_Kitty":31507,
"C_Isabella_Blue_Ear":31508,
"C_Fawn_Ear":31509,
"C_Cat_Ear_Short":31510,
"C_Cat_Ear_Long":31511,
"C_Panda_Rabbit":31512,
"C_Rabbit_Hopping_BL":31513,
"C_American_S_hair":31514,
"C_Leopard_Cat":31515,
"C_Mini_Melon":31516,
"C_JP_EV15":31517,
"C_Pop_Popcorn_Hat":31518,
"C_Slurp_Slurp_Hat":31519,
"C_Popcorn_Hat":31520,
"C_Citron_Hat":31521,
"C_Orange_Hat":31522,
"C_Yellow_Yuzu_Hat":31523,
"C_Lunch_box":31524,
"C_Kid_Deviling":31525,
"C_Shaman_Hat":31526,
"C_14_RainbowWing":31527,
"C_Stardust_Hairband":31528,
"C_Happy_Rabbit_Ribbon":31529,
"C_Greater_Dracul_Horn":31530,
"C_Lovely_Heart_Cap":31531,
"C_Neev_Barrette":31532,
"C_Warm_Cat_Muffler_BL":31533,
"C_Rainbow_Star":31534,
"C_Old_Pink_Poo_Hat":31535,
"C_Chibi_Beelzebub_Hat":31536,
"C_Return_TW_2th_Hat":31537,
"C_Love_Feeling_J":31538,
"C_Bulgogi_TW":31539,
"C_Gemini_RedEyes":31540,
"C_Drosera_Hairpin":31541,
"C_Clay_Poring_Jar_Jp":31542,
"C_Eru_Rava_Hat":31543,
"C_Piamette_Roll_Hair":31544,
"C_Eremes_Scarf_BU":31545,
"C_Clock_Casket_RD":31546,
"C_Poporing_Mascot_Cos":31547,
"C_Love_Cheek_V":31548,
"C_Little_Aquarium_V":31549,
"C_Tone_Of_Gold_V":31550,
"C_Black_Glasses_V":31551,
"C_Blue_Ribbon_V":31552,
"C_Wings_Of_Victory_V":31553,
"C_Bread_Bag2_V":31554,
"C_Hoplite_Helmet_V":31555,
"C_Moonlight_F_Hat_V":31556,
"C_Hoplite_Helmet_Silver":31557,
"C_Hoplite_Helmet_Black":31558,
"C_Royalguard_Necklace":31559,
"C_DVAngelNurseCap":31560,
"C_8Type_PurgatorialWing":31561,
"C_Zherlthsh_Doll":31562,
"C_Blue_EyeShadow_JP":31563,
"C_Variant_Veil":31564,
"C_Princess_Ribbon_Crown":31565,
"C_Stall_Of_Dominions":31566,
"C_Sheep_Horn":31567,
"C_Floating_Ball_TW":31568,
"C_OpenAir_Headset":31569,
"C_Cyclops_Visor":31570,
"C_Guardian_Processor":31571,
"C_Mobile_Pursuit_System":31572,
"C_Mecha_Cat_Ears":31573,
"C_Cyber_Income":31574,
"C_Electro_Two_Side_Up":31575,
"C_Spring_Rabbit_Hat":31576,
"C_Roast_Memory_J":31577,
"C_Alchemist_Mask_V":31578,
"C_Lovegame_Hat":31579,
"C_Autumnal_Flavor":31580,
"C_Jack_Head":31581,
"C_Jirant_Circlet_":31582,
"C_Willothewisp":31583,
"C_Marin_Muffler":31584,
"C_Drops_Muffler":31585,
"C_Poporing_Muffler":31586,
"C_NationalDay_helmet_TW":31587,
"C_SnowFlake_Tiara":31588,
"C_Gold_Magestic_Goat":31589,
"C_Der_Meisterpinsel":31590,
"C_Crown_Of_Saint":31591,
"C_ROEXE2_TH":31592,
"C_Yellow_Scarf":31593,
"C_Red_Pencil_Mouth":31594,
"C_Book_of_Soyga":31595,
"C_Spider_Temp_TW":31596,
"C_GoldFish_Hat":31597,
"C_Forest_Guide":31598,
"C_Medium_Wave":31599,
"C_Kishu_Inu":31600,
"C_Under_Rim_Glasses_Bu":31601,
"C_Midgarts_Glory":31602,
"C_Cat_Ear_ShortK":31603,
"C_Cat_Ear_LongK":31604,
"C_Volume_Low_Twin_WHK":31605,
"C_Autumn_Headband":31606,
"C_B_EarWitchHat":31607,
"C_Magicstone_Of_Grace":31608,
"C_Noble_Mask":31609,
"C_Yellow_Wizardry_Hat":31610,
"C_Dark_Snake_Lord_Stall":31611,
"C_Large_Sorcerer_Crown":31612,
"C_Blue_Strong_Hair":31613,
"C_Fox":31614,
"C_Geisha_Make":31615,
"C_Sleep_Sheep_TW":31616,
"C_Lady_Tanee_TW":31617,
"C_DancingButterfly_TW":31618,
"C_Magic_Inheritor_TW":31619,
"C_Snow_Fox_TW":31620,
"C_HappyMargay_TW":31621,
"C_LostTime_TW":31622,
"C_RomanticRose_TW":31623,
"C_HeartOfCat_TW":31624,
"C_Protect_Cloth":31625,
"C_FluffyWing_TW":31626,
"C_L_Magesic2_TW":31627,
"C_Bogy_Cap_TW":31628,
"C_Evil_Bone_Hat":31629,
"C_BaphoJ_Parachute_JP":31630,
"C_Drooping_Schmidt":31631,
"C_Drooping_Oscar":31632,
"C_Drooping_Heinrich":31633,
"C_Rudolf_Hairband":31634,
"C_Fairy_Long_BD":31635,
"C_Fairy_Long_SV":31636,
"C_Straight_Long_BU":31637,
"C_Straight_Long_RD":31638,
"C_Straight_Long_GL":31639,
"C_Straight_Long_GN":31640,
"C_Straight_Long_JBL":31641,
"C_Straight_Long_LPP":31642,
"C_Straight_Long_OM":31643,
"C_Straight_Long_PP":31644,
"C_Side_Tail_BU":31645,
"C_Side_Tail_RD":31646,
"C_Side_Tail_YL":31647,
"C_Side_Tail_GN":31648,
"C_Side_Tail_BL":31649,
"C_Side_Tail_WH":31650,
"C_Side_Tail_OM":31651,
"C_Side_Tail_PP":31652,
"C_Back_Signon_BU":31653,
"C_Back_Signon_RD":31654,
"C_Back_Signon_YL":31655,
"C_Back_Signon_GN":31656,
"C_Back_Signon_BL":31657,
"C_Back_Signon_WH":31658,
"C_Back_Signon_OM":31659,
"C_Back_Signon_PP":31660,
"C_Alphonse_Helmet":31661,
"C_Red_Hood":31662,
"C_Asara_Fairy_Hat_J":31663,
"C_B_Desert_Wolf_Hat":31664,
"C_GoldPoring_Hat_TW":31665,
"C_Crown_of_Unity":31666,
"C_PoringBeret_TW":31667,
"C_Majoruros_Horn":31668,
"C_Adv_Whisper_Mask_J":31669,
"C_Miyabi_Long_Hair":31670,
"C_Twin_Canon":31671,
"C_Mermaid_Wig":31672,
"C_Picnic_Basket":31673,
"C_Jitterbug_Cap":31674,
"C_Orange_Stem_Hat":31675,
"C_Orange_In_Mouth":31676,
"C_Stretched_Nose":31677,
"C_Pig_Girl_TW":31678,
"C_Pig_Boy_TW":31679,
"C_Fairy_Long_SVK":31680,
"C_Fairy_Long_BDK":31681,
"C_Drooping_Elven_Ears":31682,
"C_Heart_Wing_Hairband_V":31683,
"C_Kururinpa_Hair":31684,
"C_Fluffy_Semi_Long":31685,
"C_Desert_Wolf_B":31686,
"C_Alchemist_Square_Bag":31687,
"C_Poring_On_Shoulder":31688,
"C_Piamette_Roll_HairK":31689,
"C_Flame_Bird":31690,
"C_Bell_Pigeon_J":31691,
"C_YDragon_SkyWing":31692,
"C_LunaticMuffler":31693,
"C_Poring_Letter_TW":31694,
"C_Tree_Of_Sprout_JP":31695,
"C_Shark_Hat":31696,
"C_Bird_Nest":31697,
"C_Pigtail_Red_Hood":31698,
"C_Smiling_Eyes":31699,
"C_ScarfOfHero_TW":31700,
"C_ScarfOfHero_R":31701,
"C_Moon_Cat_Fighter":31702,
"C_Valentine_Hat":31703,
"C_Sweet_Valentine_Hat":31704,
"C_Red_White_Hat":31705,
"C_Tatenasi_Helmet":31706,
"C_Nine_Tail_Fox_Hair":31707,
"C_Gothic_Skull_Ribbon":31708,
"C_Golden_Violet":31709,
"C_Skygirl_Flower":31710,
"C_Gemmed_Crown":31711,
"C_Oxygen_Mask":31712,
"C_Mystery_Fruit_Shell":31713,
"C_Indian_Headband":31714,
"C_Orange_Rabbit":31715,
"C_Blinking_Eyes_RD":31716,
"C_Medium_Wave_BD":31717,
"C_Bless_Sky_Lantern_J":31718,
"C_Cons_Of_Fire":31719,
"C_VesperHeadGear":31720,
"C_ResonateTaego":31721,
"C_Sedora_Hat":31722,
"C_Tw_Rice_Ball":31723,
"C_Rice_Ball_Hood":31724,
"C_Lunar_Rainbow":31725,
"C_Hankie_In_Mouth":31726,
"C_Ribbon_Green":31727,
"C_Nobility_Hat":31728,
"C_Miracle_Plant":31729,
"C_Volume_Low_Twin_CB":31730,
"C_SnackParty":31731,
"C_BearBalloon":31732,
"C_Phantom_Of_Masquerade":31733,
"C_CitrusRibbon":31734,
"C_FortunetellinSealed":31735,
"C_Popcorn_Hair":31736,
"C_Wings_Of_Lucifer":31737,
"C_Side_Tail_PP_M_TW":31738,
"C_Side_Tail_OM_M_TW":31739,
"C_Side_Tail_WH_M_TW":31740,
"C_Side_Tail_BL_M_TW":31741,
"C_Side_Tail_GN_M_TW":31742,
"C_Side_Tail_YL_M_TW":31743,
"C_Side_Tail_RD_M_TW":31744,
"C_Side_Tail_BU_M_TW":31745,
"C_St_Long_PP_M_TW":31746,
"C_St_Long_OM_M_TW":31747,
"C_St_Long_LPP_M_TW":31748,
"C_St_Long_JBL_M_TW":31749,
"C_St_Long_GN_M_TW":31750,
"C_St_Long_GL_M_TW":31751,
"C_St_Long_RD_M_TW":31752,
"C_St_Long_BU_M_TW":31753,
"C_B_S_PP_M_TW":31754,
"C_B_S_OM_M_TW":31755,
"C_B_S_WH_M_TW":31756,
"C_B_S_BL_M_TW":31757,
"C_B_S_GN_M_TW":31758,
"C_B_S_YL_M_TW":31759,
"C_B_S_RD_M_TW":31760,
"C_B_S_BU_M_TW":31761,
"C_Heart_Card_In_Mouth":31762,
"C_Fortier_Mask":31763,
"C_Rainbow_Veil_V":31764,
"C_Garnet_Tiara":31765,
"C_Peony_Hair_Ornament":31766,
"C_TW_3rd_Balloon":31767,
"C_2019RTC_CeleAura_TW":31768,
"C_Orange_Bunny_Band":31769,
"C_Violet_Bunny_Band":31770,
"C_Blue_Bunny_Band":31771,
"C_Silver_Bunny_Hairband":31772,
"C_Aqua_Bunny_Band":31773,
"C_Maroon_Bunny_Band":31774,
"C_Golden_Bunny_Band":31775,
"C_Gray_Bunny_Band":31776,
"C_YellowBunny_Hairband":31777,
"C_PinkBunny_Hairband":31778,
"C_Green_Bunny_Hairband":31779,
"C_Sloth_Hat":31780,
"C_Green_Poring_Hairpin":31781,
"C_Solo_Play_Box1":31782,
"C_Doram_Balloon":31783,
"C_Exa_Goat_Cap":31784,
"C_Monster_Fish_Gill":31785,
"C_Red_Baby_Dragon":31786,
"C_SavageB_On_Shoulder":31787,
"C_Piamette_Roll_Hair_SV":31788,
"C_Turkey_Hat":31789,
"C_Blood_Grimoire_J":31790,
"C_Pig_Mask_J":31791,
"C_Baryon_HeadPhone_TW":31792,
"C_Feather_Of_Seraphim":31793,
"C_Puppy_Ears_Hat_Jp":31794,
"C_Elephangel_J":31795,
"C_Drooping_Boto":31796,
"C_Shih_Tzu_Long":31797,
"C_Baby_Panda":31798,
"C_Pretty_Bear_WH":31799,
"C_Br_Twin_Ribbon":31800,
"C_Karada_Meguri_Tea_Hat":31801,
"C_Royal_Milk_Tea_Hat":31802,
"C_Cons_Of_Wind":31803,
"C_Flower_Hat":31804,
"C_Sunglasses_Bball_Hat":31805,
"C_Tw_Frog_Hat":31806,
"C_Peacock_Feather":31807,
"C_Red_PhD_Hat":31808,
"C_Red_Wizardry_Hat":31809,
"C_Deep_Angel_Hairband":31810,
"C_Thief_Hood":31811,
"C_Bulb_Hairband":31812,
"C_Luna_On_Shoulder_J":31813,
"C_RabbitFamilyBalloon":31814,
"C_Angola_Intention":31815,
"C_Rabbit_Winged_Robe":31816,
"C_Rabbit_Two_Side_Up":31817,
"C_TopPlayer_TW":31818,
"C_Dullahan_Mask":31819,
"C_Golden_Baseball_Cap":31820,
"C_Jeje_Cap":31821,
"C_Summer_Baseball_Cap":31822,
"C_Nose_Glasses_J":31823,
"C_Mask_Of_Cat_J":31824,
"C_Tongue_Charm_J":31825,
"C_Sunglass_Bear_Cap_J":31826,
"Durumagi":31827,
"C_Maple_Falls_RdK":31828,
"C_Love_China_CN":31829,
"C_DragonKnight_Eyepatch":31830,
"C_Disguise_Mantle":31831,
"C_Bicolor_Cat_Witch_Hat":31832,
"C_Halloween_Cat_Short":31833,
"C_Halloween_Cat_Long":31834,
"C_2019_D10_Muffler_TW":31835,
"C_Aviator_Hat":31836,
"C_SharkHead_J":31837,
"C_Golden_Wreath":31838,
"C_FluffyWing_J":31839,
"C_BJ_HeadsetA":31840,
"C_BJ_HeadsetB":31841,
"C_Striking_hat":31842,
"C_Heavenly_Order":31843,
"C_Mob_Scarf":31844,
"C_Palace_Guard_Cap":31845,
"C_Lovely_Ribbon_Hair":31846,
"C_Blink_Eyes_Cocktai_BU":31847,
"C_Rose_Gothic_Bonnet":31848,
"C_Runaway_Accelerator":31849,
"C_Gift_of_Panagia":31850,
"C_Phalanx":31851,
"C_WitchManteau":31852,
"C_ZombieMask":31853,
"C_SnackParty_J":31854,
"Mushroom_Hair":31855,
"C_Airy_Two_Side_Up_BD":31856,
"C_Airy_Two_Side_Up_SV":31857,
"C_Signon_Princ_Wave_BU":31858,
"C_Signon_Princ_Wave_RD":31859,
"C_Signon_Princ_Wave_YL":31860,
"C_Signon_Princ_Wave_GN":31861,
"C_Signon_Princ_Wave_BL":31862,
"C_Signon_Princ_Wave_WH":31863,
"C_Signon_Princ_Wave_OM":31864,
"C_Signon_Princ_Wave_PP":31865,
"C_Braid_Headband_BU":31866,
"C_Braid_Headband_RD":31867,
"C_Braid_Headband_YL":31868,
"C_Braid_Headband_GN":31869,
"C_Braid_Headband_BL":31870,
"C_Braid_Headband_WH":31871,
"C_Braid_Headband_OM":31872,
"C_Braid_Headband_PP":31873,
"C_Exotic_Bob_L_LB":31874,
"C_Exotic_Bob_L_YL":31875,
"C_Exotic_Bob_L_WH":31876,
"C_Exotic_Bob_L_LPP":31877,
"C_Exotic_Bob_R_PK":31878,
"C_Exotic_Bob_R_BG":31879,
"C_Exotic_Bob_R_JBL":31880,
"C_Exotic_Bob_R_BW":31881,
"C_Choco_Stick_In_Mouth":31882,
"C_Nine_Tail_Fox_Hair_J":31883,
"C_Magic_Helm":31884,
"Cons_Of_Earth":31885,
"C_Pierced_Apple_E":31886,
"C_Pure_Love_Muffler":31887,
"C_W_King_Tiger_Doll_Hat":31888,
"C_Gemini_Crown":31889,
"C_Sagittarius_Diadem":31890,
"C_Surpentarius_Crown":31891,
"C_Aquarius_Diadem":31892,
"C_Libra_Crown":31893,
"C_Scorpio_Diadem":31894,
"C_Aries_Diadem":31895,
"C_Capricon_Crown":31896,
"C_Pisces_Crown":31897,
"C_Sagittarius_Crown":31898,
"C_Freyja_Crown":31899,
"C_Hair_Of_The_Strong_R":31900,
"C_White_Strong_Hair_R":31901,
"C_10_Type_Glasses":31902,
"C_White_Snake":31903,
"C_Para_Team_Hat100":31904,
"C_Blanc_Neige_Prince":31905,
"C_PGstone_Knit_Hat_PK":31906,
"C_PGstone_Knit_Hat_BW":31907,
"C_Antler_Fedora":31908,
"C_711_Knit_Hat":31909,
"C_Shaving_Cream":31910,
"C_LittleGarden":31911,
"C_Black_Veil_J":31912,
"C_Black_Feather":31913,
"C_Red_Bread_Hat":31914,
"c_Sweet_Corone":31915,
"C_Frill_Collar":31916,
"C_2018_RTC_Cape4_TW_J":31917,
"C_Party_Recruiter_Hat":31918,
"C_Friend_Recruiter_Hat":31919,
"C_Western_Grace":31920,
"C_Fairy_Long_CB":31921,
"C_Fluffy_Semi_Long_SV":31922,
"C_Baby_Polar_Bear":31923,
"C_Blinking_Eyes_BU":31924,
"C_Valentine_Hat_US":31925,
"C_Aura_Quartz_REU":31926,
"C_Blue_Pencil_In_Mouth":31927,
"C_Cylinder_Hairband":31928,
"C_Cryptura_Academy_Hat":31929,
"C_Mike_Stand":31930,
"C_Half_Rim_Glasses":31931,
"C_Suit_Sollar":31932,
"C_Miyabi_Long_Hair_LPP":31933,
"C_Blink_Eyes_Sakura":31934,
"C_Baby_Dragon_Hat":31935,
"C_Nut_Donut_In_Mouth":31936,
"C_Unicorn_Ornament":31937,
"C_L_Knitting_Low_Twin":31938,
"C_Carnation_Corolla":31939,
"C_Earth_Godess_Mask":31940,
"C_Super_Cell":31941,
"C_Romance_Rose_J":31942,
"C_Frog_Hood":31943,
"C_Elegant_Wave":31944,
"C_Golden_Angel_Band":31945,
"C_Frantic_Looking":31946,
"C_Sinister_Horn_Gear":31947,
"C_Eyes_Of_Illusion":31948,
"C_Diabolus_Wing":31949,
"C_Nut_Cracker_JP":31950,
"C_Happy_Cat_JP":31951,
"C_GatesofNetherWorld":31952,
"C_Cor_Core_Headset":31953,
"C_Vassalage_Necklace":31954,
"C_Angeling_1st":31955,
"C_Angeling_2nd":31956,
"C_Cons_Of_Poison":31957,
"C_SantaPoring_Balloon":31958,
"C_RK_Hair_BL":31959,
"C_RK_Hair_BU":31960,
"C_RK_Hair_GN":31961,
"C_RK_Hair_OM":31962,
"C_RK_Hair_PK":31963,
"C_RK_Hair_PP":31964,
"C_RK_Hair_RD":31965,
"C_RK_Hair_WH":31966,
"C_RK_Hair_YL":31967,
"C_AB_Hair_BL":31968,
"C_AB_Hair_LPP":31969,
"C_AB_Hair_OM":31970,
"C_AB_Hair_WH":31971,
"C_Purificatory_Mask":31972,
"C_Blossom_Glasses":31973,
"C_Melon_Headphone":31974,
"C_Sweet_Potato_In_Mouth":31975,
"C_Focus_Beret":31976,
"C_Rent_Dog_Officer_TH":31977,
"C_Fire_Giant_Red":31978,
"C_Fire_Giant_Gold":31979,
"aegis_31980":31980,
"Blue_Spear":32000,
"Diva_Spear":32001,
"Mirage_Spear":32002,
"Sinister_Spear_J":32003,
"Probation_Lance":32004,
"Pole_Axe_IL":32005,
"Jirant_Spear":32007,
"Metal_Stick_J":32012,
"Metal_Stick":32013,
"Blut_Spear":32014,
"Woe_Onehand_Spear1_Z":32015,
"Variant_Spear":32017,
"Undine_Spear_K":32018,
"Boost_Lance_OS":32019,
"Evt_Undine_Spear_K":32021,
"Argen_Blanco":32023,
"Harve":32024,
"Fortrage":32025,
"Ein_1HSPEAR":32026,
"G_Knight_Spear":32027,
"Argen_Blanco_J":32028,
"Harve_J":32029,
"Fortrage_J":32030,
"Aries_Spear_J":32031,
"Comp_Undine_Spear_K":32034,
"Local01_Violin":32101,
"Local02_Violin":32102,
"Woe_Instrument1_Z":32103,
"Hyegun_Erhu":32104,
"Variant_Viollin":32105,
"Variant_Blade_Whip":32106,
"Black_Circle":32107,
"Antique_Cello":32108,
"Ein_1HLUTE":32110,
"R_Cello":32111,
"Black_Circle_J":32112,
"Antique_Cello_J":32113,
"Dark_Illu_Guitar_TH":32117,
"Comp_All_In_One_Ring":32202,
"Accelerator_Chip":32203,
"Immortal_Dog_Tag":32204,
"Prta_Mil_Glove":32206,
"Illusion_B_R":32207,
"Illusion_B_L":32208,
"Illusion_BC_R":32209,
"Illusion_BC_L":32210,
"Astraea_Ring":32219,
"Time_Overload_Ring":32221,
"Brooch_Of_Hero":32222,
"Fenrir_Chain":32227,
"Schmidt_Insignia_Str":32228,
"Schmidt_Insignia_Int":32229,
"Schmidt_Insignia_Luk":32230,
"Schmidt_Insignia_Vit":32231,
"Schmidt_Insignia_Agi":32232,
"Schmidt_Insignia_Dex":32233,
"UnrivaledRing":32234,
"Celine_Brooch_K":32237,
"Morpheus_Ring_IL":32238,
"Morpheus_Armlet_IL":32239,
"Old_DetachmentsRing_J":32242,
"Star_Force_Ring_TW":32243,
"RingOfThought_TW":32245,
"Main_Memory_JP":32246,
"Leo_Ring_J":32247,
"Ein_SAFETY_PENDR":32248,
"Ein_SAFETY_PENDL":32249,
"Ein_SAFETY_EPAULR":32250,
"Ein_SAFETY_EPAULL":32251,
"H_AD_Clip":32252,
"Cancer_Ring_J":32253,
"RingofJupiter":32258,
"CannonConverter_TW":32259,
"Libra_Ring_J":32261,
"Ball_Of_RasenHuuma":32262,
"Shield_Ring":32263,
"Taurus_Ring_J":32264,
"Tip_Of_Thief_Vol2":32265,
"Aquarius_Ring_J":32266,
"Scorpio_Ring_J":32267,
"Luminous_Blue_Stone_TW":32270,
"Sealed_Ring_TW":32278,
"Scorpion_Chain_EXE":32281,
"Erron_Black_Glove_EXE":32282,
"Record_Mage_TW":32285,
"Record_Merchant_TW":32286,
"Record_Thief_TW":32287,
"Record_Acol_TW":32288,
"Pollux_Ring_J":32293,
"Procyon_Ring_J":32294,
"Crystal_Blade_Necklace":32295,
"Crystal_Blade_Necklace_":32296,
"Variant_Handgun":32300,
"Gold_Lux_IL":32301,
"Crimson_Rose":32302,
"Ein_1HGUN":32303,
"R_Revolver":32304,
"Titanium_Gun_EXE":32305,
"Farthezan":32350,
"Estal":32351,
"Ein_1HSWORD":32352,
"G_Knight_JewelSword":32353,
"Farthezan_J":32354,
"Estal_J":32355,
"Comp_Sword_Of_Bluefire":32358,
"R_Pillar":32401,
"R_Syringe":32402,
"G_Alchemist_Staff":32403,
"Engine_Pilebuncker_J":32404,
"Coolant_Injection_J":32405,
"Gene_Rod_J":32406,
"Lucis_Flail_J":32407,
"Bright_Mace_J":32408,
"IDTest_Special":100000,
"PayPromotion_Box":100002,
"ILL_Piece_A":100003,
"ILL_Piece_B":100004,
"G_Small_Mana_Potion":100005,
"G_M_DEFScroll":100006,
"G_Limit_Power_Booster":100007,
"G_Infinity_Drink":100008,
"Joy_Of_Victory":100009,
"PerfectSize_Mix":100010,
"MagicPiercing_Mix":100011,
"Enchant_Stone_Box18":100019,
"E_Bcrystal_Box":100020,
"E_Mcrystal_Box":100021,
"E_Scrystal_Box":100022,
"Ancient_Hero_Bravery":100023,
"TimeExtension1":100024,
"Ancient_Hero_Wisdom":100025,
"TimeExtension2":100026,
"Booster_Pack_1":100029,
"Booster_Pack_15":100030,
"Booster_Pack_30":100031,
"Booster_Pack_45":100032,
"Booster_Pack_60":100033,
"Booster_Pack_75":100034,
"Booster_Pack_90":100035,
"Booster_Pack_100":100036,
"Booster_Pack_115":100037,
"Booster_Pack_130":100038,
"Booster_Pack_145":100039,
"Booster_Pack_160":100040,
"Booster_Pack_175":100041,
"Boost_Up_1":100043,
"Boost_Up_2":100044,
"Stater_A_Box":100045,
"Boost_Atk_Box":100046,
"Boost_Ran_Box":100047,
"Boost_Ele_Box":100048,
"Boost_Defn_Box":100049,
"Goal_Gift_Box":100050,
"Booster_Pack_Preorder":100051,
"Enchant_Stone_Box19":100052,
"Piercing_Mix":100053,
"Time_Over_S_Box":100054,
"Hasty_Mix":100058,
"EnchantStone_Recipe_4m":100060,
"E_Red_Booster":100061,
"WL_MB_SG":100065,
"WL_MB_LOV":100066,
"WL_MB_MS":100067,
"WL_MB_DL":100068,
"WL_MB_JF":100069,
"WL_MB_ES":100070,
"WL_MB_CR":100071,
"WL_MB_CL":100072,
"WL_MB_CM":100073,
"WL_MB_TV":100074,
"DishSet05":100075,
"DishSet06":100076,
"DishSet07":100077,
"DishSet08":100078,
"DishSet09":100079,
"DishSet10":100080,
"Kr_B_Special01":100081,
"BackSignon_Box_TW":100083,
"Boarding_Halter_Box30_Z":100087,
"RTC_EnergyDrink_TW":100098,
"Temporal_Manteau_Box":100100,
"Lapine_DdukddakBox2":100109,
"Metal_7_Ticket":100125,
"Kr_B_Special02":100127,
"Noblesse_Rifine_Ticket":100128,
"Imperial_Rifine_Ticket":100129,
"Grace_Rifine_Ticket":100130,
"Imperial_Convert1":100131,
"Imperial_Convert2":100132,
"Grace_Convert1":100133,
"Grace_Convert2":100134,
"Imperial_Convert3":100135,
"Imperial_Convert4":100136,
"Grace_Convert3":100137,
"Grace_Convert4":100138,
"Abyss_Ddbox2":100142,
"Abyss_Ddbox3":100144,
"Abyss_Ddbox4":100145,
"Bath_Foam_A":100147,
"Bath_Foam_B":100148,
"Bath_Foam_C":100149,
"Aroma_Oil":100150,
"Skill_Sha_M_S_Weapon":100151,
"GoldPCBang_ShieldBox":100152,
"Set_Of_Taiming_Item2":100153,
"Mado_Box02":100158,
"Auto_M_Box":100160,
"Epic_M_Box":100161,
"Auto_M_I_Box_A":100162,
"Auto_M_I_Box_B":100163,
"Auto_Imp_Melee_1":100164,
"Auto_Imp_Melee_2":100165,
"Auto_Imp_Melee_3":100166,
"Auto_Imp_Magic_1":100167,
"Auto_Imp_Magic_2":100168,
"Auto_Imp_Magic_3":100169,
"GoldPCBang_MileageBox":100170,
"Cannon_Ball_Box":100171,
"Iron_Cannon_Ball_Box":100172,
"Soul_Cannon_Ball_Box":100173,
"Poi_Arrow_Container":100174,
"Dark_Cannon_Ball_Box":100176,
"Holy_Cannon_Ball_Box":100177,
"Cannon_Box_6":100178,
"Magic_Gear_Fuel_Box":100179,
"RepairA_Box":100180,
"RepairB_Box":100181,
"RepairC_Box":100182,
"Flame_Stone_Bundle":100183,
"Ice_Stone_Bundle":100184,
"Wind_Stone_Bundle":100185,
"Shadow_Orb_Bundle":100186,
"Charm_Fire_Bundle":100187,
"Charm_Ice_Bundle":100188,
"Charm_Wind_Bundle":100189,
"Charm_Earth_Bundle":100190,
"Kunai_Scroll_Explosive":100191,
"Gemstone_Blue":100192,
"Gemstone_YL":100193,
"Gemstone_Red":100194,
"Bullet_Case_Full":100195,
"Bullet_Case_Mine":100196,
"Bullet_Case_Tail":100197,
"Skill_Shadow_Cube":100198,
"Enchant_Stone_Box20":100202,
"Class_Sha_R_M_Melee":100205,
"Class_Sha_R_M_Magic":100206,
"Skill_Sha_R_M_Melee":100207,
"Skill_Sha_R_M_Magic":100208,
"Skill_Sha_M_S_Shield":100209,
"Skill_Sha_M_S_Pendant":100210,
"Skill_Sha_M_S_Earing":100211,
"Skill_Sha_M_S_Shoes":100212,
"Skill_Sha_M_S_Armor":100213,
"Shadowdecon_Ore_Box":100214,
"Zelunium_Ore_Box":100215,
"Ref_T_Potion":100231,
"Add_Atk_Potion":100232,
"Add_Matk_Potion":100233,
"Illu_Enhance_Cube":100251,
"Auto_Enhance_Cube":100252,
"Gstar2019Box":100253,
"Temporal_Refine_Cube":100268,
"Geffen_Refine_Cube":100269,
"Old_Refine_Cube":100270,
"Refine_Hero_Weapon":100271,
"Refine_Hero_Boots":100272,
"Remodel_Hero_Boots":100273,
"Oriental_Sword_Cube":100274,
"Dragonic_Slayer_Cube":100275,
"Shiver_Katar_K_Cube":100276,
"Blade_Katar_Cube":100277,
"Enchant_Stone_Box21":100314,
"G_Tyrs_Blessing":100316,
"G_Mental_Potion":100317,
"Exotic_Bob_Box":100319,
"OS_Weapon_Refine_Cube":100321,
"Racecap_Refine_Cube":100322,
"Runeknight_S_Cube":100323,
"Guillotinecross_S_Cube":100324,
"Archbishop_S_Cube":100325,
"Sura_S_Cube":100326,
"Sword_Of_Bluefire_Cube":100327,
"Slate_Sword_Cube":100328,
"Narcis_Bow_Cube":100329,
"Trumpet_Shell_K_Cube":100330,
"Barb_Wire_K_Cube":100331,
"2019_Chrismas_Present":100332,
"E_Infinity_Drink":100333,
"Booster_Pack_190":100335,
"Booster_Pack_200":100336,
"Booster_Call":100337,
"Booster_W_Up_1":100338,
"Booster_W_Up_2":100339,
"Booster_W_Up_3":100340,
"E_ILL_Up":100341,
"Exp_Up_1":100342,
"Exp_Up_2":100343,
"Exp_Up_3":100344,
"Exp_Up_4":100345,
"Jexp_Up_1":100346,
"2020_Goal_Gift_Box":100347,
"Core_Battle_Manual":100351,
"Real_Battle_Manual":100352,
"Auto_Armor_Refine_Cube":100354,
"Bio_Weapon_Refine_Cube":100355,
"Ranger_S_Cube":100356,
"Warlock_S_Cube":100357,
"Sorcerer_S_Cube":100358,
"WanderMins_S_Cube":100359,
"Avenger_Cube":100360,
"Meteor_Striker_Cube":100361,
"Magic_Sword_Cube":100362,
"Fatalist_Cube":100363,
"MD_Geffen_Rarmor":100365,
"MD_Geffen_Rhood":100366,
"MD_Geffen_Racc":100367,
"MD_Geffen_Rsheild":100368,
"Homun_F_Tablet":100371,
"RoyalGuard_S_Cube":100372,
"ShadowChaser_S_Cube":100373,
"Mechanic_S_Cube":100374,
"Genetic_S_Cube":100375,
"Royal_Bow_K_Cube":100376,
"Scalet_Dragon_L_Cube":100377,
"Shadow_Staff_K_Cube":100378,
"Freezing_Rod_Cube":100379,
"3Lv_9Refine_Weapon_7Gu":100381,
"3Lv_10Refine_Weapon_8Gu":100382,
"3Lv_11Refine_Weapon_9Gu":100383,
"3Lv_12Refine_Weapon_10G":100384,
"4Lv_9Refine_Weapon_8Gu":100385,
"4Lv_10Refine_Weapon_9Gu":100386,
"4Lv_11Refine_Weapon_10G":100387,
"Iron_Nail_K_Cube":100388,
"Ray_Knuckle_Cube":100390,
"Moonlight_Box_IL":100391,
"S_Moonlight_Box_IL":100392,
"Undine_Spear_K_Cube":100393,
"Light_Blade_Cube":100394,
"Iron_Staff_Cube":100395,
"Blue_Crystal_Staff_Cube":100396,
"Demon_Hunt_Bible_Cube":100397,
"Saint_Hall_Cube":100398,
"MeawFoxtail_Cube":100399,
"Fog_Dew_Sword_Cube":100400,
"Humma_Clear_Cube":100401,
"OneSkyOneSun_Cube":100402,
"SoulWeight_Cube":100403,
"Crimson_Rose_Cube":100404,
"Master_Soul_Rifle_Cube":100405,
"Golden_L_Launcher_Cube":100406,
"The_Black_Gatling_Cube":100407,
"Demon_S_Shot_Cube":100408,
"Great_Hero_Bravery":100412,
"Great_Hero_Wisdom":100413,
"Vampire_Box_IL":100414,
"S_Vampire_Box_IL":100415,
"S_Frozen_Box_IL":100416,
"Turtle_Is_Box_IL":100417,
"S_Turtle_Is_Box_IL":100418,
"Teddy_Bear_Box_IL":100419,
"S_Teddy_Bear_Box_IL":100420,
"Luanda_Box_IL":100421,
"S_Luanda_Box_IL":100422,
"Labyrinth_Box_IL":100423,
"S_Teddy_Labyrinth_IL":100424,
"Underwater_Box_IL":100425,
"S_Underwater_Box_IL":100426,
"Signon_Prin_Wave_Box":100428,
"EnchantStone_Recipe_3m":100433,
"Circlet_Refine_Cube":100436,
"Hero_Weapon_Cube":100437,
"New_S_Weapon_Cube":100442,
"New_S_Shield_Cube":100443,
"New_S_Armor_Cube":100444,
"New_S_Shoes_Cube":100445,
"New_S_Earring_Cube":100446,
"New_S_Pendant_Cube":100447,
"Minus_Pow":100452,
"Minus_Spl":100453,
"Minus_Sta":100454,
"Minus_Wis":100455,
"Minus_Con":100456,
"Minus_Crt":100457,
"MD_Airboat_Bexp":100460,
"MD_Airboat_Reward":100462,
"Stone_Robe_Box":100465,
"Egir_Power_Box":100466,
"Egir_Magic_Box":100467,
"Egirnion_Box":100468,
"OS_Helm_Box":100469,
"Famous_Hat_Box":100470,
"MD_Airboat_Expbox":100475,
"MD_Airboat_Random":100476,
"Poenetentia_Box1":100477,
"Poenetentia_Box2":100478,
"Sakray_Fury":100479,
"Sakray_Fury2":100480,
"Overclocker":100481,
"Sakray_Regret":100485,
"Sakray_Regret2":100486,
"Loki_Coin_2":100487,
"Loki_Advice_2":100488,
"Stone_Robe2_Box":100495,
"Stone_Top_Box":100496,
"Stone_Top2_Box":100497,
"Stone_Middle_Box":100498,
"Stone_Middle2_Box":100499,
"Stone_Bottom_Box":100500,
"Stone_Bottom2_Box":100501,
"Enchant_Stone_Box22":100502,
"Exp_Up_1_S":100508,
"Exp_Up_2_S":100509,
"Exp_Up_3_S":100510,
"Exp_Up_4_S":100511,
"Ex_Skill_Shadow_Cube":100512,
"Cachua_Costume_Box":100515,
"Eye_Cleaner":100516,
"Ear_Cleaner":100517,
"Tonics":100518,
"Mini_Extinguisher":100519,
"Water_Of_Lucky":100520,
"Strong_Antidote":100521,
"High_Energy_Chocolate":100522,
"Refined_Holy_Water":100523,
"Kr_B_Special03":100534,
"Class_Shadow_WP_Cube":100537,
"Class_Shadow_AM_Cube":100538,
"Class_Shadow_SU_Cube":100539,
"Class_Shadow_SD_Cube":100540,
"Class_Shadow_PD_Cube":100541,
"Class_Shadow_EA_Cube":100542,
"BioWeapon_Helm_Box":100547,
"Tree_Of_Sprout_Box":100553,
"Special_Costume_Box":100569,
"Special_Costume_Box_":100570,
"FullPeneShadow_Mix":100572,
"Rag_Inven_Box":100573,
"AID_Manual_1h":100574,
"AID_Bubble_Gum_1h":100575,
"AID_Insurance_1h":100576,
"AID_Special_1h":100577,
"PendantStoneForWork":100579,
"Dark_Stone":100580,
"Thanatos_Pendant_Box":100585,
"Thanos_W_Reform_1":100591,
"Thanos_W_Reform_2":100592,
"FullTempShadow_Mix":100596,
"Shadow_Mix_Recipe2":100600,
"Illusion_Module_Mix":100601,
"Automatic_Module_Mix":100602,
"Lapine_DdukddakBox3":100603,
"Auction_Promotion":100616,
"Thanos_Refine_Hammer":100619,
"True_GemShadow_Mix":100620,
"Mammoth_Mix":100621,
"Shadow_Mix_Recipe_TH":100623,
"GrayWolf_7_Ticket":100626,
"GrayWolf_9_Ticket":100627,
"Consecrate_Weapon_1":100648,
"Consecrate_Weapon_2":100649,
"Pontifex_Courage":100650,
"Pontifex_Wisdom":100651,
"Pontifex_Tenacity":100652,
"Pontifex_Belief":100653,
"Blue_Prints_Scroll":100655,
"EXPShadow_Mix":100661,
"Bio_Helm_Refine_Cube":100684,
"Material_Shadow_CubeII":100690,
"AbsorbShadow_Mix":100691,
"C_Armor_Reform_1":100694,
"C_Armor_Reform_2":100695,
"Twins_Box_IL":100699,
"S_Twins_Box_IL":100700,
"Ancient_Hero_Will":100706,
"Mammoth_Shadow_Box":100707,
"Shadow_R_M_Box":100708,
"All_Shadow_Cube":100709,
"EXP_Overclocker":100710,
"Fluffy_Semi_Long_Box":100717,
"Enchant_Stone_Box23":100721,
"Booster_RandomOpt_P":100722,
"Booster_RandomOpt_M":100723,
"Spring_Energy":100724,
"Booster_Pack_215":100726,
"Booster_Pack_230":100727,
"AngelPoringJewel_Box":100728,
"Up_Hero_Weapon_Box":100742,
"Hero_LT_Refine_Melee":100744,
"Hero_LT_Refine_Magic":100745,
"C_Weapon_Reform_1":100746,
"C_Weapon_Reform_2":100747,
"C_Weapon_Reform_3":100748,
"High_Refine_Guarantee":100750,
"Refine_Guarantee":100751,
"Special_Refine_Cube":100752,
"Hero_Equipment_Cube":100753,
"Kr_B_Special04":100754,
"MajorAutoSpell_Mix":100783,
"Shadow_Changer_W_Shi":100784,
"AutoSpell_Shadow_Box":100785,
"C_Armor_Reform_3":100786,
"Darkness_Bible":100796,
"BroadcastBox_":100810,
"Summer_Energy":100816,
"Thanos_Upgrade_Box":100817,
"Hero_Weapon_Up_Box_1":100819,
"Hero_Weapon_Up_Box_2":100820,
"Hero_Weapon_Hammer_1":100821,
"Hero_Weapon_Hammer_2":100822,
"Lens_Craft_Stone":100823,
"Farfalle":100829,
"Cream_Noodle2":100830,
"Festival_Noodle2":100831,
"Tamato_Noodle2":100832,
"Oil_Noodle":100833,
"Hero_Weapon_Up_Box_3":100834,
"Hero_Weapon_Hammer_3":100835,
"Watermelon_Pudding_J":100848,
"S_Enchant_Stone_Box":100870,
"C_Giant_Fly_1Day_Box__":100874,
"C_Wing_Of_Fly_3Day_B__":100875,
"S_Piercing_Box":100880,
"PhyMag_Shadow_Box":100886,
"MagicalShadow_Mix":100887,
"PhysicalShadow_Mix":100888,
"Shadow_Changer_A_W":100890,
"Teleport_Ep19_01":100900,
"Teleport_Ep18_01":100901,
"Teleport_Ep17_02":100902,
"Teleport_Ep17_01":100903,
"Teleport_Ep16_01":100904,
"E_All_In_One_Buff":100906,
"S_M_Piercing_Box":100908,
"S_Dual_Stone_Box":100910,
"S_Costume_Box":100911,
"EXP_Drop_Up_7days":100913,
"EXP_Drop_Up_1Hours":100914,
"Hero_Weapon_Hammer_4":100917,
"Hero_Weapon_Up_Box_4":100918,
"Enchant_Stone_Box24":100920,
"GM_Lost_Bagpack":100929,
"E_Potion_Box":100933,
"Buff_Scroll_Box":100934,
"Hero_Weapon_Hammer_5":100938,
"Hero_Weapon_Up_Box_5":100939,
"Season_Evt_Reward_9":100943,
"EXP_Drop_Up_1day":100949,
"Evt_RagFes_Box":100950,
"S_Ignition_Cube":100951,
"S_W_Breath_Cube":100952,
"S_F_Breath_Cube":100954,
"S_Sonic_Cube":100955,
"S_Banish_Cannon_Cube":100956,
"S_Brand_Cube":100957,
"S_Genesis_Cube":100958,
"S_Chain_Press_Cube":100959,
"S_Strain_Cube":100960,
"S_Jack_Cube":100961,
"S_Chain_Cube":100962,
"S_Crimson_Cube":100963,
"S_Grave_Cube":100964,
"S_Dust_Cube":100965,
"S_Varetyr_Cube":100966,
"S_Psychic_Cube":100967,
"S_Vulcan_Cube":100968,
"S_Boomerang_Cube":100969,
"S_Arms_Cube":100970,
"S_Tornado_Cube":100971,
"S_Spore_Bomb_Cube":100972,
"S_Cannon_Cart_Cube":100973,
"S_Crazy_Cube":100974,
"S_Cart_Tornado_Cube":100975,
"S_Duplelight_Cube":100976,
"S_Magnus_Cube":100977,
"S_Adoramus_Cube":100978,
"S_Judex_Cube":100979,
"S_Knucklearrow_Cube":100980,
"S_Skynetblow_Cube":100981,
"S_Rampage_Cube":100982,
"S_TigerCannon_Cube":100983,
"S_Rolling_Cube":100984,
"S_Ripper_Cube":100985,
"S_Slash_Cube":100986,
"S_Katar_Cube":100987,
"S_Menace_Cube":100988,
"S_Shadowspell_Cube":100989,
"S_Triangle_Cube":100990,
"S_Paint_Cube":100991,
"S_Shooting_Cube":100992,
"S_Arrow_Cube":100994,
"S_Aimed_Cube":100995,
"S_Cluster_Cube":100996,
"S_Rainstorm_Cube":100997,
"S_Metalic_Cube":100998,
"S_Arrowvulcan_Cube":100999,
"S_Reverberation_Cube":101000,
"S_Moonlight_Cube":101001,
"S_Sunshine_Cube":101002,
"S_Stardust_Cube":101003,
"S_S_Cube":101004,
"S_Evilcurse_Cube":101005,
"S_Syuriken_Cube":101006,
"S_Kunai_Cube":101007,
"S_Huusouka_Cube":101008,
"S_Kamaenraku_Cube":101009,
"S_God_Hammer_Cube":101010,
"S_Shatter_Buster_Cube":101011,
"S_Tail_Dragon_Cube":101012,
"S_Trip_Cube":101013,
"S_Flare_Dance_Cube":101014,
"S_Super_Magic_Cube":101015,
"S_Super_Power_Cube":101016,
"S_Silvervine_Cube":101017,
"S_Catnip_Cube":101018,
"S_SavageRabbit_Cube":101019,
"S_Pickyrush_Cube":101020,
"S_RuneKnight_Cube":101021,
"S_RoyalGuard_Cube":101022,
"S_Warlock_Cube":101023,
"S_Sorcerer_Cube":101024,
"S_Mechanic_Cube":101025,
"S_Generic_Cube":101026,
"S_ArchBishop_Cube":101027,
"S_Sura_Cube":101028,
"S_GuillotineCross_Cube":101029,
"S_ShadowChaser_Cube":101030,
"S_Ranger_Cube":101031,
"S_Wanderer_Cube":101032,
"S_Minstrel_Cube":101033,
"S_Star_Emperor_Cube":101034,
"S_Soul_Reaper_Cube":101035,
"S_Kagerou_Cube":101036,
"S_Oboro_Cube":101037,
"S_Rebellion_Cube":101038,
"S_SuperNovice_Cube":101039,
"S_Doram_Cube":101040,
"S_Mammoth_Cube":101041,
"S_Gemstone_Cube":101042,
"S_Pene1_Cube":101043,
"S_Pene2_Cube":101044,
"S_Temp1_Cube":101045,
"S_Temp2_Cube":101046,
"Blacksmith_Bless_Box_3":101047,
"Shadow_Hammer_Box_3":101048,
"Select_Example1":101060,
"Select_Example2":101062,
"Barmund_Rune_Box":101067,
"Chuseog_Present_Box":101070,
"Sealed_Card3":101074,
"SLD_Card_Recipe":101075,
"Vivatus_Weapon_Hammer":101077,
"Adulter_Weapon_Up_Box":101078,
"DF_Infinity_Drink":101097,
"ClockTower_Regulator":101099,
"Poenetentia_Box3":101100,
"Poenetentia_Box4":101101,
"Enchant_Stone_Box25":101103,
"Cannon_Box_Ice":101107,
"Cannon_Box_Lightning":101108,
"Cannon_Box_Stone":101109,
"Cannon_Box_Flare":101110,
"Cannon_Box_Poisoning":101111,
"Kunai_Scroll":101112,
"Kunai_Scroll_Nothing":101113,
"Kunai_Scroll_Shadow":101114,
"Kunai_Scroll_Hamaya":101115,
"Nw_Grenade_Box":101116,
"Soa_Charm_Bundle":101117,
"SS_Charm_Box":101118,
"SS_Charm_F_Box":101119,
"SS_Charm_W_Box":101120,
"SS_Charm_G_Box":101121,
"SS_Charm_L_Box":101122,
"RO_Live_Shop_Box":101123,
"RO_Live_Shop_Ex_Box":101124,
"DF_Halloween_Candy":101126,
"Season_Evt_Reward_11":101128,
"Payment_Costume_Box1":101129,
"Payment_Costume_Box2":101130,
"E_Boarding_Halter_Box":101139,
"Security_Campaign_Box":101148,
"C_Braid_Half_Up_Box":101159,
"Season_Evt_Reward_12":101161,
"Ep19_Rgan_Scroll":101162,
"Kr_B_Special05":101166,
"Kr_B_Special06":101167,
"Kr_B_Special07":101168,
"Kr_B_Special09":101169,
"Kr_B_Special08":101170,
"FullPenest_Shadow_Up":101177,
"Reload_Shadow_Up":101178,
"SpellCaster_Shadow_Up":101179,
"Ex_Status_Shadow_Up":101180,
"ReloadShadow_Mix":101181,
"SpellCasterShadow_Mix":101182,
"Ice_F_Stone_Box":101183,
"Ice_F_Stone_Box2":101184,
"Snow_F_Enchant":101185,
"Glacier_W_Enchant":101186,
"Snow_F_Refine":101187,
"Glacier_W_Refine":101188,
"Hero_Weapon_Hammer_6":101189,
"Hero_Weapon_Up_Box_6":101190,
"Hero_Token_Box":101194,
"Motp_Potion":101200,
"Snow_F_Enchant2":101217,
"Snow_F_Enchant3":101218,
"Snow_F_Enchant4":101219,
"Snow_F_Enchant5":101220,
"Booster_Pack_120":101234,
"Booster_Pack_150":101236,
"E_EXP_Drop_Up_7days":101238,
"Season_Evt_Reward_1":101240,
"Strange_Tteokguk":101241,
"Shadow_Changer_NPC":101243,
"R_BearersShadow_Mix":101257,
"M_BlitzShadow_Mix":101258,
"Special_Hat_Hammer":101259,
"R_Bearers_Shadow_Up":101260,
"M_Blitz_Shadow_Up":101261,
"Absorb_Shadow_Up":101262,
"Mammoth_Shadow_Up":101264,
"2021_Winter_Event_Box1":101268,
"2021_Winter_Event_Box2":101269,
"Enchant_Stone_Box26":101271,
"New_Year_Rice_Soup":101276,
"2022_LunarNewYears_box":101279,
"Poenitentia_Hammer":101306,
"Barmund_Hammer":101307,
"True_GemShadow_Up":101308,
"EXPShadow_Up":101309,
"MagicalShadow_Up":101310,
"InfinityShadow_Up":101311,
"aegis_101314":101314,
"2022Reward_Box":101321,
"aegis_101322":101322,
"Fruits_Set_Trap":101331,
"aegis_101336":101336,
"aegis_101337":101337,
"Bs_Item_M_S_52":101340,
"Bs_Item_M_S_53":101341,
"Bs_Item_M_S_54":101342,
"Bs_Item_M_S_55":101343,
"Bs_Item_M_S_56":101344,
"Bs_Item_M_S_57":101345,
"Bs_Item_M_S_58":101346,
"Bs_Item_M_S_59":101347,
"E_Bubble_Gum_Box10":101352,
"OS_Weapon_Reform":101355,
"BlessOfRabbit":101357,
"MajorAutoSpell_Up":101359,
"Hasty_Up":101360,
"PhysicalShadow_Up":101361,
"PerfectSize_Up":101362,
"OS_Helm_Hammer":101363,
"OS_Weapon_Hammer":101364,
"Helm_Of_Faith_Hammer":101389,
"Clock_Tower_W_Hammer":101390,
"VR_Books001":101391,
"aegis_101393":101393,
"aegis_101394":101394,
"Enchant_Ticket_3":101399,
"aegis_101404":101404,
"aegis_101406":101406,
"aegis_101407":101407,
"aegis_101408":101408,
"aegis_101416":101416,
"Boost_Armor_Box":101423,
"Special_Coin_Pack":101453,
"Metal_W_Box":101454,
"E_Auto_Up":101455,
"Memento_Box":101456,
"P_Memento_Box":101457,
"Booster_Hat_Box":101458,
"Booster_Back_Box":101459,
"P_Booster230_Gift":101460,
"Fan_Greed_1Hour_Box":101461,
"HD_Elunium_10Box_MSP":101463,
"HD_Oridecon_10Box_MSP":101465,
"Minus_Status_Box_":101470,
"Alchemist_Box_":101471,
"P_Booster_Call":101473,
"Booster_B_M_1":101474,
"Booster_B_M_2":101475,
"Booster230_Gift":101476,
"Freedom_Stick_Cube":101482,
"Blessed_Knife_Cube":101483,
"Booster_Pack_10":101490,
"Booster_Pack_20":101491,
"Booster_Pack_40":101492,
"Booster_Pack_50":101493,
"Booster_Pack_70":101494,
"Booster_Pack_80":101495,
"Booster_Pack_110":101496,
"Booster_Pack_140":101497,
"Booster_Pack_170":101498,
"Booster_Pack_180":101499,
"Booster_Pack_210":101500,
"Booster_Pack_220":101501,
"Booster_Pack_240":101502,
"Booster_Pack_250":101503,
"aegis_101512":101512,
"aegis_101513":101513,
"aegis_101514":101514,
"F_VR_Book001":101522,
"F_VR_Book002":101523,
"F_VR_Book003":101524,
"F_VR_Book004":101525,
"Booster_Call_Package":101538,
"FullPene_Select_Box":101542,
"FullPene_Earring_Box":101543,
"FullPene_Pendant_Box":101544,
"FullPene_Armor_Box":101545,
"FullPene_Shoes_Box":101546,
"FullTemp_Select_Box":101547,
"FullTemp_Earring_Box":101548,
"FullTemp_Pendant_Box":101549,
"FullTemp_Armor_Box":101550,
"FullTemp_Shoes_Box":101551,
"Durable_Select_Box":101552,
"Durable_Weapon_Box":101553,
"Durable_Shield_Box":101554,
"Clever_Select_Box":101555,
"Clever_Weapon_Box":101556,
"Clever_Shield_Box":101557,
"OS_Helm_Box_":101563,
"AllMighty_Up":101564,
"Shadow_R_M_Box_":101565,
"KAKAO_Plus_Box":101567,
"E_Boarding_Halter_Box2":101589,
"Force_of_Fullmoon":101592,
"Evt_20th_Shield":101596,
"Evt_20th_Protector":101597,
"Evt_Makingmaterials_Box":101599,
"Evt_20th_Whitegold":101600,
"Evt_20th_Gold":101601,
"Evt_20th_Silver":101602,
"Evt_20th_Bronze":101603,
"Evt_20th_Return":101604,
"Evt_20th_Return2":101605,
"EP19_DGW_Refine":101637,
"D_Glacier_W_Enchant":101638,
"D_Gw_Extractor":101639,
"GMT_Robe_Stone":101645,
"Mjo_Ein_Enchant":101649,
"Viva_Adul_Hat_Box_11":101653,
"AllMighty_Select_Box":101654,
"AllMighty_Earring_Box":101655,
"AllMighty_Pendant_Box":101656,
"TrueGem_Select_Box":101657,
"TrueGem_Earring_Box":101658,
"TrueGem_Pendant_Box":101659,
"TrueGem_Shoes_Box":101660,
"TrueGem_Armor_Box":101661,
"PerfectSize_Select_Box":101662,
"PerfectSize_Weapon_Box":101663,
"PerfectSize_Armor_Box":101664,
"EXPShadow_Mix2":101665,
"Shadow_Up_Box":101666,
"aegis_101675":101675,
"F_VR_Book006":101705,
"F_VR_Book007":101706,
"Mammoth_Earring_Box":101717,
"Mammoth_Pendant_Box":101718,
"Mammoth_Armor_Box":101719,
"Mammoth_Shoes_Box":101720,
"SpellCaster_Earring_Box":101721,
"SpellCaster_Pendant_Box":101722,
"SpellCaster_Armor_Box":101723,
"SpellCaster_Shoes_Box":101724,
"Absorb_Weapon_Box":101725,
"Absorb_Shield_Box":101726,
"Mammoth_Select_Box":101727,
"SpellCaster_Select_Box":101728,
"Absorb_Select_Box":101729,
"E_Cloth_Dye_Box":101744,
"Dimmen_A_Reform":101745,
"Dimmen_A_Enchant":101746,
"Herosria_Gift":101750,
"RO_Festival_Box":101752,
"Heros_Purple_H_Jam":101753,
"Heros_Red_H_Jam":101754,
"Heros_Blue_H_Jam":101755,
"Heros_Yellow_H_Jam":101756,
"Heros_White_H_Jam":101757,
"Plain_Rune_Box5":101759,
"Flame_Rune_Box5":101760,
"Ice_Rune_Box5":101761,
"Death_Rune_Box5":101762,
"Barmund_P_Enchant":101765,
"Barmund_D_Enchant":101766,
"Barmund_F_Enchant":101767,
"Barmund_I_Enchant":101768,
"Barmund_Plain_Reform":101769,
"Barmund_Death_Reform":101770,
"Barmund_Flame_Reform":101771,
"Barmund_Ice_Reform":101772,
"Service1_M_01_Box":101774,
"Service1_M_05_Box":101775,
"Service1_M_07_Box":101776,
"Service1_M_10_Box":101777,
"Service1P_M_01_Box":101778,
"Service1P_M_05_Box":101779,
"Service1P_M_07_Box":101780,
"Service1P_M_10_Box":101781,
"Service1_F_01_Box":101782,
"Service1_F_05_Box":101783,
"Service1_F_07_Box":101784,
"Service1_F_10_Box":101785,
"Service1P_F_01_Box":101786,
"Service1P_F_05_Box":101787,
"Service1P_F_07_Box":101788,
"Service1P_F_10_Box":101789,
"SubjectCape_Refine_Cube":101792,
"R_Bearers_Select_Box":101801,
"R_Bearers_Earring_Box":101802,
"R_Bearers_Pendant_Box":101803,
"R_Bearers_Armor_Box":101804,
"R_Bearers_Shoes_Box":101805,
"Hasty_Select_Box":101806,
"Hasty_Weapon_Box":101807,
"Hasty_Shield_Box":101808,
"S_Reload_Shield_Box":101809,
"Dimmen_A_Refine":101816,
"F_VR_Book009":101834,
"F_VR_Book005":101835,
"F_VR_Book008":101837,
"RO_Arena_Box":101839,
"RO_Arena_Box2":101840,
"MAutoSpell_Select_Box":101856,
"MAutoSpell_Earring_Box":101858,
"MAutoSpell_Pendant_Box":101859,
"MAutoSpell_Armor_Box":101860,
"MAutoSpell_Shoes_Box":101861,
"Infinity_Select_Box":101862,
"Infinity_Weapon_Box":101863,
"Infinity_Shield_Box":101864,
"Luxurious_Blue_Box":101869,
"aegis_101876":101876,
"Vr_Book_Event":101889,
"Temple_Rune_Box5":101912,
"Venom_Rune_Box5":101913,
"Soul_Rune_Box5":101914,
"EXP_Select_Box":101919,
"EXP_Weapon_Box":101920,
"EXP_Shield_Box":101921,
"M_Blitz_Select_Box":101922,
"M_Blitz_Weapon_Box":101923,
"M_Blitz_Shield_Box":101924,
"Cvt_Wing_Box":101925,
"Barmund_S_Enchant":101930,
"Barmund_V_Enchant":101931,
"Barmund_T_Enchant":101932,
"Barmund_Soul_Reform":101933,
"Barmund_Venom_Reform":101934,
"Barmund_Temple_Reform":101935,
"Barmund_S_Reform":101936,
"Barmund_V_Reform":101937,
"Barmund_T_Reform":101938,
"A_Bubble_Gum":101947,
"A_Bubble_Gum_Box10":101948,
"SunShine_Sand":101952,
"Intake_Hair_Box":101954,
"Mocadas_Enchant_Box":102015,
"F_Ein_1HDAGGER_Box":102016,
"Mocadas_Refine_Box":102017,
"Amp_Blueprint1":102018,
"Amp_Blueprint3":102019,
"Amp_Blueprint2":102020,
"Amp_Blueprint4":102021,
"Amp_Blueprint6":102022,
"Amp_Blueprint5":102023,
"Amp_Blueprint7":102024,
"Amp_Blueprint8":102025,
"Amp_Blueprint9":102026,
"Amp_Blueprint10":102027,
"Amp_Blueprint11":102028,
"Amp_Blueprint12":102029,
"Amp_Blueprint13":102030,
"Amp_Blueprint14":102031,
"Amp_Blueprint15":102032,
"Amp_Blueprint16":102033,
"Amp_Blueprint17":102034,
"Amp_Blueprint18":102035,
"Dead_Soul_Aura":102038,
"Mocadas_Slabs1":102040,
"Mocadas_Slabs2":102041,
"Mocadas_Slabs3":102042,
"Mocadas_Slabs4":102043,
"Mocadas_Slabs5":102044,
"Mocadas_Slabs6":102045,
"Mocadas_Slabs7":102046,
"Mocadas_Slabs8":102047,
"Mocadas_Slabs9":102048,
"Mocadas_Slabs10":102049,
"Mocadas_Slabs11":102050,
"Mocadas_Slabs12":102051,
"Mocadas_Slabs13":102052,
"Mocadas_Slabs14":102053,
"Mocadas_Slabs15":102054,
"Mocadas_Slabs16":102055,
"Mocadas_Slabs17":102056,
"Mocadas_Slabs18":102057,
"Mocadas_Slabs19":102058,
"Mocadas_Slabs20":102059,
"Mocadas_Slabs21":102060,
"Mocadas_Slabs22":102061,
"Mocadas_Slabs23":102062,
"Pene_Set_Cube":102067,
"S_Bearers_Cube":102068,
"Temp_Set_Cube":102069,
"Justice_Weapon_Box":102070,
"Injustice_Weapon_Box":102071,
"Justice_Weapon_Hammer":102072,
"Injustice_Weapon_Hammer":102073,
"GoodnEvil_Helm_Box":102074,
"GoodnEvil_Helm_Hammer":102075,
"GoodnEvil_Circlet_Box":102084,
"aegis_102121":102121,
"Shadow_Select_Box_Set":102123,
"F_Ein_Weapon_Hammer":102124,
"Refine_Hammer_Box":102125,
"Amp_Blueprint19":102126,
"All_In_One_buff":102128,
"All_In_One_Healing":102129,
"aegis_102193":102193,
"Ep20_Fatty_Icegangu":102202,
"Hero_Weapon_Up_S_Box":102213,
"Hero_Weapon_Hammer_S":102214,
"aegis_102215":102215,
"aegis_102216":102216,
"Hero_Weapon_S_Box_1":102217,
"Hero_Weapon_S_Box_2":102218,
"Hero_Weapon_S_Box_3":102219,
"Hero_Weapon_S_Box_4":102220,
"Hero_Weapon_S_Box_5":102221,
"Hero_Weapon_S_Box_6":102222,
"Hero_Weapon_S_Box_7":102223,
"Hero_Up_Cube_11":102224,
"SLD_Boss_Card_Album":102226,
"Glacier_Armor_9Refine":102227,
"EP20_DGA_Refine":102228,
"Isgard_Crown_Hammer":102238,
"VIP_Black_Card":102246,
"VIP_Gift":102247,
"VVIP_Gift":102248,
"SVIP_Gift":102249,
"Loki_Advice":102277,
"Loki_Coin":102278,
"Bs_Item_M_S_60":102295,
"2023_Spring_Select":102306,
"2023_Spring_Collection":102307,
"Bs_Item_M_S_61":102308,
"Bs_Item_M_S_62":102310,
"Bs_Item_M_S_63":102311,
"aegis_102332":102332,
"Stone_Robe3_Box":102333,
"RO_Concert_Scroll":102337,
"RO_Concert_Scroll2":102338,
"RO_Concert_Scroll_Box":102340,
"Loki_Advice_3":102342,
"Loki_Coin_3":102343,
"Fan_Upgrade_Kit_EX":102344,
"Fan_Upgrade_Kit_EX_10":102345,
"CatPaw_1Day_Box":102353,
"Battle_Aura_TW":102354,
"Bar_D_A_Seal":102373,
"Bar_D_A_Unseal":102374,
"FA_Armor_Reform_1":102396,
"FA_Armor_Reform_2":102397,
"Maya_Scroll_TW":102404,
"aegis_102413":102413
}

